import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import stream from 'stream';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import zlib from 'zlib';
import _createForOfIteratorHelperLoose from '@babel/runtime/helpers/createForOfIteratorHelperLoose';
import fontkit from '@react-pdf/fontkit';
import PNG from '@react-pdf/png-js';
import _extends from '@babel/runtime/helpers/extends';
import CryptoJS from 'crypto-js/md5';

var PDFReference = /*#__PURE__*/function (_stream$Writable) {
  _inheritsLoose(PDFReference, _stream$Writable);

  function PDFReference(document, id, data) {
    var _this;

    _this = _stream$Writable.call(this, {
      decodeStrings: false
    }) || this;
    _this.finalize = _this.finalize.bind(_assertThisInitialized(_this));
    _this.document = document;
    _this.id = id;

    if (data == null) {
      data = {};
    }

    _this.data = data;
    _this.gen = 0;
    _this.deflate = null;
    _this.compress = _this.document.compress && !_this.data.Filter;
    _this.uncompressedLength = 0;
    _this.chunks = [];
    return _this;
  }

  var _proto = PDFReference.prototype;

  _proto.initDeflate = function initDeflate() {
    var _this2 = this;

    this.data.Filter = 'FlateDecode';
    this.deflate = zlib.createDeflate();
    this.deflate.on('data', function (chunk) {
      _this2.chunks.push(chunk);

      return _this2.data.Length += chunk.length;
    });
    return this.deflate.on('end', this.finalize);
  };

  _proto._write = function _write(chunk, encoding, callback) {
    if (!Buffer.isBuffer(chunk)) {
      chunk = Buffer.from(chunk + '\n', 'binary');
    }

    this.uncompressedLength += chunk.length;

    if (this.data.Length == null) {
      this.data.Length = 0;
    }

    if (this.compress) {
      if (!this.deflate) {
        this.initDeflate();
      }

      this.deflate.write(chunk);
    } else {
      this.chunks.push(chunk);
      this.data.Length += chunk.length;
    }

    return callback();
  };

  _proto.end = function end() {
    _stream$Writable.prototype.end.apply(this, arguments);

    if (this.deflate) {
      return this.deflate.end();
    }

    return this.finalize();
  };

  _proto.finalize = function finalize() {
    this.offset = this.document._offset;

    this.document._write(this.id + " " + this.gen + " obj");

    this.document._write(PDFObject$1.convert(this.data));

    if (this.chunks.length) {
      this.document._write('stream');

      for (var _i = 0, _Array$from = Array.from(this.chunks); _i < _Array$from.length; _i++) {
        var chunk = _Array$from[_i];

        this.document._write(chunk);
      }

      this.chunks.length = 0; // free up memory

      this.document._write('\nendstream');
    }

    this.document._write('endobj');

    return this.document._refEnd(this);
  };

  _proto.toString = function toString() {
    return this.id + " " + this.gen + " R";
  };

  return PDFReference;
}(stream.Writable);

var PDFNameTree = /*#__PURE__*/function () {
  function PDFNameTree() {
    this._items = {};
  }

  var _proto = PDFNameTree.prototype;

  _proto.add = function add(key, val) {
    return this._items[key] = val;
  };

  _proto.get = function get(key) {
    return this._items[key];
  };

  _proto.toString = function toString() {
    // Needs to be sorted by key
    var sortedKeys = Object.keys(this._items).sort(function (a, b) {
      return a.localeCompare(b);
    });
    var out = ['<<'];

    if (sortedKeys.length > 1) {
      var first = sortedKeys[0],
          last = sortedKeys[sortedKeys.length - 1];
      out.push("  /Limits " + PDFObject$1.convert([new String(first), new String(last)]));
    }

    out.push('  /Names [');

    for (var _iterator = _createForOfIteratorHelperLoose(sortedKeys), _step; !(_step = _iterator()).done;) {
      var key = _step.value;
      out.push("    " + PDFObject$1.convert(new String(key)) + " " + PDFObject$1.convert(this._items[key]));
    }

    out.push(']');
    out.push('>>');
    return out.join('\n');
  };

  return PDFNameTree;
}();

var escapableRe = /[\n\r\t\b\f\(\)\\]/g;
var escapable = {
  '\n': '\\n',
  '\r': '\\r',
  '\t': '\\t',
  '\b': '\\b',
  '\f': '\\f',
  '\\': '\\\\',
  '(': '\\(',
  ')': '\\)'
};

var pad = function pad(str, length) {
  return (Array(length + 1).join('0') + str).slice(-length);
}; // Convert little endian UTF-16 to big endian


var swapBytes = function swapBytes(buff) {
  var l = buff.length;

  if (l & 0x01) {
    throw new Error('Buffer length must be even');
  } else {
    for (var i = 0, end = l - 1; i < end; i += 2) {
      var a = buff[i];
      buff[i] = buff[i + 1];
      buff[i + 1] = a;
    }
  }

  return buff;
};

var PDFObject = /*#__PURE__*/function () {
  function PDFObject() {}

  PDFObject.convert = function convert(object) {
    // String literals are converted to the PDF name type
    if (typeof object === 'string') {
      return "/" + object;
    } // String objects are converted to PDF strings (UTF-16)


    if (object instanceof String) {
      var string = object; // Detect if this is a unicode string

      var isUnicode = false;

      for (var i = 0, end = string.length; i < end; i++) {
        if (string.charCodeAt(i) > 0x7f) {
          isUnicode = true;
          break;
        }
      } // If so, encode it as big endian UTF-16


      if (isUnicode) {
        string = swapBytes(Buffer.from("\uFEFF" + string, 'utf16le')).toString('binary');
      } // Escape characters as required by the spec


      string = string.replace(escapableRe, function (c) {
        return escapable[c];
      });
      return "(" + string + ")"; // Buffers are converted to PDF hex strings
    }

    if (Buffer.isBuffer(object)) {
      return "<" + object.toString('hex') + ">";
    }

    if (object instanceof PDFReference || object instanceof PDFNameTree) {
      return object.toString();
    }

    if (object instanceof Date) {
      return "(D:" + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + 'Z)';
    }

    if (Array.isArray(object)) {
      var items = Array.from(object).map(function (e) {
        return PDFObject.convert(e);
      }).join(' ');
      return "[" + items + "]";
    }

    if ({}.toString.call(object) === '[object Object]') {
      var out = ['<<'];

      for (var key in object) {
        var val = object[key];
        out.push("/" + key + " " + PDFObject.convert(val));
      }

      out.push('>>');
      return out.join('\n');
    }

    if (typeof object === 'number') {
      return PDFObject.number(object);
    }

    return "" + object;
  };

  PDFObject.number = function number(n) {
    if (n > -1e21 && n < 1e21) {
      return Math.round(n * 1e6) / 1e6;
    }

    throw new Error("unsupported number: " + n);
  };

  return PDFObject;
}();

var PDFObject$1 = PDFObject;
var DEFAULT_MARGINS = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
var SIZES = {
  '4A0': [4767.87, 6740.79],
  '2A0': [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  EXECUTIVE: [521.86, 756.0],
  FOLIO: [612.0, 936.0],
  LEGAL: [612.0, 1008.0],
  LETTER: [612.0, 792.0],
  TABLOID: [792.0, 1224.0]
};

var PDFPage = /*#__PURE__*/function () {
  function PDFPage(document, options) {
    var _this = this;

    this.document = document;

    if (options == null) {
      options = {};
    }

    this.size = options.size || 'letter';
    this.layout = options.layout || 'portrait';
    this.margins = DEFAULT_MARGINS; // calculate page dimensions

    var dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
    this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
    this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
    this.content = this.document.ref(); // Initialize the Font, XObject, and ExtGState dictionaries

    this.resources = this.document.ref({
      ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI']
    }); // Lazily create these dictionaries

    Object.defineProperties(this, {
      fonts: {
        get: function get() {
          return _this.resources.data.Font != null ? _this.resources.data.Font : _this.resources.data.Font = {};
        }
      },
      xobjects: {
        get: function get() {
          return _this.resources.data.XObject != null ? _this.resources.data.XObject : _this.resources.data.XObject = {};
        }
      },
      ext_gstates: {
        get: function get() {
          return _this.resources.data.ExtGState != null ? _this.resources.data.ExtGState : _this.resources.data.ExtGState = {};
        }
      },
      patterns: {
        get: function get() {
          return _this.resources.data.Pattern != null ? _this.resources.data.Pattern : _this.resources.data.Pattern = {};
        }
      },
      annotations: {
        get: function get() {
          return _this.dictionary.data.Annots != null ? _this.dictionary.data.Annots : _this.dictionary.data.Annots = [];
        }
      }
    }); // The page dictionary

    this.dictionary = this.document.ref({
      Type: 'Page',
      Parent: this.document._root.data.Pages,
      MediaBox: [0, 0, this.width, this.height],
      Contents: this.content,
      Resources: this.resources
    });
  }

  var _proto = PDFPage.prototype;

  _proto.maxY = function maxY() {
    return this.height;
  };

  _proto.write = function write(chunk) {
    return this.content.write(chunk);
  };

  _proto.end = function end() {
    this.dictionary.end();
    this.resources.end();
    return this.content.end();
  };

  return PDFPage;
}();

var number$2 = PDFObject$1.number;

var PDFGradient$1 = /*#__PURE__*/function () {
  function PDFGradient(doc) {
    this.doc = doc;
    this.stops = [];
    this.embedded = false;
    this.transform = [1, 0, 0, 1, 0, 0];
  }

  var _proto = PDFGradient.prototype;

  _proto.stop = function stop(pos, color, opacity) {
    if (opacity == null) {
      opacity = 1;
    }

    color = this.doc._normalizeColor(color);

    if (this.stops.length === 0) {
      if (color.length === 3) {
        this._colorSpace = 'DeviceRGB';
      } else if (color.length === 4) {
        this._colorSpace = 'DeviceCMYK';
      } else if (color.length === 1) {
        this._colorSpace = 'DeviceGray';
      } else {
        throw new Error('Unknown color space');
      }
    } else if (this._colorSpace === 'DeviceRGB' && color.length !== 3 || this._colorSpace === 'DeviceCMYK' && color.length !== 4 || this._colorSpace === 'DeviceGray' && color.length !== 1) {
      throw new Error('All gradient stops must use the same color space');
    }

    opacity = Math.max(0, Math.min(1, opacity));
    this.stops.push([pos, color, opacity]);
    return this;
  };

  _proto.setTransform = function setTransform(m11, m12, m21, m22, dx, dy) {
    this.transform = [m11, m12, m21, m22, dx, dy];
    return this;
  };

  _proto.embed = function embed(m) {
    var fn;
    var stopsLength = this.stops.length;

    if (stopsLength === 0) {
      return;
    }

    this.embedded = true;
    this.matrix = m; // if the last stop comes before 100%, add a copy at 100%

    var last = this.stops[stopsLength - 1];

    if (last[0] < 1) {
      this.stops.push([1, last[1], last[2]]);
    }

    var bounds = [];
    var encode = [];
    var stops = [];

    for (var i = 0; i < stopsLength - 1; i++) {
      encode.push(0, 1);

      if (i + 2 !== stopsLength) {
        bounds.push(this.stops[i + 1][0]);
      }

      fn = this.doc.ref({
        FunctionType: 2,
        Domain: [0, 1],
        C0: this.stops[i + 0][1],
        C1: this.stops[i + 1][1],
        N: 1
      });
      stops.push(fn);
      fn.end();
    } // if there are only two stops, we don't need a stitching function


    if (stopsLength === 1) {
      fn = stops[0];
    } else {
      fn = this.doc.ref({
        FunctionType: 3,
        // stitching function
        Domain: [0, 1],
        Functions: stops,
        Bounds: bounds,
        Encode: encode
      });
      fn.end();
    }

    this.id = "Sh" + ++this.doc._gradCount;
    var shader = this.shader(fn);
    shader.end();
    var pattern = this.doc.ref({
      Type: 'Pattern',
      PatternType: 2,
      Shading: shader,
      Matrix: this.matrix.map(number$2)
    });
    pattern.end();

    if (this.stops.some(function (stop) {
      return stop[2] < 1;
    })) {
      var grad = this.opacityGradient();
      grad._colorSpace = 'DeviceGray';

      for (var _iterator = _createForOfIteratorHelperLoose(this.stops), _step; !(_step = _iterator()).done;) {
        var stop = _step.value;
        grad.stop(stop[0], [stop[2]]);
      }

      grad = grad.embed(this.matrix);
      var pageBBox = [0, 0, this.doc.page.width, this.doc.page.height];
      var form = this.doc.ref({
        Type: 'XObject',
        Subtype: 'Form',
        FormType: 1,
        BBox: pageBBox,
        Group: {
          Type: 'Group',
          S: 'Transparency',
          CS: 'DeviceGray'
        },
        Resources: {
          ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
          Pattern: {
            Sh1: grad
          }
        }
      });
      form.write('/Pattern cs /Sh1 scn');
      form.end(pageBBox.join(' ') + " re f");
      var gstate = this.doc.ref({
        Type: 'ExtGState',
        SMask: {
          Type: 'Mask',
          S: 'Luminosity',
          G: form
        }
      });
      gstate.end();
      var opacityPattern = this.doc.ref({
        Type: 'Pattern',
        PatternType: 1,
        PaintType: 1,
        TilingType: 2,
        BBox: pageBBox,
        XStep: pageBBox[2],
        YStep: pageBBox[3],
        Resources: {
          ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
          Pattern: {
            Sh1: pattern
          },
          ExtGState: {
            Gs1: gstate
          }
        }
      });
      opacityPattern.write('/Gs1 gs /Pattern cs /Sh1 scn');
      opacityPattern.end(pageBBox.join(' ') + " re f");
      this.doc.page.patterns[this.id] = opacityPattern;
    } else {
      this.doc.page.patterns[this.id] = pattern;
    }

    return pattern;
  };

  _proto.apply = function apply(op) {
    // apply gradient transform to existing document ctm
    var _this$doc$_ctm = this.doc._ctm,
        m0 = _this$doc$_ctm[0],
        m1 = _this$doc$_ctm[1],
        m2 = _this$doc$_ctm[2],
        m3 = _this$doc$_ctm[3],
        m4 = _this$doc$_ctm[4],
        m5 = _this$doc$_ctm[5];
    var _this$transform = this.transform,
        m11 = _this$transform[0],
        m12 = _this$transform[1],
        m21 = _this$transform[2],
        m22 = _this$transform[3],
        dx = _this$transform[4],
        dy = _this$transform[5];
    var m = [m0 * m11 + m2 * m12, m1 * m11 + m3 * m12, m0 * m21 + m2 * m22, m1 * m21 + m3 * m22, m0 * dx + m2 * dy + m4, m1 * dx + m3 * dy + m5];

    if (!this.embedded || m.join(' ') !== this.matrix.join(' ')) {
      this.embed(m);
    }

    return this.doc.addContent("/" + this.id + " " + op);
  };

  return PDFGradient;
}();

var PDFLinearGradient$1 = /*#__PURE__*/function (_PDFGradient) {
  _inheritsLoose(PDFLinearGradient, _PDFGradient);

  function PDFLinearGradient(doc, x1, y1, x2, y2) {
    var _this;

    _this = _PDFGradient.call(this, doc) || this;
    _this.x1 = x1;
    _this.y1 = y1;
    _this.x2 = x2;
    _this.y2 = y2;
    return _this;
  }

  var _proto2 = PDFLinearGradient.prototype;

  _proto2.shader = function shader(fn) {
    return this.doc.ref({
      ShadingType: 2,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.x2, this.y2],
      Function: fn,
      Extend: [true, true]
    });
  };

  _proto2.opacityGradient = function opacityGradient() {
    return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
  };

  return PDFLinearGradient;
}(PDFGradient$1);

var PDFRadialGradient$1 = /*#__PURE__*/function (_PDFGradient2) {
  _inheritsLoose(PDFRadialGradient, _PDFGradient2);

  function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
    var _this2;

    _this2 = _PDFGradient2.call(this, doc) || this;
    _this2.doc = doc;
    _this2.x1 = x1;
    _this2.y1 = y1;
    _this2.r1 = r1;
    _this2.x2 = x2;
    _this2.y2 = y2;
    _this2.r2 = r2;
    return _this2;
  }

  var _proto3 = PDFRadialGradient.prototype;

  _proto3.shader = function shader(fn) {
    return this.doc.ref({
      ShadingType: 3,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
      Function: fn,
      Extend: [true, true]
    });
  };

  _proto3.opacityGradient = function opacityGradient() {
    return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
  };

  return PDFRadialGradient;
}(PDFGradient$1);

var Gradient = {
  PDFGradient: PDFGradient$1,
  PDFLinearGradient: PDFLinearGradient$1,
  PDFRadialGradient: PDFRadialGradient$1
};
var PDFGradient = Gradient.PDFGradient,
    PDFLinearGradient = Gradient.PDFLinearGradient,
    PDFRadialGradient = Gradient.PDFRadialGradient;
var Color = {
  initColor: function initColor() {
    // The opacity dictionaries
    this._opacityRegistry = {};
    this._opacityCount = 0;
    return this._gradCount = 0;
  },
  _normalizeColor: function _normalizeColor(color) {
    if (color instanceof PDFGradient) {
      return color;
    }

    var part;

    if (typeof color === 'string') {
      if (color.charAt(0) === '#') {
        if (color.length === 4) {
          color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, '#$1$1$2$2$3$3');
        }

        var hex = parseInt(color.slice(1), 16);
        color = [hex >> 16, hex >> 8 & 0xff, hex & 0xff];
      } else if (namedColors[color]) {
        color = namedColors[color];
      }
    }

    if (Array.isArray(color)) {
      // RGB
      if (color.length === 3) {
        color = function () {
          var result = [];

          for (var _i = 0, _Array$from = Array.from(color); _i < _Array$from.length; _i++) {
            part = _Array$from[_i];
            result.push(part / 255);
          }

          return result;
        }(); // CMYK

      } else if (color.length === 4) {
        color = function () {
          var result1 = [];

          for (var _i2 = 0, _Array$from2 = Array.from(color); _i2 < _Array$from2.length; _i2++) {
            part = _Array$from2[_i2];
            result1.push(part / 100);
          }

          return result1;
        }();
      }

      return color;
    }

    return null;
  },
  _setColor: function _setColor(color, stroke) {
    color = this._normalizeColor(color);

    if (!color) {
      return false;
    }

    var op = stroke ? 'SCN' : 'scn';

    if (color instanceof PDFGradient) {
      this._setColorSpace('Pattern', stroke);

      color.apply(op);
    } else {
      var space = color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';

      this._setColorSpace(space, stroke);

      color = color.join(' ');
      this.addContent(color + " " + op);
    }

    return true;
  },
  _setColorSpace: function _setColorSpace(space, stroke) {
    var op = stroke ? 'CS' : 'cs';
    return this.addContent("/" + space + " " + op);
  },
  fillColor: function fillColor(color, opacity) {
    var set = this._setColor(color, false);

    if (set) {
      this.fillOpacity(opacity);
    } // save this for text wrapper, which needs to reset
    // the fill color on new pages


    this._fillColor = [color, opacity];
    return this;
  },
  strokeColor: function strokeColor(color, opacity) {
    var set = this._setColor(color, true);

    if (set) {
      this.strokeOpacity(opacity);
    }

    return this;
  },
  opacity: function opacity(_opacity) {
    this._doOpacity(_opacity, _opacity);

    return this;
  },
  fillOpacity: function fillOpacity(opacity) {
    this._doOpacity(opacity, null);

    return this;
  },
  strokeOpacity: function strokeOpacity(opacity) {
    this._doOpacity(null, opacity);

    return this;
  },
  _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
    var dictionary, name;

    if (fillOpacity == null && strokeOpacity == null) {
      return;
    }

    if (fillOpacity != null) {
      fillOpacity = Math.max(0, Math.min(1, fillOpacity));
    }

    if (strokeOpacity != null) {
      strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
    }

    var key = fillOpacity + "_" + strokeOpacity;

    if (this._opacityRegistry[key]) {
      var _Array$from3 = Array.from(this._opacityRegistry[key]);

      dictionary = _Array$from3[0];
      name = _Array$from3[1];
    } else {
      dictionary = {
        Type: 'ExtGState'
      };

      if (fillOpacity != null) {
        dictionary.ca = fillOpacity;
      }

      if (strokeOpacity != null) {
        dictionary.CA = strokeOpacity;
      }

      dictionary = this.ref(dictionary);
      dictionary.end();
      var id = ++this._opacityCount;
      name = "Gs" + id;
      this._opacityRegistry[key] = [dictionary, name];
    }

    this.page.ext_gstates[name] = dictionary;
    return this.addContent("/" + name + " gs");
  },
  linearGradient: function linearGradient(x1, y1, x2, y2) {
    return new PDFLinearGradient(this, x1, y1, x2, y2);
  },
  radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
    return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
  }
};
var namedColors = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  grey: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
/* eslint-disable no-lonely-if */

var cx, cy, px, py, sx, sy;
cx = cy = px = py = sx = sy = 0; // parseDataPath copy pasted from svgo
// https://github.com/svg/svgo/blob/e4918ccdd1a2b5831defe0f00c1286744b479448/lib/path.js

var argsCountPerCommand = {
  M: 2,
  m: 2,
  Z: 0,
  z: 0,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7
};
/**
 * @type {(c: string) => c is PathDataCommand}
 */

var isCommand = function isCommand(c) {
  return c in argsCountPerCommand;
};
/**
 * @type {(c: string) => boolean}
 */


var isWsp = function isWsp(c) {
  var codePoint = c.codePointAt(0);
  return codePoint === 0x20 || codePoint === 0x9 || codePoint === 0xd || codePoint === 0xa;
};
/**
 * @type {(c: string) => boolean}
 */


var isDigit = function isDigit(c) {
  var codePoint = c.codePointAt(0);

  if (codePoint == null) {
    return false;
  }

  return 48 <= codePoint && codePoint <= 57;
};
/**
 * @typedef {'none' | 'sign' | 'whole' | 'decimal_point' | 'decimal' | 'e' | 'exponent_sign' | 'exponent'} ReadNumberState
 */

/**
 * @type {(string: string, cursor: number) => [number, number | null]}
 */


var readNumber = function readNumber(string, cursor) {
  var i = cursor;
  var value = '';
  var state =
  /** @type {ReadNumberState} */
  'none';

  for (; i < string.length; i += 1) {
    var c = string[i];

    if (c === '+' || c === '-') {
      if (state === 'none') {
        state = 'sign';
        value += c;
        continue;
      }

      if (state === 'e') {
        state = 'exponent_sign';
        value += c;
        continue;
      }
    }

    if (isDigit(c)) {
      if (state === 'none' || state === 'sign' || state === 'whole') {
        state = 'whole';
        value += c;
        continue;
      }

      if (state === 'decimal_point' || state === 'decimal') {
        state = 'decimal';
        value += c;
        continue;
      }

      if (state === 'e' || state === 'exponent_sign' || state === 'exponent') {
        state = 'exponent';
        value += c;
        continue;
      }
    }

    if (c === '.') {
      if (state === 'none' || state === 'sign' || state === 'whole') {
        state = 'decimal_point';
        value += c;
        continue;
      }
    }

    if (c === 'E' || c === 'e') {
      if (state === 'whole' || state === 'decimal_point' || state === 'decimal') {
        state = 'e';
        value += c;
        continue;
      }
    }

    break;
  }

  var number = Number.parseFloat(value);

  if (Number.isNaN(number)) {
    return [cursor, null];
  } else {
    // step back to delegate iteration to parent loop
    return [i - 1, number];
  }
};
/**
 * @type {(string: string) => Array<PathDataItem>}
 */


var parsePathData = function parsePathData(string) {
  /**
   * @type {Array<PathDataItem>}
   */
  var pathData = [];
  /**
   * @type {null | PathDataCommand}
   */

  var command = null;
  var args =
  /** @type {number[]} */
  [];
  var argsCount = 0;
  var canHaveComma = false;
  var hadComma = false;

  for (var i = 0; i < string.length; i += 1) {
    var c = string.charAt(i);

    if (isWsp(c)) {
      continue;
    } // allow comma only between arguments


    if (canHaveComma && c === ',') {
      if (hadComma) {
        break;
      }

      hadComma = true;
      continue;
    }

    if (isCommand(c)) {
      if (hadComma) {
        return pathData;
      }

      if (command == null) {
        // moveto should be leading command
        if (c !== 'M' && c !== 'm') {
          return pathData;
        }
      } else {
        // stop if previous command arguments are not flushed
        if (args.length !== 0) {
          return pathData;
        }
      }

      command = c;
      args = [];
      argsCount = argsCountPerCommand[command];
      canHaveComma = false; // flush command without arguments

      if (argsCount === 0) {
        pathData.push({
          command: command,
          args: args
        });
      }

      continue;
    } // avoid parsing arguments if no command detected


    if (command == null) {
      return pathData;
    } // read next argument


    var newCursor = i;
    var number = null;

    if (command === 'A' || command === 'a') {
      var position = args.length;

      if (position === 0 || position === 1) {
        // allow only positive number without sign as first two arguments
        if (c !== '+' && c !== '-') {
          var _readNumber = readNumber(string, i);

          newCursor = _readNumber[0];
          number = _readNumber[1];
        }
      }

      if (position === 2 || position === 5 || position === 6) {
        var _readNumber2 = readNumber(string, i);

        newCursor = _readNumber2[0];
        number = _readNumber2[1];
      }

      if (position === 3 || position === 4) {
        // read flags
        if (c === '0') {
          number = 0;
        }

        if (c === '1') {
          number = 1;
        }
      }
    } else {
      var _readNumber3 = readNumber(string, i);

      newCursor = _readNumber3[0];
      number = _readNumber3[1];
    }

    if (number == null) {
      return pathData;
    }

    args.push(number);
    canHaveComma = true;
    hadComma = false;
    i = newCursor; // flush arguments when necessary count is reached

    if (args.length === argsCount) {
      pathData.push({
        command: command,
        args: args
      }); // subsequent moveto coordinates are threated as implicit lineto commands

      if (command === 'M') {
        command = 'L';
      }

      if (command === 'm') {
        command = 'l';
      }

      args = [];
    }
  }

  return pathData;
};

var _apply = function apply(commands, doc) {
  // current point, control point, and subpath starting point
  cx = cy = px = py = sx = sy = 0; // run the commands

  for (var i = 0; i < commands.length; i++) {
    var _commands$i = commands[i],
        command = _commands$i.command,
        args = _commands$i.args;

    if (typeof runners[command] === 'function') {
      runners[command](doc, args);
    }
  }
};

var runners = {
  M: function M(doc, a) {
    cx = a[0];
    cy = a[1];
    px = py = null;
    sx = cx;
    sy = cy;
    return doc.moveTo(cx, cy);
  },
  m: function m(doc, a) {
    cx += a[0];
    cy += a[1];
    px = py = null;
    sx = cx;
    sy = cy;
    return doc.moveTo(cx, cy);
  },
  C: function C(doc, a) {
    cx = a[4];
    cy = a[5];
    px = a[2];
    py = a[3];
    return doc.bezierCurveTo.apply(doc, a);
  },
  c: function c(doc, a) {
    doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
    px = cx + a[2];
    py = cy + a[3];
    cx += a[4];
    return cy += a[5];
  },
  S: function S(doc, a) {
    if (px === null) {
      px = cx;
      py = cy;
    }

    doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
    px = a[0];
    py = a[1];
    cx = a[2];
    return cy = a[3];
  },
  s: function s(doc, a) {
    if (px === null) {
      px = cx;
      py = cy;
    }

    doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
    px = cx + a[0];
    py = cy + a[1];
    cx += a[2];
    return cy += a[3];
  },
  Q: function Q(doc, a) {
    px = a[0];
    py = a[1];
    cx = a[2];
    cy = a[3];
    return doc.quadraticCurveTo(a[0], a[1], cx, cy);
  },
  q: function q(doc, a) {
    doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
    px = cx + a[0];
    py = cy + a[1];
    cx += a[2];
    return cy += a[3];
  },
  T: function T(doc, a) {
    if (px === null) {
      px = cx;
      py = cy;
    } else {
      px = cx - (px - cx);
      py = cy - (py - cy);
    }

    doc.quadraticCurveTo(px, py, a[0], a[1]);
    px = cx - (px - cx);
    py = cy - (py - cy);
    cx = a[0];
    return cy = a[1];
  },
  t: function t(doc, a) {
    if (px === null) {
      px = cx;
      py = cy;
    } else {
      px = cx - (px - cx);
      py = cy - (py - cy);
    }

    doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
    cx += a[0];
    return cy += a[1];
  },
  A: function A(doc, a) {
    solveArc(doc, cx, cy, a);
    cx = a[5];
    return cy = a[6];
  },
  a: function a(doc, _a) {
    _a[5] += cx;
    _a[6] += cy;
    solveArc(doc, cx, cy, _a);
    cx = _a[5];
    return cy = _a[6];
  },
  L: function L(doc, a) {
    cx = a[0];
    cy = a[1];
    px = py = null;
    return doc.lineTo(cx, cy);
  },
  l: function l(doc, a) {
    cx += a[0];
    cy += a[1];
    px = py = null;
    return doc.lineTo(cx, cy);
  },
  H: function H(doc, a) {
    cx = a[0];
    px = py = null;
    return doc.lineTo(cx, cy);
  },
  h: function h(doc, a) {
    cx += a[0];
    px = py = null;
    return doc.lineTo(cx, cy);
  },
  V: function V(doc, a) {
    cy = a[0];
    px = py = null;
    return doc.lineTo(cx, cy);
  },
  v: function v(doc, a) {
    cy += a[0];
    px = py = null;
    return doc.lineTo(cx, cy);
  },
  Z: function Z(doc) {
    doc.closePath();
    cx = sx;
    return cy = sy;
  },
  z: function z(doc) {
    doc.closePath();
    cx = sx;
    return cy = sy;
  }
};

var solveArc = function solveArc(doc, x, y, coords) {
  var rx = coords[0],
      ry = coords[1],
      rot = coords[2],
      large = coords[3],
      sweep = coords[4],
      ex = coords[5],
      ey = coords[6];
  var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);

  for (var _iterator = _createForOfIteratorHelperLoose(segs), _step; !(_step = _iterator()).done;) {
    var seg = _step.value;
    var bez = segmentToBezier.apply(void 0, seg);
    doc.bezierCurveTo.apply(doc, bez);
  }
}; // from Inkscape svgtopdf, thanks!


var arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
  var th = rotateX * (Math.PI / 180);
  var sin_th = Math.sin(th);
  var cos_th = Math.cos(th);
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
  py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
  var pl = px * px / (rx * rx) + py * py / (ry * ry);

  if (pl > 1) {
    pl = Math.sqrt(pl);
    rx *= pl;
    ry *= pl;
  }

  var a00 = cos_th / rx;
  var a01 = sin_th / rx;
  var a10 = -sin_th / ry;
  var a11 = cos_th / ry;
  var x0 = a00 * ox + a01 * oy;
  var y0 = a10 * ox + a11 * oy;
  var x1 = a00 * x + a01 * y;
  var y1 = a10 * x + a11 * y;
  var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
  var sfactor_sq = 1 / d - 0.25;

  if (sfactor_sq < 0) {
    sfactor_sq = 0;
  }

  var sfactor = Math.sqrt(sfactor_sq);

  if (sweep === large) {
    sfactor = -sfactor;
  }

  var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
  var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
  var th0 = Math.atan2(y0 - yc, x0 - xc);
  var th1 = Math.atan2(y1 - yc, x1 - xc);
  var th_arc = th1 - th0;

  if (th_arc < 0 && sweep === 1) {
    th_arc += 2 * Math.PI;
  } else if (th_arc > 0 && sweep === 0) {
    th_arc -= 2 * Math.PI;
  }

  var segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
  var result = [];

  for (var i = 0; i < segments; i++) {
    var th2 = th0 + i * th_arc / segments;
    var th3 = th0 + (i + 1) * th_arc / segments;
    result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
  }

  return result;
};

var segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
  var a00 = cos_th * rx;
  var a01 = -sin_th * ry;
  var a10 = sin_th * rx;
  var a11 = cos_th * ry;
  var th_half = 0.5 * (th1 - th0);
  var t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
  var x1 = cx + Math.cos(th0) - t * Math.sin(th0);
  var y1 = cy + Math.sin(th0) + t * Math.cos(th0);
  var x3 = cx + Math.cos(th1);
  var y3 = cy + Math.sin(th1);
  var x2 = x3 + t * Math.sin(th1);
  var y2 = y3 - t * Math.cos(th1);
  return [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
};

var SVGPath = /*#__PURE__*/function () {
  function SVGPath() {}

  SVGPath.apply = function apply(doc, path) {
    var commands = parsePathData(path);

    _apply(commands, doc);
  };

  return SVGPath;
}();

var number$1 = PDFObject$1.number; // This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.

var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var Vector = {
  initVector: function initVector() {
    this._ctm = [1, 0, 0, 1, 0, 0]; // current transformation matrix

    return this._ctmStack = [];
  },
  save: function save() {
    this._ctmStack.push(this._ctm.slice()); // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?


    return this.addContent('q');
  },
  restore: function restore() {
    this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0];
    return this.addContent('Q');
  },
  closePath: function closePath() {
    return this.addContent('h');
  },
  lineWidth: function lineWidth(w) {
    return this.addContent(number$1(w) + " w");
  },
  _CAP_STYLES: {
    BUTT: 0,
    ROUND: 1,
    SQUARE: 2
  },
  lineCap: function lineCap(c) {
    if (typeof c === 'string') {
      c = this._CAP_STYLES[c.toUpperCase()];
    }

    return this.addContent(c + " J");
  },
  _JOIN_STYLES: {
    MITER: 0,
    ROUND: 1,
    BEVEL: 2
  },
  lineJoin: function lineJoin(j) {
    if (typeof j === 'string') {
      j = this._JOIN_STYLES[j.toUpperCase()];
    }

    return this.addContent(j + " j");
  },
  miterLimit: function miterLimit(m) {
    return this.addContent(number$1(m) + " M");
  },
  dash: function dash(length, options) {
    var phase;

    if (options == null) {
      options = {};
    }

    if (length == null) {
      return this;
    }

    if (Array.isArray(length)) {
      length = Array.from(length).map(function (v) {
        return PDFObject$1.number(v);
      }).join(' ');
      phase = options.phase || 0;
      return this.addContent("[" + length + "] " + PDFObject$1.number(phase) + " d");
    } else {
      var space = options.space != null ? options.space : length;
      phase = options.phase || 0;
      return this.addContent("[" + PDFObject$1.number(length) + " " + PDFObject$1.number(space) + "] " + PDFObject$1.number(phase) + " d");
    }
  },
  undash: function undash() {
    return this.addContent('[] 0 d');
  },
  moveTo: function moveTo(x, y) {
    return this.addContent(number$1(x) + " " + number$1(y) + " m");
  },
  lineTo: function lineTo(x, y) {
    return this.addContent(number$1(x) + " " + number$1(y) + " l");
  },
  bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
    return this.addContent(number$1(cp1x) + " " + number$1(cp1y) + " " + number$1(cp2x) + " " + number$1(cp2y) + " " + number$1(x) + " " + number$1(y) + " c");
  },
  quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
    return this.addContent(number$1(cpx) + " " + number$1(cpy) + " " + number$1(x) + " " + number$1(y) + " v");
  },
  rect: function rect(x, y, w, h) {
    return this.addContent(number$1(x) + " " + number$1(y) + " " + number$1(w) + " " + number$1(h) + " re");
  },
  roundedRect: function roundedRect(x, y, w, h, r) {
    if (r == null) {
      r = 0;
    }

    r = Math.min(r, 0.5 * w, 0.5 * h); // amount to inset control points from corners (see `ellipse`)

    var c = r * (1.0 - KAPPA);
    this.moveTo(x + r, y);
    this.lineTo(x + w - r, y);
    this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
    this.lineTo(x + w, y + h - r);
    this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
    this.lineTo(x + r, y + h);
    this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
    this.lineTo(x, y + r);
    this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
    return this.closePath();
  },
  ellipse: function ellipse(x, y, r1, r2) {
    // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
    if (r2 == null) {
      r2 = r1;
    }

    x -= r1;
    y -= r2;
    var ox = r1 * KAPPA;
    var oy = r2 * KAPPA;
    var xe = x + r1 * 2;
    var ye = y + r2 * 2;
    var xm = x + r1;
    var ym = y + r2;
    this.moveTo(x, ym);
    this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    return this.closePath();
  },
  circle: function circle(x, y, radius) {
    return this.ellipse(x, y, radius);
  },
  arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
    if (anticlockwise == null) {
      anticlockwise = false;
    }

    var TWO_PI = 2.0 * Math.PI;
    var HALF_PI = 0.5 * Math.PI;
    var deltaAng = endAngle - startAngle;

    if (Math.abs(deltaAng) > TWO_PI) {
      // draw only full circle if more than that is specified
      deltaAng = TWO_PI;
    } else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
      // necessary to flip direction of rendering
      var dir = anticlockwise ? -1 : 1;
      deltaAng = dir * TWO_PI + deltaAng;
    }

    var numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
    var segAng = deltaAng / numSegs;
    var handleLen = segAng / HALF_PI * KAPPA * radius;
    var curAng = startAngle; // component distances between anchor point and control point

    var deltaCx = -Math.sin(curAng) * handleLen;
    var deltaCy = Math.cos(curAng) * handleLen; // anchor point

    var ax = x + Math.cos(curAng) * radius;
    var ay = y + Math.sin(curAng) * radius; // calculate and render segments

    this.moveTo(ax, ay);

    for (var segIdx = 0, end = numSegs, asc = 0 <= end; asc ? segIdx < end : segIdx > end; asc ? segIdx++ : segIdx--) {
      // starting control point
      var cp1x = ax + deltaCx;
      var cp1y = ay + deltaCy; // step angle

      curAng += segAng; // next anchor point

      ax = x + Math.cos(curAng) * radius;
      ay = y + Math.sin(curAng) * radius; // next control point delta

      deltaCx = -Math.sin(curAng) * handleLen;
      deltaCy = Math.cos(curAng) * handleLen; // ending control point

      var cp2x = ax - deltaCx;
      var cp2y = ay - deltaCy; // render segment

      this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
    }

    return this;
  },
  polygon: function polygon() {
    for (var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++) {
      points[_key] = arguments[_key];
    }

    this.moveTo.apply(this, Array.from(points.shift() || []));

    for (var _i = 0, _Array$from = Array.from(points); _i < _Array$from.length; _i++) {
      var point = _Array$from[_i];
      this.lineTo.apply(this, Array.from(point || []));
    }

    return this.closePath();
  },
  path: function path(_path) {
    SVGPath.apply(this, _path);
    return this;
  },
  _windingRule: function _windingRule(rule) {
    if (/even-?odd/.test(rule)) {
      return '*';
    }

    return '';
  },
  fill: function fill(color, rule) {
    if (/(even-?odd)|(non-?zero)/.test(color)) {
      rule = color;
      color = null;
    }

    if (color) {
      this.fillColor(color);
    }

    return this.addContent("f" + this._windingRule(rule));
  },
  stroke: function stroke(color) {
    if (color) {
      this.strokeColor(color);
    }

    return this.addContent('S');
  },
  fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
    if (strokeColor == null) {
      strokeColor = fillColor;
    }

    var isFillRule = /(even-?odd)|(non-?zero)/;

    if (isFillRule.test(fillColor)) {
      rule = fillColor;
      fillColor = null;
    }

    if (isFillRule.test(strokeColor)) {
      rule = strokeColor;
      strokeColor = fillColor;
    }

    if (fillColor) {
      this.fillColor(fillColor);
      this.strokeColor(strokeColor);
    }

    return this.addContent("B" + this._windingRule(rule));
  },
  clip: function clip(rule) {
    return this.addContent("W" + this._windingRule(rule) + " n");
  },
  transform: function transform(m11, m12, m21, m22, dx, dy) {
    // keep track of the current transformation matrix
    var m = this._ctm;

    var _Array$from2 = Array.from(m),
        m0 = _Array$from2[0],
        m1 = _Array$from2[1],
        m2 = _Array$from2[2],
        m3 = _Array$from2[3],
        m4 = _Array$from2[4],
        m5 = _Array$from2[5];

    m[0] = m0 * m11 + m2 * m12;
    m[1] = m1 * m11 + m3 * m12;
    m[2] = m0 * m21 + m2 * m22;
    m[3] = m1 * m21 + m3 * m22;
    m[4] = m0 * dx + m2 * dy + m4;
    m[5] = m1 * dx + m3 * dy + m5;
    var values = [m11, m12, m21, m22, dx, dy].map(function (v) {
      return PDFObject$1.number(v);
    }).join(' ');
    return this.addContent(values + " cm");
  },
  translate: function translate(x, y) {
    return this.transform(1, 0, 0, 1, x, y);
  },
  rotate: function rotate(angle, options) {
    if (options === void 0) {
      options = {};
    }

    var y;
    var rad = angle * Math.PI / 180;
    var cos = Math.cos(rad);
    var sin = Math.sin(rad);
    var x = y = 0;

    if (options.origin != null) {
      var _Array$from3 = Array.from(options.origin);

      x = _Array$from3[0];
      y = _Array$from3[1];
      var x1 = x * cos - y * sin;
      var y1 = x * sin + y * cos;
      x -= x1;
      y -= y1;
    }

    return this.transform(cos, sin, -sin, cos, x, y);
  },
  scale: function scale(xFactor, yFactor, options) {
    if (options === void 0) {
      options = {};
    }

    var y;

    if (yFactor == null) {
      yFactor = xFactor;
    }

    if (typeof yFactor === 'object') {
      options = yFactor;
      yFactor = xFactor;
    }

    var x = y = 0;

    if (options.origin != null) {
      var _Array$from4 = Array.from(options.origin);

      x = _Array$from4[0];
      y = _Array$from4[1];
      x -= xFactor * x;
      y -= yFactor * y;
    }

    return this.transform(xFactor, 0, 0, yFactor, x, y);
  }
};

var range = function range(left, right, inclusive) {
  var range = [];
  var ascending = left < right;
  var end = !inclusive ? right : ascending ? right + 1 : right - 1;

  for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }

  return range;
};

var WIN_ANSI_MAP = {
  402: 131,
  8211: 150,
  8212: 151,
  8216: 145,
  8217: 146,
  8218: 130,
  8220: 147,
  8221: 148,
  8222: 132,
  8224: 134,
  8225: 135,
  8226: 149,
  8230: 133,
  8364: 128,
  8240: 137,
  8249: 139,
  8250: 155,
  710: 136,
  8482: 153,
  338: 140,
  339: 156,
  732: 152,
  352: 138,
  353: 154,
  376: 159,
  381: 142,
  382: 158
};
var characters = ".notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis".split(/\s+/);

function _parse(contents) {
  var obj = {
    attributes: {},
    glyphWidths: {},
    kernPairs: {}
  };
  var section = '';

  for (var _iterator = _createForOfIteratorHelperLoose(contents.split('\n')), _step; !(_step = _iterator()).done;) {
    var line = _step.value;
    var match;
    var a;

    if (match = line.match(/^Start(\w+)/)) {
      section = match[1];
      continue;
    } else if (match = line.match(/^End(\w+)/)) {
      section = '';
      continue;
    }

    switch (section) {
      case 'FontMetrics':
        match = line.match(/(^\w+)\s+(.*)/);
        var key = match[1];
        var value = match[2];

        if (a = obj.attributes[key]) {
          if (!Array.isArray(a)) {
            a = obj.attributes[key] = [a];
          }

          a.push(value);
        } else {
          obj.attributes[key] = value;
        }

        break;

      case 'CharMetrics':
        if (!/^CH?\s/.test(line)) {
          continue;
        }

        var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
        obj.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
        break;

      case 'KernPairs':
        match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);

        if (match) {
          obj.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
        }

        break;
    }
  }

  return obj;
}

var AFMFont = /*#__PURE__*/function () {
  AFMFont.open = function open(filename) {
    {
      throw new Error('AFMFont.open not available on browser build');
    }
  };

  AFMFont.fromJson = function fromJson(json) {
    return new AFMFont(json);
  };

  function AFMFont(contents) {
    var _this = this;

    if (typeof contents === 'string') {
      this.contents = contents;
      this.parse();
    } else {
      this.attributes = contents.attributes;
      this.glyphWidths = contents.glyphWidths;
      this.kernPairs = contents.kernPairs;
    }

    this.charWidths = range(0, 255, true).map(function (i) {
      return _this.glyphWidths[characters[i]];
    });
    this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map(function (e) {
      return +e;
    });
    this.ascender = +(this.attributes.Ascender || 0);
    this.descender = +(this.attributes.Descender || 0);
    this.xHeight = +(this.attributes.XHeight || 0);
    this.capHeight = +(this.attributes.CapHeight || 0);
    this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
  }

  var _proto = AFMFont.prototype;

  _proto.parse = function parse() {
    var parsed = _parse(this.contents);

    this.attributes = parsed.attributes;
    this.glyphWidths = parsed.glyphWidths;
    this.kernPairs = parsed.kernPairs;
  };

  _proto.encodeText = function encodeText(text) {
    var res = [];

    for (var i = 0, end = text.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
      var char = text.charCodeAt(i);
      char = WIN_ANSI_MAP[char] || char;
      res.push(char.toString(16));
    }

    return res;
  };

  _proto.glyphsForString = function glyphsForString(string) {
    var glyphs = [];

    for (var i = 0, end = string.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
      var charCode = string.charCodeAt(i);
      glyphs.push(this.characterToGlyph(charCode));
    }

    return glyphs;
  };

  _proto.characterToGlyph = function characterToGlyph(character) {
    return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
  };

  _proto.widthOfGlyph = function widthOfGlyph(glyph) {
    return this.glyphWidths[glyph] || 0;
  };

  _proto.getKernPair = function getKernPair(left, right) {
    return this.kernPairs[left + '\0' + right] || 0;
  };

  _proto.advancesForGlyphs = function advancesForGlyphs(glyphs) {
    var advances = [];

    for (var index = 0; index < glyphs.length; index++) {
      var left = glyphs[index];
      var right = glyphs[index + 1];
      advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
    }

    return advances;
  };

  return AFMFont;
}();

var attributes$8 = {
  Comment: ["Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 17:27:09 1997", "UniqueID 43050", "VMusage 39754 50779"],
  FontName: "Courier",
  FullName: "Courier",
  FamilyName: "Courier",
  Weight: "Medium",
  ItalicAngle: "0",
  IsFixedPitch: "true",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-23 -250 715 805 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "003.000",
  Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "562",
  XHeight: "426",
  Ascender: "629",
  Descender: "-157",
  StdHW: "51",
  StdVW: "51"
};
var glyphWidths$8 = {
  space: 600,
  exclam: 600,
  quotedbl: 600,
  numbersign: 600,
  dollar: 600,
  percent: 600,
  ampersand: 600,
  quoteright: 600,
  parenleft: 600,
  parenright: 600,
  asterisk: 600,
  plus: 600,
  comma: 600,
  hyphen: 600,
  period: 600,
  slash: 600,
  zero: 600,
  one: 600,
  two: 600,
  three: 600,
  four: 600,
  five: 600,
  six: 600,
  seven: 600,
  eight: 600,
  nine: 600,
  colon: 600,
  semicolon: 600,
  less: 600,
  equal: 600,
  greater: 600,
  question: 600,
  at: 600,
  A: 600,
  B: 600,
  C: 600,
  D: 600,
  E: 600,
  F: 600,
  G: 600,
  H: 600,
  I: 600,
  J: 600,
  K: 600,
  L: 600,
  M: 600,
  N: 600,
  O: 600,
  P: 600,
  Q: 600,
  R: 600,
  S: 600,
  T: 600,
  U: 600,
  V: 600,
  W: 600,
  X: 600,
  Y: 600,
  Z: 600,
  bracketleft: 600,
  backslash: 600,
  bracketright: 600,
  asciicircum: 600,
  underscore: 600,
  quoteleft: 600,
  a: 600,
  b: 600,
  c: 600,
  d: 600,
  e: 600,
  f: 600,
  g: 600,
  h: 600,
  i: 600,
  j: 600,
  k: 600,
  l: 600,
  m: 600,
  n: 600,
  o: 600,
  p: 600,
  q: 600,
  r: 600,
  s: 600,
  t: 600,
  u: 600,
  v: 600,
  w: 600,
  x: 600,
  y: 600,
  z: 600,
  braceleft: 600,
  bar: 600,
  braceright: 600,
  asciitilde: 600,
  exclamdown: 600,
  cent: 600,
  sterling: 600,
  fraction: 600,
  yen: 600,
  florin: 600,
  section: 600,
  currency: 600,
  quotesingle: 600,
  quotedblleft: 600,
  guillemotleft: 600,
  guilsinglleft: 600,
  guilsinglright: 600,
  fi: 600,
  fl: 600,
  endash: 600,
  dagger: 600,
  daggerdbl: 600,
  periodcentered: 600,
  paragraph: 600,
  bullet: 600,
  quotesinglbase: 600,
  quotedblbase: 600,
  quotedblright: 600,
  guillemotright: 600,
  ellipsis: 600,
  perthousand: 600,
  questiondown: 600,
  grave: 600,
  acute: 600,
  circumflex: 600,
  tilde: 600,
  macron: 600,
  breve: 600,
  dotaccent: 600,
  dieresis: 600,
  ring: 600,
  cedilla: 600,
  hungarumlaut: 600,
  ogonek: 600,
  caron: 600,
  emdash: 600,
  AE: 600,
  ordfeminine: 600,
  Lslash: 600,
  Oslash: 600,
  OE: 600,
  ordmasculine: 600,
  ae: 600,
  dotlessi: 600,
  lslash: 600,
  oslash: 600,
  oe: 600,
  germandbls: 600,
  Idieresis: 600,
  eacute: 600,
  abreve: 600,
  uhungarumlaut: 600,
  ecaron: 600,
  Ydieresis: 600,
  divide: 600,
  Yacute: 600,
  Acircumflex: 600,
  aacute: 600,
  Ucircumflex: 600,
  yacute: 600,
  scommaaccent: 600,
  ecircumflex: 600,
  Uring: 600,
  Udieresis: 600,
  aogonek: 600,
  Uacute: 600,
  uogonek: 600,
  Edieresis: 600,
  Dcroat: 600,
  commaaccent: 600,
  copyright: 600,
  Emacron: 600,
  ccaron: 600,
  aring: 600,
  Ncommaaccent: 600,
  lacute: 600,
  agrave: 600,
  Tcommaaccent: 600,
  Cacute: 600,
  atilde: 600,
  Edotaccent: 600,
  scaron: 600,
  scedilla: 600,
  iacute: 600,
  lozenge: 600,
  Rcaron: 600,
  Gcommaaccent: 600,
  ucircumflex: 600,
  acircumflex: 600,
  Amacron: 600,
  rcaron: 600,
  ccedilla: 600,
  Zdotaccent: 600,
  Thorn: 600,
  Omacron: 600,
  Racute: 600,
  Sacute: 600,
  dcaron: 600,
  Umacron: 600,
  uring: 600,
  threesuperior: 600,
  Ograve: 600,
  Agrave: 600,
  Abreve: 600,
  multiply: 600,
  uacute: 600,
  Tcaron: 600,
  partialdiff: 600,
  ydieresis: 600,
  Nacute: 600,
  icircumflex: 600,
  Ecircumflex: 600,
  adieresis: 600,
  edieresis: 600,
  cacute: 600,
  nacute: 600,
  umacron: 600,
  Ncaron: 600,
  Iacute: 600,
  plusminus: 600,
  brokenbar: 600,
  registered: 600,
  Gbreve: 600,
  Idotaccent: 600,
  summation: 600,
  Egrave: 600,
  racute: 600,
  omacron: 600,
  Zacute: 600,
  Zcaron: 600,
  greaterequal: 600,
  Eth: 600,
  Ccedilla: 600,
  lcommaaccent: 600,
  tcaron: 600,
  eogonek: 600,
  Uogonek: 600,
  Aacute: 600,
  Adieresis: 600,
  egrave: 600,
  zacute: 600,
  iogonek: 600,
  Oacute: 600,
  oacute: 600,
  amacron: 600,
  sacute: 600,
  idieresis: 600,
  Ocircumflex: 600,
  Ugrave: 600,
  Delta: 600,
  thorn: 600,
  twosuperior: 600,
  Odieresis: 600,
  mu: 600,
  igrave: 600,
  ohungarumlaut: 600,
  Eogonek: 600,
  dcroat: 600,
  threequarters: 600,
  Scedilla: 600,
  lcaron: 600,
  Kcommaaccent: 600,
  Lacute: 600,
  trademark: 600,
  edotaccent: 600,
  Igrave: 600,
  Imacron: 600,
  Lcaron: 600,
  onehalf: 600,
  lessequal: 600,
  ocircumflex: 600,
  ntilde: 600,
  Uhungarumlaut: 600,
  Eacute: 600,
  emacron: 600,
  gbreve: 600,
  onequarter: 600,
  Scaron: 600,
  Scommaaccent: 600,
  Ohungarumlaut: 600,
  degree: 600,
  ograve: 600,
  Ccaron: 600,
  ugrave: 600,
  radical: 600,
  Dcaron: 600,
  rcommaaccent: 600,
  Ntilde: 600,
  otilde: 600,
  Rcommaaccent: 600,
  Lcommaaccent: 600,
  Atilde: 600,
  Aogonek: 600,
  Aring: 600,
  Otilde: 600,
  zdotaccent: 600,
  Ecaron: 600,
  Iogonek: 600,
  kcommaaccent: 600,
  minus: 600,
  Icircumflex: 600,
  ncaron: 600,
  tcommaaccent: 600,
  logicalnot: 600,
  odieresis: 600,
  udieresis: 600,
  notequal: 600,
  gcommaaccent: 600,
  eth: 600,
  zcaron: 600,
  ncommaaccent: 600,
  onesuperior: 600,
  imacron: 600,
  Euro: 600
};
var kernPairs$8 = {};
var Courier = {
  attributes: attributes$8,
  glyphWidths: glyphWidths$8,
  kernPairs: kernPairs$8
};
var attributes$7 = {
  Comment: ["Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Mon Jun 23 16:28:00 1997", "UniqueID 43048", "VMusage 41139 52164"],
  FontName: "Courier-Bold",
  FullName: "Courier Bold",
  FamilyName: "Courier",
  Weight: "Bold",
  ItalicAngle: "0",
  IsFixedPitch: "true",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-113 -250 749 801 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "003.000",
  Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "562",
  XHeight: "439",
  Ascender: "629",
  Descender: "-157",
  StdHW: "84",
  StdVW: "106"
};
var glyphWidths$7 = {
  space: 600,
  exclam: 600,
  quotedbl: 600,
  numbersign: 600,
  dollar: 600,
  percent: 600,
  ampersand: 600,
  quoteright: 600,
  parenleft: 600,
  parenright: 600,
  asterisk: 600,
  plus: 600,
  comma: 600,
  hyphen: 600,
  period: 600,
  slash: 600,
  zero: 600,
  one: 600,
  two: 600,
  three: 600,
  four: 600,
  five: 600,
  six: 600,
  seven: 600,
  eight: 600,
  nine: 600,
  colon: 600,
  semicolon: 600,
  less: 600,
  equal: 600,
  greater: 600,
  question: 600,
  at: 600,
  A: 600,
  B: 600,
  C: 600,
  D: 600,
  E: 600,
  F: 600,
  G: 600,
  H: 600,
  I: 600,
  J: 600,
  K: 600,
  L: 600,
  M: 600,
  N: 600,
  O: 600,
  P: 600,
  Q: 600,
  R: 600,
  S: 600,
  T: 600,
  U: 600,
  V: 600,
  W: 600,
  X: 600,
  Y: 600,
  Z: 600,
  bracketleft: 600,
  backslash: 600,
  bracketright: 600,
  asciicircum: 600,
  underscore: 600,
  quoteleft: 600,
  a: 600,
  b: 600,
  c: 600,
  d: 600,
  e: 600,
  f: 600,
  g: 600,
  h: 600,
  i: 600,
  j: 600,
  k: 600,
  l: 600,
  m: 600,
  n: 600,
  o: 600,
  p: 600,
  q: 600,
  r: 600,
  s: 600,
  t: 600,
  u: 600,
  v: 600,
  w: 600,
  x: 600,
  y: 600,
  z: 600,
  braceleft: 600,
  bar: 600,
  braceright: 600,
  asciitilde: 600,
  exclamdown: 600,
  cent: 600,
  sterling: 600,
  fraction: 600,
  yen: 600,
  florin: 600,
  section: 600,
  currency: 600,
  quotesingle: 600,
  quotedblleft: 600,
  guillemotleft: 600,
  guilsinglleft: 600,
  guilsinglright: 600,
  fi: 600,
  fl: 600,
  endash: 600,
  dagger: 600,
  daggerdbl: 600,
  periodcentered: 600,
  paragraph: 600,
  bullet: 600,
  quotesinglbase: 600,
  quotedblbase: 600,
  quotedblright: 600,
  guillemotright: 600,
  ellipsis: 600,
  perthousand: 600,
  questiondown: 600,
  grave: 600,
  acute: 600,
  circumflex: 600,
  tilde: 600,
  macron: 600,
  breve: 600,
  dotaccent: 600,
  dieresis: 600,
  ring: 600,
  cedilla: 600,
  hungarumlaut: 600,
  ogonek: 600,
  caron: 600,
  emdash: 600,
  AE: 600,
  ordfeminine: 600,
  Lslash: 600,
  Oslash: 600,
  OE: 600,
  ordmasculine: 600,
  ae: 600,
  dotlessi: 600,
  lslash: 600,
  oslash: 600,
  oe: 600,
  germandbls: 600,
  Idieresis: 600,
  eacute: 600,
  abreve: 600,
  uhungarumlaut: 600,
  ecaron: 600,
  Ydieresis: 600,
  divide: 600,
  Yacute: 600,
  Acircumflex: 600,
  aacute: 600,
  Ucircumflex: 600,
  yacute: 600,
  scommaaccent: 600,
  ecircumflex: 600,
  Uring: 600,
  Udieresis: 600,
  aogonek: 600,
  Uacute: 600,
  uogonek: 600,
  Edieresis: 600,
  Dcroat: 600,
  commaaccent: 600,
  copyright: 600,
  Emacron: 600,
  ccaron: 600,
  aring: 600,
  Ncommaaccent: 600,
  lacute: 600,
  agrave: 600,
  Tcommaaccent: 600,
  Cacute: 600,
  atilde: 600,
  Edotaccent: 600,
  scaron: 600,
  scedilla: 600,
  iacute: 600,
  lozenge: 600,
  Rcaron: 600,
  Gcommaaccent: 600,
  ucircumflex: 600,
  acircumflex: 600,
  Amacron: 600,
  rcaron: 600,
  ccedilla: 600,
  Zdotaccent: 600,
  Thorn: 600,
  Omacron: 600,
  Racute: 600,
  Sacute: 600,
  dcaron: 600,
  Umacron: 600,
  uring: 600,
  threesuperior: 600,
  Ograve: 600,
  Agrave: 600,
  Abreve: 600,
  multiply: 600,
  uacute: 600,
  Tcaron: 600,
  partialdiff: 600,
  ydieresis: 600,
  Nacute: 600,
  icircumflex: 600,
  Ecircumflex: 600,
  adieresis: 600,
  edieresis: 600,
  cacute: 600,
  nacute: 600,
  umacron: 600,
  Ncaron: 600,
  Iacute: 600,
  plusminus: 600,
  brokenbar: 600,
  registered: 600,
  Gbreve: 600,
  Idotaccent: 600,
  summation: 600,
  Egrave: 600,
  racute: 600,
  omacron: 600,
  Zacute: 600,
  Zcaron: 600,
  greaterequal: 600,
  Eth: 600,
  Ccedilla: 600,
  lcommaaccent: 600,
  tcaron: 600,
  eogonek: 600,
  Uogonek: 600,
  Aacute: 600,
  Adieresis: 600,
  egrave: 600,
  zacute: 600,
  iogonek: 600,
  Oacute: 600,
  oacute: 600,
  amacron: 600,
  sacute: 600,
  idieresis: 600,
  Ocircumflex: 600,
  Ugrave: 600,
  Delta: 600,
  thorn: 600,
  twosuperior: 600,
  Odieresis: 600,
  mu: 600,
  igrave: 600,
  ohungarumlaut: 600,
  Eogonek: 600,
  dcroat: 600,
  threequarters: 600,
  Scedilla: 600,
  lcaron: 600,
  Kcommaaccent: 600,
  Lacute: 600,
  trademark: 600,
  edotaccent: 600,
  Igrave: 600,
  Imacron: 600,
  Lcaron: 600,
  onehalf: 600,
  lessequal: 600,
  ocircumflex: 600,
  ntilde: 600,
  Uhungarumlaut: 600,
  Eacute: 600,
  emacron: 600,
  gbreve: 600,
  onequarter: 600,
  Scaron: 600,
  Scommaaccent: 600,
  Ohungarumlaut: 600,
  degree: 600,
  ograve: 600,
  Ccaron: 600,
  ugrave: 600,
  radical: 600,
  Dcaron: 600,
  rcommaaccent: 600,
  Ntilde: 600,
  otilde: 600,
  Rcommaaccent: 600,
  Lcommaaccent: 600,
  Atilde: 600,
  Aogonek: 600,
  Aring: 600,
  Otilde: 600,
  zdotaccent: 600,
  Ecaron: 600,
  Iogonek: 600,
  kcommaaccent: 600,
  minus: 600,
  Icircumflex: 600,
  ncaron: 600,
  tcommaaccent: 600,
  logicalnot: 600,
  odieresis: 600,
  udieresis: 600,
  notequal: 600,
  gcommaaccent: 600,
  eth: 600,
  zcaron: 600,
  ncommaaccent: 600,
  onesuperior: 600,
  imacron: 600,
  Euro: 600
};
var kernPairs$7 = {};
var CourierBold = {
  attributes: attributes$7,
  glyphWidths: glyphWidths$7,
  kernPairs: kernPairs$7
};
var attributes$6 = {
  Comment: ["Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 17:37:52 1997", "UniqueID 43051", "VMusage 16248 75829"],
  FontName: "Courier-Oblique",
  FullName: "Courier Oblique",
  FamilyName: "Courier",
  Weight: "Medium",
  ItalicAngle: "-12",
  IsFixedPitch: "true",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-27 -250 849 805 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "003.000",
  Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "562",
  XHeight: "426",
  Ascender: "629",
  Descender: "-157",
  StdHW: "51",
  StdVW: "51"
};
var glyphWidths$6 = {
  space: 600,
  exclam: 600,
  quotedbl: 600,
  numbersign: 600,
  dollar: 600,
  percent: 600,
  ampersand: 600,
  quoteright: 600,
  parenleft: 600,
  parenright: 600,
  asterisk: 600,
  plus: 600,
  comma: 600,
  hyphen: 600,
  period: 600,
  slash: 600,
  zero: 600,
  one: 600,
  two: 600,
  three: 600,
  four: 600,
  five: 600,
  six: 600,
  seven: 600,
  eight: 600,
  nine: 600,
  colon: 600,
  semicolon: 600,
  less: 600,
  equal: 600,
  greater: 600,
  question: 600,
  at: 600,
  A: 600,
  B: 600,
  C: 600,
  D: 600,
  E: 600,
  F: 600,
  G: 600,
  H: 600,
  I: 600,
  J: 600,
  K: 600,
  L: 600,
  M: 600,
  N: 600,
  O: 600,
  P: 600,
  Q: 600,
  R: 600,
  S: 600,
  T: 600,
  U: 600,
  V: 600,
  W: 600,
  X: 600,
  Y: 600,
  Z: 600,
  bracketleft: 600,
  backslash: 600,
  bracketright: 600,
  asciicircum: 600,
  underscore: 600,
  quoteleft: 600,
  a: 600,
  b: 600,
  c: 600,
  d: 600,
  e: 600,
  f: 600,
  g: 600,
  h: 600,
  i: 600,
  j: 600,
  k: 600,
  l: 600,
  m: 600,
  n: 600,
  o: 600,
  p: 600,
  q: 600,
  r: 600,
  s: 600,
  t: 600,
  u: 600,
  v: 600,
  w: 600,
  x: 600,
  y: 600,
  z: 600,
  braceleft: 600,
  bar: 600,
  braceright: 600,
  asciitilde: 600,
  exclamdown: 600,
  cent: 600,
  sterling: 600,
  fraction: 600,
  yen: 600,
  florin: 600,
  section: 600,
  currency: 600,
  quotesingle: 600,
  quotedblleft: 600,
  guillemotleft: 600,
  guilsinglleft: 600,
  guilsinglright: 600,
  fi: 600,
  fl: 600,
  endash: 600,
  dagger: 600,
  daggerdbl: 600,
  periodcentered: 600,
  paragraph: 600,
  bullet: 600,
  quotesinglbase: 600,
  quotedblbase: 600,
  quotedblright: 600,
  guillemotright: 600,
  ellipsis: 600,
  perthousand: 600,
  questiondown: 600,
  grave: 600,
  acute: 600,
  circumflex: 600,
  tilde: 600,
  macron: 600,
  breve: 600,
  dotaccent: 600,
  dieresis: 600,
  ring: 600,
  cedilla: 600,
  hungarumlaut: 600,
  ogonek: 600,
  caron: 600,
  emdash: 600,
  AE: 600,
  ordfeminine: 600,
  Lslash: 600,
  Oslash: 600,
  OE: 600,
  ordmasculine: 600,
  ae: 600,
  dotlessi: 600,
  lslash: 600,
  oslash: 600,
  oe: 600,
  germandbls: 600,
  Idieresis: 600,
  eacute: 600,
  abreve: 600,
  uhungarumlaut: 600,
  ecaron: 600,
  Ydieresis: 600,
  divide: 600,
  Yacute: 600,
  Acircumflex: 600,
  aacute: 600,
  Ucircumflex: 600,
  yacute: 600,
  scommaaccent: 600,
  ecircumflex: 600,
  Uring: 600,
  Udieresis: 600,
  aogonek: 600,
  Uacute: 600,
  uogonek: 600,
  Edieresis: 600,
  Dcroat: 600,
  commaaccent: 600,
  copyright: 600,
  Emacron: 600,
  ccaron: 600,
  aring: 600,
  Ncommaaccent: 600,
  lacute: 600,
  agrave: 600,
  Tcommaaccent: 600,
  Cacute: 600,
  atilde: 600,
  Edotaccent: 600,
  scaron: 600,
  scedilla: 600,
  iacute: 600,
  lozenge: 600,
  Rcaron: 600,
  Gcommaaccent: 600,
  ucircumflex: 600,
  acircumflex: 600,
  Amacron: 600,
  rcaron: 600,
  ccedilla: 600,
  Zdotaccent: 600,
  Thorn: 600,
  Omacron: 600,
  Racute: 600,
  Sacute: 600,
  dcaron: 600,
  Umacron: 600,
  uring: 600,
  threesuperior: 600,
  Ograve: 600,
  Agrave: 600,
  Abreve: 600,
  multiply: 600,
  uacute: 600,
  Tcaron: 600,
  partialdiff: 600,
  ydieresis: 600,
  Nacute: 600,
  icircumflex: 600,
  Ecircumflex: 600,
  adieresis: 600,
  edieresis: 600,
  cacute: 600,
  nacute: 600,
  umacron: 600,
  Ncaron: 600,
  Iacute: 600,
  plusminus: 600,
  brokenbar: 600,
  registered: 600,
  Gbreve: 600,
  Idotaccent: 600,
  summation: 600,
  Egrave: 600,
  racute: 600,
  omacron: 600,
  Zacute: 600,
  Zcaron: 600,
  greaterequal: 600,
  Eth: 600,
  Ccedilla: 600,
  lcommaaccent: 600,
  tcaron: 600,
  eogonek: 600,
  Uogonek: 600,
  Aacute: 600,
  Adieresis: 600,
  egrave: 600,
  zacute: 600,
  iogonek: 600,
  Oacute: 600,
  oacute: 600,
  amacron: 600,
  sacute: 600,
  idieresis: 600,
  Ocircumflex: 600,
  Ugrave: 600,
  Delta: 600,
  thorn: 600,
  twosuperior: 600,
  Odieresis: 600,
  mu: 600,
  igrave: 600,
  ohungarumlaut: 600,
  Eogonek: 600,
  dcroat: 600,
  threequarters: 600,
  Scedilla: 600,
  lcaron: 600,
  Kcommaaccent: 600,
  Lacute: 600,
  trademark: 600,
  edotaccent: 600,
  Igrave: 600,
  Imacron: 600,
  Lcaron: 600,
  onehalf: 600,
  lessequal: 600,
  ocircumflex: 600,
  ntilde: 600,
  Uhungarumlaut: 600,
  Eacute: 600,
  emacron: 600,
  gbreve: 600,
  onequarter: 600,
  Scaron: 600,
  Scommaaccent: 600,
  Ohungarumlaut: 600,
  degree: 600,
  ograve: 600,
  Ccaron: 600,
  ugrave: 600,
  radical: 600,
  Dcaron: 600,
  rcommaaccent: 600,
  Ntilde: 600,
  otilde: 600,
  Rcommaaccent: 600,
  Lcommaaccent: 600,
  Atilde: 600,
  Aogonek: 600,
  Aring: 600,
  Otilde: 600,
  zdotaccent: 600,
  Ecaron: 600,
  Iogonek: 600,
  kcommaaccent: 600,
  minus: 600,
  Icircumflex: 600,
  ncaron: 600,
  tcommaaccent: 600,
  logicalnot: 600,
  odieresis: 600,
  udieresis: 600,
  notequal: 600,
  gcommaaccent: 600,
  eth: 600,
  zcaron: 600,
  ncommaaccent: 600,
  onesuperior: 600,
  imacron: 600,
  Euro: 600
};
var kernPairs$6 = {};
var CourierOblique = {
  attributes: attributes$6,
  glyphWidths: glyphWidths$6,
  kernPairs: kernPairs$6
};
var attributes$5 = {
  Comment: ["Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 12:38:23 1997", "UniqueID 43054", "VMusage 37069 48094"],
  FontName: "Helvetica",
  FullName: "Helvetica",
  FamilyName: "Helvetica",
  Weight: "Medium",
  ItalicAngle: "0",
  IsFixedPitch: "false",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-166 -225 1000 931 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "002.000",
  Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "718",
  XHeight: "523",
  Ascender: "718",
  Descender: "-207",
  StdHW: "76",
  StdVW: "88"
};
var glyphWidths$5 = {
  space: 278,
  exclam: 278,
  quotedbl: 355,
  numbersign: 556,
  dollar: 556,
  percent: 889,
  ampersand: 667,
  quoteright: 222,
  parenleft: 333,
  parenright: 333,
  asterisk: 389,
  plus: 584,
  comma: 278,
  hyphen: 333,
  period: 278,
  slash: 278,
  zero: 556,
  one: 556,
  two: 556,
  three: 556,
  four: 556,
  five: 556,
  six: 556,
  seven: 556,
  eight: 556,
  nine: 556,
  colon: 278,
  semicolon: 278,
  less: 584,
  equal: 584,
  greater: 584,
  question: 556,
  at: 1015,
  A: 667,
  B: 667,
  C: 722,
  D: 722,
  E: 667,
  F: 611,
  G: 778,
  H: 722,
  I: 278,
  J: 500,
  K: 667,
  L: 556,
  M: 833,
  N: 722,
  O: 778,
  P: 667,
  Q: 778,
  R: 722,
  S: 667,
  T: 611,
  U: 722,
  V: 667,
  W: 944,
  X: 667,
  Y: 667,
  Z: 611,
  bracketleft: 278,
  backslash: 278,
  bracketright: 278,
  asciicircum: 469,
  underscore: 556,
  quoteleft: 222,
  a: 556,
  b: 556,
  c: 500,
  d: 556,
  e: 556,
  f: 278,
  g: 556,
  h: 556,
  i: 222,
  j: 222,
  k: 500,
  l: 222,
  m: 833,
  n: 556,
  o: 556,
  p: 556,
  q: 556,
  r: 333,
  s: 500,
  t: 278,
  u: 556,
  v: 500,
  w: 722,
  x: 500,
  y: 500,
  z: 500,
  braceleft: 334,
  bar: 260,
  braceright: 334,
  asciitilde: 584,
  exclamdown: 333,
  cent: 556,
  sterling: 556,
  fraction: 167,
  yen: 556,
  florin: 556,
  section: 556,
  currency: 556,
  quotesingle: 191,
  quotedblleft: 333,
  guillemotleft: 556,
  guilsinglleft: 333,
  guilsinglright: 333,
  fi: 500,
  fl: 500,
  endash: 556,
  dagger: 556,
  daggerdbl: 556,
  periodcentered: 278,
  paragraph: 537,
  bullet: 350,
  quotesinglbase: 222,
  quotedblbase: 333,
  quotedblright: 333,
  guillemotright: 556,
  ellipsis: 1000,
  perthousand: 1000,
  questiondown: 611,
  grave: 333,
  acute: 333,
  circumflex: 333,
  tilde: 333,
  macron: 333,
  breve: 333,
  dotaccent: 333,
  dieresis: 333,
  ring: 333,
  cedilla: 333,
  hungarumlaut: 333,
  ogonek: 333,
  caron: 333,
  emdash: 1000,
  AE: 1000,
  ordfeminine: 370,
  Lslash: 556,
  Oslash: 778,
  OE: 1000,
  ordmasculine: 365,
  ae: 889,
  dotlessi: 278,
  lslash: 222,
  oslash: 611,
  oe: 944,
  germandbls: 611,
  Idieresis: 278,
  eacute: 556,
  abreve: 556,
  uhungarumlaut: 556,
  ecaron: 556,
  Ydieresis: 667,
  divide: 584,
  Yacute: 667,
  Acircumflex: 667,
  aacute: 556,
  Ucircumflex: 722,
  yacute: 500,
  scommaaccent: 500,
  ecircumflex: 556,
  Uring: 722,
  Udieresis: 722,
  aogonek: 556,
  Uacute: 722,
  uogonek: 556,
  Edieresis: 667,
  Dcroat: 722,
  commaaccent: 250,
  copyright: 737,
  Emacron: 667,
  ccaron: 500,
  aring: 556,
  Ncommaaccent: 722,
  lacute: 222,
  agrave: 556,
  Tcommaaccent: 611,
  Cacute: 722,
  atilde: 556,
  Edotaccent: 667,
  scaron: 500,
  scedilla: 500,
  iacute: 278,
  lozenge: 471,
  Rcaron: 722,
  Gcommaaccent: 778,
  ucircumflex: 556,
  acircumflex: 556,
  Amacron: 667,
  rcaron: 333,
  ccedilla: 500,
  Zdotaccent: 611,
  Thorn: 667,
  Omacron: 778,
  Racute: 722,
  Sacute: 667,
  dcaron: 643,
  Umacron: 722,
  uring: 556,
  threesuperior: 333,
  Ograve: 778,
  Agrave: 667,
  Abreve: 667,
  multiply: 584,
  uacute: 556,
  Tcaron: 611,
  partialdiff: 476,
  ydieresis: 500,
  Nacute: 722,
  icircumflex: 278,
  Ecircumflex: 667,
  adieresis: 556,
  edieresis: 556,
  cacute: 500,
  nacute: 556,
  umacron: 556,
  Ncaron: 722,
  Iacute: 278,
  plusminus: 584,
  brokenbar: 260,
  registered: 737,
  Gbreve: 778,
  Idotaccent: 278,
  summation: 600,
  Egrave: 667,
  racute: 333,
  omacron: 556,
  Zacute: 611,
  Zcaron: 611,
  greaterequal: 549,
  Eth: 722,
  Ccedilla: 722,
  lcommaaccent: 222,
  tcaron: 317,
  eogonek: 556,
  Uogonek: 722,
  Aacute: 667,
  Adieresis: 667,
  egrave: 556,
  zacute: 500,
  iogonek: 222,
  Oacute: 778,
  oacute: 556,
  amacron: 556,
  sacute: 500,
  idieresis: 278,
  Ocircumflex: 778,
  Ugrave: 722,
  Delta: 612,
  thorn: 556,
  twosuperior: 333,
  Odieresis: 778,
  mu: 556,
  igrave: 278,
  ohungarumlaut: 556,
  Eogonek: 667,
  dcroat: 556,
  threequarters: 834,
  Scedilla: 667,
  lcaron: 299,
  Kcommaaccent: 667,
  Lacute: 556,
  trademark: 1000,
  edotaccent: 556,
  Igrave: 278,
  Imacron: 278,
  Lcaron: 556,
  onehalf: 834,
  lessequal: 549,
  ocircumflex: 556,
  ntilde: 556,
  Uhungarumlaut: 722,
  Eacute: 667,
  emacron: 556,
  gbreve: 556,
  onequarter: 834,
  Scaron: 667,
  Scommaaccent: 667,
  Ohungarumlaut: 778,
  degree: 400,
  ograve: 556,
  Ccaron: 722,
  ugrave: 556,
  radical: 453,
  Dcaron: 722,
  rcommaaccent: 333,
  Ntilde: 722,
  otilde: 556,
  Rcommaaccent: 722,
  Lcommaaccent: 556,
  Atilde: 667,
  Aogonek: 667,
  Aring: 667,
  Otilde: 778,
  zdotaccent: 500,
  Ecaron: 667,
  Iogonek: 278,
  kcommaaccent: 500,
  minus: 584,
  Icircumflex: 278,
  ncaron: 556,
  tcommaaccent: 278,
  logicalnot: 584,
  odieresis: 556,
  udieresis: 556,
  notequal: 549,
  gcommaaccent: 556,
  eth: 556,
  zcaron: 500,
  ncommaaccent: 556,
  onesuperior: 333,
  imacron: 278,
  Euro: 556
};
var kernPairs$5 = {
  "A\0C": -30,
  "A\0Cacute": -30,
  "A\0Ccaron": -30,
  "A\0Ccedilla": -30,
  "A\0G": -30,
  "A\0Gbreve": -30,
  "A\0Gcommaaccent": -30,
  "A\0O": -30,
  "A\0Oacute": -30,
  "A\0Ocircumflex": -30,
  "A\0Odieresis": -30,
  "A\0Ograve": -30,
  "A\0Ohungarumlaut": -30,
  "A\0Omacron": -30,
  "A\0Oslash": -30,
  "A\0Otilde": -30,
  "A\0Q": -30,
  "A\0T": -120,
  "A\0Tcaron": -120,
  "A\0Tcommaaccent": -120,
  "A\0U": -50,
  "A\0Uacute": -50,
  "A\0Ucircumflex": -50,
  "A\0Udieresis": -50,
  "A\0Ugrave": -50,
  "A\0Uhungarumlaut": -50,
  "A\0Umacron": -50,
  "A\0Uogonek": -50,
  "A\0Uring": -50,
  "A\0V": -70,
  "A\0W": -50,
  "A\0Y": -100,
  "A\0Yacute": -100,
  "A\0Ydieresis": -100,
  "A\0u": -30,
  "A\0uacute": -30,
  "A\0ucircumflex": -30,
  "A\0udieresis": -30,
  "A\0ugrave": -30,
  "A\0uhungarumlaut": -30,
  "A\0umacron": -30,
  "A\0uogonek": -30,
  "A\0uring": -30,
  "A\0v": -40,
  "A\0w": -40,
  "A\0y": -40,
  "A\0yacute": -40,
  "A\0ydieresis": -40,
  "Aacute\0C": -30,
  "Aacute\0Cacute": -30,
  "Aacute\0Ccaron": -30,
  "Aacute\0Ccedilla": -30,
  "Aacute\0G": -30,
  "Aacute\0Gbreve": -30,
  "Aacute\0Gcommaaccent": -30,
  "Aacute\0O": -30,
  "Aacute\0Oacute": -30,
  "Aacute\0Ocircumflex": -30,
  "Aacute\0Odieresis": -30,
  "Aacute\0Ograve": -30,
  "Aacute\0Ohungarumlaut": -30,
  "Aacute\0Omacron": -30,
  "Aacute\0Oslash": -30,
  "Aacute\0Otilde": -30,
  "Aacute\0Q": -30,
  "Aacute\0T": -120,
  "Aacute\0Tcaron": -120,
  "Aacute\0Tcommaaccent": -120,
  "Aacute\0U": -50,
  "Aacute\0Uacute": -50,
  "Aacute\0Ucircumflex": -50,
  "Aacute\0Udieresis": -50,
  "Aacute\0Ugrave": -50,
  "Aacute\0Uhungarumlaut": -50,
  "Aacute\0Umacron": -50,
  "Aacute\0Uogonek": -50,
  "Aacute\0Uring": -50,
  "Aacute\0V": -70,
  "Aacute\0W": -50,
  "Aacute\0Y": -100,
  "Aacute\0Yacute": -100,
  "Aacute\0Ydieresis": -100,
  "Aacute\0u": -30,
  "Aacute\0uacute": -30,
  "Aacute\0ucircumflex": -30,
  "Aacute\0udieresis": -30,
  "Aacute\0ugrave": -30,
  "Aacute\0uhungarumlaut": -30,
  "Aacute\0umacron": -30,
  "Aacute\0uogonek": -30,
  "Aacute\0uring": -30,
  "Aacute\0v": -40,
  "Aacute\0w": -40,
  "Aacute\0y": -40,
  "Aacute\0yacute": -40,
  "Aacute\0ydieresis": -40,
  "Abreve\0C": -30,
  "Abreve\0Cacute": -30,
  "Abreve\0Ccaron": -30,
  "Abreve\0Ccedilla": -30,
  "Abreve\0G": -30,
  "Abreve\0Gbreve": -30,
  "Abreve\0Gcommaaccent": -30,
  "Abreve\0O": -30,
  "Abreve\0Oacute": -30,
  "Abreve\0Ocircumflex": -30,
  "Abreve\0Odieresis": -30,
  "Abreve\0Ograve": -30,
  "Abreve\0Ohungarumlaut": -30,
  "Abreve\0Omacron": -30,
  "Abreve\0Oslash": -30,
  "Abreve\0Otilde": -30,
  "Abreve\0Q": -30,
  "Abreve\0T": -120,
  "Abreve\0Tcaron": -120,
  "Abreve\0Tcommaaccent": -120,
  "Abreve\0U": -50,
  "Abreve\0Uacute": -50,
  "Abreve\0Ucircumflex": -50,
  "Abreve\0Udieresis": -50,
  "Abreve\0Ugrave": -50,
  "Abreve\0Uhungarumlaut": -50,
  "Abreve\0Umacron": -50,
  "Abreve\0Uogonek": -50,
  "Abreve\0Uring": -50,
  "Abreve\0V": -70,
  "Abreve\0W": -50,
  "Abreve\0Y": -100,
  "Abreve\0Yacute": -100,
  "Abreve\0Ydieresis": -100,
  "Abreve\0u": -30,
  "Abreve\0uacute": -30,
  "Abreve\0ucircumflex": -30,
  "Abreve\0udieresis": -30,
  "Abreve\0ugrave": -30,
  "Abreve\0uhungarumlaut": -30,
  "Abreve\0umacron": -30,
  "Abreve\0uogonek": -30,
  "Abreve\0uring": -30,
  "Abreve\0v": -40,
  "Abreve\0w": -40,
  "Abreve\0y": -40,
  "Abreve\0yacute": -40,
  "Abreve\0ydieresis": -40,
  "Acircumflex\0C": -30,
  "Acircumflex\0Cacute": -30,
  "Acircumflex\0Ccaron": -30,
  "Acircumflex\0Ccedilla": -30,
  "Acircumflex\0G": -30,
  "Acircumflex\0Gbreve": -30,
  "Acircumflex\0Gcommaaccent": -30,
  "Acircumflex\0O": -30,
  "Acircumflex\0Oacute": -30,
  "Acircumflex\0Ocircumflex": -30,
  "Acircumflex\0Odieresis": -30,
  "Acircumflex\0Ograve": -30,
  "Acircumflex\0Ohungarumlaut": -30,
  "Acircumflex\0Omacron": -30,
  "Acircumflex\0Oslash": -30,
  "Acircumflex\0Otilde": -30,
  "Acircumflex\0Q": -30,
  "Acircumflex\0T": -120,
  "Acircumflex\0Tcaron": -120,
  "Acircumflex\0Tcommaaccent": -120,
  "Acircumflex\0U": -50,
  "Acircumflex\0Uacute": -50,
  "Acircumflex\0Ucircumflex": -50,
  "Acircumflex\0Udieresis": -50,
  "Acircumflex\0Ugrave": -50,
  "Acircumflex\0Uhungarumlaut": -50,
  "Acircumflex\0Umacron": -50,
  "Acircumflex\0Uogonek": -50,
  "Acircumflex\0Uring": -50,
  "Acircumflex\0V": -70,
  "Acircumflex\0W": -50,
  "Acircumflex\0Y": -100,
  "Acircumflex\0Yacute": -100,
  "Acircumflex\0Ydieresis": -100,
  "Acircumflex\0u": -30,
  "Acircumflex\0uacute": -30,
  "Acircumflex\0ucircumflex": -30,
  "Acircumflex\0udieresis": -30,
  "Acircumflex\0ugrave": -30,
  "Acircumflex\0uhungarumlaut": -30,
  "Acircumflex\0umacron": -30,
  "Acircumflex\0uogonek": -30,
  "Acircumflex\0uring": -30,
  "Acircumflex\0v": -40,
  "Acircumflex\0w": -40,
  "Acircumflex\0y": -40,
  "Acircumflex\0yacute": -40,
  "Acircumflex\0ydieresis": -40,
  "Adieresis\0C": -30,
  "Adieresis\0Cacute": -30,
  "Adieresis\0Ccaron": -30,
  "Adieresis\0Ccedilla": -30,
  "Adieresis\0G": -30,
  "Adieresis\0Gbreve": -30,
  "Adieresis\0Gcommaaccent": -30,
  "Adieresis\0O": -30,
  "Adieresis\0Oacute": -30,
  "Adieresis\0Ocircumflex": -30,
  "Adieresis\0Odieresis": -30,
  "Adieresis\0Ograve": -30,
  "Adieresis\0Ohungarumlaut": -30,
  "Adieresis\0Omacron": -30,
  "Adieresis\0Oslash": -30,
  "Adieresis\0Otilde": -30,
  "Adieresis\0Q": -30,
  "Adieresis\0T": -120,
  "Adieresis\0Tcaron": -120,
  "Adieresis\0Tcommaaccent": -120,
  "Adieresis\0U": -50,
  "Adieresis\0Uacute": -50,
  "Adieresis\0Ucircumflex": -50,
  "Adieresis\0Udieresis": -50,
  "Adieresis\0Ugrave": -50,
  "Adieresis\0Uhungarumlaut": -50,
  "Adieresis\0Umacron": -50,
  "Adieresis\0Uogonek": -50,
  "Adieresis\0Uring": -50,
  "Adieresis\0V": -70,
  "Adieresis\0W": -50,
  "Adieresis\0Y": -100,
  "Adieresis\0Yacute": -100,
  "Adieresis\0Ydieresis": -100,
  "Adieresis\0u": -30,
  "Adieresis\0uacute": -30,
  "Adieresis\0ucircumflex": -30,
  "Adieresis\0udieresis": -30,
  "Adieresis\0ugrave": -30,
  "Adieresis\0uhungarumlaut": -30,
  "Adieresis\0umacron": -30,
  "Adieresis\0uogonek": -30,
  "Adieresis\0uring": -30,
  "Adieresis\0v": -40,
  "Adieresis\0w": -40,
  "Adieresis\0y": -40,
  "Adieresis\0yacute": -40,
  "Adieresis\0ydieresis": -40,
  "Agrave\0C": -30,
  "Agrave\0Cacute": -30,
  "Agrave\0Ccaron": -30,
  "Agrave\0Ccedilla": -30,
  "Agrave\0G": -30,
  "Agrave\0Gbreve": -30,
  "Agrave\0Gcommaaccent": -30,
  "Agrave\0O": -30,
  "Agrave\0Oacute": -30,
  "Agrave\0Ocircumflex": -30,
  "Agrave\0Odieresis": -30,
  "Agrave\0Ograve": -30,
  "Agrave\0Ohungarumlaut": -30,
  "Agrave\0Omacron": -30,
  "Agrave\0Oslash": -30,
  "Agrave\0Otilde": -30,
  "Agrave\0Q": -30,
  "Agrave\0T": -120,
  "Agrave\0Tcaron": -120,
  "Agrave\0Tcommaaccent": -120,
  "Agrave\0U": -50,
  "Agrave\0Uacute": -50,
  "Agrave\0Ucircumflex": -50,
  "Agrave\0Udieresis": -50,
  "Agrave\0Ugrave": -50,
  "Agrave\0Uhungarumlaut": -50,
  "Agrave\0Umacron": -50,
  "Agrave\0Uogonek": -50,
  "Agrave\0Uring": -50,
  "Agrave\0V": -70,
  "Agrave\0W": -50,
  "Agrave\0Y": -100,
  "Agrave\0Yacute": -100,
  "Agrave\0Ydieresis": -100,
  "Agrave\0u": -30,
  "Agrave\0uacute": -30,
  "Agrave\0ucircumflex": -30,
  "Agrave\0udieresis": -30,
  "Agrave\0ugrave": -30,
  "Agrave\0uhungarumlaut": -30,
  "Agrave\0umacron": -30,
  "Agrave\0uogonek": -30,
  "Agrave\0uring": -30,
  "Agrave\0v": -40,
  "Agrave\0w": -40,
  "Agrave\0y": -40,
  "Agrave\0yacute": -40,
  "Agrave\0ydieresis": -40,
  "Amacron\0C": -30,
  "Amacron\0Cacute": -30,
  "Amacron\0Ccaron": -30,
  "Amacron\0Ccedilla": -30,
  "Amacron\0G": -30,
  "Amacron\0Gbreve": -30,
  "Amacron\0Gcommaaccent": -30,
  "Amacron\0O": -30,
  "Amacron\0Oacute": -30,
  "Amacron\0Ocircumflex": -30,
  "Amacron\0Odieresis": -30,
  "Amacron\0Ograve": -30,
  "Amacron\0Ohungarumlaut": -30,
  "Amacron\0Omacron": -30,
  "Amacron\0Oslash": -30,
  "Amacron\0Otilde": -30,
  "Amacron\0Q": -30,
  "Amacron\0T": -120,
  "Amacron\0Tcaron": -120,
  "Amacron\0Tcommaaccent": -120,
  "Amacron\0U": -50,
  "Amacron\0Uacute": -50,
  "Amacron\0Ucircumflex": -50,
  "Amacron\0Udieresis": -50,
  "Amacron\0Ugrave": -50,
  "Amacron\0Uhungarumlaut": -50,
  "Amacron\0Umacron": -50,
  "Amacron\0Uogonek": -50,
  "Amacron\0Uring": -50,
  "Amacron\0V": -70,
  "Amacron\0W": -50,
  "Amacron\0Y": -100,
  "Amacron\0Yacute": -100,
  "Amacron\0Ydieresis": -100,
  "Amacron\0u": -30,
  "Amacron\0uacute": -30,
  "Amacron\0ucircumflex": -30,
  "Amacron\0udieresis": -30,
  "Amacron\0ugrave": -30,
  "Amacron\0uhungarumlaut": -30,
  "Amacron\0umacron": -30,
  "Amacron\0uogonek": -30,
  "Amacron\0uring": -30,
  "Amacron\0v": -40,
  "Amacron\0w": -40,
  "Amacron\0y": -40,
  "Amacron\0yacute": -40,
  "Amacron\0ydieresis": -40,
  "Aogonek\0C": -30,
  "Aogonek\0Cacute": -30,
  "Aogonek\0Ccaron": -30,
  "Aogonek\0Ccedilla": -30,
  "Aogonek\0G": -30,
  "Aogonek\0Gbreve": -30,
  "Aogonek\0Gcommaaccent": -30,
  "Aogonek\0O": -30,
  "Aogonek\0Oacute": -30,
  "Aogonek\0Ocircumflex": -30,
  "Aogonek\0Odieresis": -30,
  "Aogonek\0Ograve": -30,
  "Aogonek\0Ohungarumlaut": -30,
  "Aogonek\0Omacron": -30,
  "Aogonek\0Oslash": -30,
  "Aogonek\0Otilde": -30,
  "Aogonek\0Q": -30,
  "Aogonek\0T": -120,
  "Aogonek\0Tcaron": -120,
  "Aogonek\0Tcommaaccent": -120,
  "Aogonek\0U": -50,
  "Aogonek\0Uacute": -50,
  "Aogonek\0Ucircumflex": -50,
  "Aogonek\0Udieresis": -50,
  "Aogonek\0Ugrave": -50,
  "Aogonek\0Uhungarumlaut": -50,
  "Aogonek\0Umacron": -50,
  "Aogonek\0Uogonek": -50,
  "Aogonek\0Uring": -50,
  "Aogonek\0V": -70,
  "Aogonek\0W": -50,
  "Aogonek\0Y": -100,
  "Aogonek\0Yacute": -100,
  "Aogonek\0Ydieresis": -100,
  "Aogonek\0u": -30,
  "Aogonek\0uacute": -30,
  "Aogonek\0ucircumflex": -30,
  "Aogonek\0udieresis": -30,
  "Aogonek\0ugrave": -30,
  "Aogonek\0uhungarumlaut": -30,
  "Aogonek\0umacron": -30,
  "Aogonek\0uogonek": -30,
  "Aogonek\0uring": -30,
  "Aogonek\0v": -40,
  "Aogonek\0w": -40,
  "Aogonek\0y": -40,
  "Aogonek\0yacute": -40,
  "Aogonek\0ydieresis": -40,
  "Aring\0C": -30,
  "Aring\0Cacute": -30,
  "Aring\0Ccaron": -30,
  "Aring\0Ccedilla": -30,
  "Aring\0G": -30,
  "Aring\0Gbreve": -30,
  "Aring\0Gcommaaccent": -30,
  "Aring\0O": -30,
  "Aring\0Oacute": -30,
  "Aring\0Ocircumflex": -30,
  "Aring\0Odieresis": -30,
  "Aring\0Ograve": -30,
  "Aring\0Ohungarumlaut": -30,
  "Aring\0Omacron": -30,
  "Aring\0Oslash": -30,
  "Aring\0Otilde": -30,
  "Aring\0Q": -30,
  "Aring\0T": -120,
  "Aring\0Tcaron": -120,
  "Aring\0Tcommaaccent": -120,
  "Aring\0U": -50,
  "Aring\0Uacute": -50,
  "Aring\0Ucircumflex": -50,
  "Aring\0Udieresis": -50,
  "Aring\0Ugrave": -50,
  "Aring\0Uhungarumlaut": -50,
  "Aring\0Umacron": -50,
  "Aring\0Uogonek": -50,
  "Aring\0Uring": -50,
  "Aring\0V": -70,
  "Aring\0W": -50,
  "Aring\0Y": -100,
  "Aring\0Yacute": -100,
  "Aring\0Ydieresis": -100,
  "Aring\0u": -30,
  "Aring\0uacute": -30,
  "Aring\0ucircumflex": -30,
  "Aring\0udieresis": -30,
  "Aring\0ugrave": -30,
  "Aring\0uhungarumlaut": -30,
  "Aring\0umacron": -30,
  "Aring\0uogonek": -30,
  "Aring\0uring": -30,
  "Aring\0v": -40,
  "Aring\0w": -40,
  "Aring\0y": -40,
  "Aring\0yacute": -40,
  "Aring\0ydieresis": -40,
  "Atilde\0C": -30,
  "Atilde\0Cacute": -30,
  "Atilde\0Ccaron": -30,
  "Atilde\0Ccedilla": -30,
  "Atilde\0G": -30,
  "Atilde\0Gbreve": -30,
  "Atilde\0Gcommaaccent": -30,
  "Atilde\0O": -30,
  "Atilde\0Oacute": -30,
  "Atilde\0Ocircumflex": -30,
  "Atilde\0Odieresis": -30,
  "Atilde\0Ograve": -30,
  "Atilde\0Ohungarumlaut": -30,
  "Atilde\0Omacron": -30,
  "Atilde\0Oslash": -30,
  "Atilde\0Otilde": -30,
  "Atilde\0Q": -30,
  "Atilde\0T": -120,
  "Atilde\0Tcaron": -120,
  "Atilde\0Tcommaaccent": -120,
  "Atilde\0U": -50,
  "Atilde\0Uacute": -50,
  "Atilde\0Ucircumflex": -50,
  "Atilde\0Udieresis": -50,
  "Atilde\0Ugrave": -50,
  "Atilde\0Uhungarumlaut": -50,
  "Atilde\0Umacron": -50,
  "Atilde\0Uogonek": -50,
  "Atilde\0Uring": -50,
  "Atilde\0V": -70,
  "Atilde\0W": -50,
  "Atilde\0Y": -100,
  "Atilde\0Yacute": -100,
  "Atilde\0Ydieresis": -100,
  "Atilde\0u": -30,
  "Atilde\0uacute": -30,
  "Atilde\0ucircumflex": -30,
  "Atilde\0udieresis": -30,
  "Atilde\0ugrave": -30,
  "Atilde\0uhungarumlaut": -30,
  "Atilde\0umacron": -30,
  "Atilde\0uogonek": -30,
  "Atilde\0uring": -30,
  "Atilde\0v": -40,
  "Atilde\0w": -40,
  "Atilde\0y": -40,
  "Atilde\0yacute": -40,
  "Atilde\0ydieresis": -40,
  "B\0U": -10,
  "B\0Uacute": -10,
  "B\0Ucircumflex": -10,
  "B\0Udieresis": -10,
  "B\0Ugrave": -10,
  "B\0Uhungarumlaut": -10,
  "B\0Umacron": -10,
  "B\0Uogonek": -10,
  "B\0Uring": -10,
  "B\0comma": -20,
  "B\0period": -20,
  "C\0comma": -30,
  "C\0period": -30,
  "Cacute\0comma": -30,
  "Cacute\0period": -30,
  "Ccaron\0comma": -30,
  "Ccaron\0period": -30,
  "Ccedilla\0comma": -30,
  "Ccedilla\0period": -30,
  "D\0A": -40,
  "D\0Aacute": -40,
  "D\0Abreve": -40,
  "D\0Acircumflex": -40,
  "D\0Adieresis": -40,
  "D\0Agrave": -40,
  "D\0Amacron": -40,
  "D\0Aogonek": -40,
  "D\0Aring": -40,
  "D\0Atilde": -40,
  "D\0V": -70,
  "D\0W": -40,
  "D\0Y": -90,
  "D\0Yacute": -90,
  "D\0Ydieresis": -90,
  "D\0comma": -70,
  "D\0period": -70,
  "Dcaron\0A": -40,
  "Dcaron\0Aacute": -40,
  "Dcaron\0Abreve": -40,
  "Dcaron\0Acircumflex": -40,
  "Dcaron\0Adieresis": -40,
  "Dcaron\0Agrave": -40,
  "Dcaron\0Amacron": -40,
  "Dcaron\0Aogonek": -40,
  "Dcaron\0Aring": -40,
  "Dcaron\0Atilde": -40,
  "Dcaron\0V": -70,
  "Dcaron\0W": -40,
  "Dcaron\0Y": -90,
  "Dcaron\0Yacute": -90,
  "Dcaron\0Ydieresis": -90,
  "Dcaron\0comma": -70,
  "Dcaron\0period": -70,
  "Dcroat\0A": -40,
  "Dcroat\0Aacute": -40,
  "Dcroat\0Abreve": -40,
  "Dcroat\0Acircumflex": -40,
  "Dcroat\0Adieresis": -40,
  "Dcroat\0Agrave": -40,
  "Dcroat\0Amacron": -40,
  "Dcroat\0Aogonek": -40,
  "Dcroat\0Aring": -40,
  "Dcroat\0Atilde": -40,
  "Dcroat\0V": -70,
  "Dcroat\0W": -40,
  "Dcroat\0Y": -90,
  "Dcroat\0Yacute": -90,
  "Dcroat\0Ydieresis": -90,
  "Dcroat\0comma": -70,
  "Dcroat\0period": -70,
  "F\0A": -80,
  "F\0Aacute": -80,
  "F\0Abreve": -80,
  "F\0Acircumflex": -80,
  "F\0Adieresis": -80,
  "F\0Agrave": -80,
  "F\0Amacron": -80,
  "F\0Aogonek": -80,
  "F\0Aring": -80,
  "F\0Atilde": -80,
  "F\0a": -50,
  "F\0aacute": -50,
  "F\0abreve": -50,
  "F\0acircumflex": -50,
  "F\0adieresis": -50,
  "F\0agrave": -50,
  "F\0amacron": -50,
  "F\0aogonek": -50,
  "F\0aring": -50,
  "F\0atilde": -50,
  "F\0comma": -150,
  "F\0e": -30,
  "F\0eacute": -30,
  "F\0ecaron": -30,
  "F\0ecircumflex": -30,
  "F\0edieresis": -30,
  "F\0edotaccent": -30,
  "F\0egrave": -30,
  "F\0emacron": -30,
  "F\0eogonek": -30,
  "F\0o": -30,
  "F\0oacute": -30,
  "F\0ocircumflex": -30,
  "F\0odieresis": -30,
  "F\0ograve": -30,
  "F\0ohungarumlaut": -30,
  "F\0omacron": -30,
  "F\0oslash": -30,
  "F\0otilde": -30,
  "F\0period": -150,
  "F\0r": -45,
  "F\0racute": -45,
  "F\0rcaron": -45,
  "F\0rcommaaccent": -45,
  "J\0A": -20,
  "J\0Aacute": -20,
  "J\0Abreve": -20,
  "J\0Acircumflex": -20,
  "J\0Adieresis": -20,
  "J\0Agrave": -20,
  "J\0Amacron": -20,
  "J\0Aogonek": -20,
  "J\0Aring": -20,
  "J\0Atilde": -20,
  "J\0a": -20,
  "J\0aacute": -20,
  "J\0abreve": -20,
  "J\0acircumflex": -20,
  "J\0adieresis": -20,
  "J\0agrave": -20,
  "J\0amacron": -20,
  "J\0aogonek": -20,
  "J\0aring": -20,
  "J\0atilde": -20,
  "J\0comma": -30,
  "J\0period": -30,
  "J\0u": -20,
  "J\0uacute": -20,
  "J\0ucircumflex": -20,
  "J\0udieresis": -20,
  "J\0ugrave": -20,
  "J\0uhungarumlaut": -20,
  "J\0umacron": -20,
  "J\0uogonek": -20,
  "J\0uring": -20,
  "K\0O": -50,
  "K\0Oacute": -50,
  "K\0Ocircumflex": -50,
  "K\0Odieresis": -50,
  "K\0Ograve": -50,
  "K\0Ohungarumlaut": -50,
  "K\0Omacron": -50,
  "K\0Oslash": -50,
  "K\0Otilde": -50,
  "K\0e": -40,
  "K\0eacute": -40,
  "K\0ecaron": -40,
  "K\0ecircumflex": -40,
  "K\0edieresis": -40,
  "K\0edotaccent": -40,
  "K\0egrave": -40,
  "K\0emacron": -40,
  "K\0eogonek": -40,
  "K\0o": -40,
  "K\0oacute": -40,
  "K\0ocircumflex": -40,
  "K\0odieresis": -40,
  "K\0ograve": -40,
  "K\0ohungarumlaut": -40,
  "K\0omacron": -40,
  "K\0oslash": -40,
  "K\0otilde": -40,
  "K\0u": -30,
  "K\0uacute": -30,
  "K\0ucircumflex": -30,
  "K\0udieresis": -30,
  "K\0ugrave": -30,
  "K\0uhungarumlaut": -30,
  "K\0umacron": -30,
  "K\0uogonek": -30,
  "K\0uring": -30,
  "K\0y": -50,
  "K\0yacute": -50,
  "K\0ydieresis": -50,
  "Kcommaaccent\0O": -50,
  "Kcommaaccent\0Oacute": -50,
  "Kcommaaccent\0Ocircumflex": -50,
  "Kcommaaccent\0Odieresis": -50,
  "Kcommaaccent\0Ograve": -50,
  "Kcommaaccent\0Ohungarumlaut": -50,
  "Kcommaaccent\0Omacron": -50,
  "Kcommaaccent\0Oslash": -50,
  "Kcommaaccent\0Otilde": -50,
  "Kcommaaccent\0e": -40,
  "Kcommaaccent\0eacute": -40,
  "Kcommaaccent\0ecaron": -40,
  "Kcommaaccent\0ecircumflex": -40,
  "Kcommaaccent\0edieresis": -40,
  "Kcommaaccent\0edotaccent": -40,
  "Kcommaaccent\0egrave": -40,
  "Kcommaaccent\0emacron": -40,
  "Kcommaaccent\0eogonek": -40,
  "Kcommaaccent\0o": -40,
  "Kcommaaccent\0oacute": -40,
  "Kcommaaccent\0ocircumflex": -40,
  "Kcommaaccent\0odieresis": -40,
  "Kcommaaccent\0ograve": -40,
  "Kcommaaccent\0ohungarumlaut": -40,
  "Kcommaaccent\0omacron": -40,
  "Kcommaaccent\0oslash": -40,
  "Kcommaaccent\0otilde": -40,
  "Kcommaaccent\0u": -30,
  "Kcommaaccent\0uacute": -30,
  "Kcommaaccent\0ucircumflex": -30,
  "Kcommaaccent\0udieresis": -30,
  "Kcommaaccent\0ugrave": -30,
  "Kcommaaccent\0uhungarumlaut": -30,
  "Kcommaaccent\0umacron": -30,
  "Kcommaaccent\0uogonek": -30,
  "Kcommaaccent\0uring": -30,
  "Kcommaaccent\0y": -50,
  "Kcommaaccent\0yacute": -50,
  "Kcommaaccent\0ydieresis": -50,
  "L\0T": -110,
  "L\0Tcaron": -110,
  "L\0Tcommaaccent": -110,
  "L\0V": -110,
  "L\0W": -70,
  "L\0Y": -140,
  "L\0Yacute": -140,
  "L\0Ydieresis": -140,
  "L\0quotedblright": -140,
  "L\0quoteright": -160,
  "L\0y": -30,
  "L\0yacute": -30,
  "L\0ydieresis": -30,
  "Lacute\0T": -110,
  "Lacute\0Tcaron": -110,
  "Lacute\0Tcommaaccent": -110,
  "Lacute\0V": -110,
  "Lacute\0W": -70,
  "Lacute\0Y": -140,
  "Lacute\0Yacute": -140,
  "Lacute\0Ydieresis": -140,
  "Lacute\0quotedblright": -140,
  "Lacute\0quoteright": -160,
  "Lacute\0y": -30,
  "Lacute\0yacute": -30,
  "Lacute\0ydieresis": -30,
  "Lcaron\0T": -110,
  "Lcaron\0Tcaron": -110,
  "Lcaron\0Tcommaaccent": -110,
  "Lcaron\0V": -110,
  "Lcaron\0W": -70,
  "Lcaron\0Y": -140,
  "Lcaron\0Yacute": -140,
  "Lcaron\0Ydieresis": -140,
  "Lcaron\0quotedblright": -140,
  "Lcaron\0quoteright": -160,
  "Lcaron\0y": -30,
  "Lcaron\0yacute": -30,
  "Lcaron\0ydieresis": -30,
  "Lcommaaccent\0T": -110,
  "Lcommaaccent\0Tcaron": -110,
  "Lcommaaccent\0Tcommaaccent": -110,
  "Lcommaaccent\0V": -110,
  "Lcommaaccent\0W": -70,
  "Lcommaaccent\0Y": -140,
  "Lcommaaccent\0Yacute": -140,
  "Lcommaaccent\0Ydieresis": -140,
  "Lcommaaccent\0quotedblright": -140,
  "Lcommaaccent\0quoteright": -160,
  "Lcommaaccent\0y": -30,
  "Lcommaaccent\0yacute": -30,
  "Lcommaaccent\0ydieresis": -30,
  "Lslash\0T": -110,
  "Lslash\0Tcaron": -110,
  "Lslash\0Tcommaaccent": -110,
  "Lslash\0V": -110,
  "Lslash\0W": -70,
  "Lslash\0Y": -140,
  "Lslash\0Yacute": -140,
  "Lslash\0Ydieresis": -140,
  "Lslash\0quotedblright": -140,
  "Lslash\0quoteright": -160,
  "Lslash\0y": -30,
  "Lslash\0yacute": -30,
  "Lslash\0ydieresis": -30,
  "O\0A": -20,
  "O\0Aacute": -20,
  "O\0Abreve": -20,
  "O\0Acircumflex": -20,
  "O\0Adieresis": -20,
  "O\0Agrave": -20,
  "O\0Amacron": -20,
  "O\0Aogonek": -20,
  "O\0Aring": -20,
  "O\0Atilde": -20,
  "O\0T": -40,
  "O\0Tcaron": -40,
  "O\0Tcommaaccent": -40,
  "O\0V": -50,
  "O\0W": -30,
  "O\0X": -60,
  "O\0Y": -70,
  "O\0Yacute": -70,
  "O\0Ydieresis": -70,
  "O\0comma": -40,
  "O\0period": -40,
  "Oacute\0A": -20,
  "Oacute\0Aacute": -20,
  "Oacute\0Abreve": -20,
  "Oacute\0Acircumflex": -20,
  "Oacute\0Adieresis": -20,
  "Oacute\0Agrave": -20,
  "Oacute\0Amacron": -20,
  "Oacute\0Aogonek": -20,
  "Oacute\0Aring": -20,
  "Oacute\0Atilde": -20,
  "Oacute\0T": -40,
  "Oacute\0Tcaron": -40,
  "Oacute\0Tcommaaccent": -40,
  "Oacute\0V": -50,
  "Oacute\0W": -30,
  "Oacute\0X": -60,
  "Oacute\0Y": -70,
  "Oacute\0Yacute": -70,
  "Oacute\0Ydieresis": -70,
  "Oacute\0comma": -40,
  "Oacute\0period": -40,
  "Ocircumflex\0A": -20,
  "Ocircumflex\0Aacute": -20,
  "Ocircumflex\0Abreve": -20,
  "Ocircumflex\0Acircumflex": -20,
  "Ocircumflex\0Adieresis": -20,
  "Ocircumflex\0Agrave": -20,
  "Ocircumflex\0Amacron": -20,
  "Ocircumflex\0Aogonek": -20,
  "Ocircumflex\0Aring": -20,
  "Ocircumflex\0Atilde": -20,
  "Ocircumflex\0T": -40,
  "Ocircumflex\0Tcaron": -40,
  "Ocircumflex\0Tcommaaccent": -40,
  "Ocircumflex\0V": -50,
  "Ocircumflex\0W": -30,
  "Ocircumflex\0X": -60,
  "Ocircumflex\0Y": -70,
  "Ocircumflex\0Yacute": -70,
  "Ocircumflex\0Ydieresis": -70,
  "Ocircumflex\0comma": -40,
  "Ocircumflex\0period": -40,
  "Odieresis\0A": -20,
  "Odieresis\0Aacute": -20,
  "Odieresis\0Abreve": -20,
  "Odieresis\0Acircumflex": -20,
  "Odieresis\0Adieresis": -20,
  "Odieresis\0Agrave": -20,
  "Odieresis\0Amacron": -20,
  "Odieresis\0Aogonek": -20,
  "Odieresis\0Aring": -20,
  "Odieresis\0Atilde": -20,
  "Odieresis\0T": -40,
  "Odieresis\0Tcaron": -40,
  "Odieresis\0Tcommaaccent": -40,
  "Odieresis\0V": -50,
  "Odieresis\0W": -30,
  "Odieresis\0X": -60,
  "Odieresis\0Y": -70,
  "Odieresis\0Yacute": -70,
  "Odieresis\0Ydieresis": -70,
  "Odieresis\0comma": -40,
  "Odieresis\0period": -40,
  "Ograve\0A": -20,
  "Ograve\0Aacute": -20,
  "Ograve\0Abreve": -20,
  "Ograve\0Acircumflex": -20,
  "Ograve\0Adieresis": -20,
  "Ograve\0Agrave": -20,
  "Ograve\0Amacron": -20,
  "Ograve\0Aogonek": -20,
  "Ograve\0Aring": -20,
  "Ograve\0Atilde": -20,
  "Ograve\0T": -40,
  "Ograve\0Tcaron": -40,
  "Ograve\0Tcommaaccent": -40,
  "Ograve\0V": -50,
  "Ograve\0W": -30,
  "Ograve\0X": -60,
  "Ograve\0Y": -70,
  "Ograve\0Yacute": -70,
  "Ograve\0Ydieresis": -70,
  "Ograve\0comma": -40,
  "Ograve\0period": -40,
  "Ohungarumlaut\0A": -20,
  "Ohungarumlaut\0Aacute": -20,
  "Ohungarumlaut\0Abreve": -20,
  "Ohungarumlaut\0Acircumflex": -20,
  "Ohungarumlaut\0Adieresis": -20,
  "Ohungarumlaut\0Agrave": -20,
  "Ohungarumlaut\0Amacron": -20,
  "Ohungarumlaut\0Aogonek": -20,
  "Ohungarumlaut\0Aring": -20,
  "Ohungarumlaut\0Atilde": -20,
  "Ohungarumlaut\0T": -40,
  "Ohungarumlaut\0Tcaron": -40,
  "Ohungarumlaut\0Tcommaaccent": -40,
  "Ohungarumlaut\0V": -50,
  "Ohungarumlaut\0W": -30,
  "Ohungarumlaut\0X": -60,
  "Ohungarumlaut\0Y": -70,
  "Ohungarumlaut\0Yacute": -70,
  "Ohungarumlaut\0Ydieresis": -70,
  "Ohungarumlaut\0comma": -40,
  "Ohungarumlaut\0period": -40,
  "Omacron\0A": -20,
  "Omacron\0Aacute": -20,
  "Omacron\0Abreve": -20,
  "Omacron\0Acircumflex": -20,
  "Omacron\0Adieresis": -20,
  "Omacron\0Agrave": -20,
  "Omacron\0Amacron": -20,
  "Omacron\0Aogonek": -20,
  "Omacron\0Aring": -20,
  "Omacron\0Atilde": -20,
  "Omacron\0T": -40,
  "Omacron\0Tcaron": -40,
  "Omacron\0Tcommaaccent": -40,
  "Omacron\0V": -50,
  "Omacron\0W": -30,
  "Omacron\0X": -60,
  "Omacron\0Y": -70,
  "Omacron\0Yacute": -70,
  "Omacron\0Ydieresis": -70,
  "Omacron\0comma": -40,
  "Omacron\0period": -40,
  "Oslash\0A": -20,
  "Oslash\0Aacute": -20,
  "Oslash\0Abreve": -20,
  "Oslash\0Acircumflex": -20,
  "Oslash\0Adieresis": -20,
  "Oslash\0Agrave": -20,
  "Oslash\0Amacron": -20,
  "Oslash\0Aogonek": -20,
  "Oslash\0Aring": -20,
  "Oslash\0Atilde": -20,
  "Oslash\0T": -40,
  "Oslash\0Tcaron": -40,
  "Oslash\0Tcommaaccent": -40,
  "Oslash\0V": -50,
  "Oslash\0W": -30,
  "Oslash\0X": -60,
  "Oslash\0Y": -70,
  "Oslash\0Yacute": -70,
  "Oslash\0Ydieresis": -70,
  "Oslash\0comma": -40,
  "Oslash\0period": -40,
  "Otilde\0A": -20,
  "Otilde\0Aacute": -20,
  "Otilde\0Abreve": -20,
  "Otilde\0Acircumflex": -20,
  "Otilde\0Adieresis": -20,
  "Otilde\0Agrave": -20,
  "Otilde\0Amacron": -20,
  "Otilde\0Aogonek": -20,
  "Otilde\0Aring": -20,
  "Otilde\0Atilde": -20,
  "Otilde\0T": -40,
  "Otilde\0Tcaron": -40,
  "Otilde\0Tcommaaccent": -40,
  "Otilde\0V": -50,
  "Otilde\0W": -30,
  "Otilde\0X": -60,
  "Otilde\0Y": -70,
  "Otilde\0Yacute": -70,
  "Otilde\0Ydieresis": -70,
  "Otilde\0comma": -40,
  "Otilde\0period": -40,
  "P\0A": -120,
  "P\0Aacute": -120,
  "P\0Abreve": -120,
  "P\0Acircumflex": -120,
  "P\0Adieresis": -120,
  "P\0Agrave": -120,
  "P\0Amacron": -120,
  "P\0Aogonek": -120,
  "P\0Aring": -120,
  "P\0Atilde": -120,
  "P\0a": -40,
  "P\0aacute": -40,
  "P\0abreve": -40,
  "P\0acircumflex": -40,
  "P\0adieresis": -40,
  "P\0agrave": -40,
  "P\0amacron": -40,
  "P\0aogonek": -40,
  "P\0aring": -40,
  "P\0atilde": -40,
  "P\0comma": -180,
  "P\0e": -50,
  "P\0eacute": -50,
  "P\0ecaron": -50,
  "P\0ecircumflex": -50,
  "P\0edieresis": -50,
  "P\0edotaccent": -50,
  "P\0egrave": -50,
  "P\0emacron": -50,
  "P\0eogonek": -50,
  "P\0o": -50,
  "P\0oacute": -50,
  "P\0ocircumflex": -50,
  "P\0odieresis": -50,
  "P\0ograve": -50,
  "P\0ohungarumlaut": -50,
  "P\0omacron": -50,
  "P\0oslash": -50,
  "P\0otilde": -50,
  "P\0period": -180,
  "Q\0U": -10,
  "Q\0Uacute": -10,
  "Q\0Ucircumflex": -10,
  "Q\0Udieresis": -10,
  "Q\0Ugrave": -10,
  "Q\0Uhungarumlaut": -10,
  "Q\0Umacron": -10,
  "Q\0Uogonek": -10,
  "Q\0Uring": -10,
  "R\0O": -20,
  "R\0Oacute": -20,
  "R\0Ocircumflex": -20,
  "R\0Odieresis": -20,
  "R\0Ograve": -20,
  "R\0Ohungarumlaut": -20,
  "R\0Omacron": -20,
  "R\0Oslash": -20,
  "R\0Otilde": -20,
  "R\0T": -30,
  "R\0Tcaron": -30,
  "R\0Tcommaaccent": -30,
  "R\0U": -40,
  "R\0Uacute": -40,
  "R\0Ucircumflex": -40,
  "R\0Udieresis": -40,
  "R\0Ugrave": -40,
  "R\0Uhungarumlaut": -40,
  "R\0Umacron": -40,
  "R\0Uogonek": -40,
  "R\0Uring": -40,
  "R\0V": -50,
  "R\0W": -30,
  "R\0Y": -50,
  "R\0Yacute": -50,
  "R\0Ydieresis": -50,
  "Racute\0O": -20,
  "Racute\0Oacute": -20,
  "Racute\0Ocircumflex": -20,
  "Racute\0Odieresis": -20,
  "Racute\0Ograve": -20,
  "Racute\0Ohungarumlaut": -20,
  "Racute\0Omacron": -20,
  "Racute\0Oslash": -20,
  "Racute\0Otilde": -20,
  "Racute\0T": -30,
  "Racute\0Tcaron": -30,
  "Racute\0Tcommaaccent": -30,
  "Racute\0U": -40,
  "Racute\0Uacute": -40,
  "Racute\0Ucircumflex": -40,
  "Racute\0Udieresis": -40,
  "Racute\0Ugrave": -40,
  "Racute\0Uhungarumlaut": -40,
  "Racute\0Umacron": -40,
  "Racute\0Uogonek": -40,
  "Racute\0Uring": -40,
  "Racute\0V": -50,
  "Racute\0W": -30,
  "Racute\0Y": -50,
  "Racute\0Yacute": -50,
  "Racute\0Ydieresis": -50,
  "Rcaron\0O": -20,
  "Rcaron\0Oacute": -20,
  "Rcaron\0Ocircumflex": -20,
  "Rcaron\0Odieresis": -20,
  "Rcaron\0Ograve": -20,
  "Rcaron\0Ohungarumlaut": -20,
  "Rcaron\0Omacron": -20,
  "Rcaron\0Oslash": -20,
  "Rcaron\0Otilde": -20,
  "Rcaron\0T": -30,
  "Rcaron\0Tcaron": -30,
  "Rcaron\0Tcommaaccent": -30,
  "Rcaron\0U": -40,
  "Rcaron\0Uacute": -40,
  "Rcaron\0Ucircumflex": -40,
  "Rcaron\0Udieresis": -40,
  "Rcaron\0Ugrave": -40,
  "Rcaron\0Uhungarumlaut": -40,
  "Rcaron\0Umacron": -40,
  "Rcaron\0Uogonek": -40,
  "Rcaron\0Uring": -40,
  "Rcaron\0V": -50,
  "Rcaron\0W": -30,
  "Rcaron\0Y": -50,
  "Rcaron\0Yacute": -50,
  "Rcaron\0Ydieresis": -50,
  "Rcommaaccent\0O": -20,
  "Rcommaaccent\0Oacute": -20,
  "Rcommaaccent\0Ocircumflex": -20,
  "Rcommaaccent\0Odieresis": -20,
  "Rcommaaccent\0Ograve": -20,
  "Rcommaaccent\0Ohungarumlaut": -20,
  "Rcommaaccent\0Omacron": -20,
  "Rcommaaccent\0Oslash": -20,
  "Rcommaaccent\0Otilde": -20,
  "Rcommaaccent\0T": -30,
  "Rcommaaccent\0Tcaron": -30,
  "Rcommaaccent\0Tcommaaccent": -30,
  "Rcommaaccent\0U": -40,
  "Rcommaaccent\0Uacute": -40,
  "Rcommaaccent\0Ucircumflex": -40,
  "Rcommaaccent\0Udieresis": -40,
  "Rcommaaccent\0Ugrave": -40,
  "Rcommaaccent\0Uhungarumlaut": -40,
  "Rcommaaccent\0Umacron": -40,
  "Rcommaaccent\0Uogonek": -40,
  "Rcommaaccent\0Uring": -40,
  "Rcommaaccent\0V": -50,
  "Rcommaaccent\0W": -30,
  "Rcommaaccent\0Y": -50,
  "Rcommaaccent\0Yacute": -50,
  "Rcommaaccent\0Ydieresis": -50,
  "S\0comma": -20,
  "S\0period": -20,
  "Sacute\0comma": -20,
  "Sacute\0period": -20,
  "Scaron\0comma": -20,
  "Scaron\0period": -20,
  "Scedilla\0comma": -20,
  "Scedilla\0period": -20,
  "Scommaaccent\0comma": -20,
  "Scommaaccent\0period": -20,
  "T\0A": -120,
  "T\0Aacute": -120,
  "T\0Abreve": -120,
  "T\0Acircumflex": -120,
  "T\0Adieresis": -120,
  "T\0Agrave": -120,
  "T\0Amacron": -120,
  "T\0Aogonek": -120,
  "T\0Aring": -120,
  "T\0Atilde": -120,
  "T\0O": -40,
  "T\0Oacute": -40,
  "T\0Ocircumflex": -40,
  "T\0Odieresis": -40,
  "T\0Ograve": -40,
  "T\0Ohungarumlaut": -40,
  "T\0Omacron": -40,
  "T\0Oslash": -40,
  "T\0Otilde": -40,
  "T\0a": -120,
  "T\0aacute": -120,
  "T\0abreve": -60,
  "T\0acircumflex": -120,
  "T\0adieresis": -120,
  "T\0agrave": -120,
  "T\0amacron": -60,
  "T\0aogonek": -120,
  "T\0aring": -120,
  "T\0atilde": -60,
  "T\0colon": -20,
  "T\0comma": -120,
  "T\0e": -120,
  "T\0eacute": -120,
  "T\0ecaron": -120,
  "T\0ecircumflex": -120,
  "T\0edieresis": -120,
  "T\0edotaccent": -120,
  "T\0egrave": -60,
  "T\0emacron": -60,
  "T\0eogonek": -120,
  "T\0hyphen": -140,
  "T\0o": -120,
  "T\0oacute": -120,
  "T\0ocircumflex": -120,
  "T\0odieresis": -120,
  "T\0ograve": -120,
  "T\0ohungarumlaut": -120,
  "T\0omacron": -60,
  "T\0oslash": -120,
  "T\0otilde": -60,
  "T\0period": -120,
  "T\0r": -120,
  "T\0racute": -120,
  "T\0rcaron": -120,
  "T\0rcommaaccent": -120,
  "T\0semicolon": -20,
  "T\0u": -120,
  "T\0uacute": -120,
  "T\0ucircumflex": -120,
  "T\0udieresis": -120,
  "T\0ugrave": -120,
  "T\0uhungarumlaut": -120,
  "T\0umacron": -60,
  "T\0uogonek": -120,
  "T\0uring": -120,
  "T\0w": -120,
  "T\0y": -120,
  "T\0yacute": -120,
  "T\0ydieresis": -60,
  "Tcaron\0A": -120,
  "Tcaron\0Aacute": -120,
  "Tcaron\0Abreve": -120,
  "Tcaron\0Acircumflex": -120,
  "Tcaron\0Adieresis": -120,
  "Tcaron\0Agrave": -120,
  "Tcaron\0Amacron": -120,
  "Tcaron\0Aogonek": -120,
  "Tcaron\0Aring": -120,
  "Tcaron\0Atilde": -120,
  "Tcaron\0O": -40,
  "Tcaron\0Oacute": -40,
  "Tcaron\0Ocircumflex": -40,
  "Tcaron\0Odieresis": -40,
  "Tcaron\0Ograve": -40,
  "Tcaron\0Ohungarumlaut": -40,
  "Tcaron\0Omacron": -40,
  "Tcaron\0Oslash": -40,
  "Tcaron\0Otilde": -40,
  "Tcaron\0a": -120,
  "Tcaron\0aacute": -120,
  "Tcaron\0abreve": -60,
  "Tcaron\0acircumflex": -120,
  "Tcaron\0adieresis": -120,
  "Tcaron\0agrave": -120,
  "Tcaron\0amacron": -60,
  "Tcaron\0aogonek": -120,
  "Tcaron\0aring": -120,
  "Tcaron\0atilde": -60,
  "Tcaron\0colon": -20,
  "Tcaron\0comma": -120,
  "Tcaron\0e": -120,
  "Tcaron\0eacute": -120,
  "Tcaron\0ecaron": -120,
  "Tcaron\0ecircumflex": -120,
  "Tcaron\0edieresis": -120,
  "Tcaron\0edotaccent": -120,
  "Tcaron\0egrave": -60,
  "Tcaron\0emacron": -60,
  "Tcaron\0eogonek": -120,
  "Tcaron\0hyphen": -140,
  "Tcaron\0o": -120,
  "Tcaron\0oacute": -120,
  "Tcaron\0ocircumflex": -120,
  "Tcaron\0odieresis": -120,
  "Tcaron\0ograve": -120,
  "Tcaron\0ohungarumlaut": -120,
  "Tcaron\0omacron": -60,
  "Tcaron\0oslash": -120,
  "Tcaron\0otilde": -60,
  "Tcaron\0period": -120,
  "Tcaron\0r": -120,
  "Tcaron\0racute": -120,
  "Tcaron\0rcaron": -120,
  "Tcaron\0rcommaaccent": -120,
  "Tcaron\0semicolon": -20,
  "Tcaron\0u": -120,
  "Tcaron\0uacute": -120,
  "Tcaron\0ucircumflex": -120,
  "Tcaron\0udieresis": -120,
  "Tcaron\0ugrave": -120,
  "Tcaron\0uhungarumlaut": -120,
  "Tcaron\0umacron": -60,
  "Tcaron\0uogonek": -120,
  "Tcaron\0uring": -120,
  "Tcaron\0w": -120,
  "Tcaron\0y": -120,
  "Tcaron\0yacute": -120,
  "Tcaron\0ydieresis": -60,
  "Tcommaaccent\0A": -120,
  "Tcommaaccent\0Aacute": -120,
  "Tcommaaccent\0Abreve": -120,
  "Tcommaaccent\0Acircumflex": -120,
  "Tcommaaccent\0Adieresis": -120,
  "Tcommaaccent\0Agrave": -120,
  "Tcommaaccent\0Amacron": -120,
  "Tcommaaccent\0Aogonek": -120,
  "Tcommaaccent\0Aring": -120,
  "Tcommaaccent\0Atilde": -120,
  "Tcommaaccent\0O": -40,
  "Tcommaaccent\0Oacute": -40,
  "Tcommaaccent\0Ocircumflex": -40,
  "Tcommaaccent\0Odieresis": -40,
  "Tcommaaccent\0Ograve": -40,
  "Tcommaaccent\0Ohungarumlaut": -40,
  "Tcommaaccent\0Omacron": -40,
  "Tcommaaccent\0Oslash": -40,
  "Tcommaaccent\0Otilde": -40,
  "Tcommaaccent\0a": -120,
  "Tcommaaccent\0aacute": -120,
  "Tcommaaccent\0abreve": -60,
  "Tcommaaccent\0acircumflex": -120,
  "Tcommaaccent\0adieresis": -120,
  "Tcommaaccent\0agrave": -120,
  "Tcommaaccent\0amacron": -60,
  "Tcommaaccent\0aogonek": -120,
  "Tcommaaccent\0aring": -120,
  "Tcommaaccent\0atilde": -60,
  "Tcommaaccent\0colon": -20,
  "Tcommaaccent\0comma": -120,
  "Tcommaaccent\0e": -120,
  "Tcommaaccent\0eacute": -120,
  "Tcommaaccent\0ecaron": -120,
  "Tcommaaccent\0ecircumflex": -120,
  "Tcommaaccent\0edieresis": -120,
  "Tcommaaccent\0edotaccent": -120,
  "Tcommaaccent\0egrave": -60,
  "Tcommaaccent\0emacron": -60,
  "Tcommaaccent\0eogonek": -120,
  "Tcommaaccent\0hyphen": -140,
  "Tcommaaccent\0o": -120,
  "Tcommaaccent\0oacute": -120,
  "Tcommaaccent\0ocircumflex": -120,
  "Tcommaaccent\0odieresis": -120,
  "Tcommaaccent\0ograve": -120,
  "Tcommaaccent\0ohungarumlaut": -120,
  "Tcommaaccent\0omacron": -60,
  "Tcommaaccent\0oslash": -120,
  "Tcommaaccent\0otilde": -60,
  "Tcommaaccent\0period": -120,
  "Tcommaaccent\0r": -120,
  "Tcommaaccent\0racute": -120,
  "Tcommaaccent\0rcaron": -120,
  "Tcommaaccent\0rcommaaccent": -120,
  "Tcommaaccent\0semicolon": -20,
  "Tcommaaccent\0u": -120,
  "Tcommaaccent\0uacute": -120,
  "Tcommaaccent\0ucircumflex": -120,
  "Tcommaaccent\0udieresis": -120,
  "Tcommaaccent\0ugrave": -120,
  "Tcommaaccent\0uhungarumlaut": -120,
  "Tcommaaccent\0umacron": -60,
  "Tcommaaccent\0uogonek": -120,
  "Tcommaaccent\0uring": -120,
  "Tcommaaccent\0w": -120,
  "Tcommaaccent\0y": -120,
  "Tcommaaccent\0yacute": -120,
  "Tcommaaccent\0ydieresis": -60,
  "U\0A": -40,
  "U\0Aacute": -40,
  "U\0Abreve": -40,
  "U\0Acircumflex": -40,
  "U\0Adieresis": -40,
  "U\0Agrave": -40,
  "U\0Amacron": -40,
  "U\0Aogonek": -40,
  "U\0Aring": -40,
  "U\0Atilde": -40,
  "U\0comma": -40,
  "U\0period": -40,
  "Uacute\0A": -40,
  "Uacute\0Aacute": -40,
  "Uacute\0Abreve": -40,
  "Uacute\0Acircumflex": -40,
  "Uacute\0Adieresis": -40,
  "Uacute\0Agrave": -40,
  "Uacute\0Amacron": -40,
  "Uacute\0Aogonek": -40,
  "Uacute\0Aring": -40,
  "Uacute\0Atilde": -40,
  "Uacute\0comma": -40,
  "Uacute\0period": -40,
  "Ucircumflex\0A": -40,
  "Ucircumflex\0Aacute": -40,
  "Ucircumflex\0Abreve": -40,
  "Ucircumflex\0Acircumflex": -40,
  "Ucircumflex\0Adieresis": -40,
  "Ucircumflex\0Agrave": -40,
  "Ucircumflex\0Amacron": -40,
  "Ucircumflex\0Aogonek": -40,
  "Ucircumflex\0Aring": -40,
  "Ucircumflex\0Atilde": -40,
  "Ucircumflex\0comma": -40,
  "Ucircumflex\0period": -40,
  "Udieresis\0A": -40,
  "Udieresis\0Aacute": -40,
  "Udieresis\0Abreve": -40,
  "Udieresis\0Acircumflex": -40,
  "Udieresis\0Adieresis": -40,
  "Udieresis\0Agrave": -40,
  "Udieresis\0Amacron": -40,
  "Udieresis\0Aogonek": -40,
  "Udieresis\0Aring": -40,
  "Udieresis\0Atilde": -40,
  "Udieresis\0comma": -40,
  "Udieresis\0period": -40,
  "Ugrave\0A": -40,
  "Ugrave\0Aacute": -40,
  "Ugrave\0Abreve": -40,
  "Ugrave\0Acircumflex": -40,
  "Ugrave\0Adieresis": -40,
  "Ugrave\0Agrave": -40,
  "Ugrave\0Amacron": -40,
  "Ugrave\0Aogonek": -40,
  "Ugrave\0Aring": -40,
  "Ugrave\0Atilde": -40,
  "Ugrave\0comma": -40,
  "Ugrave\0period": -40,
  "Uhungarumlaut\0A": -40,
  "Uhungarumlaut\0Aacute": -40,
  "Uhungarumlaut\0Abreve": -40,
  "Uhungarumlaut\0Acircumflex": -40,
  "Uhungarumlaut\0Adieresis": -40,
  "Uhungarumlaut\0Agrave": -40,
  "Uhungarumlaut\0Amacron": -40,
  "Uhungarumlaut\0Aogonek": -40,
  "Uhungarumlaut\0Aring": -40,
  "Uhungarumlaut\0Atilde": -40,
  "Uhungarumlaut\0comma": -40,
  "Uhungarumlaut\0period": -40,
  "Umacron\0A": -40,
  "Umacron\0Aacute": -40,
  "Umacron\0Abreve": -40,
  "Umacron\0Acircumflex": -40,
  "Umacron\0Adieresis": -40,
  "Umacron\0Agrave": -40,
  "Umacron\0Amacron": -40,
  "Umacron\0Aogonek": -40,
  "Umacron\0Aring": -40,
  "Umacron\0Atilde": -40,
  "Umacron\0comma": -40,
  "Umacron\0period": -40,
  "Uogonek\0A": -40,
  "Uogonek\0Aacute": -40,
  "Uogonek\0Abreve": -40,
  "Uogonek\0Acircumflex": -40,
  "Uogonek\0Adieresis": -40,
  "Uogonek\0Agrave": -40,
  "Uogonek\0Amacron": -40,
  "Uogonek\0Aogonek": -40,
  "Uogonek\0Aring": -40,
  "Uogonek\0Atilde": -40,
  "Uogonek\0comma": -40,
  "Uogonek\0period": -40,
  "Uring\0A": -40,
  "Uring\0Aacute": -40,
  "Uring\0Abreve": -40,
  "Uring\0Acircumflex": -40,
  "Uring\0Adieresis": -40,
  "Uring\0Agrave": -40,
  "Uring\0Amacron": -40,
  "Uring\0Aogonek": -40,
  "Uring\0Aring": -40,
  "Uring\0Atilde": -40,
  "Uring\0comma": -40,
  "Uring\0period": -40,
  "V\0A": -80,
  "V\0Aacute": -80,
  "V\0Abreve": -80,
  "V\0Acircumflex": -80,
  "V\0Adieresis": -80,
  "V\0Agrave": -80,
  "V\0Amacron": -80,
  "V\0Aogonek": -80,
  "V\0Aring": -80,
  "V\0Atilde": -80,
  "V\0G": -40,
  "V\0Gbreve": -40,
  "V\0Gcommaaccent": -40,
  "V\0O": -40,
  "V\0Oacute": -40,
  "V\0Ocircumflex": -40,
  "V\0Odieresis": -40,
  "V\0Ograve": -40,
  "V\0Ohungarumlaut": -40,
  "V\0Omacron": -40,
  "V\0Oslash": -40,
  "V\0Otilde": -40,
  "V\0a": -70,
  "V\0aacute": -70,
  "V\0abreve": -70,
  "V\0acircumflex": -70,
  "V\0adieresis": -70,
  "V\0agrave": -70,
  "V\0amacron": -70,
  "V\0aogonek": -70,
  "V\0aring": -70,
  "V\0atilde": -70,
  "V\0colon": -40,
  "V\0comma": -125,
  "V\0e": -80,
  "V\0eacute": -80,
  "V\0ecaron": -80,
  "V\0ecircumflex": -80,
  "V\0edieresis": -80,
  "V\0edotaccent": -80,
  "V\0egrave": -80,
  "V\0emacron": -80,
  "V\0eogonek": -80,
  "V\0hyphen": -80,
  "V\0o": -80,
  "V\0oacute": -80,
  "V\0ocircumflex": -80,
  "V\0odieresis": -80,
  "V\0ograve": -80,
  "V\0ohungarumlaut": -80,
  "V\0omacron": -80,
  "V\0oslash": -80,
  "V\0otilde": -80,
  "V\0period": -125,
  "V\0semicolon": -40,
  "V\0u": -70,
  "V\0uacute": -70,
  "V\0ucircumflex": -70,
  "V\0udieresis": -70,
  "V\0ugrave": -70,
  "V\0uhungarumlaut": -70,
  "V\0umacron": -70,
  "V\0uogonek": -70,
  "V\0uring": -70,
  "W\0A": -50,
  "W\0Aacute": -50,
  "W\0Abreve": -50,
  "W\0Acircumflex": -50,
  "W\0Adieresis": -50,
  "W\0Agrave": -50,
  "W\0Amacron": -50,
  "W\0Aogonek": -50,
  "W\0Aring": -50,
  "W\0Atilde": -50,
  "W\0O": -20,
  "W\0Oacute": -20,
  "W\0Ocircumflex": -20,
  "W\0Odieresis": -20,
  "W\0Ograve": -20,
  "W\0Ohungarumlaut": -20,
  "W\0Omacron": -20,
  "W\0Oslash": -20,
  "W\0Otilde": -20,
  "W\0a": -40,
  "W\0aacute": -40,
  "W\0abreve": -40,
  "W\0acircumflex": -40,
  "W\0adieresis": -40,
  "W\0agrave": -40,
  "W\0amacron": -40,
  "W\0aogonek": -40,
  "W\0aring": -40,
  "W\0atilde": -40,
  "W\0comma": -80,
  "W\0e": -30,
  "W\0eacute": -30,
  "W\0ecaron": -30,
  "W\0ecircumflex": -30,
  "W\0edieresis": -30,
  "W\0edotaccent": -30,
  "W\0egrave": -30,
  "W\0emacron": -30,
  "W\0eogonek": -30,
  "W\0hyphen": -40,
  "W\0o": -30,
  "W\0oacute": -30,
  "W\0ocircumflex": -30,
  "W\0odieresis": -30,
  "W\0ograve": -30,
  "W\0ohungarumlaut": -30,
  "W\0omacron": -30,
  "W\0oslash": -30,
  "W\0otilde": -30,
  "W\0period": -80,
  "W\0u": -30,
  "W\0uacute": -30,
  "W\0ucircumflex": -30,
  "W\0udieresis": -30,
  "W\0ugrave": -30,
  "W\0uhungarumlaut": -30,
  "W\0umacron": -30,
  "W\0uogonek": -30,
  "W\0uring": -30,
  "W\0y": -20,
  "W\0yacute": -20,
  "W\0ydieresis": -20,
  "Y\0A": -110,
  "Y\0Aacute": -110,
  "Y\0Abreve": -110,
  "Y\0Acircumflex": -110,
  "Y\0Adieresis": -110,
  "Y\0Agrave": -110,
  "Y\0Amacron": -110,
  "Y\0Aogonek": -110,
  "Y\0Aring": -110,
  "Y\0Atilde": -110,
  "Y\0O": -85,
  "Y\0Oacute": -85,
  "Y\0Ocircumflex": -85,
  "Y\0Odieresis": -85,
  "Y\0Ograve": -85,
  "Y\0Ohungarumlaut": -85,
  "Y\0Omacron": -85,
  "Y\0Oslash": -85,
  "Y\0Otilde": -85,
  "Y\0a": -140,
  "Y\0aacute": -140,
  "Y\0abreve": -70,
  "Y\0acircumflex": -140,
  "Y\0adieresis": -140,
  "Y\0agrave": -140,
  "Y\0amacron": -70,
  "Y\0aogonek": -140,
  "Y\0aring": -140,
  "Y\0atilde": -140,
  "Y\0colon": -60,
  "Y\0comma": -140,
  "Y\0e": -140,
  "Y\0eacute": -140,
  "Y\0ecaron": -140,
  "Y\0ecircumflex": -140,
  "Y\0edieresis": -140,
  "Y\0edotaccent": -140,
  "Y\0egrave": -140,
  "Y\0emacron": -70,
  "Y\0eogonek": -140,
  "Y\0hyphen": -140,
  "Y\0i": -20,
  "Y\0iacute": -20,
  "Y\0iogonek": -20,
  "Y\0o": -140,
  "Y\0oacute": -140,
  "Y\0ocircumflex": -140,
  "Y\0odieresis": -140,
  "Y\0ograve": -140,
  "Y\0ohungarumlaut": -140,
  "Y\0omacron": -140,
  "Y\0oslash": -140,
  "Y\0otilde": -140,
  "Y\0period": -140,
  "Y\0semicolon": -60,
  "Y\0u": -110,
  "Y\0uacute": -110,
  "Y\0ucircumflex": -110,
  "Y\0udieresis": -110,
  "Y\0ugrave": -110,
  "Y\0uhungarumlaut": -110,
  "Y\0umacron": -110,
  "Y\0uogonek": -110,
  "Y\0uring": -110,
  "Yacute\0A": -110,
  "Yacute\0Aacute": -110,
  "Yacute\0Abreve": -110,
  "Yacute\0Acircumflex": -110,
  "Yacute\0Adieresis": -110,
  "Yacute\0Agrave": -110,
  "Yacute\0Amacron": -110,
  "Yacute\0Aogonek": -110,
  "Yacute\0Aring": -110,
  "Yacute\0Atilde": -110,
  "Yacute\0O": -85,
  "Yacute\0Oacute": -85,
  "Yacute\0Ocircumflex": -85,
  "Yacute\0Odieresis": -85,
  "Yacute\0Ograve": -85,
  "Yacute\0Ohungarumlaut": -85,
  "Yacute\0Omacron": -85,
  "Yacute\0Oslash": -85,
  "Yacute\0Otilde": -85,
  "Yacute\0a": -140,
  "Yacute\0aacute": -140,
  "Yacute\0abreve": -70,
  "Yacute\0acircumflex": -140,
  "Yacute\0adieresis": -140,
  "Yacute\0agrave": -140,
  "Yacute\0amacron": -70,
  "Yacute\0aogonek": -140,
  "Yacute\0aring": -140,
  "Yacute\0atilde": -70,
  "Yacute\0colon": -60,
  "Yacute\0comma": -140,
  "Yacute\0e": -140,
  "Yacute\0eacute": -140,
  "Yacute\0ecaron": -140,
  "Yacute\0ecircumflex": -140,
  "Yacute\0edieresis": -140,
  "Yacute\0edotaccent": -140,
  "Yacute\0egrave": -140,
  "Yacute\0emacron": -70,
  "Yacute\0eogonek": -140,
  "Yacute\0hyphen": -140,
  "Yacute\0i": -20,
  "Yacute\0iacute": -20,
  "Yacute\0iogonek": -20,
  "Yacute\0o": -140,
  "Yacute\0oacute": -140,
  "Yacute\0ocircumflex": -140,
  "Yacute\0odieresis": -140,
  "Yacute\0ograve": -140,
  "Yacute\0ohungarumlaut": -140,
  "Yacute\0omacron": -70,
  "Yacute\0oslash": -140,
  "Yacute\0otilde": -140,
  "Yacute\0period": -140,
  "Yacute\0semicolon": -60,
  "Yacute\0u": -110,
  "Yacute\0uacute": -110,
  "Yacute\0ucircumflex": -110,
  "Yacute\0udieresis": -110,
  "Yacute\0ugrave": -110,
  "Yacute\0uhungarumlaut": -110,
  "Yacute\0umacron": -110,
  "Yacute\0uogonek": -110,
  "Yacute\0uring": -110,
  "Ydieresis\0A": -110,
  "Ydieresis\0Aacute": -110,
  "Ydieresis\0Abreve": -110,
  "Ydieresis\0Acircumflex": -110,
  "Ydieresis\0Adieresis": -110,
  "Ydieresis\0Agrave": -110,
  "Ydieresis\0Amacron": -110,
  "Ydieresis\0Aogonek": -110,
  "Ydieresis\0Aring": -110,
  "Ydieresis\0Atilde": -110,
  "Ydieresis\0O": -85,
  "Ydieresis\0Oacute": -85,
  "Ydieresis\0Ocircumflex": -85,
  "Ydieresis\0Odieresis": -85,
  "Ydieresis\0Ograve": -85,
  "Ydieresis\0Ohungarumlaut": -85,
  "Ydieresis\0Omacron": -85,
  "Ydieresis\0Oslash": -85,
  "Ydieresis\0Otilde": -85,
  "Ydieresis\0a": -140,
  "Ydieresis\0aacute": -140,
  "Ydieresis\0abreve": -70,
  "Ydieresis\0acircumflex": -140,
  "Ydieresis\0adieresis": -140,
  "Ydieresis\0agrave": -140,
  "Ydieresis\0amacron": -70,
  "Ydieresis\0aogonek": -140,
  "Ydieresis\0aring": -140,
  "Ydieresis\0atilde": -70,
  "Ydieresis\0colon": -60,
  "Ydieresis\0comma": -140,
  "Ydieresis\0e": -140,
  "Ydieresis\0eacute": -140,
  "Ydieresis\0ecaron": -140,
  "Ydieresis\0ecircumflex": -140,
  "Ydieresis\0edieresis": -140,
  "Ydieresis\0edotaccent": -140,
  "Ydieresis\0egrave": -140,
  "Ydieresis\0emacron": -70,
  "Ydieresis\0eogonek": -140,
  "Ydieresis\0hyphen": -140,
  "Ydieresis\0i": -20,
  "Ydieresis\0iacute": -20,
  "Ydieresis\0iogonek": -20,
  "Ydieresis\0o": -140,
  "Ydieresis\0oacute": -140,
  "Ydieresis\0ocircumflex": -140,
  "Ydieresis\0odieresis": -140,
  "Ydieresis\0ograve": -140,
  "Ydieresis\0ohungarumlaut": -140,
  "Ydieresis\0omacron": -140,
  "Ydieresis\0oslash": -140,
  "Ydieresis\0otilde": -140,
  "Ydieresis\0period": -140,
  "Ydieresis\0semicolon": -60,
  "Ydieresis\0u": -110,
  "Ydieresis\0uacute": -110,
  "Ydieresis\0ucircumflex": -110,
  "Ydieresis\0udieresis": -110,
  "Ydieresis\0ugrave": -110,
  "Ydieresis\0uhungarumlaut": -110,
  "Ydieresis\0umacron": -110,
  "Ydieresis\0uogonek": -110,
  "Ydieresis\0uring": -110,
  "a\0v": -20,
  "a\0w": -20,
  "a\0y": -30,
  "a\0yacute": -30,
  "a\0ydieresis": -30,
  "aacute\0v": -20,
  "aacute\0w": -20,
  "aacute\0y": -30,
  "aacute\0yacute": -30,
  "aacute\0ydieresis": -30,
  "abreve\0v": -20,
  "abreve\0w": -20,
  "abreve\0y": -30,
  "abreve\0yacute": -30,
  "abreve\0ydieresis": -30,
  "acircumflex\0v": -20,
  "acircumflex\0w": -20,
  "acircumflex\0y": -30,
  "acircumflex\0yacute": -30,
  "acircumflex\0ydieresis": -30,
  "adieresis\0v": -20,
  "adieresis\0w": -20,
  "adieresis\0y": -30,
  "adieresis\0yacute": -30,
  "adieresis\0ydieresis": -30,
  "agrave\0v": -20,
  "agrave\0w": -20,
  "agrave\0y": -30,
  "agrave\0yacute": -30,
  "agrave\0ydieresis": -30,
  "amacron\0v": -20,
  "amacron\0w": -20,
  "amacron\0y": -30,
  "amacron\0yacute": -30,
  "amacron\0ydieresis": -30,
  "aogonek\0v": -20,
  "aogonek\0w": -20,
  "aogonek\0y": -30,
  "aogonek\0yacute": -30,
  "aogonek\0ydieresis": -30,
  "aring\0v": -20,
  "aring\0w": -20,
  "aring\0y": -30,
  "aring\0yacute": -30,
  "aring\0ydieresis": -30,
  "atilde\0v": -20,
  "atilde\0w": -20,
  "atilde\0y": -30,
  "atilde\0yacute": -30,
  "atilde\0ydieresis": -30,
  "b\0b": -10,
  "b\0comma": -40,
  "b\0l": -20,
  "b\0lacute": -20,
  "b\0lcommaaccent": -20,
  "b\0lslash": -20,
  "b\0period": -40,
  "b\0u": -20,
  "b\0uacute": -20,
  "b\0ucircumflex": -20,
  "b\0udieresis": -20,
  "b\0ugrave": -20,
  "b\0uhungarumlaut": -20,
  "b\0umacron": -20,
  "b\0uogonek": -20,
  "b\0uring": -20,
  "b\0v": -20,
  "b\0y": -20,
  "b\0yacute": -20,
  "b\0ydieresis": -20,
  "c\0comma": -15,
  "c\0k": -20,
  "c\0kcommaaccent": -20,
  "cacute\0comma": -15,
  "cacute\0k": -20,
  "cacute\0kcommaaccent": -20,
  "ccaron\0comma": -15,
  "ccaron\0k": -20,
  "ccaron\0kcommaaccent": -20,
  "ccedilla\0comma": -15,
  "ccedilla\0k": -20,
  "ccedilla\0kcommaaccent": -20,
  "colon\0space": -50,
  "comma\0quotedblright": -100,
  "comma\0quoteright": -100,
  "e\0comma": -15,
  "e\0period": -15,
  "e\0v": -30,
  "e\0w": -20,
  "e\0x": -30,
  "e\0y": -20,
  "e\0yacute": -20,
  "e\0ydieresis": -20,
  "eacute\0comma": -15,
  "eacute\0period": -15,
  "eacute\0v": -30,
  "eacute\0w": -20,
  "eacute\0x": -30,
  "eacute\0y": -20,
  "eacute\0yacute": -20,
  "eacute\0ydieresis": -20,
  "ecaron\0comma": -15,
  "ecaron\0period": -15,
  "ecaron\0v": -30,
  "ecaron\0w": -20,
  "ecaron\0x": -30,
  "ecaron\0y": -20,
  "ecaron\0yacute": -20,
  "ecaron\0ydieresis": -20,
  "ecircumflex\0comma": -15,
  "ecircumflex\0period": -15,
  "ecircumflex\0v": -30,
  "ecircumflex\0w": -20,
  "ecircumflex\0x": -30,
  "ecircumflex\0y": -20,
  "ecircumflex\0yacute": -20,
  "ecircumflex\0ydieresis": -20,
  "edieresis\0comma": -15,
  "edieresis\0period": -15,
  "edieresis\0v": -30,
  "edieresis\0w": -20,
  "edieresis\0x": -30,
  "edieresis\0y": -20,
  "edieresis\0yacute": -20,
  "edieresis\0ydieresis": -20,
  "edotaccent\0comma": -15,
  "edotaccent\0period": -15,
  "edotaccent\0v": -30,
  "edotaccent\0w": -20,
  "edotaccent\0x": -30,
  "edotaccent\0y": -20,
  "edotaccent\0yacute": -20,
  "edotaccent\0ydieresis": -20,
  "egrave\0comma": -15,
  "egrave\0period": -15,
  "egrave\0v": -30,
  "egrave\0w": -20,
  "egrave\0x": -30,
  "egrave\0y": -20,
  "egrave\0yacute": -20,
  "egrave\0ydieresis": -20,
  "emacron\0comma": -15,
  "emacron\0period": -15,
  "emacron\0v": -30,
  "emacron\0w": -20,
  "emacron\0x": -30,
  "emacron\0y": -20,
  "emacron\0yacute": -20,
  "emacron\0ydieresis": -20,
  "eogonek\0comma": -15,
  "eogonek\0period": -15,
  "eogonek\0v": -30,
  "eogonek\0w": -20,
  "eogonek\0x": -30,
  "eogonek\0y": -20,
  "eogonek\0yacute": -20,
  "eogonek\0ydieresis": -20,
  "f\0a": -30,
  "f\0aacute": -30,
  "f\0abreve": -30,
  "f\0acircumflex": -30,
  "f\0adieresis": -30,
  "f\0agrave": -30,
  "f\0amacron": -30,
  "f\0aogonek": -30,
  "f\0aring": -30,
  "f\0atilde": -30,
  "f\0comma": -30,
  "f\0dotlessi": -28,
  "f\0e": -30,
  "f\0eacute": -30,
  "f\0ecaron": -30,
  "f\0ecircumflex": -30,
  "f\0edieresis": -30,
  "f\0edotaccent": -30,
  "f\0egrave": -30,
  "f\0emacron": -30,
  "f\0eogonek": -30,
  "f\0o": -30,
  "f\0oacute": -30,
  "f\0ocircumflex": -30,
  "f\0odieresis": -30,
  "f\0ograve": -30,
  "f\0ohungarumlaut": -30,
  "f\0omacron": -30,
  "f\0oslash": -30,
  "f\0otilde": -30,
  "f\0period": -30,
  "f\0quotedblright": 60,
  "f\0quoteright": 50,
  "g\0r": -10,
  "g\0racute": -10,
  "g\0rcaron": -10,
  "g\0rcommaaccent": -10,
  "gbreve\0r": -10,
  "gbreve\0racute": -10,
  "gbreve\0rcaron": -10,
  "gbreve\0rcommaaccent": -10,
  "gcommaaccent\0r": -10,
  "gcommaaccent\0racute": -10,
  "gcommaaccent\0rcaron": -10,
  "gcommaaccent\0rcommaaccent": -10,
  "h\0y": -30,
  "h\0yacute": -30,
  "h\0ydieresis": -30,
  "k\0e": -20,
  "k\0eacute": -20,
  "k\0ecaron": -20,
  "k\0ecircumflex": -20,
  "k\0edieresis": -20,
  "k\0edotaccent": -20,
  "k\0egrave": -20,
  "k\0emacron": -20,
  "k\0eogonek": -20,
  "k\0o": -20,
  "k\0oacute": -20,
  "k\0ocircumflex": -20,
  "k\0odieresis": -20,
  "k\0ograve": -20,
  "k\0ohungarumlaut": -20,
  "k\0omacron": -20,
  "k\0oslash": -20,
  "k\0otilde": -20,
  "kcommaaccent\0e": -20,
  "kcommaaccent\0eacute": -20,
  "kcommaaccent\0ecaron": -20,
  "kcommaaccent\0ecircumflex": -20,
  "kcommaaccent\0edieresis": -20,
  "kcommaaccent\0edotaccent": -20,
  "kcommaaccent\0egrave": -20,
  "kcommaaccent\0emacron": -20,
  "kcommaaccent\0eogonek": -20,
  "kcommaaccent\0o": -20,
  "kcommaaccent\0oacute": -20,
  "kcommaaccent\0ocircumflex": -20,
  "kcommaaccent\0odieresis": -20,
  "kcommaaccent\0ograve": -20,
  "kcommaaccent\0ohungarumlaut": -20,
  "kcommaaccent\0omacron": -20,
  "kcommaaccent\0oslash": -20,
  "kcommaaccent\0otilde": -20,
  "m\0u": -10,
  "m\0uacute": -10,
  "m\0ucircumflex": -10,
  "m\0udieresis": -10,
  "m\0ugrave": -10,
  "m\0uhungarumlaut": -10,
  "m\0umacron": -10,
  "m\0uogonek": -10,
  "m\0uring": -10,
  "m\0y": -15,
  "m\0yacute": -15,
  "m\0ydieresis": -15,
  "n\0u": -10,
  "n\0uacute": -10,
  "n\0ucircumflex": -10,
  "n\0udieresis": -10,
  "n\0ugrave": -10,
  "n\0uhungarumlaut": -10,
  "n\0umacron": -10,
  "n\0uogonek": -10,
  "n\0uring": -10,
  "n\0v": -20,
  "n\0y": -15,
  "n\0yacute": -15,
  "n\0ydieresis": -15,
  "nacute\0u": -10,
  "nacute\0uacute": -10,
  "nacute\0ucircumflex": -10,
  "nacute\0udieresis": -10,
  "nacute\0ugrave": -10,
  "nacute\0uhungarumlaut": -10,
  "nacute\0umacron": -10,
  "nacute\0uogonek": -10,
  "nacute\0uring": -10,
  "nacute\0v": -20,
  "nacute\0y": -15,
  "nacute\0yacute": -15,
  "nacute\0ydieresis": -15,
  "ncaron\0u": -10,
  "ncaron\0uacute": -10,
  "ncaron\0ucircumflex": -10,
  "ncaron\0udieresis": -10,
  "ncaron\0ugrave": -10,
  "ncaron\0uhungarumlaut": -10,
  "ncaron\0umacron": -10,
  "ncaron\0uogonek": -10,
  "ncaron\0uring": -10,
  "ncaron\0v": -20,
  "ncaron\0y": -15,
  "ncaron\0yacute": -15,
  "ncaron\0ydieresis": -15,
  "ncommaaccent\0u": -10,
  "ncommaaccent\0uacute": -10,
  "ncommaaccent\0ucircumflex": -10,
  "ncommaaccent\0udieresis": -10,
  "ncommaaccent\0ugrave": -10,
  "ncommaaccent\0uhungarumlaut": -10,
  "ncommaaccent\0umacron": -10,
  "ncommaaccent\0uogonek": -10,
  "ncommaaccent\0uring": -10,
  "ncommaaccent\0v": -20,
  "ncommaaccent\0y": -15,
  "ncommaaccent\0yacute": -15,
  "ncommaaccent\0ydieresis": -15,
  "ntilde\0u": -10,
  "ntilde\0uacute": -10,
  "ntilde\0ucircumflex": -10,
  "ntilde\0udieresis": -10,
  "ntilde\0ugrave": -10,
  "ntilde\0uhungarumlaut": -10,
  "ntilde\0umacron": -10,
  "ntilde\0uogonek": -10,
  "ntilde\0uring": -10,
  "ntilde\0v": -20,
  "ntilde\0y": -15,
  "ntilde\0yacute": -15,
  "ntilde\0ydieresis": -15,
  "o\0comma": -40,
  "o\0period": -40,
  "o\0v": -15,
  "o\0w": -15,
  "o\0x": -30,
  "o\0y": -30,
  "o\0yacute": -30,
  "o\0ydieresis": -30,
  "oacute\0comma": -40,
  "oacute\0period": -40,
  "oacute\0v": -15,
  "oacute\0w": -15,
  "oacute\0x": -30,
  "oacute\0y": -30,
  "oacute\0yacute": -30,
  "oacute\0ydieresis": -30,
  "ocircumflex\0comma": -40,
  "ocircumflex\0period": -40,
  "ocircumflex\0v": -15,
  "ocircumflex\0w": -15,
  "ocircumflex\0x": -30,
  "ocircumflex\0y": -30,
  "ocircumflex\0yacute": -30,
  "ocircumflex\0ydieresis": -30,
  "odieresis\0comma": -40,
  "odieresis\0period": -40,
  "odieresis\0v": -15,
  "odieresis\0w": -15,
  "odieresis\0x": -30,
  "odieresis\0y": -30,
  "odieresis\0yacute": -30,
  "odieresis\0ydieresis": -30,
  "ograve\0comma": -40,
  "ograve\0period": -40,
  "ograve\0v": -15,
  "ograve\0w": -15,
  "ograve\0x": -30,
  "ograve\0y": -30,
  "ograve\0yacute": -30,
  "ograve\0ydieresis": -30,
  "ohungarumlaut\0comma": -40,
  "ohungarumlaut\0period": -40,
  "ohungarumlaut\0v": -15,
  "ohungarumlaut\0w": -15,
  "ohungarumlaut\0x": -30,
  "ohungarumlaut\0y": -30,
  "ohungarumlaut\0yacute": -30,
  "ohungarumlaut\0ydieresis": -30,
  "omacron\0comma": -40,
  "omacron\0period": -40,
  "omacron\0v": -15,
  "omacron\0w": -15,
  "omacron\0x": -30,
  "omacron\0y": -30,
  "omacron\0yacute": -30,
  "omacron\0ydieresis": -30,
  "oslash\0a": -55,
  "oslash\0aacute": -55,
  "oslash\0abreve": -55,
  "oslash\0acircumflex": -55,
  "oslash\0adieresis": -55,
  "oslash\0agrave": -55,
  "oslash\0amacron": -55,
  "oslash\0aogonek": -55,
  "oslash\0aring": -55,
  "oslash\0atilde": -55,
  "oslash\0b": -55,
  "oslash\0c": -55,
  "oslash\0cacute": -55,
  "oslash\0ccaron": -55,
  "oslash\0ccedilla": -55,
  "oslash\0comma": -95,
  "oslash\0d": -55,
  "oslash\0dcroat": -55,
  "oslash\0e": -55,
  "oslash\0eacute": -55,
  "oslash\0ecaron": -55,
  "oslash\0ecircumflex": -55,
  "oslash\0edieresis": -55,
  "oslash\0edotaccent": -55,
  "oslash\0egrave": -55,
  "oslash\0emacron": -55,
  "oslash\0eogonek": -55,
  "oslash\0f": -55,
  "oslash\0g": -55,
  "oslash\0gbreve": -55,
  "oslash\0gcommaaccent": -55,
  "oslash\0h": -55,
  "oslash\0i": -55,
  "oslash\0iacute": -55,
  "oslash\0icircumflex": -55,
  "oslash\0idieresis": -55,
  "oslash\0igrave": -55,
  "oslash\0imacron": -55,
  "oslash\0iogonek": -55,
  "oslash\0j": -55,
  "oslash\0k": -55,
  "oslash\0kcommaaccent": -55,
  "oslash\0l": -55,
  "oslash\0lacute": -55,
  "oslash\0lcommaaccent": -55,
  "oslash\0lslash": -55,
  "oslash\0m": -55,
  "oslash\0n": -55,
  "oslash\0nacute": -55,
  "oslash\0ncaron": -55,
  "oslash\0ncommaaccent": -55,
  "oslash\0ntilde": -55,
  "oslash\0o": -55,
  "oslash\0oacute": -55,
  "oslash\0ocircumflex": -55,
  "oslash\0odieresis": -55,
  "oslash\0ograve": -55,
  "oslash\0ohungarumlaut": -55,
  "oslash\0omacron": -55,
  "oslash\0oslash": -55,
  "oslash\0otilde": -55,
  "oslash\0p": -55,
  "oslash\0period": -95,
  "oslash\0q": -55,
  "oslash\0r": -55,
  "oslash\0racute": -55,
  "oslash\0rcaron": -55,
  "oslash\0rcommaaccent": -55,
  "oslash\0s": -55,
  "oslash\0sacute": -55,
  "oslash\0scaron": -55,
  "oslash\0scedilla": -55,
  "oslash\0scommaaccent": -55,
  "oslash\0t": -55,
  "oslash\0tcommaaccent": -55,
  "oslash\0u": -55,
  "oslash\0uacute": -55,
  "oslash\0ucircumflex": -55,
  "oslash\0udieresis": -55,
  "oslash\0ugrave": -55,
  "oslash\0uhungarumlaut": -55,
  "oslash\0umacron": -55,
  "oslash\0uogonek": -55,
  "oslash\0uring": -55,
  "oslash\0v": -70,
  "oslash\0w": -70,
  "oslash\0x": -85,
  "oslash\0y": -70,
  "oslash\0yacute": -70,
  "oslash\0ydieresis": -70,
  "oslash\0z": -55,
  "oslash\0zacute": -55,
  "oslash\0zcaron": -55,
  "oslash\0zdotaccent": -55,
  "otilde\0comma": -40,
  "otilde\0period": -40,
  "otilde\0v": -15,
  "otilde\0w": -15,
  "otilde\0x": -30,
  "otilde\0y": -30,
  "otilde\0yacute": -30,
  "otilde\0ydieresis": -30,
  "p\0comma": -35,
  "p\0period": -35,
  "p\0y": -30,
  "p\0yacute": -30,
  "p\0ydieresis": -30,
  "period\0quotedblright": -100,
  "period\0quoteright": -100,
  "period\0space": -60,
  "quotedblright\0space": -40,
  "quoteleft\0quoteleft": -57,
  "quoteright\0d": -50,
  "quoteright\0dcroat": -50,
  "quoteright\0quoteright": -57,
  "quoteright\0r": -50,
  "quoteright\0racute": -50,
  "quoteright\0rcaron": -50,
  "quoteright\0rcommaaccent": -50,
  "quoteright\0s": -50,
  "quoteright\0sacute": -50,
  "quoteright\0scaron": -50,
  "quoteright\0scedilla": -50,
  "quoteright\0scommaaccent": -50,
  "quoteright\0space": -70,
  "r\0a": -10,
  "r\0aacute": -10,
  "r\0abreve": -10,
  "r\0acircumflex": -10,
  "r\0adieresis": -10,
  "r\0agrave": -10,
  "r\0amacron": -10,
  "r\0aogonek": -10,
  "r\0aring": -10,
  "r\0atilde": -10,
  "r\0colon": 30,
  "r\0comma": -50,
  "r\0i": 15,
  "r\0iacute": 15,
  "r\0icircumflex": 15,
  "r\0idieresis": 15,
  "r\0igrave": 15,
  "r\0imacron": 15,
  "r\0iogonek": 15,
  "r\0k": 15,
  "r\0kcommaaccent": 15,
  "r\0l": 15,
  "r\0lacute": 15,
  "r\0lcommaaccent": 15,
  "r\0lslash": 15,
  "r\0m": 25,
  "r\0n": 25,
  "r\0nacute": 25,
  "r\0ncaron": 25,
  "r\0ncommaaccent": 25,
  "r\0ntilde": 25,
  "r\0p": 30,
  "r\0period": -50,
  "r\0semicolon": 30,
  "r\0t": 40,
  "r\0tcommaaccent": 40,
  "r\0u": 15,
  "r\0uacute": 15,
  "r\0ucircumflex": 15,
  "r\0udieresis": 15,
  "r\0ugrave": 15,
  "r\0uhungarumlaut": 15,
  "r\0umacron": 15,
  "r\0uogonek": 15,
  "r\0uring": 15,
  "r\0v": 30,
  "r\0y": 30,
  "r\0yacute": 30,
  "r\0ydieresis": 30,
  "racute\0a": -10,
  "racute\0aacute": -10,
  "racute\0abreve": -10,
  "racute\0acircumflex": -10,
  "racute\0adieresis": -10,
  "racute\0agrave": -10,
  "racute\0amacron": -10,
  "racute\0aogonek": -10,
  "racute\0aring": -10,
  "racute\0atilde": -10,
  "racute\0colon": 30,
  "racute\0comma": -50,
  "racute\0i": 15,
  "racute\0iacute": 15,
  "racute\0icircumflex": 15,
  "racute\0idieresis": 15,
  "racute\0igrave": 15,
  "racute\0imacron": 15,
  "racute\0iogonek": 15,
  "racute\0k": 15,
  "racute\0kcommaaccent": 15,
  "racute\0l": 15,
  "racute\0lacute": 15,
  "racute\0lcommaaccent": 15,
  "racute\0lslash": 15,
  "racute\0m": 25,
  "racute\0n": 25,
  "racute\0nacute": 25,
  "racute\0ncaron": 25,
  "racute\0ncommaaccent": 25,
  "racute\0ntilde": 25,
  "racute\0p": 30,
  "racute\0period": -50,
  "racute\0semicolon": 30,
  "racute\0t": 40,
  "racute\0tcommaaccent": 40,
  "racute\0u": 15,
  "racute\0uacute": 15,
  "racute\0ucircumflex": 15,
  "racute\0udieresis": 15,
  "racute\0ugrave": 15,
  "racute\0uhungarumlaut": 15,
  "racute\0umacron": 15,
  "racute\0uogonek": 15,
  "racute\0uring": 15,
  "racute\0v": 30,
  "racute\0y": 30,
  "racute\0yacute": 30,
  "racute\0ydieresis": 30,
  "rcaron\0a": -10,
  "rcaron\0aacute": -10,
  "rcaron\0abreve": -10,
  "rcaron\0acircumflex": -10,
  "rcaron\0adieresis": -10,
  "rcaron\0agrave": -10,
  "rcaron\0amacron": -10,
  "rcaron\0aogonek": -10,
  "rcaron\0aring": -10,
  "rcaron\0atilde": -10,
  "rcaron\0colon": 30,
  "rcaron\0comma": -50,
  "rcaron\0i": 15,
  "rcaron\0iacute": 15,
  "rcaron\0icircumflex": 15,
  "rcaron\0idieresis": 15,
  "rcaron\0igrave": 15,
  "rcaron\0imacron": 15,
  "rcaron\0iogonek": 15,
  "rcaron\0k": 15,
  "rcaron\0kcommaaccent": 15,
  "rcaron\0l": 15,
  "rcaron\0lacute": 15,
  "rcaron\0lcommaaccent": 15,
  "rcaron\0lslash": 15,
  "rcaron\0m": 25,
  "rcaron\0n": 25,
  "rcaron\0nacute": 25,
  "rcaron\0ncaron": 25,
  "rcaron\0ncommaaccent": 25,
  "rcaron\0ntilde": 25,
  "rcaron\0p": 30,
  "rcaron\0period": -50,
  "rcaron\0semicolon": 30,
  "rcaron\0t": 40,
  "rcaron\0tcommaaccent": 40,
  "rcaron\0u": 15,
  "rcaron\0uacute": 15,
  "rcaron\0ucircumflex": 15,
  "rcaron\0udieresis": 15,
  "rcaron\0ugrave": 15,
  "rcaron\0uhungarumlaut": 15,
  "rcaron\0umacron": 15,
  "rcaron\0uogonek": 15,
  "rcaron\0uring": 15,
  "rcaron\0v": 30,
  "rcaron\0y": 30,
  "rcaron\0yacute": 30,
  "rcaron\0ydieresis": 30,
  "rcommaaccent\0a": -10,
  "rcommaaccent\0aacute": -10,
  "rcommaaccent\0abreve": -10,
  "rcommaaccent\0acircumflex": -10,
  "rcommaaccent\0adieresis": -10,
  "rcommaaccent\0agrave": -10,
  "rcommaaccent\0amacron": -10,
  "rcommaaccent\0aogonek": -10,
  "rcommaaccent\0aring": -10,
  "rcommaaccent\0atilde": -10,
  "rcommaaccent\0colon": 30,
  "rcommaaccent\0comma": -50,
  "rcommaaccent\0i": 15,
  "rcommaaccent\0iacute": 15,
  "rcommaaccent\0icircumflex": 15,
  "rcommaaccent\0idieresis": 15,
  "rcommaaccent\0igrave": 15,
  "rcommaaccent\0imacron": 15,
  "rcommaaccent\0iogonek": 15,
  "rcommaaccent\0k": 15,
  "rcommaaccent\0kcommaaccent": 15,
  "rcommaaccent\0l": 15,
  "rcommaaccent\0lacute": 15,
  "rcommaaccent\0lcommaaccent": 15,
  "rcommaaccent\0lslash": 15,
  "rcommaaccent\0m": 25,
  "rcommaaccent\0n": 25,
  "rcommaaccent\0nacute": 25,
  "rcommaaccent\0ncaron": 25,
  "rcommaaccent\0ncommaaccent": 25,
  "rcommaaccent\0ntilde": 25,
  "rcommaaccent\0p": 30,
  "rcommaaccent\0period": -50,
  "rcommaaccent\0semicolon": 30,
  "rcommaaccent\0t": 40,
  "rcommaaccent\0tcommaaccent": 40,
  "rcommaaccent\0u": 15,
  "rcommaaccent\0uacute": 15,
  "rcommaaccent\0ucircumflex": 15,
  "rcommaaccent\0udieresis": 15,
  "rcommaaccent\0ugrave": 15,
  "rcommaaccent\0uhungarumlaut": 15,
  "rcommaaccent\0umacron": 15,
  "rcommaaccent\0uogonek": 15,
  "rcommaaccent\0uring": 15,
  "rcommaaccent\0v": 30,
  "rcommaaccent\0y": 30,
  "rcommaaccent\0yacute": 30,
  "rcommaaccent\0ydieresis": 30,
  "s\0comma": -15,
  "s\0period": -15,
  "s\0w": -30,
  "sacute\0comma": -15,
  "sacute\0period": -15,
  "sacute\0w": -30,
  "scaron\0comma": -15,
  "scaron\0period": -15,
  "scaron\0w": -30,
  "scedilla\0comma": -15,
  "scedilla\0period": -15,
  "scedilla\0w": -30,
  "scommaaccent\0comma": -15,
  "scommaaccent\0period": -15,
  "scommaaccent\0w": -30,
  "semicolon\0space": -50,
  "space\0T": -50,
  "space\0Tcaron": -50,
  "space\0Tcommaaccent": -50,
  "space\0V": -50,
  "space\0W": -40,
  "space\0Y": -90,
  "space\0Yacute": -90,
  "space\0Ydieresis": -90,
  "space\0quotedblleft": -30,
  "space\0quoteleft": -60,
  "v\0a": -25,
  "v\0aacute": -25,
  "v\0abreve": -25,
  "v\0acircumflex": -25,
  "v\0adieresis": -25,
  "v\0agrave": -25,
  "v\0amacron": -25,
  "v\0aogonek": -25,
  "v\0aring": -25,
  "v\0atilde": -25,
  "v\0comma": -80,
  "v\0e": -25,
  "v\0eacute": -25,
  "v\0ecaron": -25,
  "v\0ecircumflex": -25,
  "v\0edieresis": -25,
  "v\0edotaccent": -25,
  "v\0egrave": -25,
  "v\0emacron": -25,
  "v\0eogonek": -25,
  "v\0o": -25,
  "v\0oacute": -25,
  "v\0ocircumflex": -25,
  "v\0odieresis": -25,
  "v\0ograve": -25,
  "v\0ohungarumlaut": -25,
  "v\0omacron": -25,
  "v\0oslash": -25,
  "v\0otilde": -25,
  "v\0period": -80,
  "w\0a": -15,
  "w\0aacute": -15,
  "w\0abreve": -15,
  "w\0acircumflex": -15,
  "w\0adieresis": -15,
  "w\0agrave": -15,
  "w\0amacron": -15,
  "w\0aogonek": -15,
  "w\0aring": -15,
  "w\0atilde": -15,
  "w\0comma": -60,
  "w\0e": -10,
  "w\0eacute": -10,
  "w\0ecaron": -10,
  "w\0ecircumflex": -10,
  "w\0edieresis": -10,
  "w\0edotaccent": -10,
  "w\0egrave": -10,
  "w\0emacron": -10,
  "w\0eogonek": -10,
  "w\0o": -10,
  "w\0oacute": -10,
  "w\0ocircumflex": -10,
  "w\0odieresis": -10,
  "w\0ograve": -10,
  "w\0ohungarumlaut": -10,
  "w\0omacron": -10,
  "w\0oslash": -10,
  "w\0otilde": -10,
  "w\0period": -60,
  "x\0e": -30,
  "x\0eacute": -30,
  "x\0ecaron": -30,
  "x\0ecircumflex": -30,
  "x\0edieresis": -30,
  "x\0edotaccent": -30,
  "x\0egrave": -30,
  "x\0emacron": -30,
  "x\0eogonek": -30,
  "y\0a": -20,
  "y\0aacute": -20,
  "y\0abreve": -20,
  "y\0acircumflex": -20,
  "y\0adieresis": -20,
  "y\0agrave": -20,
  "y\0amacron": -20,
  "y\0aogonek": -20,
  "y\0aring": -20,
  "y\0atilde": -20,
  "y\0comma": -100,
  "y\0e": -20,
  "y\0eacute": -20,
  "y\0ecaron": -20,
  "y\0ecircumflex": -20,
  "y\0edieresis": -20,
  "y\0edotaccent": -20,
  "y\0egrave": -20,
  "y\0emacron": -20,
  "y\0eogonek": -20,
  "y\0o": -20,
  "y\0oacute": -20,
  "y\0ocircumflex": -20,
  "y\0odieresis": -20,
  "y\0ograve": -20,
  "y\0ohungarumlaut": -20,
  "y\0omacron": -20,
  "y\0oslash": -20,
  "y\0otilde": -20,
  "y\0period": -100,
  "yacute\0a": -20,
  "yacute\0aacute": -20,
  "yacute\0abreve": -20,
  "yacute\0acircumflex": -20,
  "yacute\0adieresis": -20,
  "yacute\0agrave": -20,
  "yacute\0amacron": -20,
  "yacute\0aogonek": -20,
  "yacute\0aring": -20,
  "yacute\0atilde": -20,
  "yacute\0comma": -100,
  "yacute\0e": -20,
  "yacute\0eacute": -20,
  "yacute\0ecaron": -20,
  "yacute\0ecircumflex": -20,
  "yacute\0edieresis": -20,
  "yacute\0edotaccent": -20,
  "yacute\0egrave": -20,
  "yacute\0emacron": -20,
  "yacute\0eogonek": -20,
  "yacute\0o": -20,
  "yacute\0oacute": -20,
  "yacute\0ocircumflex": -20,
  "yacute\0odieresis": -20,
  "yacute\0ograve": -20,
  "yacute\0ohungarumlaut": -20,
  "yacute\0omacron": -20,
  "yacute\0oslash": -20,
  "yacute\0otilde": -20,
  "yacute\0period": -100,
  "ydieresis\0a": -20,
  "ydieresis\0aacute": -20,
  "ydieresis\0abreve": -20,
  "ydieresis\0acircumflex": -20,
  "ydieresis\0adieresis": -20,
  "ydieresis\0agrave": -20,
  "ydieresis\0amacron": -20,
  "ydieresis\0aogonek": -20,
  "ydieresis\0aring": -20,
  "ydieresis\0atilde": -20,
  "ydieresis\0comma": -100,
  "ydieresis\0e": -20,
  "ydieresis\0eacute": -20,
  "ydieresis\0ecaron": -20,
  "ydieresis\0ecircumflex": -20,
  "ydieresis\0edieresis": -20,
  "ydieresis\0edotaccent": -20,
  "ydieresis\0egrave": -20,
  "ydieresis\0emacron": -20,
  "ydieresis\0eogonek": -20,
  "ydieresis\0o": -20,
  "ydieresis\0oacute": -20,
  "ydieresis\0ocircumflex": -20,
  "ydieresis\0odieresis": -20,
  "ydieresis\0ograve": -20,
  "ydieresis\0ohungarumlaut": -20,
  "ydieresis\0omacron": -20,
  "ydieresis\0oslash": -20,
  "ydieresis\0otilde": -20,
  "ydieresis\0period": -100,
  "z\0e": -15,
  "z\0eacute": -15,
  "z\0ecaron": -15,
  "z\0ecircumflex": -15,
  "z\0edieresis": -15,
  "z\0edotaccent": -15,
  "z\0egrave": -15,
  "z\0emacron": -15,
  "z\0eogonek": -15,
  "z\0o": -15,
  "z\0oacute": -15,
  "z\0ocircumflex": -15,
  "z\0odieresis": -15,
  "z\0ograve": -15,
  "z\0ohungarumlaut": -15,
  "z\0omacron": -15,
  "z\0oslash": -15,
  "z\0otilde": -15,
  "zacute\0e": -15,
  "zacute\0eacute": -15,
  "zacute\0ecaron": -15,
  "zacute\0ecircumflex": -15,
  "zacute\0edieresis": -15,
  "zacute\0edotaccent": -15,
  "zacute\0egrave": -15,
  "zacute\0emacron": -15,
  "zacute\0eogonek": -15,
  "zacute\0o": -15,
  "zacute\0oacute": -15,
  "zacute\0ocircumflex": -15,
  "zacute\0odieresis": -15,
  "zacute\0ograve": -15,
  "zacute\0ohungarumlaut": -15,
  "zacute\0omacron": -15,
  "zacute\0oslash": -15,
  "zacute\0otilde": -15,
  "zcaron\0e": -15,
  "zcaron\0eacute": -15,
  "zcaron\0ecaron": -15,
  "zcaron\0ecircumflex": -15,
  "zcaron\0edieresis": -15,
  "zcaron\0edotaccent": -15,
  "zcaron\0egrave": -15,
  "zcaron\0emacron": -15,
  "zcaron\0eogonek": -15,
  "zcaron\0o": -15,
  "zcaron\0oacute": -15,
  "zcaron\0ocircumflex": -15,
  "zcaron\0odieresis": -15,
  "zcaron\0ograve": -15,
  "zcaron\0ohungarumlaut": -15,
  "zcaron\0omacron": -15,
  "zcaron\0oslash": -15,
  "zcaron\0otilde": -15,
  "zdotaccent\0e": -15,
  "zdotaccent\0eacute": -15,
  "zdotaccent\0ecaron": -15,
  "zdotaccent\0ecircumflex": -15,
  "zdotaccent\0edieresis": -15,
  "zdotaccent\0edotaccent": -15,
  "zdotaccent\0egrave": -15,
  "zdotaccent\0emacron": -15,
  "zdotaccent\0eogonek": -15,
  "zdotaccent\0o": -15,
  "zdotaccent\0oacute": -15,
  "zdotaccent\0ocircumflex": -15,
  "zdotaccent\0odieresis": -15,
  "zdotaccent\0ograve": -15,
  "zdotaccent\0ohungarumlaut": -15,
  "zdotaccent\0omacron": -15,
  "zdotaccent\0oslash": -15,
  "zdotaccent\0otilde": -15
};
var Helvetica = {
  attributes: attributes$5,
  glyphWidths: glyphWidths$5,
  kernPairs: kernPairs$5
};
var attributes$4 = {
  Comment: ["Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 12:43:52 1997", "UniqueID 43052", "VMusage 37169 48194"],
  FontName: "Helvetica-Bold",
  FullName: "Helvetica Bold",
  FamilyName: "Helvetica",
  Weight: "Bold",
  ItalicAngle: "0",
  IsFixedPitch: "false",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-170 -228 1003 962 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "002.000",
  Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "718",
  XHeight: "532",
  Ascender: "718",
  Descender: "-207",
  StdHW: "118",
  StdVW: "140"
};
var glyphWidths$4 = {
  space: 278,
  exclam: 333,
  quotedbl: 474,
  numbersign: 556,
  dollar: 556,
  percent: 889,
  ampersand: 722,
  quoteright: 278,
  parenleft: 333,
  parenright: 333,
  asterisk: 389,
  plus: 584,
  comma: 278,
  hyphen: 333,
  period: 278,
  slash: 278,
  zero: 556,
  one: 556,
  two: 556,
  three: 556,
  four: 556,
  five: 556,
  six: 556,
  seven: 556,
  eight: 556,
  nine: 556,
  colon: 333,
  semicolon: 333,
  less: 584,
  equal: 584,
  greater: 584,
  question: 611,
  at: 975,
  A: 722,
  B: 722,
  C: 722,
  D: 722,
  E: 667,
  F: 611,
  G: 778,
  H: 722,
  I: 278,
  J: 556,
  K: 722,
  L: 611,
  M: 833,
  N: 722,
  O: 778,
  P: 667,
  Q: 778,
  R: 722,
  S: 667,
  T: 611,
  U: 722,
  V: 667,
  W: 944,
  X: 667,
  Y: 667,
  Z: 611,
  bracketleft: 333,
  backslash: 278,
  bracketright: 333,
  asciicircum: 584,
  underscore: 556,
  quoteleft: 278,
  a: 556,
  b: 611,
  c: 556,
  d: 611,
  e: 556,
  f: 333,
  g: 611,
  h: 611,
  i: 278,
  j: 278,
  k: 556,
  l: 278,
  m: 889,
  n: 611,
  o: 611,
  p: 611,
  q: 611,
  r: 389,
  s: 556,
  t: 333,
  u: 611,
  v: 556,
  w: 778,
  x: 556,
  y: 556,
  z: 500,
  braceleft: 389,
  bar: 280,
  braceright: 389,
  asciitilde: 584,
  exclamdown: 333,
  cent: 556,
  sterling: 556,
  fraction: 167,
  yen: 556,
  florin: 556,
  section: 556,
  currency: 556,
  quotesingle: 238,
  quotedblleft: 500,
  guillemotleft: 556,
  guilsinglleft: 333,
  guilsinglright: 333,
  fi: 611,
  fl: 611,
  endash: 556,
  dagger: 556,
  daggerdbl: 556,
  periodcentered: 278,
  paragraph: 556,
  bullet: 350,
  quotesinglbase: 278,
  quotedblbase: 500,
  quotedblright: 500,
  guillemotright: 556,
  ellipsis: 1000,
  perthousand: 1000,
  questiondown: 611,
  grave: 333,
  acute: 333,
  circumflex: 333,
  tilde: 333,
  macron: 333,
  breve: 333,
  dotaccent: 333,
  dieresis: 333,
  ring: 333,
  cedilla: 333,
  hungarumlaut: 333,
  ogonek: 333,
  caron: 333,
  emdash: 1000,
  AE: 1000,
  ordfeminine: 370,
  Lslash: 611,
  Oslash: 778,
  OE: 1000,
  ordmasculine: 365,
  ae: 889,
  dotlessi: 278,
  lslash: 278,
  oslash: 611,
  oe: 944,
  germandbls: 611,
  Idieresis: 278,
  eacute: 556,
  abreve: 556,
  uhungarumlaut: 611,
  ecaron: 556,
  Ydieresis: 667,
  divide: 584,
  Yacute: 667,
  Acircumflex: 722,
  aacute: 556,
  Ucircumflex: 722,
  yacute: 556,
  scommaaccent: 556,
  ecircumflex: 556,
  Uring: 722,
  Udieresis: 722,
  aogonek: 556,
  Uacute: 722,
  uogonek: 611,
  Edieresis: 667,
  Dcroat: 722,
  commaaccent: 250,
  copyright: 737,
  Emacron: 667,
  ccaron: 556,
  aring: 556,
  Ncommaaccent: 722,
  lacute: 278,
  agrave: 556,
  Tcommaaccent: 611,
  Cacute: 722,
  atilde: 556,
  Edotaccent: 667,
  scaron: 556,
  scedilla: 556,
  iacute: 278,
  lozenge: 494,
  Rcaron: 722,
  Gcommaaccent: 778,
  ucircumflex: 611,
  acircumflex: 556,
  Amacron: 722,
  rcaron: 389,
  ccedilla: 556,
  Zdotaccent: 611,
  Thorn: 667,
  Omacron: 778,
  Racute: 722,
  Sacute: 667,
  dcaron: 743,
  Umacron: 722,
  uring: 611,
  threesuperior: 333,
  Ograve: 778,
  Agrave: 722,
  Abreve: 722,
  multiply: 584,
  uacute: 611,
  Tcaron: 611,
  partialdiff: 494,
  ydieresis: 556,
  Nacute: 722,
  icircumflex: 278,
  Ecircumflex: 667,
  adieresis: 556,
  edieresis: 556,
  cacute: 556,
  nacute: 611,
  umacron: 611,
  Ncaron: 722,
  Iacute: 278,
  plusminus: 584,
  brokenbar: 280,
  registered: 737,
  Gbreve: 778,
  Idotaccent: 278,
  summation: 600,
  Egrave: 667,
  racute: 389,
  omacron: 611,
  Zacute: 611,
  Zcaron: 611,
  greaterequal: 549,
  Eth: 722,
  Ccedilla: 722,
  lcommaaccent: 278,
  tcaron: 389,
  eogonek: 556,
  Uogonek: 722,
  Aacute: 722,
  Adieresis: 722,
  egrave: 556,
  zacute: 500,
  iogonek: 278,
  Oacute: 778,
  oacute: 611,
  amacron: 556,
  sacute: 556,
  idieresis: 278,
  Ocircumflex: 778,
  Ugrave: 722,
  Delta: 612,
  thorn: 611,
  twosuperior: 333,
  Odieresis: 778,
  mu: 611,
  igrave: 278,
  ohungarumlaut: 611,
  Eogonek: 667,
  dcroat: 611,
  threequarters: 834,
  Scedilla: 667,
  lcaron: 400,
  Kcommaaccent: 722,
  Lacute: 611,
  trademark: 1000,
  edotaccent: 556,
  Igrave: 278,
  Imacron: 278,
  Lcaron: 611,
  onehalf: 834,
  lessequal: 549,
  ocircumflex: 611,
  ntilde: 611,
  Uhungarumlaut: 722,
  Eacute: 667,
  emacron: 556,
  gbreve: 611,
  onequarter: 834,
  Scaron: 667,
  Scommaaccent: 667,
  Ohungarumlaut: 778,
  degree: 400,
  ograve: 611,
  Ccaron: 722,
  ugrave: 611,
  radical: 549,
  Dcaron: 722,
  rcommaaccent: 389,
  Ntilde: 722,
  otilde: 611,
  Rcommaaccent: 722,
  Lcommaaccent: 611,
  Atilde: 722,
  Aogonek: 722,
  Aring: 722,
  Otilde: 778,
  zdotaccent: 500,
  Ecaron: 667,
  Iogonek: 278,
  kcommaaccent: 556,
  minus: 584,
  Icircumflex: 278,
  ncaron: 611,
  tcommaaccent: 333,
  logicalnot: 584,
  odieresis: 611,
  udieresis: 611,
  notequal: 549,
  gcommaaccent: 611,
  eth: 611,
  zcaron: 500,
  ncommaaccent: 611,
  onesuperior: 333,
  imacron: 278,
  Euro: 556
};
var kernPairs$4 = {
  "A\0C": -40,
  "A\0Cacute": -40,
  "A\0Ccaron": -40,
  "A\0Ccedilla": -40,
  "A\0G": -50,
  "A\0Gbreve": -50,
  "A\0Gcommaaccent": -50,
  "A\0O": -40,
  "A\0Oacute": -40,
  "A\0Ocircumflex": -40,
  "A\0Odieresis": -40,
  "A\0Ograve": -40,
  "A\0Ohungarumlaut": -40,
  "A\0Omacron": -40,
  "A\0Oslash": -40,
  "A\0Otilde": -40,
  "A\0Q": -40,
  "A\0T": -90,
  "A\0Tcaron": -90,
  "A\0Tcommaaccent": -90,
  "A\0U": -50,
  "A\0Uacute": -50,
  "A\0Ucircumflex": -50,
  "A\0Udieresis": -50,
  "A\0Ugrave": -50,
  "A\0Uhungarumlaut": -50,
  "A\0Umacron": -50,
  "A\0Uogonek": -50,
  "A\0Uring": -50,
  "A\0V": -80,
  "A\0W": -60,
  "A\0Y": -110,
  "A\0Yacute": -110,
  "A\0Ydieresis": -110,
  "A\0u": -30,
  "A\0uacute": -30,
  "A\0ucircumflex": -30,
  "A\0udieresis": -30,
  "A\0ugrave": -30,
  "A\0uhungarumlaut": -30,
  "A\0umacron": -30,
  "A\0uogonek": -30,
  "A\0uring": -30,
  "A\0v": -40,
  "A\0w": -30,
  "A\0y": -30,
  "A\0yacute": -30,
  "A\0ydieresis": -30,
  "Aacute\0C": -40,
  "Aacute\0Cacute": -40,
  "Aacute\0Ccaron": -40,
  "Aacute\0Ccedilla": -40,
  "Aacute\0G": -50,
  "Aacute\0Gbreve": -50,
  "Aacute\0Gcommaaccent": -50,
  "Aacute\0O": -40,
  "Aacute\0Oacute": -40,
  "Aacute\0Ocircumflex": -40,
  "Aacute\0Odieresis": -40,
  "Aacute\0Ograve": -40,
  "Aacute\0Ohungarumlaut": -40,
  "Aacute\0Omacron": -40,
  "Aacute\0Oslash": -40,
  "Aacute\0Otilde": -40,
  "Aacute\0Q": -40,
  "Aacute\0T": -90,
  "Aacute\0Tcaron": -90,
  "Aacute\0Tcommaaccent": -90,
  "Aacute\0U": -50,
  "Aacute\0Uacute": -50,
  "Aacute\0Ucircumflex": -50,
  "Aacute\0Udieresis": -50,
  "Aacute\0Ugrave": -50,
  "Aacute\0Uhungarumlaut": -50,
  "Aacute\0Umacron": -50,
  "Aacute\0Uogonek": -50,
  "Aacute\0Uring": -50,
  "Aacute\0V": -80,
  "Aacute\0W": -60,
  "Aacute\0Y": -110,
  "Aacute\0Yacute": -110,
  "Aacute\0Ydieresis": -110,
  "Aacute\0u": -30,
  "Aacute\0uacute": -30,
  "Aacute\0ucircumflex": -30,
  "Aacute\0udieresis": -30,
  "Aacute\0ugrave": -30,
  "Aacute\0uhungarumlaut": -30,
  "Aacute\0umacron": -30,
  "Aacute\0uogonek": -30,
  "Aacute\0uring": -30,
  "Aacute\0v": -40,
  "Aacute\0w": -30,
  "Aacute\0y": -30,
  "Aacute\0yacute": -30,
  "Aacute\0ydieresis": -30,
  "Abreve\0C": -40,
  "Abreve\0Cacute": -40,
  "Abreve\0Ccaron": -40,
  "Abreve\0Ccedilla": -40,
  "Abreve\0G": -50,
  "Abreve\0Gbreve": -50,
  "Abreve\0Gcommaaccent": -50,
  "Abreve\0O": -40,
  "Abreve\0Oacute": -40,
  "Abreve\0Ocircumflex": -40,
  "Abreve\0Odieresis": -40,
  "Abreve\0Ograve": -40,
  "Abreve\0Ohungarumlaut": -40,
  "Abreve\0Omacron": -40,
  "Abreve\0Oslash": -40,
  "Abreve\0Otilde": -40,
  "Abreve\0Q": -40,
  "Abreve\0T": -90,
  "Abreve\0Tcaron": -90,
  "Abreve\0Tcommaaccent": -90,
  "Abreve\0U": -50,
  "Abreve\0Uacute": -50,
  "Abreve\0Ucircumflex": -50,
  "Abreve\0Udieresis": -50,
  "Abreve\0Ugrave": -50,
  "Abreve\0Uhungarumlaut": -50,
  "Abreve\0Umacron": -50,
  "Abreve\0Uogonek": -50,
  "Abreve\0Uring": -50,
  "Abreve\0V": -80,
  "Abreve\0W": -60,
  "Abreve\0Y": -110,
  "Abreve\0Yacute": -110,
  "Abreve\0Ydieresis": -110,
  "Abreve\0u": -30,
  "Abreve\0uacute": -30,
  "Abreve\0ucircumflex": -30,
  "Abreve\0udieresis": -30,
  "Abreve\0ugrave": -30,
  "Abreve\0uhungarumlaut": -30,
  "Abreve\0umacron": -30,
  "Abreve\0uogonek": -30,
  "Abreve\0uring": -30,
  "Abreve\0v": -40,
  "Abreve\0w": -30,
  "Abreve\0y": -30,
  "Abreve\0yacute": -30,
  "Abreve\0ydieresis": -30,
  "Acircumflex\0C": -40,
  "Acircumflex\0Cacute": -40,
  "Acircumflex\0Ccaron": -40,
  "Acircumflex\0Ccedilla": -40,
  "Acircumflex\0G": -50,
  "Acircumflex\0Gbreve": -50,
  "Acircumflex\0Gcommaaccent": -50,
  "Acircumflex\0O": -40,
  "Acircumflex\0Oacute": -40,
  "Acircumflex\0Ocircumflex": -40,
  "Acircumflex\0Odieresis": -40,
  "Acircumflex\0Ograve": -40,
  "Acircumflex\0Ohungarumlaut": -40,
  "Acircumflex\0Omacron": -40,
  "Acircumflex\0Oslash": -40,
  "Acircumflex\0Otilde": -40,
  "Acircumflex\0Q": -40,
  "Acircumflex\0T": -90,
  "Acircumflex\0Tcaron": -90,
  "Acircumflex\0Tcommaaccent": -90,
  "Acircumflex\0U": -50,
  "Acircumflex\0Uacute": -50,
  "Acircumflex\0Ucircumflex": -50,
  "Acircumflex\0Udieresis": -50,
  "Acircumflex\0Ugrave": -50,
  "Acircumflex\0Uhungarumlaut": -50,
  "Acircumflex\0Umacron": -50,
  "Acircumflex\0Uogonek": -50,
  "Acircumflex\0Uring": -50,
  "Acircumflex\0V": -80,
  "Acircumflex\0W": -60,
  "Acircumflex\0Y": -110,
  "Acircumflex\0Yacute": -110,
  "Acircumflex\0Ydieresis": -110,
  "Acircumflex\0u": -30,
  "Acircumflex\0uacute": -30,
  "Acircumflex\0ucircumflex": -30,
  "Acircumflex\0udieresis": -30,
  "Acircumflex\0ugrave": -30,
  "Acircumflex\0uhungarumlaut": -30,
  "Acircumflex\0umacron": -30,
  "Acircumflex\0uogonek": -30,
  "Acircumflex\0uring": -30,
  "Acircumflex\0v": -40,
  "Acircumflex\0w": -30,
  "Acircumflex\0y": -30,
  "Acircumflex\0yacute": -30,
  "Acircumflex\0ydieresis": -30,
  "Adieresis\0C": -40,
  "Adieresis\0Cacute": -40,
  "Adieresis\0Ccaron": -40,
  "Adieresis\0Ccedilla": -40,
  "Adieresis\0G": -50,
  "Adieresis\0Gbreve": -50,
  "Adieresis\0Gcommaaccent": -50,
  "Adieresis\0O": -40,
  "Adieresis\0Oacute": -40,
  "Adieresis\0Ocircumflex": -40,
  "Adieresis\0Odieresis": -40,
  "Adieresis\0Ograve": -40,
  "Adieresis\0Ohungarumlaut": -40,
  "Adieresis\0Omacron": -40,
  "Adieresis\0Oslash": -40,
  "Adieresis\0Otilde": -40,
  "Adieresis\0Q": -40,
  "Adieresis\0T": -90,
  "Adieresis\0Tcaron": -90,
  "Adieresis\0Tcommaaccent": -90,
  "Adieresis\0U": -50,
  "Adieresis\0Uacute": -50,
  "Adieresis\0Ucircumflex": -50,
  "Adieresis\0Udieresis": -50,
  "Adieresis\0Ugrave": -50,
  "Adieresis\0Uhungarumlaut": -50,
  "Adieresis\0Umacron": -50,
  "Adieresis\0Uogonek": -50,
  "Adieresis\0Uring": -50,
  "Adieresis\0V": -80,
  "Adieresis\0W": -60,
  "Adieresis\0Y": -110,
  "Adieresis\0Yacute": -110,
  "Adieresis\0Ydieresis": -110,
  "Adieresis\0u": -30,
  "Adieresis\0uacute": -30,
  "Adieresis\0ucircumflex": -30,
  "Adieresis\0udieresis": -30,
  "Adieresis\0ugrave": -30,
  "Adieresis\0uhungarumlaut": -30,
  "Adieresis\0umacron": -30,
  "Adieresis\0uogonek": -30,
  "Adieresis\0uring": -30,
  "Adieresis\0v": -40,
  "Adieresis\0w": -30,
  "Adieresis\0y": -30,
  "Adieresis\0yacute": -30,
  "Adieresis\0ydieresis": -30,
  "Agrave\0C": -40,
  "Agrave\0Cacute": -40,
  "Agrave\0Ccaron": -40,
  "Agrave\0Ccedilla": -40,
  "Agrave\0G": -50,
  "Agrave\0Gbreve": -50,
  "Agrave\0Gcommaaccent": -50,
  "Agrave\0O": -40,
  "Agrave\0Oacute": -40,
  "Agrave\0Ocircumflex": -40,
  "Agrave\0Odieresis": -40,
  "Agrave\0Ograve": -40,
  "Agrave\0Ohungarumlaut": -40,
  "Agrave\0Omacron": -40,
  "Agrave\0Oslash": -40,
  "Agrave\0Otilde": -40,
  "Agrave\0Q": -40,
  "Agrave\0T": -90,
  "Agrave\0Tcaron": -90,
  "Agrave\0Tcommaaccent": -90,
  "Agrave\0U": -50,
  "Agrave\0Uacute": -50,
  "Agrave\0Ucircumflex": -50,
  "Agrave\0Udieresis": -50,
  "Agrave\0Ugrave": -50,
  "Agrave\0Uhungarumlaut": -50,
  "Agrave\0Umacron": -50,
  "Agrave\0Uogonek": -50,
  "Agrave\0Uring": -50,
  "Agrave\0V": -80,
  "Agrave\0W": -60,
  "Agrave\0Y": -110,
  "Agrave\0Yacute": -110,
  "Agrave\0Ydieresis": -110,
  "Agrave\0u": -30,
  "Agrave\0uacute": -30,
  "Agrave\0ucircumflex": -30,
  "Agrave\0udieresis": -30,
  "Agrave\0ugrave": -30,
  "Agrave\0uhungarumlaut": -30,
  "Agrave\0umacron": -30,
  "Agrave\0uogonek": -30,
  "Agrave\0uring": -30,
  "Agrave\0v": -40,
  "Agrave\0w": -30,
  "Agrave\0y": -30,
  "Agrave\0yacute": -30,
  "Agrave\0ydieresis": -30,
  "Amacron\0C": -40,
  "Amacron\0Cacute": -40,
  "Amacron\0Ccaron": -40,
  "Amacron\0Ccedilla": -40,
  "Amacron\0G": -50,
  "Amacron\0Gbreve": -50,
  "Amacron\0Gcommaaccent": -50,
  "Amacron\0O": -40,
  "Amacron\0Oacute": -40,
  "Amacron\0Ocircumflex": -40,
  "Amacron\0Odieresis": -40,
  "Amacron\0Ograve": -40,
  "Amacron\0Ohungarumlaut": -40,
  "Amacron\0Omacron": -40,
  "Amacron\0Oslash": -40,
  "Amacron\0Otilde": -40,
  "Amacron\0Q": -40,
  "Amacron\0T": -90,
  "Amacron\0Tcaron": -90,
  "Amacron\0Tcommaaccent": -90,
  "Amacron\0U": -50,
  "Amacron\0Uacute": -50,
  "Amacron\0Ucircumflex": -50,
  "Amacron\0Udieresis": -50,
  "Amacron\0Ugrave": -50,
  "Amacron\0Uhungarumlaut": -50,
  "Amacron\0Umacron": -50,
  "Amacron\0Uogonek": -50,
  "Amacron\0Uring": -50,
  "Amacron\0V": -80,
  "Amacron\0W": -60,
  "Amacron\0Y": -110,
  "Amacron\0Yacute": -110,
  "Amacron\0Ydieresis": -110,
  "Amacron\0u": -30,
  "Amacron\0uacute": -30,
  "Amacron\0ucircumflex": -30,
  "Amacron\0udieresis": -30,
  "Amacron\0ugrave": -30,
  "Amacron\0uhungarumlaut": -30,
  "Amacron\0umacron": -30,
  "Amacron\0uogonek": -30,
  "Amacron\0uring": -30,
  "Amacron\0v": -40,
  "Amacron\0w": -30,
  "Amacron\0y": -30,
  "Amacron\0yacute": -30,
  "Amacron\0ydieresis": -30,
  "Aogonek\0C": -40,
  "Aogonek\0Cacute": -40,
  "Aogonek\0Ccaron": -40,
  "Aogonek\0Ccedilla": -40,
  "Aogonek\0G": -50,
  "Aogonek\0Gbreve": -50,
  "Aogonek\0Gcommaaccent": -50,
  "Aogonek\0O": -40,
  "Aogonek\0Oacute": -40,
  "Aogonek\0Ocircumflex": -40,
  "Aogonek\0Odieresis": -40,
  "Aogonek\0Ograve": -40,
  "Aogonek\0Ohungarumlaut": -40,
  "Aogonek\0Omacron": -40,
  "Aogonek\0Oslash": -40,
  "Aogonek\0Otilde": -40,
  "Aogonek\0Q": -40,
  "Aogonek\0T": -90,
  "Aogonek\0Tcaron": -90,
  "Aogonek\0Tcommaaccent": -90,
  "Aogonek\0U": -50,
  "Aogonek\0Uacute": -50,
  "Aogonek\0Ucircumflex": -50,
  "Aogonek\0Udieresis": -50,
  "Aogonek\0Ugrave": -50,
  "Aogonek\0Uhungarumlaut": -50,
  "Aogonek\0Umacron": -50,
  "Aogonek\0Uogonek": -50,
  "Aogonek\0Uring": -50,
  "Aogonek\0V": -80,
  "Aogonek\0W": -60,
  "Aogonek\0Y": -110,
  "Aogonek\0Yacute": -110,
  "Aogonek\0Ydieresis": -110,
  "Aogonek\0u": -30,
  "Aogonek\0uacute": -30,
  "Aogonek\0ucircumflex": -30,
  "Aogonek\0udieresis": -30,
  "Aogonek\0ugrave": -30,
  "Aogonek\0uhungarumlaut": -30,
  "Aogonek\0umacron": -30,
  "Aogonek\0uogonek": -30,
  "Aogonek\0uring": -30,
  "Aogonek\0v": -40,
  "Aogonek\0w": -30,
  "Aogonek\0y": -30,
  "Aogonek\0yacute": -30,
  "Aogonek\0ydieresis": -30,
  "Aring\0C": -40,
  "Aring\0Cacute": -40,
  "Aring\0Ccaron": -40,
  "Aring\0Ccedilla": -40,
  "Aring\0G": -50,
  "Aring\0Gbreve": -50,
  "Aring\0Gcommaaccent": -50,
  "Aring\0O": -40,
  "Aring\0Oacute": -40,
  "Aring\0Ocircumflex": -40,
  "Aring\0Odieresis": -40,
  "Aring\0Ograve": -40,
  "Aring\0Ohungarumlaut": -40,
  "Aring\0Omacron": -40,
  "Aring\0Oslash": -40,
  "Aring\0Otilde": -40,
  "Aring\0Q": -40,
  "Aring\0T": -90,
  "Aring\0Tcaron": -90,
  "Aring\0Tcommaaccent": -90,
  "Aring\0U": -50,
  "Aring\0Uacute": -50,
  "Aring\0Ucircumflex": -50,
  "Aring\0Udieresis": -50,
  "Aring\0Ugrave": -50,
  "Aring\0Uhungarumlaut": -50,
  "Aring\0Umacron": -50,
  "Aring\0Uogonek": -50,
  "Aring\0Uring": -50,
  "Aring\0V": -80,
  "Aring\0W": -60,
  "Aring\0Y": -110,
  "Aring\0Yacute": -110,
  "Aring\0Ydieresis": -110,
  "Aring\0u": -30,
  "Aring\0uacute": -30,
  "Aring\0ucircumflex": -30,
  "Aring\0udieresis": -30,
  "Aring\0ugrave": -30,
  "Aring\0uhungarumlaut": -30,
  "Aring\0umacron": -30,
  "Aring\0uogonek": -30,
  "Aring\0uring": -30,
  "Aring\0v": -40,
  "Aring\0w": -30,
  "Aring\0y": -30,
  "Aring\0yacute": -30,
  "Aring\0ydieresis": -30,
  "Atilde\0C": -40,
  "Atilde\0Cacute": -40,
  "Atilde\0Ccaron": -40,
  "Atilde\0Ccedilla": -40,
  "Atilde\0G": -50,
  "Atilde\0Gbreve": -50,
  "Atilde\0Gcommaaccent": -50,
  "Atilde\0O": -40,
  "Atilde\0Oacute": -40,
  "Atilde\0Ocircumflex": -40,
  "Atilde\0Odieresis": -40,
  "Atilde\0Ograve": -40,
  "Atilde\0Ohungarumlaut": -40,
  "Atilde\0Omacron": -40,
  "Atilde\0Oslash": -40,
  "Atilde\0Otilde": -40,
  "Atilde\0Q": -40,
  "Atilde\0T": -90,
  "Atilde\0Tcaron": -90,
  "Atilde\0Tcommaaccent": -90,
  "Atilde\0U": -50,
  "Atilde\0Uacute": -50,
  "Atilde\0Ucircumflex": -50,
  "Atilde\0Udieresis": -50,
  "Atilde\0Ugrave": -50,
  "Atilde\0Uhungarumlaut": -50,
  "Atilde\0Umacron": -50,
  "Atilde\0Uogonek": -50,
  "Atilde\0Uring": -50,
  "Atilde\0V": -80,
  "Atilde\0W": -60,
  "Atilde\0Y": -110,
  "Atilde\0Yacute": -110,
  "Atilde\0Ydieresis": -110,
  "Atilde\0u": -30,
  "Atilde\0uacute": -30,
  "Atilde\0ucircumflex": -30,
  "Atilde\0udieresis": -30,
  "Atilde\0ugrave": -30,
  "Atilde\0uhungarumlaut": -30,
  "Atilde\0umacron": -30,
  "Atilde\0uogonek": -30,
  "Atilde\0uring": -30,
  "Atilde\0v": -40,
  "Atilde\0w": -30,
  "Atilde\0y": -30,
  "Atilde\0yacute": -30,
  "Atilde\0ydieresis": -30,
  "B\0A": -30,
  "B\0Aacute": -30,
  "B\0Abreve": -30,
  "B\0Acircumflex": -30,
  "B\0Adieresis": -30,
  "B\0Agrave": -30,
  "B\0Amacron": -30,
  "B\0Aogonek": -30,
  "B\0Aring": -30,
  "B\0Atilde": -30,
  "B\0U": -10,
  "B\0Uacute": -10,
  "B\0Ucircumflex": -10,
  "B\0Udieresis": -10,
  "B\0Ugrave": -10,
  "B\0Uhungarumlaut": -10,
  "B\0Umacron": -10,
  "B\0Uogonek": -10,
  "B\0Uring": -10,
  "D\0A": -40,
  "D\0Aacute": -40,
  "D\0Abreve": -40,
  "D\0Acircumflex": -40,
  "D\0Adieresis": -40,
  "D\0Agrave": -40,
  "D\0Amacron": -40,
  "D\0Aogonek": -40,
  "D\0Aring": -40,
  "D\0Atilde": -40,
  "D\0V": -40,
  "D\0W": -40,
  "D\0Y": -70,
  "D\0Yacute": -70,
  "D\0Ydieresis": -70,
  "D\0comma": -30,
  "D\0period": -30,
  "Dcaron\0A": -40,
  "Dcaron\0Aacute": -40,
  "Dcaron\0Abreve": -40,
  "Dcaron\0Acircumflex": -40,
  "Dcaron\0Adieresis": -40,
  "Dcaron\0Agrave": -40,
  "Dcaron\0Amacron": -40,
  "Dcaron\0Aogonek": -40,
  "Dcaron\0Aring": -40,
  "Dcaron\0Atilde": -40,
  "Dcaron\0V": -40,
  "Dcaron\0W": -40,
  "Dcaron\0Y": -70,
  "Dcaron\0Yacute": -70,
  "Dcaron\0Ydieresis": -70,
  "Dcaron\0comma": -30,
  "Dcaron\0period": -30,
  "Dcroat\0A": -40,
  "Dcroat\0Aacute": -40,
  "Dcroat\0Abreve": -40,
  "Dcroat\0Acircumflex": -40,
  "Dcroat\0Adieresis": -40,
  "Dcroat\0Agrave": -40,
  "Dcroat\0Amacron": -40,
  "Dcroat\0Aogonek": -40,
  "Dcroat\0Aring": -40,
  "Dcroat\0Atilde": -40,
  "Dcroat\0V": -40,
  "Dcroat\0W": -40,
  "Dcroat\0Y": -70,
  "Dcroat\0Yacute": -70,
  "Dcroat\0Ydieresis": -70,
  "Dcroat\0comma": -30,
  "Dcroat\0period": -30,
  "F\0A": -80,
  "F\0Aacute": -80,
  "F\0Abreve": -80,
  "F\0Acircumflex": -80,
  "F\0Adieresis": -80,
  "F\0Agrave": -80,
  "F\0Amacron": -80,
  "F\0Aogonek": -80,
  "F\0Aring": -80,
  "F\0Atilde": -80,
  "F\0a": -20,
  "F\0aacute": -20,
  "F\0abreve": -20,
  "F\0acircumflex": -20,
  "F\0adieresis": -20,
  "F\0agrave": -20,
  "F\0amacron": -20,
  "F\0aogonek": -20,
  "F\0aring": -20,
  "F\0atilde": -20,
  "F\0comma": -100,
  "F\0period": -100,
  "J\0A": -20,
  "J\0Aacute": -20,
  "J\0Abreve": -20,
  "J\0Acircumflex": -20,
  "J\0Adieresis": -20,
  "J\0Agrave": -20,
  "J\0Amacron": -20,
  "J\0Aogonek": -20,
  "J\0Aring": -20,
  "J\0Atilde": -20,
  "J\0comma": -20,
  "J\0period": -20,
  "J\0u": -20,
  "J\0uacute": -20,
  "J\0ucircumflex": -20,
  "J\0udieresis": -20,
  "J\0ugrave": -20,
  "J\0uhungarumlaut": -20,
  "J\0umacron": -20,
  "J\0uogonek": -20,
  "J\0uring": -20,
  "K\0O": -30,
  "K\0Oacute": -30,
  "K\0Ocircumflex": -30,
  "K\0Odieresis": -30,
  "K\0Ograve": -30,
  "K\0Ohungarumlaut": -30,
  "K\0Omacron": -30,
  "K\0Oslash": -30,
  "K\0Otilde": -30,
  "K\0e": -15,
  "K\0eacute": -15,
  "K\0ecaron": -15,
  "K\0ecircumflex": -15,
  "K\0edieresis": -15,
  "K\0edotaccent": -15,
  "K\0egrave": -15,
  "K\0emacron": -15,
  "K\0eogonek": -15,
  "K\0o": -35,
  "K\0oacute": -35,
  "K\0ocircumflex": -35,
  "K\0odieresis": -35,
  "K\0ograve": -35,
  "K\0ohungarumlaut": -35,
  "K\0omacron": -35,
  "K\0oslash": -35,
  "K\0otilde": -35,
  "K\0u": -30,
  "K\0uacute": -30,
  "K\0ucircumflex": -30,
  "K\0udieresis": -30,
  "K\0ugrave": -30,
  "K\0uhungarumlaut": -30,
  "K\0umacron": -30,
  "K\0uogonek": -30,
  "K\0uring": -30,
  "K\0y": -40,
  "K\0yacute": -40,
  "K\0ydieresis": -40,
  "Kcommaaccent\0O": -30,
  "Kcommaaccent\0Oacute": -30,
  "Kcommaaccent\0Ocircumflex": -30,
  "Kcommaaccent\0Odieresis": -30,
  "Kcommaaccent\0Ograve": -30,
  "Kcommaaccent\0Ohungarumlaut": -30,
  "Kcommaaccent\0Omacron": -30,
  "Kcommaaccent\0Oslash": -30,
  "Kcommaaccent\0Otilde": -30,
  "Kcommaaccent\0e": -15,
  "Kcommaaccent\0eacute": -15,
  "Kcommaaccent\0ecaron": -15,
  "Kcommaaccent\0ecircumflex": -15,
  "Kcommaaccent\0edieresis": -15,
  "Kcommaaccent\0edotaccent": -15,
  "Kcommaaccent\0egrave": -15,
  "Kcommaaccent\0emacron": -15,
  "Kcommaaccent\0eogonek": -15,
  "Kcommaaccent\0o": -35,
  "Kcommaaccent\0oacute": -35,
  "Kcommaaccent\0ocircumflex": -35,
  "Kcommaaccent\0odieresis": -35,
  "Kcommaaccent\0ograve": -35,
  "Kcommaaccent\0ohungarumlaut": -35,
  "Kcommaaccent\0omacron": -35,
  "Kcommaaccent\0oslash": -35,
  "Kcommaaccent\0otilde": -35,
  "Kcommaaccent\0u": -30,
  "Kcommaaccent\0uacute": -30,
  "Kcommaaccent\0ucircumflex": -30,
  "Kcommaaccent\0udieresis": -30,
  "Kcommaaccent\0ugrave": -30,
  "Kcommaaccent\0uhungarumlaut": -30,
  "Kcommaaccent\0umacron": -30,
  "Kcommaaccent\0uogonek": -30,
  "Kcommaaccent\0uring": -30,
  "Kcommaaccent\0y": -40,
  "Kcommaaccent\0yacute": -40,
  "Kcommaaccent\0ydieresis": -40,
  "L\0T": -90,
  "L\0Tcaron": -90,
  "L\0Tcommaaccent": -90,
  "L\0V": -110,
  "L\0W": -80,
  "L\0Y": -120,
  "L\0Yacute": -120,
  "L\0Ydieresis": -120,
  "L\0quotedblright": -140,
  "L\0quoteright": -140,
  "L\0y": -30,
  "L\0yacute": -30,
  "L\0ydieresis": -30,
  "Lacute\0T": -90,
  "Lacute\0Tcaron": -90,
  "Lacute\0Tcommaaccent": -90,
  "Lacute\0V": -110,
  "Lacute\0W": -80,
  "Lacute\0Y": -120,
  "Lacute\0Yacute": -120,
  "Lacute\0Ydieresis": -120,
  "Lacute\0quotedblright": -140,
  "Lacute\0quoteright": -140,
  "Lacute\0y": -30,
  "Lacute\0yacute": -30,
  "Lacute\0ydieresis": -30,
  "Lcommaaccent\0T": -90,
  "Lcommaaccent\0Tcaron": -90,
  "Lcommaaccent\0Tcommaaccent": -90,
  "Lcommaaccent\0V": -110,
  "Lcommaaccent\0W": -80,
  "Lcommaaccent\0Y": -120,
  "Lcommaaccent\0Yacute": -120,
  "Lcommaaccent\0Ydieresis": -120,
  "Lcommaaccent\0quotedblright": -140,
  "Lcommaaccent\0quoteright": -140,
  "Lcommaaccent\0y": -30,
  "Lcommaaccent\0yacute": -30,
  "Lcommaaccent\0ydieresis": -30,
  "Lslash\0T": -90,
  "Lslash\0Tcaron": -90,
  "Lslash\0Tcommaaccent": -90,
  "Lslash\0V": -110,
  "Lslash\0W": -80,
  "Lslash\0Y": -120,
  "Lslash\0Yacute": -120,
  "Lslash\0Ydieresis": -120,
  "Lslash\0quotedblright": -140,
  "Lslash\0quoteright": -140,
  "Lslash\0y": -30,
  "Lslash\0yacute": -30,
  "Lslash\0ydieresis": -30,
  "O\0A": -50,
  "O\0Aacute": -50,
  "O\0Abreve": -50,
  "O\0Acircumflex": -50,
  "O\0Adieresis": -50,
  "O\0Agrave": -50,
  "O\0Amacron": -50,
  "O\0Aogonek": -50,
  "O\0Aring": -50,
  "O\0Atilde": -50,
  "O\0T": -40,
  "O\0Tcaron": -40,
  "O\0Tcommaaccent": -40,
  "O\0V": -50,
  "O\0W": -50,
  "O\0X": -50,
  "O\0Y": -70,
  "O\0Yacute": -70,
  "O\0Ydieresis": -70,
  "O\0comma": -40,
  "O\0period": -40,
  "Oacute\0A": -50,
  "Oacute\0Aacute": -50,
  "Oacute\0Abreve": -50,
  "Oacute\0Acircumflex": -50,
  "Oacute\0Adieresis": -50,
  "Oacute\0Agrave": -50,
  "Oacute\0Amacron": -50,
  "Oacute\0Aogonek": -50,
  "Oacute\0Aring": -50,
  "Oacute\0Atilde": -50,
  "Oacute\0T": -40,
  "Oacute\0Tcaron": -40,
  "Oacute\0Tcommaaccent": -40,
  "Oacute\0V": -50,
  "Oacute\0W": -50,
  "Oacute\0X": -50,
  "Oacute\0Y": -70,
  "Oacute\0Yacute": -70,
  "Oacute\0Ydieresis": -70,
  "Oacute\0comma": -40,
  "Oacute\0period": -40,
  "Ocircumflex\0A": -50,
  "Ocircumflex\0Aacute": -50,
  "Ocircumflex\0Abreve": -50,
  "Ocircumflex\0Acircumflex": -50,
  "Ocircumflex\0Adieresis": -50,
  "Ocircumflex\0Agrave": -50,
  "Ocircumflex\0Amacron": -50,
  "Ocircumflex\0Aogonek": -50,
  "Ocircumflex\0Aring": -50,
  "Ocircumflex\0Atilde": -50,
  "Ocircumflex\0T": -40,
  "Ocircumflex\0Tcaron": -40,
  "Ocircumflex\0Tcommaaccent": -40,
  "Ocircumflex\0V": -50,
  "Ocircumflex\0W": -50,
  "Ocircumflex\0X": -50,
  "Ocircumflex\0Y": -70,
  "Ocircumflex\0Yacute": -70,
  "Ocircumflex\0Ydieresis": -70,
  "Ocircumflex\0comma": -40,
  "Ocircumflex\0period": -40,
  "Odieresis\0A": -50,
  "Odieresis\0Aacute": -50,
  "Odieresis\0Abreve": -50,
  "Odieresis\0Acircumflex": -50,
  "Odieresis\0Adieresis": -50,
  "Odieresis\0Agrave": -50,
  "Odieresis\0Amacron": -50,
  "Odieresis\0Aogonek": -50,
  "Odieresis\0Aring": -50,
  "Odieresis\0Atilde": -50,
  "Odieresis\0T": -40,
  "Odieresis\0Tcaron": -40,
  "Odieresis\0Tcommaaccent": -40,
  "Odieresis\0V": -50,
  "Odieresis\0W": -50,
  "Odieresis\0X": -50,
  "Odieresis\0Y": -70,
  "Odieresis\0Yacute": -70,
  "Odieresis\0Ydieresis": -70,
  "Odieresis\0comma": -40,
  "Odieresis\0period": -40,
  "Ograve\0A": -50,
  "Ograve\0Aacute": -50,
  "Ograve\0Abreve": -50,
  "Ograve\0Acircumflex": -50,
  "Ograve\0Adieresis": -50,
  "Ograve\0Agrave": -50,
  "Ograve\0Amacron": -50,
  "Ograve\0Aogonek": -50,
  "Ograve\0Aring": -50,
  "Ograve\0Atilde": -50,
  "Ograve\0T": -40,
  "Ograve\0Tcaron": -40,
  "Ograve\0Tcommaaccent": -40,
  "Ograve\0V": -50,
  "Ograve\0W": -50,
  "Ograve\0X": -50,
  "Ograve\0Y": -70,
  "Ograve\0Yacute": -70,
  "Ograve\0Ydieresis": -70,
  "Ograve\0comma": -40,
  "Ograve\0period": -40,
  "Ohungarumlaut\0A": -50,
  "Ohungarumlaut\0Aacute": -50,
  "Ohungarumlaut\0Abreve": -50,
  "Ohungarumlaut\0Acircumflex": -50,
  "Ohungarumlaut\0Adieresis": -50,
  "Ohungarumlaut\0Agrave": -50,
  "Ohungarumlaut\0Amacron": -50,
  "Ohungarumlaut\0Aogonek": -50,
  "Ohungarumlaut\0Aring": -50,
  "Ohungarumlaut\0Atilde": -50,
  "Ohungarumlaut\0T": -40,
  "Ohungarumlaut\0Tcaron": -40,
  "Ohungarumlaut\0Tcommaaccent": -40,
  "Ohungarumlaut\0V": -50,
  "Ohungarumlaut\0W": -50,
  "Ohungarumlaut\0X": -50,
  "Ohungarumlaut\0Y": -70,
  "Ohungarumlaut\0Yacute": -70,
  "Ohungarumlaut\0Ydieresis": -70,
  "Ohungarumlaut\0comma": -40,
  "Ohungarumlaut\0period": -40,
  "Omacron\0A": -50,
  "Omacron\0Aacute": -50,
  "Omacron\0Abreve": -50,
  "Omacron\0Acircumflex": -50,
  "Omacron\0Adieresis": -50,
  "Omacron\0Agrave": -50,
  "Omacron\0Amacron": -50,
  "Omacron\0Aogonek": -50,
  "Omacron\0Aring": -50,
  "Omacron\0Atilde": -50,
  "Omacron\0T": -40,
  "Omacron\0Tcaron": -40,
  "Omacron\0Tcommaaccent": -40,
  "Omacron\0V": -50,
  "Omacron\0W": -50,
  "Omacron\0X": -50,
  "Omacron\0Y": -70,
  "Omacron\0Yacute": -70,
  "Omacron\0Ydieresis": -70,
  "Omacron\0comma": -40,
  "Omacron\0period": -40,
  "Oslash\0A": -50,
  "Oslash\0Aacute": -50,
  "Oslash\0Abreve": -50,
  "Oslash\0Acircumflex": -50,
  "Oslash\0Adieresis": -50,
  "Oslash\0Agrave": -50,
  "Oslash\0Amacron": -50,
  "Oslash\0Aogonek": -50,
  "Oslash\0Aring": -50,
  "Oslash\0Atilde": -50,
  "Oslash\0T": -40,
  "Oslash\0Tcaron": -40,
  "Oslash\0Tcommaaccent": -40,
  "Oslash\0V": -50,
  "Oslash\0W": -50,
  "Oslash\0X": -50,
  "Oslash\0Y": -70,
  "Oslash\0Yacute": -70,
  "Oslash\0Ydieresis": -70,
  "Oslash\0comma": -40,
  "Oslash\0period": -40,
  "Otilde\0A": -50,
  "Otilde\0Aacute": -50,
  "Otilde\0Abreve": -50,
  "Otilde\0Acircumflex": -50,
  "Otilde\0Adieresis": -50,
  "Otilde\0Agrave": -50,
  "Otilde\0Amacron": -50,
  "Otilde\0Aogonek": -50,
  "Otilde\0Aring": -50,
  "Otilde\0Atilde": -50,
  "Otilde\0T": -40,
  "Otilde\0Tcaron": -40,
  "Otilde\0Tcommaaccent": -40,
  "Otilde\0V": -50,
  "Otilde\0W": -50,
  "Otilde\0X": -50,
  "Otilde\0Y": -70,
  "Otilde\0Yacute": -70,
  "Otilde\0Ydieresis": -70,
  "Otilde\0comma": -40,
  "Otilde\0period": -40,
  "P\0A": -100,
  "P\0Aacute": -100,
  "P\0Abreve": -100,
  "P\0Acircumflex": -100,
  "P\0Adieresis": -100,
  "P\0Agrave": -100,
  "P\0Amacron": -100,
  "P\0Aogonek": -100,
  "P\0Aring": -100,
  "P\0Atilde": -100,
  "P\0a": -30,
  "P\0aacute": -30,
  "P\0abreve": -30,
  "P\0acircumflex": -30,
  "P\0adieresis": -30,
  "P\0agrave": -30,
  "P\0amacron": -30,
  "P\0aogonek": -30,
  "P\0aring": -30,
  "P\0atilde": -30,
  "P\0comma": -120,
  "P\0e": -30,
  "P\0eacute": -30,
  "P\0ecaron": -30,
  "P\0ecircumflex": -30,
  "P\0edieresis": -30,
  "P\0edotaccent": -30,
  "P\0egrave": -30,
  "P\0emacron": -30,
  "P\0eogonek": -30,
  "P\0o": -40,
  "P\0oacute": -40,
  "P\0ocircumflex": -40,
  "P\0odieresis": -40,
  "P\0ograve": -40,
  "P\0ohungarumlaut": -40,
  "P\0omacron": -40,
  "P\0oslash": -40,
  "P\0otilde": -40,
  "P\0period": -120,
  "Q\0U": -10,
  "Q\0Uacute": -10,
  "Q\0Ucircumflex": -10,
  "Q\0Udieresis": -10,
  "Q\0Ugrave": -10,
  "Q\0Uhungarumlaut": -10,
  "Q\0Umacron": -10,
  "Q\0Uogonek": -10,
  "Q\0Uring": -10,
  "Q\0comma": 20,
  "Q\0period": 20,
  "R\0O": -20,
  "R\0Oacute": -20,
  "R\0Ocircumflex": -20,
  "R\0Odieresis": -20,
  "R\0Ograve": -20,
  "R\0Ohungarumlaut": -20,
  "R\0Omacron": -20,
  "R\0Oslash": -20,
  "R\0Otilde": -20,
  "R\0T": -20,
  "R\0Tcaron": -20,
  "R\0Tcommaaccent": -20,
  "R\0U": -20,
  "R\0Uacute": -20,
  "R\0Ucircumflex": -20,
  "R\0Udieresis": -20,
  "R\0Ugrave": -20,
  "R\0Uhungarumlaut": -20,
  "R\0Umacron": -20,
  "R\0Uogonek": -20,
  "R\0Uring": -20,
  "R\0V": -50,
  "R\0W": -40,
  "R\0Y": -50,
  "R\0Yacute": -50,
  "R\0Ydieresis": -50,
  "Racute\0O": -20,
  "Racute\0Oacute": -20,
  "Racute\0Ocircumflex": -20,
  "Racute\0Odieresis": -20,
  "Racute\0Ograve": -20,
  "Racute\0Ohungarumlaut": -20,
  "Racute\0Omacron": -20,
  "Racute\0Oslash": -20,
  "Racute\0Otilde": -20,
  "Racute\0T": -20,
  "Racute\0Tcaron": -20,
  "Racute\0Tcommaaccent": -20,
  "Racute\0U": -20,
  "Racute\0Uacute": -20,
  "Racute\0Ucircumflex": -20,
  "Racute\0Udieresis": -20,
  "Racute\0Ugrave": -20,
  "Racute\0Uhungarumlaut": -20,
  "Racute\0Umacron": -20,
  "Racute\0Uogonek": -20,
  "Racute\0Uring": -20,
  "Racute\0V": -50,
  "Racute\0W": -40,
  "Racute\0Y": -50,
  "Racute\0Yacute": -50,
  "Racute\0Ydieresis": -50,
  "Rcaron\0O": -20,
  "Rcaron\0Oacute": -20,
  "Rcaron\0Ocircumflex": -20,
  "Rcaron\0Odieresis": -20,
  "Rcaron\0Ograve": -20,
  "Rcaron\0Ohungarumlaut": -20,
  "Rcaron\0Omacron": -20,
  "Rcaron\0Oslash": -20,
  "Rcaron\0Otilde": -20,
  "Rcaron\0T": -20,
  "Rcaron\0Tcaron": -20,
  "Rcaron\0Tcommaaccent": -20,
  "Rcaron\0U": -20,
  "Rcaron\0Uacute": -20,
  "Rcaron\0Ucircumflex": -20,
  "Rcaron\0Udieresis": -20,
  "Rcaron\0Ugrave": -20,
  "Rcaron\0Uhungarumlaut": -20,
  "Rcaron\0Umacron": -20,
  "Rcaron\0Uogonek": -20,
  "Rcaron\0Uring": -20,
  "Rcaron\0V": -50,
  "Rcaron\0W": -40,
  "Rcaron\0Y": -50,
  "Rcaron\0Yacute": -50,
  "Rcaron\0Ydieresis": -50,
  "Rcommaaccent\0O": -20,
  "Rcommaaccent\0Oacute": -20,
  "Rcommaaccent\0Ocircumflex": -20,
  "Rcommaaccent\0Odieresis": -20,
  "Rcommaaccent\0Ograve": -20,
  "Rcommaaccent\0Ohungarumlaut": -20,
  "Rcommaaccent\0Omacron": -20,
  "Rcommaaccent\0Oslash": -20,
  "Rcommaaccent\0Otilde": -20,
  "Rcommaaccent\0T": -20,
  "Rcommaaccent\0Tcaron": -20,
  "Rcommaaccent\0Tcommaaccent": -20,
  "Rcommaaccent\0U": -20,
  "Rcommaaccent\0Uacute": -20,
  "Rcommaaccent\0Ucircumflex": -20,
  "Rcommaaccent\0Udieresis": -20,
  "Rcommaaccent\0Ugrave": -20,
  "Rcommaaccent\0Uhungarumlaut": -20,
  "Rcommaaccent\0Umacron": -20,
  "Rcommaaccent\0Uogonek": -20,
  "Rcommaaccent\0Uring": -20,
  "Rcommaaccent\0V": -50,
  "Rcommaaccent\0W": -40,
  "Rcommaaccent\0Y": -50,
  "Rcommaaccent\0Yacute": -50,
  "Rcommaaccent\0Ydieresis": -50,
  "T\0A": -90,
  "T\0Aacute": -90,
  "T\0Abreve": -90,
  "T\0Acircumflex": -90,
  "T\0Adieresis": -90,
  "T\0Agrave": -90,
  "T\0Amacron": -90,
  "T\0Aogonek": -90,
  "T\0Aring": -90,
  "T\0Atilde": -90,
  "T\0O": -40,
  "T\0Oacute": -40,
  "T\0Ocircumflex": -40,
  "T\0Odieresis": -40,
  "T\0Ograve": -40,
  "T\0Ohungarumlaut": -40,
  "T\0Omacron": -40,
  "T\0Oslash": -40,
  "T\0Otilde": -40,
  "T\0a": -80,
  "T\0aacute": -80,
  "T\0abreve": -80,
  "T\0acircumflex": -80,
  "T\0adieresis": -80,
  "T\0agrave": -80,
  "T\0amacron": -80,
  "T\0aogonek": -80,
  "T\0aring": -80,
  "T\0atilde": -80,
  "T\0colon": -40,
  "T\0comma": -80,
  "T\0e": -60,
  "T\0eacute": -60,
  "T\0ecaron": -60,
  "T\0ecircumflex": -60,
  "T\0edieresis": -60,
  "T\0edotaccent": -60,
  "T\0egrave": -60,
  "T\0emacron": -60,
  "T\0eogonek": -60,
  "T\0hyphen": -120,
  "T\0o": -80,
  "T\0oacute": -80,
  "T\0ocircumflex": -80,
  "T\0odieresis": -80,
  "T\0ograve": -80,
  "T\0ohungarumlaut": -80,
  "T\0omacron": -80,
  "T\0oslash": -80,
  "T\0otilde": -80,
  "T\0period": -80,
  "T\0r": -80,
  "T\0racute": -80,
  "T\0rcommaaccent": -80,
  "T\0semicolon": -40,
  "T\0u": -90,
  "T\0uacute": -90,
  "T\0ucircumflex": -90,
  "T\0udieresis": -90,
  "T\0ugrave": -90,
  "T\0uhungarumlaut": -90,
  "T\0umacron": -90,
  "T\0uogonek": -90,
  "T\0uring": -90,
  "T\0w": -60,
  "T\0y": -60,
  "T\0yacute": -60,
  "T\0ydieresis": -60,
  "Tcaron\0A": -90,
  "Tcaron\0Aacute": -90,
  "Tcaron\0Abreve": -90,
  "Tcaron\0Acircumflex": -90,
  "Tcaron\0Adieresis": -90,
  "Tcaron\0Agrave": -90,
  "Tcaron\0Amacron": -90,
  "Tcaron\0Aogonek": -90,
  "Tcaron\0Aring": -90,
  "Tcaron\0Atilde": -90,
  "Tcaron\0O": -40,
  "Tcaron\0Oacute": -40,
  "Tcaron\0Ocircumflex": -40,
  "Tcaron\0Odieresis": -40,
  "Tcaron\0Ograve": -40,
  "Tcaron\0Ohungarumlaut": -40,
  "Tcaron\0Omacron": -40,
  "Tcaron\0Oslash": -40,
  "Tcaron\0Otilde": -40,
  "Tcaron\0a": -80,
  "Tcaron\0aacute": -80,
  "Tcaron\0abreve": -80,
  "Tcaron\0acircumflex": -80,
  "Tcaron\0adieresis": -80,
  "Tcaron\0agrave": -80,
  "Tcaron\0amacron": -80,
  "Tcaron\0aogonek": -80,
  "Tcaron\0aring": -80,
  "Tcaron\0atilde": -80,
  "Tcaron\0colon": -40,
  "Tcaron\0comma": -80,
  "Tcaron\0e": -60,
  "Tcaron\0eacute": -60,
  "Tcaron\0ecaron": -60,
  "Tcaron\0ecircumflex": -60,
  "Tcaron\0edieresis": -60,
  "Tcaron\0edotaccent": -60,
  "Tcaron\0egrave": -60,
  "Tcaron\0emacron": -60,
  "Tcaron\0eogonek": -60,
  "Tcaron\0hyphen": -120,
  "Tcaron\0o": -80,
  "Tcaron\0oacute": -80,
  "Tcaron\0ocircumflex": -80,
  "Tcaron\0odieresis": -80,
  "Tcaron\0ograve": -80,
  "Tcaron\0ohungarumlaut": -80,
  "Tcaron\0omacron": -80,
  "Tcaron\0oslash": -80,
  "Tcaron\0otilde": -80,
  "Tcaron\0period": -80,
  "Tcaron\0r": -80,
  "Tcaron\0racute": -80,
  "Tcaron\0rcommaaccent": -80,
  "Tcaron\0semicolon": -40,
  "Tcaron\0u": -90,
  "Tcaron\0uacute": -90,
  "Tcaron\0ucircumflex": -90,
  "Tcaron\0udieresis": -90,
  "Tcaron\0ugrave": -90,
  "Tcaron\0uhungarumlaut": -90,
  "Tcaron\0umacron": -90,
  "Tcaron\0uogonek": -90,
  "Tcaron\0uring": -90,
  "Tcaron\0w": -60,
  "Tcaron\0y": -60,
  "Tcaron\0yacute": -60,
  "Tcaron\0ydieresis": -60,
  "Tcommaaccent\0A": -90,
  "Tcommaaccent\0Aacute": -90,
  "Tcommaaccent\0Abreve": -90,
  "Tcommaaccent\0Acircumflex": -90,
  "Tcommaaccent\0Adieresis": -90,
  "Tcommaaccent\0Agrave": -90,
  "Tcommaaccent\0Amacron": -90,
  "Tcommaaccent\0Aogonek": -90,
  "Tcommaaccent\0Aring": -90,
  "Tcommaaccent\0Atilde": -90,
  "Tcommaaccent\0O": -40,
  "Tcommaaccent\0Oacute": -40,
  "Tcommaaccent\0Ocircumflex": -40,
  "Tcommaaccent\0Odieresis": -40,
  "Tcommaaccent\0Ograve": -40,
  "Tcommaaccent\0Ohungarumlaut": -40,
  "Tcommaaccent\0Omacron": -40,
  "Tcommaaccent\0Oslash": -40,
  "Tcommaaccent\0Otilde": -40,
  "Tcommaaccent\0a": -80,
  "Tcommaaccent\0aacute": -80,
  "Tcommaaccent\0abreve": -80,
  "Tcommaaccent\0acircumflex": -80,
  "Tcommaaccent\0adieresis": -80,
  "Tcommaaccent\0agrave": -80,
  "Tcommaaccent\0amacron": -80,
  "Tcommaaccent\0aogonek": -80,
  "Tcommaaccent\0aring": -80,
  "Tcommaaccent\0atilde": -80,
  "Tcommaaccent\0colon": -40,
  "Tcommaaccent\0comma": -80,
  "Tcommaaccent\0e": -60,
  "Tcommaaccent\0eacute": -60,
  "Tcommaaccent\0ecaron": -60,
  "Tcommaaccent\0ecircumflex": -60,
  "Tcommaaccent\0edieresis": -60,
  "Tcommaaccent\0edotaccent": -60,
  "Tcommaaccent\0egrave": -60,
  "Tcommaaccent\0emacron": -60,
  "Tcommaaccent\0eogonek": -60,
  "Tcommaaccent\0hyphen": -120,
  "Tcommaaccent\0o": -80,
  "Tcommaaccent\0oacute": -80,
  "Tcommaaccent\0ocircumflex": -80,
  "Tcommaaccent\0odieresis": -80,
  "Tcommaaccent\0ograve": -80,
  "Tcommaaccent\0ohungarumlaut": -80,
  "Tcommaaccent\0omacron": -80,
  "Tcommaaccent\0oslash": -80,
  "Tcommaaccent\0otilde": -80,
  "Tcommaaccent\0period": -80,
  "Tcommaaccent\0r": -80,
  "Tcommaaccent\0racute": -80,
  "Tcommaaccent\0rcommaaccent": -80,
  "Tcommaaccent\0semicolon": -40,
  "Tcommaaccent\0u": -90,
  "Tcommaaccent\0uacute": -90,
  "Tcommaaccent\0ucircumflex": -90,
  "Tcommaaccent\0udieresis": -90,
  "Tcommaaccent\0ugrave": -90,
  "Tcommaaccent\0uhungarumlaut": -90,
  "Tcommaaccent\0umacron": -90,
  "Tcommaaccent\0uogonek": -90,
  "Tcommaaccent\0uring": -90,
  "Tcommaaccent\0w": -60,
  "Tcommaaccent\0y": -60,
  "Tcommaaccent\0yacute": -60,
  "Tcommaaccent\0ydieresis": -60,
  "U\0A": -50,
  "U\0Aacute": -50,
  "U\0Abreve": -50,
  "U\0Acircumflex": -50,
  "U\0Adieresis": -50,
  "U\0Agrave": -50,
  "U\0Amacron": -50,
  "U\0Aogonek": -50,
  "U\0Aring": -50,
  "U\0Atilde": -50,
  "U\0comma": -30,
  "U\0period": -30,
  "Uacute\0A": -50,
  "Uacute\0Aacute": -50,
  "Uacute\0Abreve": -50,
  "Uacute\0Acircumflex": -50,
  "Uacute\0Adieresis": -50,
  "Uacute\0Agrave": -50,
  "Uacute\0Amacron": -50,
  "Uacute\0Aogonek": -50,
  "Uacute\0Aring": -50,
  "Uacute\0Atilde": -50,
  "Uacute\0comma": -30,
  "Uacute\0period": -30,
  "Ucircumflex\0A": -50,
  "Ucircumflex\0Aacute": -50,
  "Ucircumflex\0Abreve": -50,
  "Ucircumflex\0Acircumflex": -50,
  "Ucircumflex\0Adieresis": -50,
  "Ucircumflex\0Agrave": -50,
  "Ucircumflex\0Amacron": -50,
  "Ucircumflex\0Aogonek": -50,
  "Ucircumflex\0Aring": -50,
  "Ucircumflex\0Atilde": -50,
  "Ucircumflex\0comma": -30,
  "Ucircumflex\0period": -30,
  "Udieresis\0A": -50,
  "Udieresis\0Aacute": -50,
  "Udieresis\0Abreve": -50,
  "Udieresis\0Acircumflex": -50,
  "Udieresis\0Adieresis": -50,
  "Udieresis\0Agrave": -50,
  "Udieresis\0Amacron": -50,
  "Udieresis\0Aogonek": -50,
  "Udieresis\0Aring": -50,
  "Udieresis\0Atilde": -50,
  "Udieresis\0comma": -30,
  "Udieresis\0period": -30,
  "Ugrave\0A": -50,
  "Ugrave\0Aacute": -50,
  "Ugrave\0Abreve": -50,
  "Ugrave\0Acircumflex": -50,
  "Ugrave\0Adieresis": -50,
  "Ugrave\0Agrave": -50,
  "Ugrave\0Amacron": -50,
  "Ugrave\0Aogonek": -50,
  "Ugrave\0Aring": -50,
  "Ugrave\0Atilde": -50,
  "Ugrave\0comma": -30,
  "Ugrave\0period": -30,
  "Uhungarumlaut\0A": -50,
  "Uhungarumlaut\0Aacute": -50,
  "Uhungarumlaut\0Abreve": -50,
  "Uhungarumlaut\0Acircumflex": -50,
  "Uhungarumlaut\0Adieresis": -50,
  "Uhungarumlaut\0Agrave": -50,
  "Uhungarumlaut\0Amacron": -50,
  "Uhungarumlaut\0Aogonek": -50,
  "Uhungarumlaut\0Aring": -50,
  "Uhungarumlaut\0Atilde": -50,
  "Uhungarumlaut\0comma": -30,
  "Uhungarumlaut\0period": -30,
  "Umacron\0A": -50,
  "Umacron\0Aacute": -50,
  "Umacron\0Abreve": -50,
  "Umacron\0Acircumflex": -50,
  "Umacron\0Adieresis": -50,
  "Umacron\0Agrave": -50,
  "Umacron\0Amacron": -50,
  "Umacron\0Aogonek": -50,
  "Umacron\0Aring": -50,
  "Umacron\0Atilde": -50,
  "Umacron\0comma": -30,
  "Umacron\0period": -30,
  "Uogonek\0A": -50,
  "Uogonek\0Aacute": -50,
  "Uogonek\0Abreve": -50,
  "Uogonek\0Acircumflex": -50,
  "Uogonek\0Adieresis": -50,
  "Uogonek\0Agrave": -50,
  "Uogonek\0Amacron": -50,
  "Uogonek\0Aogonek": -50,
  "Uogonek\0Aring": -50,
  "Uogonek\0Atilde": -50,
  "Uogonek\0comma": -30,
  "Uogonek\0period": -30,
  "Uring\0A": -50,
  "Uring\0Aacute": -50,
  "Uring\0Abreve": -50,
  "Uring\0Acircumflex": -50,
  "Uring\0Adieresis": -50,
  "Uring\0Agrave": -50,
  "Uring\0Amacron": -50,
  "Uring\0Aogonek": -50,
  "Uring\0Aring": -50,
  "Uring\0Atilde": -50,
  "Uring\0comma": -30,
  "Uring\0period": -30,
  "V\0A": -80,
  "V\0Aacute": -80,
  "V\0Abreve": -80,
  "V\0Acircumflex": -80,
  "V\0Adieresis": -80,
  "V\0Agrave": -80,
  "V\0Amacron": -80,
  "V\0Aogonek": -80,
  "V\0Aring": -80,
  "V\0Atilde": -80,
  "V\0G": -50,
  "V\0Gbreve": -50,
  "V\0Gcommaaccent": -50,
  "V\0O": -50,
  "V\0Oacute": -50,
  "V\0Ocircumflex": -50,
  "V\0Odieresis": -50,
  "V\0Ograve": -50,
  "V\0Ohungarumlaut": -50,
  "V\0Omacron": -50,
  "V\0Oslash": -50,
  "V\0Otilde": -50,
  "V\0a": -60,
  "V\0aacute": -60,
  "V\0abreve": -60,
  "V\0acircumflex": -60,
  "V\0adieresis": -60,
  "V\0agrave": -60,
  "V\0amacron": -60,
  "V\0aogonek": -60,
  "V\0aring": -60,
  "V\0atilde": -60,
  "V\0colon": -40,
  "V\0comma": -120,
  "V\0e": -50,
  "V\0eacute": -50,
  "V\0ecaron": -50,
  "V\0ecircumflex": -50,
  "V\0edieresis": -50,
  "V\0edotaccent": -50,
  "V\0egrave": -50,
  "V\0emacron": -50,
  "V\0eogonek": -50,
  "V\0hyphen": -80,
  "V\0o": -90,
  "V\0oacute": -90,
  "V\0ocircumflex": -90,
  "V\0odieresis": -90,
  "V\0ograve": -90,
  "V\0ohungarumlaut": -90,
  "V\0omacron": -90,
  "V\0oslash": -90,
  "V\0otilde": -90,
  "V\0period": -120,
  "V\0semicolon": -40,
  "V\0u": -60,
  "V\0uacute": -60,
  "V\0ucircumflex": -60,
  "V\0udieresis": -60,
  "V\0ugrave": -60,
  "V\0uhungarumlaut": -60,
  "V\0umacron": -60,
  "V\0uogonek": -60,
  "V\0uring": -60,
  "W\0A": -60,
  "W\0Aacute": -60,
  "W\0Abreve": -60,
  "W\0Acircumflex": -60,
  "W\0Adieresis": -60,
  "W\0Agrave": -60,
  "W\0Amacron": -60,
  "W\0Aogonek": -60,
  "W\0Aring": -60,
  "W\0Atilde": -60,
  "W\0O": -20,
  "W\0Oacute": -20,
  "W\0Ocircumflex": -20,
  "W\0Odieresis": -20,
  "W\0Ograve": -20,
  "W\0Ohungarumlaut": -20,
  "W\0Omacron": -20,
  "W\0Oslash": -20,
  "W\0Otilde": -20,
  "W\0a": -40,
  "W\0aacute": -40,
  "W\0abreve": -40,
  "W\0acircumflex": -40,
  "W\0adieresis": -40,
  "W\0agrave": -40,
  "W\0amacron": -40,
  "W\0aogonek": -40,
  "W\0aring": -40,
  "W\0atilde": -40,
  "W\0colon": -10,
  "W\0comma": -80,
  "W\0e": -35,
  "W\0eacute": -35,
  "W\0ecaron": -35,
  "W\0ecircumflex": -35,
  "W\0edieresis": -35,
  "W\0edotaccent": -35,
  "W\0egrave": -35,
  "W\0emacron": -35,
  "W\0eogonek": -35,
  "W\0hyphen": -40,
  "W\0o": -60,
  "W\0oacute": -60,
  "W\0ocircumflex": -60,
  "W\0odieresis": -60,
  "W\0ograve": -60,
  "W\0ohungarumlaut": -60,
  "W\0omacron": -60,
  "W\0oslash": -60,
  "W\0otilde": -60,
  "W\0period": -80,
  "W\0semicolon": -10,
  "W\0u": -45,
  "W\0uacute": -45,
  "W\0ucircumflex": -45,
  "W\0udieresis": -45,
  "W\0ugrave": -45,
  "W\0uhungarumlaut": -45,
  "W\0umacron": -45,
  "W\0uogonek": -45,
  "W\0uring": -45,
  "W\0y": -20,
  "W\0yacute": -20,
  "W\0ydieresis": -20,
  "Y\0A": -110,
  "Y\0Aacute": -110,
  "Y\0Abreve": -110,
  "Y\0Acircumflex": -110,
  "Y\0Adieresis": -110,
  "Y\0Agrave": -110,
  "Y\0Amacron": -110,
  "Y\0Aogonek": -110,
  "Y\0Aring": -110,
  "Y\0Atilde": -110,
  "Y\0O": -70,
  "Y\0Oacute": -70,
  "Y\0Ocircumflex": -70,
  "Y\0Odieresis": -70,
  "Y\0Ograve": -70,
  "Y\0Ohungarumlaut": -70,
  "Y\0Omacron": -70,
  "Y\0Oslash": -70,
  "Y\0Otilde": -70,
  "Y\0a": -90,
  "Y\0aacute": -90,
  "Y\0abreve": -90,
  "Y\0acircumflex": -90,
  "Y\0adieresis": -90,
  "Y\0agrave": -90,
  "Y\0amacron": -90,
  "Y\0aogonek": -90,
  "Y\0aring": -90,
  "Y\0atilde": -90,
  "Y\0colon": -50,
  "Y\0comma": -100,
  "Y\0e": -80,
  "Y\0eacute": -80,
  "Y\0ecaron": -80,
  "Y\0ecircumflex": -80,
  "Y\0edieresis": -80,
  "Y\0edotaccent": -80,
  "Y\0egrave": -80,
  "Y\0emacron": -80,
  "Y\0eogonek": -80,
  "Y\0o": -100,
  "Y\0oacute": -100,
  "Y\0ocircumflex": -100,
  "Y\0odieresis": -100,
  "Y\0ograve": -100,
  "Y\0ohungarumlaut": -100,
  "Y\0omacron": -100,
  "Y\0oslash": -100,
  "Y\0otilde": -100,
  "Y\0period": -100,
  "Y\0semicolon": -50,
  "Y\0u": -100,
  "Y\0uacute": -100,
  "Y\0ucircumflex": -100,
  "Y\0udieresis": -100,
  "Y\0ugrave": -100,
  "Y\0uhungarumlaut": -100,
  "Y\0umacron": -100,
  "Y\0uogonek": -100,
  "Y\0uring": -100,
  "Yacute\0A": -110,
  "Yacute\0Aacute": -110,
  "Yacute\0Abreve": -110,
  "Yacute\0Acircumflex": -110,
  "Yacute\0Adieresis": -110,
  "Yacute\0Agrave": -110,
  "Yacute\0Amacron": -110,
  "Yacute\0Aogonek": -110,
  "Yacute\0Aring": -110,
  "Yacute\0Atilde": -110,
  "Yacute\0O": -70,
  "Yacute\0Oacute": -70,
  "Yacute\0Ocircumflex": -70,
  "Yacute\0Odieresis": -70,
  "Yacute\0Ograve": -70,
  "Yacute\0Ohungarumlaut": -70,
  "Yacute\0Omacron": -70,
  "Yacute\0Oslash": -70,
  "Yacute\0Otilde": -70,
  "Yacute\0a": -90,
  "Yacute\0aacute": -90,
  "Yacute\0abreve": -90,
  "Yacute\0acircumflex": -90,
  "Yacute\0adieresis": -90,
  "Yacute\0agrave": -90,
  "Yacute\0amacron": -90,
  "Yacute\0aogonek": -90,
  "Yacute\0aring": -90,
  "Yacute\0atilde": -90,
  "Yacute\0colon": -50,
  "Yacute\0comma": -100,
  "Yacute\0e": -80,
  "Yacute\0eacute": -80,
  "Yacute\0ecaron": -80,
  "Yacute\0ecircumflex": -80,
  "Yacute\0edieresis": -80,
  "Yacute\0edotaccent": -80,
  "Yacute\0egrave": -80,
  "Yacute\0emacron": -80,
  "Yacute\0eogonek": -80,
  "Yacute\0o": -100,
  "Yacute\0oacute": -100,
  "Yacute\0ocircumflex": -100,
  "Yacute\0odieresis": -100,
  "Yacute\0ograve": -100,
  "Yacute\0ohungarumlaut": -100,
  "Yacute\0omacron": -100,
  "Yacute\0oslash": -100,
  "Yacute\0otilde": -100,
  "Yacute\0period": -100,
  "Yacute\0semicolon": -50,
  "Yacute\0u": -100,
  "Yacute\0uacute": -100,
  "Yacute\0ucircumflex": -100,
  "Yacute\0udieresis": -100,
  "Yacute\0ugrave": -100,
  "Yacute\0uhungarumlaut": -100,
  "Yacute\0umacron": -100,
  "Yacute\0uogonek": -100,
  "Yacute\0uring": -100,
  "Ydieresis\0A": -110,
  "Ydieresis\0Aacute": -110,
  "Ydieresis\0Abreve": -110,
  "Ydieresis\0Acircumflex": -110,
  "Ydieresis\0Adieresis": -110,
  "Ydieresis\0Agrave": -110,
  "Ydieresis\0Amacron": -110,
  "Ydieresis\0Aogonek": -110,
  "Ydieresis\0Aring": -110,
  "Ydieresis\0Atilde": -110,
  "Ydieresis\0O": -70,
  "Ydieresis\0Oacute": -70,
  "Ydieresis\0Ocircumflex": -70,
  "Ydieresis\0Odieresis": -70,
  "Ydieresis\0Ograve": -70,
  "Ydieresis\0Ohungarumlaut": -70,
  "Ydieresis\0Omacron": -70,
  "Ydieresis\0Oslash": -70,
  "Ydieresis\0Otilde": -70,
  "Ydieresis\0a": -90,
  "Ydieresis\0aacute": -90,
  "Ydieresis\0abreve": -90,
  "Ydieresis\0acircumflex": -90,
  "Ydieresis\0adieresis": -90,
  "Ydieresis\0agrave": -90,
  "Ydieresis\0amacron": -90,
  "Ydieresis\0aogonek": -90,
  "Ydieresis\0aring": -90,
  "Ydieresis\0atilde": -90,
  "Ydieresis\0colon": -50,
  "Ydieresis\0comma": -100,
  "Ydieresis\0e": -80,
  "Ydieresis\0eacute": -80,
  "Ydieresis\0ecaron": -80,
  "Ydieresis\0ecircumflex": -80,
  "Ydieresis\0edieresis": -80,
  "Ydieresis\0edotaccent": -80,
  "Ydieresis\0egrave": -80,
  "Ydieresis\0emacron": -80,
  "Ydieresis\0eogonek": -80,
  "Ydieresis\0o": -100,
  "Ydieresis\0oacute": -100,
  "Ydieresis\0ocircumflex": -100,
  "Ydieresis\0odieresis": -100,
  "Ydieresis\0ograve": -100,
  "Ydieresis\0ohungarumlaut": -100,
  "Ydieresis\0omacron": -100,
  "Ydieresis\0oslash": -100,
  "Ydieresis\0otilde": -100,
  "Ydieresis\0period": -100,
  "Ydieresis\0semicolon": -50,
  "Ydieresis\0u": -100,
  "Ydieresis\0uacute": -100,
  "Ydieresis\0ucircumflex": -100,
  "Ydieresis\0udieresis": -100,
  "Ydieresis\0ugrave": -100,
  "Ydieresis\0uhungarumlaut": -100,
  "Ydieresis\0umacron": -100,
  "Ydieresis\0uogonek": -100,
  "Ydieresis\0uring": -100,
  "a\0g": -10,
  "a\0gbreve": -10,
  "a\0gcommaaccent": -10,
  "a\0v": -15,
  "a\0w": -15,
  "a\0y": -20,
  "a\0yacute": -20,
  "a\0ydieresis": -20,
  "aacute\0g": -10,
  "aacute\0gbreve": -10,
  "aacute\0gcommaaccent": -10,
  "aacute\0v": -15,
  "aacute\0w": -15,
  "aacute\0y": -20,
  "aacute\0yacute": -20,
  "aacute\0ydieresis": -20,
  "abreve\0g": -10,
  "abreve\0gbreve": -10,
  "abreve\0gcommaaccent": -10,
  "abreve\0v": -15,
  "abreve\0w": -15,
  "abreve\0y": -20,
  "abreve\0yacute": -20,
  "abreve\0ydieresis": -20,
  "acircumflex\0g": -10,
  "acircumflex\0gbreve": -10,
  "acircumflex\0gcommaaccent": -10,
  "acircumflex\0v": -15,
  "acircumflex\0w": -15,
  "acircumflex\0y": -20,
  "acircumflex\0yacute": -20,
  "acircumflex\0ydieresis": -20,
  "adieresis\0g": -10,
  "adieresis\0gbreve": -10,
  "adieresis\0gcommaaccent": -10,
  "adieresis\0v": -15,
  "adieresis\0w": -15,
  "adieresis\0y": -20,
  "adieresis\0yacute": -20,
  "adieresis\0ydieresis": -20,
  "agrave\0g": -10,
  "agrave\0gbreve": -10,
  "agrave\0gcommaaccent": -10,
  "agrave\0v": -15,
  "agrave\0w": -15,
  "agrave\0y": -20,
  "agrave\0yacute": -20,
  "agrave\0ydieresis": -20,
  "amacron\0g": -10,
  "amacron\0gbreve": -10,
  "amacron\0gcommaaccent": -10,
  "amacron\0v": -15,
  "amacron\0w": -15,
  "amacron\0y": -20,
  "amacron\0yacute": -20,
  "amacron\0ydieresis": -20,
  "aogonek\0g": -10,
  "aogonek\0gbreve": -10,
  "aogonek\0gcommaaccent": -10,
  "aogonek\0v": -15,
  "aogonek\0w": -15,
  "aogonek\0y": -20,
  "aogonek\0yacute": -20,
  "aogonek\0ydieresis": -20,
  "aring\0g": -10,
  "aring\0gbreve": -10,
  "aring\0gcommaaccent": -10,
  "aring\0v": -15,
  "aring\0w": -15,
  "aring\0y": -20,
  "aring\0yacute": -20,
  "aring\0ydieresis": -20,
  "atilde\0g": -10,
  "atilde\0gbreve": -10,
  "atilde\0gcommaaccent": -10,
  "atilde\0v": -15,
  "atilde\0w": -15,
  "atilde\0y": -20,
  "atilde\0yacute": -20,
  "atilde\0ydieresis": -20,
  "b\0l": -10,
  "b\0lacute": -10,
  "b\0lcommaaccent": -10,
  "b\0lslash": -10,
  "b\0u": -20,
  "b\0uacute": -20,
  "b\0ucircumflex": -20,
  "b\0udieresis": -20,
  "b\0ugrave": -20,
  "b\0uhungarumlaut": -20,
  "b\0umacron": -20,
  "b\0uogonek": -20,
  "b\0uring": -20,
  "b\0v": -20,
  "b\0y": -20,
  "b\0yacute": -20,
  "b\0ydieresis": -20,
  "c\0h": -10,
  "c\0k": -20,
  "c\0kcommaaccent": -20,
  "c\0l": -20,
  "c\0lacute": -20,
  "c\0lcommaaccent": -20,
  "c\0lslash": -20,
  "c\0y": -10,
  "c\0yacute": -10,
  "c\0ydieresis": -10,
  "cacute\0h": -10,
  "cacute\0k": -20,
  "cacute\0kcommaaccent": -20,
  "cacute\0l": -20,
  "cacute\0lacute": -20,
  "cacute\0lcommaaccent": -20,
  "cacute\0lslash": -20,
  "cacute\0y": -10,
  "cacute\0yacute": -10,
  "cacute\0ydieresis": -10,
  "ccaron\0h": -10,
  "ccaron\0k": -20,
  "ccaron\0kcommaaccent": -20,
  "ccaron\0l": -20,
  "ccaron\0lacute": -20,
  "ccaron\0lcommaaccent": -20,
  "ccaron\0lslash": -20,
  "ccaron\0y": -10,
  "ccaron\0yacute": -10,
  "ccaron\0ydieresis": -10,
  "ccedilla\0h": -10,
  "ccedilla\0k": -20,
  "ccedilla\0kcommaaccent": -20,
  "ccedilla\0l": -20,
  "ccedilla\0lacute": -20,
  "ccedilla\0lcommaaccent": -20,
  "ccedilla\0lslash": -20,
  "ccedilla\0y": -10,
  "ccedilla\0yacute": -10,
  "ccedilla\0ydieresis": -10,
  "colon\0space": -40,
  "comma\0quotedblright": -120,
  "comma\0quoteright": -120,
  "comma\0space": -40,
  "d\0d": -10,
  "d\0dcroat": -10,
  "d\0v": -15,
  "d\0w": -15,
  "d\0y": -15,
  "d\0yacute": -15,
  "d\0ydieresis": -15,
  "dcroat\0d": -10,
  "dcroat\0dcroat": -10,
  "dcroat\0v": -15,
  "dcroat\0w": -15,
  "dcroat\0y": -15,
  "dcroat\0yacute": -15,
  "dcroat\0ydieresis": -15,
  "e\0comma": 10,
  "e\0period": 20,
  "e\0v": -15,
  "e\0w": -15,
  "e\0x": -15,
  "e\0y": -15,
  "e\0yacute": -15,
  "e\0ydieresis": -15,
  "eacute\0comma": 10,
  "eacute\0period": 20,
  "eacute\0v": -15,
  "eacute\0w": -15,
  "eacute\0x": -15,
  "eacute\0y": -15,
  "eacute\0yacute": -15,
  "eacute\0ydieresis": -15,
  "ecaron\0comma": 10,
  "ecaron\0period": 20,
  "ecaron\0v": -15,
  "ecaron\0w": -15,
  "ecaron\0x": -15,
  "ecaron\0y": -15,
  "ecaron\0yacute": -15,
  "ecaron\0ydieresis": -15,
  "ecircumflex\0comma": 10,
  "ecircumflex\0period": 20,
  "ecircumflex\0v": -15,
  "ecircumflex\0w": -15,
  "ecircumflex\0x": -15,
  "ecircumflex\0y": -15,
  "ecircumflex\0yacute": -15,
  "ecircumflex\0ydieresis": -15,
  "edieresis\0comma": 10,
  "edieresis\0period": 20,
  "edieresis\0v": -15,
  "edieresis\0w": -15,
  "edieresis\0x": -15,
  "edieresis\0y": -15,
  "edieresis\0yacute": -15,
  "edieresis\0ydieresis": -15,
  "edotaccent\0comma": 10,
  "edotaccent\0period": 20,
  "edotaccent\0v": -15,
  "edotaccent\0w": -15,
  "edotaccent\0x": -15,
  "edotaccent\0y": -15,
  "edotaccent\0yacute": -15,
  "edotaccent\0ydieresis": -15,
  "egrave\0comma": 10,
  "egrave\0period": 20,
  "egrave\0v": -15,
  "egrave\0w": -15,
  "egrave\0x": -15,
  "egrave\0y": -15,
  "egrave\0yacute": -15,
  "egrave\0ydieresis": -15,
  "emacron\0comma": 10,
  "emacron\0period": 20,
  "emacron\0v": -15,
  "emacron\0w": -15,
  "emacron\0x": -15,
  "emacron\0y": -15,
  "emacron\0yacute": -15,
  "emacron\0ydieresis": -15,
  "eogonek\0comma": 10,
  "eogonek\0period": 20,
  "eogonek\0v": -15,
  "eogonek\0w": -15,
  "eogonek\0x": -15,
  "eogonek\0y": -15,
  "eogonek\0yacute": -15,
  "eogonek\0ydieresis": -15,
  "f\0comma": -10,
  "f\0e": -10,
  "f\0eacute": -10,
  "f\0ecaron": -10,
  "f\0ecircumflex": -10,
  "f\0edieresis": -10,
  "f\0edotaccent": -10,
  "f\0egrave": -10,
  "f\0emacron": -10,
  "f\0eogonek": -10,
  "f\0o": -20,
  "f\0oacute": -20,
  "f\0ocircumflex": -20,
  "f\0odieresis": -20,
  "f\0ograve": -20,
  "f\0ohungarumlaut": -20,
  "f\0omacron": -20,
  "f\0oslash": -20,
  "f\0otilde": -20,
  "f\0period": -10,
  "f\0quotedblright": 30,
  "f\0quoteright": 30,
  "g\0e": 10,
  "g\0eacute": 10,
  "g\0ecaron": 10,
  "g\0ecircumflex": 10,
  "g\0edieresis": 10,
  "g\0edotaccent": 10,
  "g\0egrave": 10,
  "g\0emacron": 10,
  "g\0eogonek": 10,
  "g\0g": -10,
  "g\0gbreve": -10,
  "g\0gcommaaccent": -10,
  "gbreve\0e": 10,
  "gbreve\0eacute": 10,
  "gbreve\0ecaron": 10,
  "gbreve\0ecircumflex": 10,
  "gbreve\0edieresis": 10,
  "gbreve\0edotaccent": 10,
  "gbreve\0egrave": 10,
  "gbreve\0emacron": 10,
  "gbreve\0eogonek": 10,
  "gbreve\0g": -10,
  "gbreve\0gbreve": -10,
  "gbreve\0gcommaaccent": -10,
  "gcommaaccent\0e": 10,
  "gcommaaccent\0eacute": 10,
  "gcommaaccent\0ecaron": 10,
  "gcommaaccent\0ecircumflex": 10,
  "gcommaaccent\0edieresis": 10,
  "gcommaaccent\0edotaccent": 10,
  "gcommaaccent\0egrave": 10,
  "gcommaaccent\0emacron": 10,
  "gcommaaccent\0eogonek": 10,
  "gcommaaccent\0g": -10,
  "gcommaaccent\0gbreve": -10,
  "gcommaaccent\0gcommaaccent": -10,
  "h\0y": -20,
  "h\0yacute": -20,
  "h\0ydieresis": -20,
  "k\0o": -15,
  "k\0oacute": -15,
  "k\0ocircumflex": -15,
  "k\0odieresis": -15,
  "k\0ograve": -15,
  "k\0ohungarumlaut": -15,
  "k\0omacron": -15,
  "k\0oslash": -15,
  "k\0otilde": -15,
  "kcommaaccent\0o": -15,
  "kcommaaccent\0oacute": -15,
  "kcommaaccent\0ocircumflex": -15,
  "kcommaaccent\0odieresis": -15,
  "kcommaaccent\0ograve": -15,
  "kcommaaccent\0ohungarumlaut": -15,
  "kcommaaccent\0omacron": -15,
  "kcommaaccent\0oslash": -15,
  "kcommaaccent\0otilde": -15,
  "l\0w": -15,
  "l\0y": -15,
  "l\0yacute": -15,
  "l\0ydieresis": -15,
  "lacute\0w": -15,
  "lacute\0y": -15,
  "lacute\0yacute": -15,
  "lacute\0ydieresis": -15,
  "lcommaaccent\0w": -15,
  "lcommaaccent\0y": -15,
  "lcommaaccent\0yacute": -15,
  "lcommaaccent\0ydieresis": -15,
  "lslash\0w": -15,
  "lslash\0y": -15,
  "lslash\0yacute": -15,
  "lslash\0ydieresis": -15,
  "m\0u": -20,
  "m\0uacute": -20,
  "m\0ucircumflex": -20,
  "m\0udieresis": -20,
  "m\0ugrave": -20,
  "m\0uhungarumlaut": -20,
  "m\0umacron": -20,
  "m\0uogonek": -20,
  "m\0uring": -20,
  "m\0y": -30,
  "m\0yacute": -30,
  "m\0ydieresis": -30,
  "n\0u": -10,
  "n\0uacute": -10,
  "n\0ucircumflex": -10,
  "n\0udieresis": -10,
  "n\0ugrave": -10,
  "n\0uhungarumlaut": -10,
  "n\0umacron": -10,
  "n\0uogonek": -10,
  "n\0uring": -10,
  "n\0v": -40,
  "n\0y": -20,
  "n\0yacute": -20,
  "n\0ydieresis": -20,
  "nacute\0u": -10,
  "nacute\0uacute": -10,
  "nacute\0ucircumflex": -10,
  "nacute\0udieresis": -10,
  "nacute\0ugrave": -10,
  "nacute\0uhungarumlaut": -10,
  "nacute\0umacron": -10,
  "nacute\0uogonek": -10,
  "nacute\0uring": -10,
  "nacute\0v": -40,
  "nacute\0y": -20,
  "nacute\0yacute": -20,
  "nacute\0ydieresis": -20,
  "ncaron\0u": -10,
  "ncaron\0uacute": -10,
  "ncaron\0ucircumflex": -10,
  "ncaron\0udieresis": -10,
  "ncaron\0ugrave": -10,
  "ncaron\0uhungarumlaut": -10,
  "ncaron\0umacron": -10,
  "ncaron\0uogonek": -10,
  "ncaron\0uring": -10,
  "ncaron\0v": -40,
  "ncaron\0y": -20,
  "ncaron\0yacute": -20,
  "ncaron\0ydieresis": -20,
  "ncommaaccent\0u": -10,
  "ncommaaccent\0uacute": -10,
  "ncommaaccent\0ucircumflex": -10,
  "ncommaaccent\0udieresis": -10,
  "ncommaaccent\0ugrave": -10,
  "ncommaaccent\0uhungarumlaut": -10,
  "ncommaaccent\0umacron": -10,
  "ncommaaccent\0uogonek": -10,
  "ncommaaccent\0uring": -10,
  "ncommaaccent\0v": -40,
  "ncommaaccent\0y": -20,
  "ncommaaccent\0yacute": -20,
  "ncommaaccent\0ydieresis": -20,
  "ntilde\0u": -10,
  "ntilde\0uacute": -10,
  "ntilde\0ucircumflex": -10,
  "ntilde\0udieresis": -10,
  "ntilde\0ugrave": -10,
  "ntilde\0uhungarumlaut": -10,
  "ntilde\0umacron": -10,
  "ntilde\0uogonek": -10,
  "ntilde\0uring": -10,
  "ntilde\0v": -40,
  "ntilde\0y": -20,
  "ntilde\0yacute": -20,
  "ntilde\0ydieresis": -20,
  "o\0v": -20,
  "o\0w": -15,
  "o\0x": -30,
  "o\0y": -20,
  "o\0yacute": -20,
  "o\0ydieresis": -20,
  "oacute\0v": -20,
  "oacute\0w": -15,
  "oacute\0x": -30,
  "oacute\0y": -20,
  "oacute\0yacute": -20,
  "oacute\0ydieresis": -20,
  "ocircumflex\0v": -20,
  "ocircumflex\0w": -15,
  "ocircumflex\0x": -30,
  "ocircumflex\0y": -20,
  "ocircumflex\0yacute": -20,
  "ocircumflex\0ydieresis": -20,
  "odieresis\0v": -20,
  "odieresis\0w": -15,
  "odieresis\0x": -30,
  "odieresis\0y": -20,
  "odieresis\0yacute": -20,
  "odieresis\0ydieresis": -20,
  "ograve\0v": -20,
  "ograve\0w": -15,
  "ograve\0x": -30,
  "ograve\0y": -20,
  "ograve\0yacute": -20,
  "ograve\0ydieresis": -20,
  "ohungarumlaut\0v": -20,
  "ohungarumlaut\0w": -15,
  "ohungarumlaut\0x": -30,
  "ohungarumlaut\0y": -20,
  "ohungarumlaut\0yacute": -20,
  "ohungarumlaut\0ydieresis": -20,
  "omacron\0v": -20,
  "omacron\0w": -15,
  "omacron\0x": -30,
  "omacron\0y": -20,
  "omacron\0yacute": -20,
  "omacron\0ydieresis": -20,
  "oslash\0v": -20,
  "oslash\0w": -15,
  "oslash\0x": -30,
  "oslash\0y": -20,
  "oslash\0yacute": -20,
  "oslash\0ydieresis": -20,
  "otilde\0v": -20,
  "otilde\0w": -15,
  "otilde\0x": -30,
  "otilde\0y": -20,
  "otilde\0yacute": -20,
  "otilde\0ydieresis": -20,
  "p\0y": -15,
  "p\0yacute": -15,
  "p\0ydieresis": -15,
  "period\0quotedblright": -120,
  "period\0quoteright": -120,
  "period\0space": -40,
  "quotedblright\0space": -80,
  "quoteleft\0quoteleft": -46,
  "quoteright\0d": -80,
  "quoteright\0dcroat": -80,
  "quoteright\0l": -20,
  "quoteright\0lacute": -20,
  "quoteright\0lcommaaccent": -20,
  "quoteright\0lslash": -20,
  "quoteright\0quoteright": -46,
  "quoteright\0r": -40,
  "quoteright\0racute": -40,
  "quoteright\0rcaron": -40,
  "quoteright\0rcommaaccent": -40,
  "quoteright\0s": -60,
  "quoteright\0sacute": -60,
  "quoteright\0scaron": -60,
  "quoteright\0scedilla": -60,
  "quoteright\0scommaaccent": -60,
  "quoteright\0space": -80,
  "quoteright\0v": -20,
  "r\0c": -20,
  "r\0cacute": -20,
  "r\0ccaron": -20,
  "r\0ccedilla": -20,
  "r\0comma": -60,
  "r\0d": -20,
  "r\0dcroat": -20,
  "r\0g": -15,
  "r\0gbreve": -15,
  "r\0gcommaaccent": -15,
  "r\0hyphen": -20,
  "r\0o": -20,
  "r\0oacute": -20,
  "r\0ocircumflex": -20,
  "r\0odieresis": -20,
  "r\0ograve": -20,
  "r\0ohungarumlaut": -20,
  "r\0omacron": -20,
  "r\0oslash": -20,
  "r\0otilde": -20,
  "r\0period": -60,
  "r\0q": -20,
  "r\0s": -15,
  "r\0sacute": -15,
  "r\0scaron": -15,
  "r\0scedilla": -15,
  "r\0scommaaccent": -15,
  "r\0t": 20,
  "r\0tcommaaccent": 20,
  "r\0v": 10,
  "r\0y": 10,
  "r\0yacute": 10,
  "r\0ydieresis": 10,
  "racute\0c": -20,
  "racute\0cacute": -20,
  "racute\0ccaron": -20,
  "racute\0ccedilla": -20,
  "racute\0comma": -60,
  "racute\0d": -20,
  "racute\0dcroat": -20,
  "racute\0g": -15,
  "racute\0gbreve": -15,
  "racute\0gcommaaccent": -15,
  "racute\0hyphen": -20,
  "racute\0o": -20,
  "racute\0oacute": -20,
  "racute\0ocircumflex": -20,
  "racute\0odieresis": -20,
  "racute\0ograve": -20,
  "racute\0ohungarumlaut": -20,
  "racute\0omacron": -20,
  "racute\0oslash": -20,
  "racute\0otilde": -20,
  "racute\0period": -60,
  "racute\0q": -20,
  "racute\0s": -15,
  "racute\0sacute": -15,
  "racute\0scaron": -15,
  "racute\0scedilla": -15,
  "racute\0scommaaccent": -15,
  "racute\0t": 20,
  "racute\0tcommaaccent": 20,
  "racute\0v": 10,
  "racute\0y": 10,
  "racute\0yacute": 10,
  "racute\0ydieresis": 10,
  "rcaron\0c": -20,
  "rcaron\0cacute": -20,
  "rcaron\0ccaron": -20,
  "rcaron\0ccedilla": -20,
  "rcaron\0comma": -60,
  "rcaron\0d": -20,
  "rcaron\0dcroat": -20,
  "rcaron\0g": -15,
  "rcaron\0gbreve": -15,
  "rcaron\0gcommaaccent": -15,
  "rcaron\0hyphen": -20,
  "rcaron\0o": -20,
  "rcaron\0oacute": -20,
  "rcaron\0ocircumflex": -20,
  "rcaron\0odieresis": -20,
  "rcaron\0ograve": -20,
  "rcaron\0ohungarumlaut": -20,
  "rcaron\0omacron": -20,
  "rcaron\0oslash": -20,
  "rcaron\0otilde": -20,
  "rcaron\0period": -60,
  "rcaron\0q": -20,
  "rcaron\0s": -15,
  "rcaron\0sacute": -15,
  "rcaron\0scaron": -15,
  "rcaron\0scedilla": -15,
  "rcaron\0scommaaccent": -15,
  "rcaron\0t": 20,
  "rcaron\0tcommaaccent": 20,
  "rcaron\0v": 10,
  "rcaron\0y": 10,
  "rcaron\0yacute": 10,
  "rcaron\0ydieresis": 10,
  "rcommaaccent\0c": -20,
  "rcommaaccent\0cacute": -20,
  "rcommaaccent\0ccaron": -20,
  "rcommaaccent\0ccedilla": -20,
  "rcommaaccent\0comma": -60,
  "rcommaaccent\0d": -20,
  "rcommaaccent\0dcroat": -20,
  "rcommaaccent\0g": -15,
  "rcommaaccent\0gbreve": -15,
  "rcommaaccent\0gcommaaccent": -15,
  "rcommaaccent\0hyphen": -20,
  "rcommaaccent\0o": -20,
  "rcommaaccent\0oacute": -20,
  "rcommaaccent\0ocircumflex": -20,
  "rcommaaccent\0odieresis": -20,
  "rcommaaccent\0ograve": -20,
  "rcommaaccent\0ohungarumlaut": -20,
  "rcommaaccent\0omacron": -20,
  "rcommaaccent\0oslash": -20,
  "rcommaaccent\0otilde": -20,
  "rcommaaccent\0period": -60,
  "rcommaaccent\0q": -20,
  "rcommaaccent\0s": -15,
  "rcommaaccent\0sacute": -15,
  "rcommaaccent\0scaron": -15,
  "rcommaaccent\0scedilla": -15,
  "rcommaaccent\0scommaaccent": -15,
  "rcommaaccent\0t": 20,
  "rcommaaccent\0tcommaaccent": 20,
  "rcommaaccent\0v": 10,
  "rcommaaccent\0y": 10,
  "rcommaaccent\0yacute": 10,
  "rcommaaccent\0ydieresis": 10,
  "s\0w": -15,
  "sacute\0w": -15,
  "scaron\0w": -15,
  "scedilla\0w": -15,
  "scommaaccent\0w": -15,
  "semicolon\0space": -40,
  "space\0T": -100,
  "space\0Tcaron": -100,
  "space\0Tcommaaccent": -100,
  "space\0V": -80,
  "space\0W": -80,
  "space\0Y": -120,
  "space\0Yacute": -120,
  "space\0Ydieresis": -120,
  "space\0quotedblleft": -80,
  "space\0quoteleft": -60,
  "v\0a": -20,
  "v\0aacute": -20,
  "v\0abreve": -20,
  "v\0acircumflex": -20,
  "v\0adieresis": -20,
  "v\0agrave": -20,
  "v\0amacron": -20,
  "v\0aogonek": -20,
  "v\0aring": -20,
  "v\0atilde": -20,
  "v\0comma": -80,
  "v\0o": -30,
  "v\0oacute": -30,
  "v\0ocircumflex": -30,
  "v\0odieresis": -30,
  "v\0ograve": -30,
  "v\0ohungarumlaut": -30,
  "v\0omacron": -30,
  "v\0oslash": -30,
  "v\0otilde": -30,
  "v\0period": -80,
  "w\0comma": -40,
  "w\0o": -20,
  "w\0oacute": -20,
  "w\0ocircumflex": -20,
  "w\0odieresis": -20,
  "w\0ograve": -20,
  "w\0ohungarumlaut": -20,
  "w\0omacron": -20,
  "w\0oslash": -20,
  "w\0otilde": -20,
  "w\0period": -40,
  "x\0e": -10,
  "x\0eacute": -10,
  "x\0ecaron": -10,
  "x\0ecircumflex": -10,
  "x\0edieresis": -10,
  "x\0edotaccent": -10,
  "x\0egrave": -10,
  "x\0emacron": -10,
  "x\0eogonek": -10,
  "y\0a": -30,
  "y\0aacute": -30,
  "y\0abreve": -30,
  "y\0acircumflex": -30,
  "y\0adieresis": -30,
  "y\0agrave": -30,
  "y\0amacron": -30,
  "y\0aogonek": -30,
  "y\0aring": -30,
  "y\0atilde": -30,
  "y\0comma": -80,
  "y\0e": -10,
  "y\0eacute": -10,
  "y\0ecaron": -10,
  "y\0ecircumflex": -10,
  "y\0edieresis": -10,
  "y\0edotaccent": -10,
  "y\0egrave": -10,
  "y\0emacron": -10,
  "y\0eogonek": -10,
  "y\0o": -25,
  "y\0oacute": -25,
  "y\0ocircumflex": -25,
  "y\0odieresis": -25,
  "y\0ograve": -25,
  "y\0ohungarumlaut": -25,
  "y\0omacron": -25,
  "y\0oslash": -25,
  "y\0otilde": -25,
  "y\0period": -80,
  "yacute\0a": -30,
  "yacute\0aacute": -30,
  "yacute\0abreve": -30,
  "yacute\0acircumflex": -30,
  "yacute\0adieresis": -30,
  "yacute\0agrave": -30,
  "yacute\0amacron": -30,
  "yacute\0aogonek": -30,
  "yacute\0aring": -30,
  "yacute\0atilde": -30,
  "yacute\0comma": -80,
  "yacute\0e": -10,
  "yacute\0eacute": -10,
  "yacute\0ecaron": -10,
  "yacute\0ecircumflex": -10,
  "yacute\0edieresis": -10,
  "yacute\0edotaccent": -10,
  "yacute\0egrave": -10,
  "yacute\0emacron": -10,
  "yacute\0eogonek": -10,
  "yacute\0o": -25,
  "yacute\0oacute": -25,
  "yacute\0ocircumflex": -25,
  "yacute\0odieresis": -25,
  "yacute\0ograve": -25,
  "yacute\0ohungarumlaut": -25,
  "yacute\0omacron": -25,
  "yacute\0oslash": -25,
  "yacute\0otilde": -25,
  "yacute\0period": -80,
  "ydieresis\0a": -30,
  "ydieresis\0aacute": -30,
  "ydieresis\0abreve": -30,
  "ydieresis\0acircumflex": -30,
  "ydieresis\0adieresis": -30,
  "ydieresis\0agrave": -30,
  "ydieresis\0amacron": -30,
  "ydieresis\0aogonek": -30,
  "ydieresis\0aring": -30,
  "ydieresis\0atilde": -30,
  "ydieresis\0comma": -80,
  "ydieresis\0e": -10,
  "ydieresis\0eacute": -10,
  "ydieresis\0ecaron": -10,
  "ydieresis\0ecircumflex": -10,
  "ydieresis\0edieresis": -10,
  "ydieresis\0edotaccent": -10,
  "ydieresis\0egrave": -10,
  "ydieresis\0emacron": -10,
  "ydieresis\0eogonek": -10,
  "ydieresis\0o": -25,
  "ydieresis\0oacute": -25,
  "ydieresis\0ocircumflex": -25,
  "ydieresis\0odieresis": -25,
  "ydieresis\0ograve": -25,
  "ydieresis\0ohungarumlaut": -25,
  "ydieresis\0omacron": -25,
  "ydieresis\0oslash": -25,
  "ydieresis\0otilde": -25,
  "ydieresis\0period": -80,
  "z\0e": 10,
  "z\0eacute": 10,
  "z\0ecaron": 10,
  "z\0ecircumflex": 10,
  "z\0edieresis": 10,
  "z\0edotaccent": 10,
  "z\0egrave": 10,
  "z\0emacron": 10,
  "z\0eogonek": 10,
  "zacute\0e": 10,
  "zacute\0eacute": 10,
  "zacute\0ecaron": 10,
  "zacute\0ecircumflex": 10,
  "zacute\0edieresis": 10,
  "zacute\0edotaccent": 10,
  "zacute\0egrave": 10,
  "zacute\0emacron": 10,
  "zacute\0eogonek": 10,
  "zcaron\0e": 10,
  "zcaron\0eacute": 10,
  "zcaron\0ecaron": 10,
  "zcaron\0ecircumflex": 10,
  "zcaron\0edieresis": 10,
  "zcaron\0edotaccent": 10,
  "zcaron\0egrave": 10,
  "zcaron\0emacron": 10,
  "zcaron\0eogonek": 10,
  "zdotaccent\0e": 10,
  "zdotaccent\0eacute": 10,
  "zdotaccent\0ecaron": 10,
  "zdotaccent\0ecircumflex": 10,
  "zdotaccent\0edieresis": 10,
  "zdotaccent\0edotaccent": 10,
  "zdotaccent\0egrave": 10,
  "zdotaccent\0emacron": 10,
  "zdotaccent\0eogonek": 10
};
var HelveticaBold = {
  attributes: attributes$4,
  glyphWidths: glyphWidths$4,
  kernPairs: kernPairs$4
};
var attributes$3 = {
  Comment: ["Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 12:44:31 1997", "UniqueID 43055", "VMusage 14960 69346"],
  FontName: "Helvetica-Oblique",
  FullName: "Helvetica Oblique",
  FamilyName: "Helvetica",
  Weight: "Medium",
  ItalicAngle: "-12",
  IsFixedPitch: "false",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-170 -225 1116 931 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "002.000",
  Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "718",
  XHeight: "523",
  Ascender: "718",
  Descender: "-207",
  StdHW: "76",
  StdVW: "88"
};
var glyphWidths$3 = {
  space: 278,
  exclam: 278,
  quotedbl: 355,
  numbersign: 556,
  dollar: 556,
  percent: 889,
  ampersand: 667,
  quoteright: 222,
  parenleft: 333,
  parenright: 333,
  asterisk: 389,
  plus: 584,
  comma: 278,
  hyphen: 333,
  period: 278,
  slash: 278,
  zero: 556,
  one: 556,
  two: 556,
  three: 556,
  four: 556,
  five: 556,
  six: 556,
  seven: 556,
  eight: 556,
  nine: 556,
  colon: 278,
  semicolon: 278,
  less: 584,
  equal: 584,
  greater: 584,
  question: 556,
  at: 1015,
  A: 667,
  B: 667,
  C: 722,
  D: 722,
  E: 667,
  F: 611,
  G: 778,
  H: 722,
  I: 278,
  J: 500,
  K: 667,
  L: 556,
  M: 833,
  N: 722,
  O: 778,
  P: 667,
  Q: 778,
  R: 722,
  S: 667,
  T: 611,
  U: 722,
  V: 667,
  W: 944,
  X: 667,
  Y: 667,
  Z: 611,
  bracketleft: 278,
  backslash: 278,
  bracketright: 278,
  asciicircum: 469,
  underscore: 556,
  quoteleft: 222,
  a: 556,
  b: 556,
  c: 500,
  d: 556,
  e: 556,
  f: 278,
  g: 556,
  h: 556,
  i: 222,
  j: 222,
  k: 500,
  l: 222,
  m: 833,
  n: 556,
  o: 556,
  p: 556,
  q: 556,
  r: 333,
  s: 500,
  t: 278,
  u: 556,
  v: 500,
  w: 722,
  x: 500,
  y: 500,
  z: 500,
  braceleft: 334,
  bar: 260,
  braceright: 334,
  asciitilde: 584,
  exclamdown: 333,
  cent: 556,
  sterling: 556,
  fraction: 167,
  yen: 556,
  florin: 556,
  section: 556,
  currency: 556,
  quotesingle: 191,
  quotedblleft: 333,
  guillemotleft: 556,
  guilsinglleft: 333,
  guilsinglright: 333,
  fi: 500,
  fl: 500,
  endash: 556,
  dagger: 556,
  daggerdbl: 556,
  periodcentered: 278,
  paragraph: 537,
  bullet: 350,
  quotesinglbase: 222,
  quotedblbase: 333,
  quotedblright: 333,
  guillemotright: 556,
  ellipsis: 1000,
  perthousand: 1000,
  questiondown: 611,
  grave: 333,
  acute: 333,
  circumflex: 333,
  tilde: 333,
  macron: 333,
  breve: 333,
  dotaccent: 333,
  dieresis: 333,
  ring: 333,
  cedilla: 333,
  hungarumlaut: 333,
  ogonek: 333,
  caron: 333,
  emdash: 1000,
  AE: 1000,
  ordfeminine: 370,
  Lslash: 556,
  Oslash: 778,
  OE: 1000,
  ordmasculine: 365,
  ae: 889,
  dotlessi: 278,
  lslash: 222,
  oslash: 611,
  oe: 944,
  germandbls: 611,
  Idieresis: 278,
  eacute: 556,
  abreve: 556,
  uhungarumlaut: 556,
  ecaron: 556,
  Ydieresis: 667,
  divide: 584,
  Yacute: 667,
  Acircumflex: 667,
  aacute: 556,
  Ucircumflex: 722,
  yacute: 500,
  scommaaccent: 500,
  ecircumflex: 556,
  Uring: 722,
  Udieresis: 722,
  aogonek: 556,
  Uacute: 722,
  uogonek: 556,
  Edieresis: 667,
  Dcroat: 722,
  commaaccent: 250,
  copyright: 737,
  Emacron: 667,
  ccaron: 500,
  aring: 556,
  Ncommaaccent: 722,
  lacute: 222,
  agrave: 556,
  Tcommaaccent: 611,
  Cacute: 722,
  atilde: 556,
  Edotaccent: 667,
  scaron: 500,
  scedilla: 500,
  iacute: 278,
  lozenge: 471,
  Rcaron: 722,
  Gcommaaccent: 778,
  ucircumflex: 556,
  acircumflex: 556,
  Amacron: 667,
  rcaron: 333,
  ccedilla: 500,
  Zdotaccent: 611,
  Thorn: 667,
  Omacron: 778,
  Racute: 722,
  Sacute: 667,
  dcaron: 643,
  Umacron: 722,
  uring: 556,
  threesuperior: 333,
  Ograve: 778,
  Agrave: 667,
  Abreve: 667,
  multiply: 584,
  uacute: 556,
  Tcaron: 611,
  partialdiff: 476,
  ydieresis: 500,
  Nacute: 722,
  icircumflex: 278,
  Ecircumflex: 667,
  adieresis: 556,
  edieresis: 556,
  cacute: 500,
  nacute: 556,
  umacron: 556,
  Ncaron: 722,
  Iacute: 278,
  plusminus: 584,
  brokenbar: 260,
  registered: 737,
  Gbreve: 778,
  Idotaccent: 278,
  summation: 600,
  Egrave: 667,
  racute: 333,
  omacron: 556,
  Zacute: 611,
  Zcaron: 611,
  greaterequal: 549,
  Eth: 722,
  Ccedilla: 722,
  lcommaaccent: 222,
  tcaron: 317,
  eogonek: 556,
  Uogonek: 722,
  Aacute: 667,
  Adieresis: 667,
  egrave: 556,
  zacute: 500,
  iogonek: 222,
  Oacute: 778,
  oacute: 556,
  amacron: 556,
  sacute: 500,
  idieresis: 278,
  Ocircumflex: 778,
  Ugrave: 722,
  Delta: 612,
  thorn: 556,
  twosuperior: 333,
  Odieresis: 778,
  mu: 556,
  igrave: 278,
  ohungarumlaut: 556,
  Eogonek: 667,
  dcroat: 556,
  threequarters: 834,
  Scedilla: 667,
  lcaron: 299,
  Kcommaaccent: 667,
  Lacute: 556,
  trademark: 1000,
  edotaccent: 556,
  Igrave: 278,
  Imacron: 278,
  Lcaron: 556,
  onehalf: 834,
  lessequal: 549,
  ocircumflex: 556,
  ntilde: 556,
  Uhungarumlaut: 722,
  Eacute: 667,
  emacron: 556,
  gbreve: 556,
  onequarter: 834,
  Scaron: 667,
  Scommaaccent: 667,
  Ohungarumlaut: 778,
  degree: 400,
  ograve: 556,
  Ccaron: 722,
  ugrave: 556,
  radical: 453,
  Dcaron: 722,
  rcommaaccent: 333,
  Ntilde: 722,
  otilde: 556,
  Rcommaaccent: 722,
  Lcommaaccent: 556,
  Atilde: 667,
  Aogonek: 667,
  Aring: 667,
  Otilde: 778,
  zdotaccent: 500,
  Ecaron: 667,
  Iogonek: 278,
  kcommaaccent: 500,
  minus: 584,
  Icircumflex: 278,
  ncaron: 556,
  tcommaaccent: 278,
  logicalnot: 584,
  odieresis: 556,
  udieresis: 556,
  notequal: 549,
  gcommaaccent: 556,
  eth: 556,
  zcaron: 500,
  ncommaaccent: 556,
  onesuperior: 333,
  imacron: 278,
  Euro: 556
};
var kernPairs$3 = {
  "A\0C": -30,
  "A\0Cacute": -30,
  "A\0Ccaron": -30,
  "A\0Ccedilla": -30,
  "A\0G": -30,
  "A\0Gbreve": -30,
  "A\0Gcommaaccent": -30,
  "A\0O": -30,
  "A\0Oacute": -30,
  "A\0Ocircumflex": -30,
  "A\0Odieresis": -30,
  "A\0Ograve": -30,
  "A\0Ohungarumlaut": -30,
  "A\0Omacron": -30,
  "A\0Oslash": -30,
  "A\0Otilde": -30,
  "A\0Q": -30,
  "A\0T": -120,
  "A\0Tcaron": -120,
  "A\0Tcommaaccent": -120,
  "A\0U": -50,
  "A\0Uacute": -50,
  "A\0Ucircumflex": -50,
  "A\0Udieresis": -50,
  "A\0Ugrave": -50,
  "A\0Uhungarumlaut": -50,
  "A\0Umacron": -50,
  "A\0Uogonek": -50,
  "A\0Uring": -50,
  "A\0V": -70,
  "A\0W": -50,
  "A\0Y": -100,
  "A\0Yacute": -100,
  "A\0Ydieresis": -100,
  "A\0u": -30,
  "A\0uacute": -30,
  "A\0ucircumflex": -30,
  "A\0udieresis": -30,
  "A\0ugrave": -30,
  "A\0uhungarumlaut": -30,
  "A\0umacron": -30,
  "A\0uogonek": -30,
  "A\0uring": -30,
  "A\0v": -40,
  "A\0w": -40,
  "A\0y": -40,
  "A\0yacute": -40,
  "A\0ydieresis": -40,
  "Aacute\0C": -30,
  "Aacute\0Cacute": -30,
  "Aacute\0Ccaron": -30,
  "Aacute\0Ccedilla": -30,
  "Aacute\0G": -30,
  "Aacute\0Gbreve": -30,
  "Aacute\0Gcommaaccent": -30,
  "Aacute\0O": -30,
  "Aacute\0Oacute": -30,
  "Aacute\0Ocircumflex": -30,
  "Aacute\0Odieresis": -30,
  "Aacute\0Ograve": -30,
  "Aacute\0Ohungarumlaut": -30,
  "Aacute\0Omacron": -30,
  "Aacute\0Oslash": -30,
  "Aacute\0Otilde": -30,
  "Aacute\0Q": -30,
  "Aacute\0T": -120,
  "Aacute\0Tcaron": -120,
  "Aacute\0Tcommaaccent": -120,
  "Aacute\0U": -50,
  "Aacute\0Uacute": -50,
  "Aacute\0Ucircumflex": -50,
  "Aacute\0Udieresis": -50,
  "Aacute\0Ugrave": -50,
  "Aacute\0Uhungarumlaut": -50,
  "Aacute\0Umacron": -50,
  "Aacute\0Uogonek": -50,
  "Aacute\0Uring": -50,
  "Aacute\0V": -70,
  "Aacute\0W": -50,
  "Aacute\0Y": -100,
  "Aacute\0Yacute": -100,
  "Aacute\0Ydieresis": -100,
  "Aacute\0u": -30,
  "Aacute\0uacute": -30,
  "Aacute\0ucircumflex": -30,
  "Aacute\0udieresis": -30,
  "Aacute\0ugrave": -30,
  "Aacute\0uhungarumlaut": -30,
  "Aacute\0umacron": -30,
  "Aacute\0uogonek": -30,
  "Aacute\0uring": -30,
  "Aacute\0v": -40,
  "Aacute\0w": -40,
  "Aacute\0y": -40,
  "Aacute\0yacute": -40,
  "Aacute\0ydieresis": -40,
  "Abreve\0C": -30,
  "Abreve\0Cacute": -30,
  "Abreve\0Ccaron": -30,
  "Abreve\0Ccedilla": -30,
  "Abreve\0G": -30,
  "Abreve\0Gbreve": -30,
  "Abreve\0Gcommaaccent": -30,
  "Abreve\0O": -30,
  "Abreve\0Oacute": -30,
  "Abreve\0Ocircumflex": -30,
  "Abreve\0Odieresis": -30,
  "Abreve\0Ograve": -30,
  "Abreve\0Ohungarumlaut": -30,
  "Abreve\0Omacron": -30,
  "Abreve\0Oslash": -30,
  "Abreve\0Otilde": -30,
  "Abreve\0Q": -30,
  "Abreve\0T": -120,
  "Abreve\0Tcaron": -120,
  "Abreve\0Tcommaaccent": -120,
  "Abreve\0U": -50,
  "Abreve\0Uacute": -50,
  "Abreve\0Ucircumflex": -50,
  "Abreve\0Udieresis": -50,
  "Abreve\0Ugrave": -50,
  "Abreve\0Uhungarumlaut": -50,
  "Abreve\0Umacron": -50,
  "Abreve\0Uogonek": -50,
  "Abreve\0Uring": -50,
  "Abreve\0V": -70,
  "Abreve\0W": -50,
  "Abreve\0Y": -100,
  "Abreve\0Yacute": -100,
  "Abreve\0Ydieresis": -100,
  "Abreve\0u": -30,
  "Abreve\0uacute": -30,
  "Abreve\0ucircumflex": -30,
  "Abreve\0udieresis": -30,
  "Abreve\0ugrave": -30,
  "Abreve\0uhungarumlaut": -30,
  "Abreve\0umacron": -30,
  "Abreve\0uogonek": -30,
  "Abreve\0uring": -30,
  "Abreve\0v": -40,
  "Abreve\0w": -40,
  "Abreve\0y": -40,
  "Abreve\0yacute": -40,
  "Abreve\0ydieresis": -40,
  "Acircumflex\0C": -30,
  "Acircumflex\0Cacute": -30,
  "Acircumflex\0Ccaron": -30,
  "Acircumflex\0Ccedilla": -30,
  "Acircumflex\0G": -30,
  "Acircumflex\0Gbreve": -30,
  "Acircumflex\0Gcommaaccent": -30,
  "Acircumflex\0O": -30,
  "Acircumflex\0Oacute": -30,
  "Acircumflex\0Ocircumflex": -30,
  "Acircumflex\0Odieresis": -30,
  "Acircumflex\0Ograve": -30,
  "Acircumflex\0Ohungarumlaut": -30,
  "Acircumflex\0Omacron": -30,
  "Acircumflex\0Oslash": -30,
  "Acircumflex\0Otilde": -30,
  "Acircumflex\0Q": -30,
  "Acircumflex\0T": -120,
  "Acircumflex\0Tcaron": -120,
  "Acircumflex\0Tcommaaccent": -120,
  "Acircumflex\0U": -50,
  "Acircumflex\0Uacute": -50,
  "Acircumflex\0Ucircumflex": -50,
  "Acircumflex\0Udieresis": -50,
  "Acircumflex\0Ugrave": -50,
  "Acircumflex\0Uhungarumlaut": -50,
  "Acircumflex\0Umacron": -50,
  "Acircumflex\0Uogonek": -50,
  "Acircumflex\0Uring": -50,
  "Acircumflex\0V": -70,
  "Acircumflex\0W": -50,
  "Acircumflex\0Y": -100,
  "Acircumflex\0Yacute": -100,
  "Acircumflex\0Ydieresis": -100,
  "Acircumflex\0u": -30,
  "Acircumflex\0uacute": -30,
  "Acircumflex\0ucircumflex": -30,
  "Acircumflex\0udieresis": -30,
  "Acircumflex\0ugrave": -30,
  "Acircumflex\0uhungarumlaut": -30,
  "Acircumflex\0umacron": -30,
  "Acircumflex\0uogonek": -30,
  "Acircumflex\0uring": -30,
  "Acircumflex\0v": -40,
  "Acircumflex\0w": -40,
  "Acircumflex\0y": -40,
  "Acircumflex\0yacute": -40,
  "Acircumflex\0ydieresis": -40,
  "Adieresis\0C": -30,
  "Adieresis\0Cacute": -30,
  "Adieresis\0Ccaron": -30,
  "Adieresis\0Ccedilla": -30,
  "Adieresis\0G": -30,
  "Adieresis\0Gbreve": -30,
  "Adieresis\0Gcommaaccent": -30,
  "Adieresis\0O": -30,
  "Adieresis\0Oacute": -30,
  "Adieresis\0Ocircumflex": -30,
  "Adieresis\0Odieresis": -30,
  "Adieresis\0Ograve": -30,
  "Adieresis\0Ohungarumlaut": -30,
  "Adieresis\0Omacron": -30,
  "Adieresis\0Oslash": -30,
  "Adieresis\0Otilde": -30,
  "Adieresis\0Q": -30,
  "Adieresis\0T": -120,
  "Adieresis\0Tcaron": -120,
  "Adieresis\0Tcommaaccent": -120,
  "Adieresis\0U": -50,
  "Adieresis\0Uacute": -50,
  "Adieresis\0Ucircumflex": -50,
  "Adieresis\0Udieresis": -50,
  "Adieresis\0Ugrave": -50,
  "Adieresis\0Uhungarumlaut": -50,
  "Adieresis\0Umacron": -50,
  "Adieresis\0Uogonek": -50,
  "Adieresis\0Uring": -50,
  "Adieresis\0V": -70,
  "Adieresis\0W": -50,
  "Adieresis\0Y": -100,
  "Adieresis\0Yacute": -100,
  "Adieresis\0Ydieresis": -100,
  "Adieresis\0u": -30,
  "Adieresis\0uacute": -30,
  "Adieresis\0ucircumflex": -30,
  "Adieresis\0udieresis": -30,
  "Adieresis\0ugrave": -30,
  "Adieresis\0uhungarumlaut": -30,
  "Adieresis\0umacron": -30,
  "Adieresis\0uogonek": -30,
  "Adieresis\0uring": -30,
  "Adieresis\0v": -40,
  "Adieresis\0w": -40,
  "Adieresis\0y": -40,
  "Adieresis\0yacute": -40,
  "Adieresis\0ydieresis": -40,
  "Agrave\0C": -30,
  "Agrave\0Cacute": -30,
  "Agrave\0Ccaron": -30,
  "Agrave\0Ccedilla": -30,
  "Agrave\0G": -30,
  "Agrave\0Gbreve": -30,
  "Agrave\0Gcommaaccent": -30,
  "Agrave\0O": -30,
  "Agrave\0Oacute": -30,
  "Agrave\0Ocircumflex": -30,
  "Agrave\0Odieresis": -30,
  "Agrave\0Ograve": -30,
  "Agrave\0Ohungarumlaut": -30,
  "Agrave\0Omacron": -30,
  "Agrave\0Oslash": -30,
  "Agrave\0Otilde": -30,
  "Agrave\0Q": -30,
  "Agrave\0T": -120,
  "Agrave\0Tcaron": -120,
  "Agrave\0Tcommaaccent": -120,
  "Agrave\0U": -50,
  "Agrave\0Uacute": -50,
  "Agrave\0Ucircumflex": -50,
  "Agrave\0Udieresis": -50,
  "Agrave\0Ugrave": -50,
  "Agrave\0Uhungarumlaut": -50,
  "Agrave\0Umacron": -50,
  "Agrave\0Uogonek": -50,
  "Agrave\0Uring": -50,
  "Agrave\0V": -70,
  "Agrave\0W": -50,
  "Agrave\0Y": -100,
  "Agrave\0Yacute": -100,
  "Agrave\0Ydieresis": -100,
  "Agrave\0u": -30,
  "Agrave\0uacute": -30,
  "Agrave\0ucircumflex": -30,
  "Agrave\0udieresis": -30,
  "Agrave\0ugrave": -30,
  "Agrave\0uhungarumlaut": -30,
  "Agrave\0umacron": -30,
  "Agrave\0uogonek": -30,
  "Agrave\0uring": -30,
  "Agrave\0v": -40,
  "Agrave\0w": -40,
  "Agrave\0y": -40,
  "Agrave\0yacute": -40,
  "Agrave\0ydieresis": -40,
  "Amacron\0C": -30,
  "Amacron\0Cacute": -30,
  "Amacron\0Ccaron": -30,
  "Amacron\0Ccedilla": -30,
  "Amacron\0G": -30,
  "Amacron\0Gbreve": -30,
  "Amacron\0Gcommaaccent": -30,
  "Amacron\0O": -30,
  "Amacron\0Oacute": -30,
  "Amacron\0Ocircumflex": -30,
  "Amacron\0Odieresis": -30,
  "Amacron\0Ograve": -30,
  "Amacron\0Ohungarumlaut": -30,
  "Amacron\0Omacron": -30,
  "Amacron\0Oslash": -30,
  "Amacron\0Otilde": -30,
  "Amacron\0Q": -30,
  "Amacron\0T": -120,
  "Amacron\0Tcaron": -120,
  "Amacron\0Tcommaaccent": -120,
  "Amacron\0U": -50,
  "Amacron\0Uacute": -50,
  "Amacron\0Ucircumflex": -50,
  "Amacron\0Udieresis": -50,
  "Amacron\0Ugrave": -50,
  "Amacron\0Uhungarumlaut": -50,
  "Amacron\0Umacron": -50,
  "Amacron\0Uogonek": -50,
  "Amacron\0Uring": -50,
  "Amacron\0V": -70,
  "Amacron\0W": -50,
  "Amacron\0Y": -100,
  "Amacron\0Yacute": -100,
  "Amacron\0Ydieresis": -100,
  "Amacron\0u": -30,
  "Amacron\0uacute": -30,
  "Amacron\0ucircumflex": -30,
  "Amacron\0udieresis": -30,
  "Amacron\0ugrave": -30,
  "Amacron\0uhungarumlaut": -30,
  "Amacron\0umacron": -30,
  "Amacron\0uogonek": -30,
  "Amacron\0uring": -30,
  "Amacron\0v": -40,
  "Amacron\0w": -40,
  "Amacron\0y": -40,
  "Amacron\0yacute": -40,
  "Amacron\0ydieresis": -40,
  "Aogonek\0C": -30,
  "Aogonek\0Cacute": -30,
  "Aogonek\0Ccaron": -30,
  "Aogonek\0Ccedilla": -30,
  "Aogonek\0G": -30,
  "Aogonek\0Gbreve": -30,
  "Aogonek\0Gcommaaccent": -30,
  "Aogonek\0O": -30,
  "Aogonek\0Oacute": -30,
  "Aogonek\0Ocircumflex": -30,
  "Aogonek\0Odieresis": -30,
  "Aogonek\0Ograve": -30,
  "Aogonek\0Ohungarumlaut": -30,
  "Aogonek\0Omacron": -30,
  "Aogonek\0Oslash": -30,
  "Aogonek\0Otilde": -30,
  "Aogonek\0Q": -30,
  "Aogonek\0T": -120,
  "Aogonek\0Tcaron": -120,
  "Aogonek\0Tcommaaccent": -120,
  "Aogonek\0U": -50,
  "Aogonek\0Uacute": -50,
  "Aogonek\0Ucircumflex": -50,
  "Aogonek\0Udieresis": -50,
  "Aogonek\0Ugrave": -50,
  "Aogonek\0Uhungarumlaut": -50,
  "Aogonek\0Umacron": -50,
  "Aogonek\0Uogonek": -50,
  "Aogonek\0Uring": -50,
  "Aogonek\0V": -70,
  "Aogonek\0W": -50,
  "Aogonek\0Y": -100,
  "Aogonek\0Yacute": -100,
  "Aogonek\0Ydieresis": -100,
  "Aogonek\0u": -30,
  "Aogonek\0uacute": -30,
  "Aogonek\0ucircumflex": -30,
  "Aogonek\0udieresis": -30,
  "Aogonek\0ugrave": -30,
  "Aogonek\0uhungarumlaut": -30,
  "Aogonek\0umacron": -30,
  "Aogonek\0uogonek": -30,
  "Aogonek\0uring": -30,
  "Aogonek\0v": -40,
  "Aogonek\0w": -40,
  "Aogonek\0y": -40,
  "Aogonek\0yacute": -40,
  "Aogonek\0ydieresis": -40,
  "Aring\0C": -30,
  "Aring\0Cacute": -30,
  "Aring\0Ccaron": -30,
  "Aring\0Ccedilla": -30,
  "Aring\0G": -30,
  "Aring\0Gbreve": -30,
  "Aring\0Gcommaaccent": -30,
  "Aring\0O": -30,
  "Aring\0Oacute": -30,
  "Aring\0Ocircumflex": -30,
  "Aring\0Odieresis": -30,
  "Aring\0Ograve": -30,
  "Aring\0Ohungarumlaut": -30,
  "Aring\0Omacron": -30,
  "Aring\0Oslash": -30,
  "Aring\0Otilde": -30,
  "Aring\0Q": -30,
  "Aring\0T": -120,
  "Aring\0Tcaron": -120,
  "Aring\0Tcommaaccent": -120,
  "Aring\0U": -50,
  "Aring\0Uacute": -50,
  "Aring\0Ucircumflex": -50,
  "Aring\0Udieresis": -50,
  "Aring\0Ugrave": -50,
  "Aring\0Uhungarumlaut": -50,
  "Aring\0Umacron": -50,
  "Aring\0Uogonek": -50,
  "Aring\0Uring": -50,
  "Aring\0V": -70,
  "Aring\0W": -50,
  "Aring\0Y": -100,
  "Aring\0Yacute": -100,
  "Aring\0Ydieresis": -100,
  "Aring\0u": -30,
  "Aring\0uacute": -30,
  "Aring\0ucircumflex": -30,
  "Aring\0udieresis": -30,
  "Aring\0ugrave": -30,
  "Aring\0uhungarumlaut": -30,
  "Aring\0umacron": -30,
  "Aring\0uogonek": -30,
  "Aring\0uring": -30,
  "Aring\0v": -40,
  "Aring\0w": -40,
  "Aring\0y": -40,
  "Aring\0yacute": -40,
  "Aring\0ydieresis": -40,
  "Atilde\0C": -30,
  "Atilde\0Cacute": -30,
  "Atilde\0Ccaron": -30,
  "Atilde\0Ccedilla": -30,
  "Atilde\0G": -30,
  "Atilde\0Gbreve": -30,
  "Atilde\0Gcommaaccent": -30,
  "Atilde\0O": -30,
  "Atilde\0Oacute": -30,
  "Atilde\0Ocircumflex": -30,
  "Atilde\0Odieresis": -30,
  "Atilde\0Ograve": -30,
  "Atilde\0Ohungarumlaut": -30,
  "Atilde\0Omacron": -30,
  "Atilde\0Oslash": -30,
  "Atilde\0Otilde": -30,
  "Atilde\0Q": -30,
  "Atilde\0T": -120,
  "Atilde\0Tcaron": -120,
  "Atilde\0Tcommaaccent": -120,
  "Atilde\0U": -50,
  "Atilde\0Uacute": -50,
  "Atilde\0Ucircumflex": -50,
  "Atilde\0Udieresis": -50,
  "Atilde\0Ugrave": -50,
  "Atilde\0Uhungarumlaut": -50,
  "Atilde\0Umacron": -50,
  "Atilde\0Uogonek": -50,
  "Atilde\0Uring": -50,
  "Atilde\0V": -70,
  "Atilde\0W": -50,
  "Atilde\0Y": -100,
  "Atilde\0Yacute": -100,
  "Atilde\0Ydieresis": -100,
  "Atilde\0u": -30,
  "Atilde\0uacute": -30,
  "Atilde\0ucircumflex": -30,
  "Atilde\0udieresis": -30,
  "Atilde\0ugrave": -30,
  "Atilde\0uhungarumlaut": -30,
  "Atilde\0umacron": -30,
  "Atilde\0uogonek": -30,
  "Atilde\0uring": -30,
  "Atilde\0v": -40,
  "Atilde\0w": -40,
  "Atilde\0y": -40,
  "Atilde\0yacute": -40,
  "Atilde\0ydieresis": -40,
  "B\0U": -10,
  "B\0Uacute": -10,
  "B\0Ucircumflex": -10,
  "B\0Udieresis": -10,
  "B\0Ugrave": -10,
  "B\0Uhungarumlaut": -10,
  "B\0Umacron": -10,
  "B\0Uogonek": -10,
  "B\0Uring": -10,
  "B\0comma": -20,
  "B\0period": -20,
  "C\0comma": -30,
  "C\0period": -30,
  "Cacute\0comma": -30,
  "Cacute\0period": -30,
  "Ccaron\0comma": -30,
  "Ccaron\0period": -30,
  "Ccedilla\0comma": -30,
  "Ccedilla\0period": -30,
  "D\0A": -40,
  "D\0Aacute": -40,
  "D\0Abreve": -40,
  "D\0Acircumflex": -40,
  "D\0Adieresis": -40,
  "D\0Agrave": -40,
  "D\0Amacron": -40,
  "D\0Aogonek": -40,
  "D\0Aring": -40,
  "D\0Atilde": -40,
  "D\0V": -70,
  "D\0W": -40,
  "D\0Y": -90,
  "D\0Yacute": -90,
  "D\0Ydieresis": -90,
  "D\0comma": -70,
  "D\0period": -70,
  "Dcaron\0A": -40,
  "Dcaron\0Aacute": -40,
  "Dcaron\0Abreve": -40,
  "Dcaron\0Acircumflex": -40,
  "Dcaron\0Adieresis": -40,
  "Dcaron\0Agrave": -40,
  "Dcaron\0Amacron": -40,
  "Dcaron\0Aogonek": -40,
  "Dcaron\0Aring": -40,
  "Dcaron\0Atilde": -40,
  "Dcaron\0V": -70,
  "Dcaron\0W": -40,
  "Dcaron\0Y": -90,
  "Dcaron\0Yacute": -90,
  "Dcaron\0Ydieresis": -90,
  "Dcaron\0comma": -70,
  "Dcaron\0period": -70,
  "Dcroat\0A": -40,
  "Dcroat\0Aacute": -40,
  "Dcroat\0Abreve": -40,
  "Dcroat\0Acircumflex": -40,
  "Dcroat\0Adieresis": -40,
  "Dcroat\0Agrave": -40,
  "Dcroat\0Amacron": -40,
  "Dcroat\0Aogonek": -40,
  "Dcroat\0Aring": -40,
  "Dcroat\0Atilde": -40,
  "Dcroat\0V": -70,
  "Dcroat\0W": -40,
  "Dcroat\0Y": -90,
  "Dcroat\0Yacute": -90,
  "Dcroat\0Ydieresis": -90,
  "Dcroat\0comma": -70,
  "Dcroat\0period": -70,
  "F\0A": -80,
  "F\0Aacute": -80,
  "F\0Abreve": -80,
  "F\0Acircumflex": -80,
  "F\0Adieresis": -80,
  "F\0Agrave": -80,
  "F\0Amacron": -80,
  "F\0Aogonek": -80,
  "F\0Aring": -80,
  "F\0Atilde": -80,
  "F\0a": -50,
  "F\0aacute": -50,
  "F\0abreve": -50,
  "F\0acircumflex": -50,
  "F\0adieresis": -50,
  "F\0agrave": -50,
  "F\0amacron": -50,
  "F\0aogonek": -50,
  "F\0aring": -50,
  "F\0atilde": -50,
  "F\0comma": -150,
  "F\0e": -30,
  "F\0eacute": -30,
  "F\0ecaron": -30,
  "F\0ecircumflex": -30,
  "F\0edieresis": -30,
  "F\0edotaccent": -30,
  "F\0egrave": -30,
  "F\0emacron": -30,
  "F\0eogonek": -30,
  "F\0o": -30,
  "F\0oacute": -30,
  "F\0ocircumflex": -30,
  "F\0odieresis": -30,
  "F\0ograve": -30,
  "F\0ohungarumlaut": -30,
  "F\0omacron": -30,
  "F\0oslash": -30,
  "F\0otilde": -30,
  "F\0period": -150,
  "F\0r": -45,
  "F\0racute": -45,
  "F\0rcaron": -45,
  "F\0rcommaaccent": -45,
  "J\0A": -20,
  "J\0Aacute": -20,
  "J\0Abreve": -20,
  "J\0Acircumflex": -20,
  "J\0Adieresis": -20,
  "J\0Agrave": -20,
  "J\0Amacron": -20,
  "J\0Aogonek": -20,
  "J\0Aring": -20,
  "J\0Atilde": -20,
  "J\0a": -20,
  "J\0aacute": -20,
  "J\0abreve": -20,
  "J\0acircumflex": -20,
  "J\0adieresis": -20,
  "J\0agrave": -20,
  "J\0amacron": -20,
  "J\0aogonek": -20,
  "J\0aring": -20,
  "J\0atilde": -20,
  "J\0comma": -30,
  "J\0period": -30,
  "J\0u": -20,
  "J\0uacute": -20,
  "J\0ucircumflex": -20,
  "J\0udieresis": -20,
  "J\0ugrave": -20,
  "J\0uhungarumlaut": -20,
  "J\0umacron": -20,
  "J\0uogonek": -20,
  "J\0uring": -20,
  "K\0O": -50,
  "K\0Oacute": -50,
  "K\0Ocircumflex": -50,
  "K\0Odieresis": -50,
  "K\0Ograve": -50,
  "K\0Ohungarumlaut": -50,
  "K\0Omacron": -50,
  "K\0Oslash": -50,
  "K\0Otilde": -50,
  "K\0e": -40,
  "K\0eacute": -40,
  "K\0ecaron": -40,
  "K\0ecircumflex": -40,
  "K\0edieresis": -40,
  "K\0edotaccent": -40,
  "K\0egrave": -40,
  "K\0emacron": -40,
  "K\0eogonek": -40,
  "K\0o": -40,
  "K\0oacute": -40,
  "K\0ocircumflex": -40,
  "K\0odieresis": -40,
  "K\0ograve": -40,
  "K\0ohungarumlaut": -40,
  "K\0omacron": -40,
  "K\0oslash": -40,
  "K\0otilde": -40,
  "K\0u": -30,
  "K\0uacute": -30,
  "K\0ucircumflex": -30,
  "K\0udieresis": -30,
  "K\0ugrave": -30,
  "K\0uhungarumlaut": -30,
  "K\0umacron": -30,
  "K\0uogonek": -30,
  "K\0uring": -30,
  "K\0y": -50,
  "K\0yacute": -50,
  "K\0ydieresis": -50,
  "Kcommaaccent\0O": -50,
  "Kcommaaccent\0Oacute": -50,
  "Kcommaaccent\0Ocircumflex": -50,
  "Kcommaaccent\0Odieresis": -50,
  "Kcommaaccent\0Ograve": -50,
  "Kcommaaccent\0Ohungarumlaut": -50,
  "Kcommaaccent\0Omacron": -50,
  "Kcommaaccent\0Oslash": -50,
  "Kcommaaccent\0Otilde": -50,
  "Kcommaaccent\0e": -40,
  "Kcommaaccent\0eacute": -40,
  "Kcommaaccent\0ecaron": -40,
  "Kcommaaccent\0ecircumflex": -40,
  "Kcommaaccent\0edieresis": -40,
  "Kcommaaccent\0edotaccent": -40,
  "Kcommaaccent\0egrave": -40,
  "Kcommaaccent\0emacron": -40,
  "Kcommaaccent\0eogonek": -40,
  "Kcommaaccent\0o": -40,
  "Kcommaaccent\0oacute": -40,
  "Kcommaaccent\0ocircumflex": -40,
  "Kcommaaccent\0odieresis": -40,
  "Kcommaaccent\0ograve": -40,
  "Kcommaaccent\0ohungarumlaut": -40,
  "Kcommaaccent\0omacron": -40,
  "Kcommaaccent\0oslash": -40,
  "Kcommaaccent\0otilde": -40,
  "Kcommaaccent\0u": -30,
  "Kcommaaccent\0uacute": -30,
  "Kcommaaccent\0ucircumflex": -30,
  "Kcommaaccent\0udieresis": -30,
  "Kcommaaccent\0ugrave": -30,
  "Kcommaaccent\0uhungarumlaut": -30,
  "Kcommaaccent\0umacron": -30,
  "Kcommaaccent\0uogonek": -30,
  "Kcommaaccent\0uring": -30,
  "Kcommaaccent\0y": -50,
  "Kcommaaccent\0yacute": -50,
  "Kcommaaccent\0ydieresis": -50,
  "L\0T": -110,
  "L\0Tcaron": -110,
  "L\0Tcommaaccent": -110,
  "L\0V": -110,
  "L\0W": -70,
  "L\0Y": -140,
  "L\0Yacute": -140,
  "L\0Ydieresis": -140,
  "L\0quotedblright": -140,
  "L\0quoteright": -160,
  "L\0y": -30,
  "L\0yacute": -30,
  "L\0ydieresis": -30,
  "Lacute\0T": -110,
  "Lacute\0Tcaron": -110,
  "Lacute\0Tcommaaccent": -110,
  "Lacute\0V": -110,
  "Lacute\0W": -70,
  "Lacute\0Y": -140,
  "Lacute\0Yacute": -140,
  "Lacute\0Ydieresis": -140,
  "Lacute\0quotedblright": -140,
  "Lacute\0quoteright": -160,
  "Lacute\0y": -30,
  "Lacute\0yacute": -30,
  "Lacute\0ydieresis": -30,
  "Lcaron\0T": -110,
  "Lcaron\0Tcaron": -110,
  "Lcaron\0Tcommaaccent": -110,
  "Lcaron\0V": -110,
  "Lcaron\0W": -70,
  "Lcaron\0Y": -140,
  "Lcaron\0Yacute": -140,
  "Lcaron\0Ydieresis": -140,
  "Lcaron\0quotedblright": -140,
  "Lcaron\0quoteright": -160,
  "Lcaron\0y": -30,
  "Lcaron\0yacute": -30,
  "Lcaron\0ydieresis": -30,
  "Lcommaaccent\0T": -110,
  "Lcommaaccent\0Tcaron": -110,
  "Lcommaaccent\0Tcommaaccent": -110,
  "Lcommaaccent\0V": -110,
  "Lcommaaccent\0W": -70,
  "Lcommaaccent\0Y": -140,
  "Lcommaaccent\0Yacute": -140,
  "Lcommaaccent\0Ydieresis": -140,
  "Lcommaaccent\0quotedblright": -140,
  "Lcommaaccent\0quoteright": -160,
  "Lcommaaccent\0y": -30,
  "Lcommaaccent\0yacute": -30,
  "Lcommaaccent\0ydieresis": -30,
  "Lslash\0T": -110,
  "Lslash\0Tcaron": -110,
  "Lslash\0Tcommaaccent": -110,
  "Lslash\0V": -110,
  "Lslash\0W": -70,
  "Lslash\0Y": -140,
  "Lslash\0Yacute": -140,
  "Lslash\0Ydieresis": -140,
  "Lslash\0quotedblright": -140,
  "Lslash\0quoteright": -160,
  "Lslash\0y": -30,
  "Lslash\0yacute": -30,
  "Lslash\0ydieresis": -30,
  "O\0A": -20,
  "O\0Aacute": -20,
  "O\0Abreve": -20,
  "O\0Acircumflex": -20,
  "O\0Adieresis": -20,
  "O\0Agrave": -20,
  "O\0Amacron": -20,
  "O\0Aogonek": -20,
  "O\0Aring": -20,
  "O\0Atilde": -20,
  "O\0T": -40,
  "O\0Tcaron": -40,
  "O\0Tcommaaccent": -40,
  "O\0V": -50,
  "O\0W": -30,
  "O\0X": -60,
  "O\0Y": -70,
  "O\0Yacute": -70,
  "O\0Ydieresis": -70,
  "O\0comma": -40,
  "O\0period": -40,
  "Oacute\0A": -20,
  "Oacute\0Aacute": -20,
  "Oacute\0Abreve": -20,
  "Oacute\0Acircumflex": -20,
  "Oacute\0Adieresis": -20,
  "Oacute\0Agrave": -20,
  "Oacute\0Amacron": -20,
  "Oacute\0Aogonek": -20,
  "Oacute\0Aring": -20,
  "Oacute\0Atilde": -20,
  "Oacute\0T": -40,
  "Oacute\0Tcaron": -40,
  "Oacute\0Tcommaaccent": -40,
  "Oacute\0V": -50,
  "Oacute\0W": -30,
  "Oacute\0X": -60,
  "Oacute\0Y": -70,
  "Oacute\0Yacute": -70,
  "Oacute\0Ydieresis": -70,
  "Oacute\0comma": -40,
  "Oacute\0period": -40,
  "Ocircumflex\0A": -20,
  "Ocircumflex\0Aacute": -20,
  "Ocircumflex\0Abreve": -20,
  "Ocircumflex\0Acircumflex": -20,
  "Ocircumflex\0Adieresis": -20,
  "Ocircumflex\0Agrave": -20,
  "Ocircumflex\0Amacron": -20,
  "Ocircumflex\0Aogonek": -20,
  "Ocircumflex\0Aring": -20,
  "Ocircumflex\0Atilde": -20,
  "Ocircumflex\0T": -40,
  "Ocircumflex\0Tcaron": -40,
  "Ocircumflex\0Tcommaaccent": -40,
  "Ocircumflex\0V": -50,
  "Ocircumflex\0W": -30,
  "Ocircumflex\0X": -60,
  "Ocircumflex\0Y": -70,
  "Ocircumflex\0Yacute": -70,
  "Ocircumflex\0Ydieresis": -70,
  "Ocircumflex\0comma": -40,
  "Ocircumflex\0period": -40,
  "Odieresis\0A": -20,
  "Odieresis\0Aacute": -20,
  "Odieresis\0Abreve": -20,
  "Odieresis\0Acircumflex": -20,
  "Odieresis\0Adieresis": -20,
  "Odieresis\0Agrave": -20,
  "Odieresis\0Amacron": -20,
  "Odieresis\0Aogonek": -20,
  "Odieresis\0Aring": -20,
  "Odieresis\0Atilde": -20,
  "Odieresis\0T": -40,
  "Odieresis\0Tcaron": -40,
  "Odieresis\0Tcommaaccent": -40,
  "Odieresis\0V": -50,
  "Odieresis\0W": -30,
  "Odieresis\0X": -60,
  "Odieresis\0Y": -70,
  "Odieresis\0Yacute": -70,
  "Odieresis\0Ydieresis": -70,
  "Odieresis\0comma": -40,
  "Odieresis\0period": -40,
  "Ograve\0A": -20,
  "Ograve\0Aacute": -20,
  "Ograve\0Abreve": -20,
  "Ograve\0Acircumflex": -20,
  "Ograve\0Adieresis": -20,
  "Ograve\0Agrave": -20,
  "Ograve\0Amacron": -20,
  "Ograve\0Aogonek": -20,
  "Ograve\0Aring": -20,
  "Ograve\0Atilde": -20,
  "Ograve\0T": -40,
  "Ograve\0Tcaron": -40,
  "Ograve\0Tcommaaccent": -40,
  "Ograve\0V": -50,
  "Ograve\0W": -30,
  "Ograve\0X": -60,
  "Ograve\0Y": -70,
  "Ograve\0Yacute": -70,
  "Ograve\0Ydieresis": -70,
  "Ograve\0comma": -40,
  "Ograve\0period": -40,
  "Ohungarumlaut\0A": -20,
  "Ohungarumlaut\0Aacute": -20,
  "Ohungarumlaut\0Abreve": -20,
  "Ohungarumlaut\0Acircumflex": -20,
  "Ohungarumlaut\0Adieresis": -20,
  "Ohungarumlaut\0Agrave": -20,
  "Ohungarumlaut\0Amacron": -20,
  "Ohungarumlaut\0Aogonek": -20,
  "Ohungarumlaut\0Aring": -20,
  "Ohungarumlaut\0Atilde": -20,
  "Ohungarumlaut\0T": -40,
  "Ohungarumlaut\0Tcaron": -40,
  "Ohungarumlaut\0Tcommaaccent": -40,
  "Ohungarumlaut\0V": -50,
  "Ohungarumlaut\0W": -30,
  "Ohungarumlaut\0X": -60,
  "Ohungarumlaut\0Y": -70,
  "Ohungarumlaut\0Yacute": -70,
  "Ohungarumlaut\0Ydieresis": -70,
  "Ohungarumlaut\0comma": -40,
  "Ohungarumlaut\0period": -40,
  "Omacron\0A": -20,
  "Omacron\0Aacute": -20,
  "Omacron\0Abreve": -20,
  "Omacron\0Acircumflex": -20,
  "Omacron\0Adieresis": -20,
  "Omacron\0Agrave": -20,
  "Omacron\0Amacron": -20,
  "Omacron\0Aogonek": -20,
  "Omacron\0Aring": -20,
  "Omacron\0Atilde": -20,
  "Omacron\0T": -40,
  "Omacron\0Tcaron": -40,
  "Omacron\0Tcommaaccent": -40,
  "Omacron\0V": -50,
  "Omacron\0W": -30,
  "Omacron\0X": -60,
  "Omacron\0Y": -70,
  "Omacron\0Yacute": -70,
  "Omacron\0Ydieresis": -70,
  "Omacron\0comma": -40,
  "Omacron\0period": -40,
  "Oslash\0A": -20,
  "Oslash\0Aacute": -20,
  "Oslash\0Abreve": -20,
  "Oslash\0Acircumflex": -20,
  "Oslash\0Adieresis": -20,
  "Oslash\0Agrave": -20,
  "Oslash\0Amacron": -20,
  "Oslash\0Aogonek": -20,
  "Oslash\0Aring": -20,
  "Oslash\0Atilde": -20,
  "Oslash\0T": -40,
  "Oslash\0Tcaron": -40,
  "Oslash\0Tcommaaccent": -40,
  "Oslash\0V": -50,
  "Oslash\0W": -30,
  "Oslash\0X": -60,
  "Oslash\0Y": -70,
  "Oslash\0Yacute": -70,
  "Oslash\0Ydieresis": -70,
  "Oslash\0comma": -40,
  "Oslash\0period": -40,
  "Otilde\0A": -20,
  "Otilde\0Aacute": -20,
  "Otilde\0Abreve": -20,
  "Otilde\0Acircumflex": -20,
  "Otilde\0Adieresis": -20,
  "Otilde\0Agrave": -20,
  "Otilde\0Amacron": -20,
  "Otilde\0Aogonek": -20,
  "Otilde\0Aring": -20,
  "Otilde\0Atilde": -20,
  "Otilde\0T": -40,
  "Otilde\0Tcaron": -40,
  "Otilde\0Tcommaaccent": -40,
  "Otilde\0V": -50,
  "Otilde\0W": -30,
  "Otilde\0X": -60,
  "Otilde\0Y": -70,
  "Otilde\0Yacute": -70,
  "Otilde\0Ydieresis": -70,
  "Otilde\0comma": -40,
  "Otilde\0period": -40,
  "P\0A": -120,
  "P\0Aacute": -120,
  "P\0Abreve": -120,
  "P\0Acircumflex": -120,
  "P\0Adieresis": -120,
  "P\0Agrave": -120,
  "P\0Amacron": -120,
  "P\0Aogonek": -120,
  "P\0Aring": -120,
  "P\0Atilde": -120,
  "P\0a": -40,
  "P\0aacute": -40,
  "P\0abreve": -40,
  "P\0acircumflex": -40,
  "P\0adieresis": -40,
  "P\0agrave": -40,
  "P\0amacron": -40,
  "P\0aogonek": -40,
  "P\0aring": -40,
  "P\0atilde": -40,
  "P\0comma": -180,
  "P\0e": -50,
  "P\0eacute": -50,
  "P\0ecaron": -50,
  "P\0ecircumflex": -50,
  "P\0edieresis": -50,
  "P\0edotaccent": -50,
  "P\0egrave": -50,
  "P\0emacron": -50,
  "P\0eogonek": -50,
  "P\0o": -50,
  "P\0oacute": -50,
  "P\0ocircumflex": -50,
  "P\0odieresis": -50,
  "P\0ograve": -50,
  "P\0ohungarumlaut": -50,
  "P\0omacron": -50,
  "P\0oslash": -50,
  "P\0otilde": -50,
  "P\0period": -180,
  "Q\0U": -10,
  "Q\0Uacute": -10,
  "Q\0Ucircumflex": -10,
  "Q\0Udieresis": -10,
  "Q\0Ugrave": -10,
  "Q\0Uhungarumlaut": -10,
  "Q\0Umacron": -10,
  "Q\0Uogonek": -10,
  "Q\0Uring": -10,
  "R\0O": -20,
  "R\0Oacute": -20,
  "R\0Ocircumflex": -20,
  "R\0Odieresis": -20,
  "R\0Ograve": -20,
  "R\0Ohungarumlaut": -20,
  "R\0Omacron": -20,
  "R\0Oslash": -20,
  "R\0Otilde": -20,
  "R\0T": -30,
  "R\0Tcaron": -30,
  "R\0Tcommaaccent": -30,
  "R\0U": -40,
  "R\0Uacute": -40,
  "R\0Ucircumflex": -40,
  "R\0Udieresis": -40,
  "R\0Ugrave": -40,
  "R\0Uhungarumlaut": -40,
  "R\0Umacron": -40,
  "R\0Uogonek": -40,
  "R\0Uring": -40,
  "R\0V": -50,
  "R\0W": -30,
  "R\0Y": -50,
  "R\0Yacute": -50,
  "R\0Ydieresis": -50,
  "Racute\0O": -20,
  "Racute\0Oacute": -20,
  "Racute\0Ocircumflex": -20,
  "Racute\0Odieresis": -20,
  "Racute\0Ograve": -20,
  "Racute\0Ohungarumlaut": -20,
  "Racute\0Omacron": -20,
  "Racute\0Oslash": -20,
  "Racute\0Otilde": -20,
  "Racute\0T": -30,
  "Racute\0Tcaron": -30,
  "Racute\0Tcommaaccent": -30,
  "Racute\0U": -40,
  "Racute\0Uacute": -40,
  "Racute\0Ucircumflex": -40,
  "Racute\0Udieresis": -40,
  "Racute\0Ugrave": -40,
  "Racute\0Uhungarumlaut": -40,
  "Racute\0Umacron": -40,
  "Racute\0Uogonek": -40,
  "Racute\0Uring": -40,
  "Racute\0V": -50,
  "Racute\0W": -30,
  "Racute\0Y": -50,
  "Racute\0Yacute": -50,
  "Racute\0Ydieresis": -50,
  "Rcaron\0O": -20,
  "Rcaron\0Oacute": -20,
  "Rcaron\0Ocircumflex": -20,
  "Rcaron\0Odieresis": -20,
  "Rcaron\0Ograve": -20,
  "Rcaron\0Ohungarumlaut": -20,
  "Rcaron\0Omacron": -20,
  "Rcaron\0Oslash": -20,
  "Rcaron\0Otilde": -20,
  "Rcaron\0T": -30,
  "Rcaron\0Tcaron": -30,
  "Rcaron\0Tcommaaccent": -30,
  "Rcaron\0U": -40,
  "Rcaron\0Uacute": -40,
  "Rcaron\0Ucircumflex": -40,
  "Rcaron\0Udieresis": -40,
  "Rcaron\0Ugrave": -40,
  "Rcaron\0Uhungarumlaut": -40,
  "Rcaron\0Umacron": -40,
  "Rcaron\0Uogonek": -40,
  "Rcaron\0Uring": -40,
  "Rcaron\0V": -50,
  "Rcaron\0W": -30,
  "Rcaron\0Y": -50,
  "Rcaron\0Yacute": -50,
  "Rcaron\0Ydieresis": -50,
  "Rcommaaccent\0O": -20,
  "Rcommaaccent\0Oacute": -20,
  "Rcommaaccent\0Ocircumflex": -20,
  "Rcommaaccent\0Odieresis": -20,
  "Rcommaaccent\0Ograve": -20,
  "Rcommaaccent\0Ohungarumlaut": -20,
  "Rcommaaccent\0Omacron": -20,
  "Rcommaaccent\0Oslash": -20,
  "Rcommaaccent\0Otilde": -20,
  "Rcommaaccent\0T": -30,
  "Rcommaaccent\0Tcaron": -30,
  "Rcommaaccent\0Tcommaaccent": -30,
  "Rcommaaccent\0U": -40,
  "Rcommaaccent\0Uacute": -40,
  "Rcommaaccent\0Ucircumflex": -40,
  "Rcommaaccent\0Udieresis": -40,
  "Rcommaaccent\0Ugrave": -40,
  "Rcommaaccent\0Uhungarumlaut": -40,
  "Rcommaaccent\0Umacron": -40,
  "Rcommaaccent\0Uogonek": -40,
  "Rcommaaccent\0Uring": -40,
  "Rcommaaccent\0V": -50,
  "Rcommaaccent\0W": -30,
  "Rcommaaccent\0Y": -50,
  "Rcommaaccent\0Yacute": -50,
  "Rcommaaccent\0Ydieresis": -50,
  "S\0comma": -20,
  "S\0period": -20,
  "Sacute\0comma": -20,
  "Sacute\0period": -20,
  "Scaron\0comma": -20,
  "Scaron\0period": -20,
  "Scedilla\0comma": -20,
  "Scedilla\0period": -20,
  "Scommaaccent\0comma": -20,
  "Scommaaccent\0period": -20,
  "T\0A": -120,
  "T\0Aacute": -120,
  "T\0Abreve": -120,
  "T\0Acircumflex": -120,
  "T\0Adieresis": -120,
  "T\0Agrave": -120,
  "T\0Amacron": -120,
  "T\0Aogonek": -120,
  "T\0Aring": -120,
  "T\0Atilde": -120,
  "T\0O": -40,
  "T\0Oacute": -40,
  "T\0Ocircumflex": -40,
  "T\0Odieresis": -40,
  "T\0Ograve": -40,
  "T\0Ohungarumlaut": -40,
  "T\0Omacron": -40,
  "T\0Oslash": -40,
  "T\0Otilde": -40,
  "T\0a": -120,
  "T\0aacute": -120,
  "T\0abreve": -60,
  "T\0acircumflex": -120,
  "T\0adieresis": -120,
  "T\0agrave": -120,
  "T\0amacron": -60,
  "T\0aogonek": -120,
  "T\0aring": -120,
  "T\0atilde": -60,
  "T\0colon": -20,
  "T\0comma": -120,
  "T\0e": -120,
  "T\0eacute": -120,
  "T\0ecaron": -120,
  "T\0ecircumflex": -120,
  "T\0edieresis": -120,
  "T\0edotaccent": -120,
  "T\0egrave": -60,
  "T\0emacron": -60,
  "T\0eogonek": -120,
  "T\0hyphen": -140,
  "T\0o": -120,
  "T\0oacute": -120,
  "T\0ocircumflex": -120,
  "T\0odieresis": -120,
  "T\0ograve": -120,
  "T\0ohungarumlaut": -120,
  "T\0omacron": -60,
  "T\0oslash": -120,
  "T\0otilde": -60,
  "T\0period": -120,
  "T\0r": -120,
  "T\0racute": -120,
  "T\0rcaron": -120,
  "T\0rcommaaccent": -120,
  "T\0semicolon": -20,
  "T\0u": -120,
  "T\0uacute": -120,
  "T\0ucircumflex": -120,
  "T\0udieresis": -120,
  "T\0ugrave": -120,
  "T\0uhungarumlaut": -120,
  "T\0umacron": -60,
  "T\0uogonek": -120,
  "T\0uring": -120,
  "T\0w": -120,
  "T\0y": -120,
  "T\0yacute": -120,
  "T\0ydieresis": -60,
  "Tcaron\0A": -120,
  "Tcaron\0Aacute": -120,
  "Tcaron\0Abreve": -120,
  "Tcaron\0Acircumflex": -120,
  "Tcaron\0Adieresis": -120,
  "Tcaron\0Agrave": -120,
  "Tcaron\0Amacron": -120,
  "Tcaron\0Aogonek": -120,
  "Tcaron\0Aring": -120,
  "Tcaron\0Atilde": -120,
  "Tcaron\0O": -40,
  "Tcaron\0Oacute": -40,
  "Tcaron\0Ocircumflex": -40,
  "Tcaron\0Odieresis": -40,
  "Tcaron\0Ograve": -40,
  "Tcaron\0Ohungarumlaut": -40,
  "Tcaron\0Omacron": -40,
  "Tcaron\0Oslash": -40,
  "Tcaron\0Otilde": -40,
  "Tcaron\0a": -120,
  "Tcaron\0aacute": -120,
  "Tcaron\0abreve": -60,
  "Tcaron\0acircumflex": -120,
  "Tcaron\0adieresis": -120,
  "Tcaron\0agrave": -120,
  "Tcaron\0amacron": -60,
  "Tcaron\0aogonek": -120,
  "Tcaron\0aring": -120,
  "Tcaron\0atilde": -60,
  "Tcaron\0colon": -20,
  "Tcaron\0comma": -120,
  "Tcaron\0e": -120,
  "Tcaron\0eacute": -120,
  "Tcaron\0ecaron": -120,
  "Tcaron\0ecircumflex": -120,
  "Tcaron\0edieresis": -120,
  "Tcaron\0edotaccent": -120,
  "Tcaron\0egrave": -60,
  "Tcaron\0emacron": -60,
  "Tcaron\0eogonek": -120,
  "Tcaron\0hyphen": -140,
  "Tcaron\0o": -120,
  "Tcaron\0oacute": -120,
  "Tcaron\0ocircumflex": -120,
  "Tcaron\0odieresis": -120,
  "Tcaron\0ograve": -120,
  "Tcaron\0ohungarumlaut": -120,
  "Tcaron\0omacron": -60,
  "Tcaron\0oslash": -120,
  "Tcaron\0otilde": -60,
  "Tcaron\0period": -120,
  "Tcaron\0r": -120,
  "Tcaron\0racute": -120,
  "Tcaron\0rcaron": -120,
  "Tcaron\0rcommaaccent": -120,
  "Tcaron\0semicolon": -20,
  "Tcaron\0u": -120,
  "Tcaron\0uacute": -120,
  "Tcaron\0ucircumflex": -120,
  "Tcaron\0udieresis": -120,
  "Tcaron\0ugrave": -120,
  "Tcaron\0uhungarumlaut": -120,
  "Tcaron\0umacron": -60,
  "Tcaron\0uogonek": -120,
  "Tcaron\0uring": -120,
  "Tcaron\0w": -120,
  "Tcaron\0y": -120,
  "Tcaron\0yacute": -120,
  "Tcaron\0ydieresis": -60,
  "Tcommaaccent\0A": -120,
  "Tcommaaccent\0Aacute": -120,
  "Tcommaaccent\0Abreve": -120,
  "Tcommaaccent\0Acircumflex": -120,
  "Tcommaaccent\0Adieresis": -120,
  "Tcommaaccent\0Agrave": -120,
  "Tcommaaccent\0Amacron": -120,
  "Tcommaaccent\0Aogonek": -120,
  "Tcommaaccent\0Aring": -120,
  "Tcommaaccent\0Atilde": -120,
  "Tcommaaccent\0O": -40,
  "Tcommaaccent\0Oacute": -40,
  "Tcommaaccent\0Ocircumflex": -40,
  "Tcommaaccent\0Odieresis": -40,
  "Tcommaaccent\0Ograve": -40,
  "Tcommaaccent\0Ohungarumlaut": -40,
  "Tcommaaccent\0Omacron": -40,
  "Tcommaaccent\0Oslash": -40,
  "Tcommaaccent\0Otilde": -40,
  "Tcommaaccent\0a": -120,
  "Tcommaaccent\0aacute": -120,
  "Tcommaaccent\0abreve": -60,
  "Tcommaaccent\0acircumflex": -120,
  "Tcommaaccent\0adieresis": -120,
  "Tcommaaccent\0agrave": -120,
  "Tcommaaccent\0amacron": -60,
  "Tcommaaccent\0aogonek": -120,
  "Tcommaaccent\0aring": -120,
  "Tcommaaccent\0atilde": -60,
  "Tcommaaccent\0colon": -20,
  "Tcommaaccent\0comma": -120,
  "Tcommaaccent\0e": -120,
  "Tcommaaccent\0eacute": -120,
  "Tcommaaccent\0ecaron": -120,
  "Tcommaaccent\0ecircumflex": -120,
  "Tcommaaccent\0edieresis": -120,
  "Tcommaaccent\0edotaccent": -120,
  "Tcommaaccent\0egrave": -60,
  "Tcommaaccent\0emacron": -60,
  "Tcommaaccent\0eogonek": -120,
  "Tcommaaccent\0hyphen": -140,
  "Tcommaaccent\0o": -120,
  "Tcommaaccent\0oacute": -120,
  "Tcommaaccent\0ocircumflex": -120,
  "Tcommaaccent\0odieresis": -120,
  "Tcommaaccent\0ograve": -120,
  "Tcommaaccent\0ohungarumlaut": -120,
  "Tcommaaccent\0omacron": -60,
  "Tcommaaccent\0oslash": -120,
  "Tcommaaccent\0otilde": -60,
  "Tcommaaccent\0period": -120,
  "Tcommaaccent\0r": -120,
  "Tcommaaccent\0racute": -120,
  "Tcommaaccent\0rcaron": -120,
  "Tcommaaccent\0rcommaaccent": -120,
  "Tcommaaccent\0semicolon": -20,
  "Tcommaaccent\0u": -120,
  "Tcommaaccent\0uacute": -120,
  "Tcommaaccent\0ucircumflex": -120,
  "Tcommaaccent\0udieresis": -120,
  "Tcommaaccent\0ugrave": -120,
  "Tcommaaccent\0uhungarumlaut": -120,
  "Tcommaaccent\0umacron": -60,
  "Tcommaaccent\0uogonek": -120,
  "Tcommaaccent\0uring": -120,
  "Tcommaaccent\0w": -120,
  "Tcommaaccent\0y": -120,
  "Tcommaaccent\0yacute": -120,
  "Tcommaaccent\0ydieresis": -60,
  "U\0A": -40,
  "U\0Aacute": -40,
  "U\0Abreve": -40,
  "U\0Acircumflex": -40,
  "U\0Adieresis": -40,
  "U\0Agrave": -40,
  "U\0Amacron": -40,
  "U\0Aogonek": -40,
  "U\0Aring": -40,
  "U\0Atilde": -40,
  "U\0comma": -40,
  "U\0period": -40,
  "Uacute\0A": -40,
  "Uacute\0Aacute": -40,
  "Uacute\0Abreve": -40,
  "Uacute\0Acircumflex": -40,
  "Uacute\0Adieresis": -40,
  "Uacute\0Agrave": -40,
  "Uacute\0Amacron": -40,
  "Uacute\0Aogonek": -40,
  "Uacute\0Aring": -40,
  "Uacute\0Atilde": -40,
  "Uacute\0comma": -40,
  "Uacute\0period": -40,
  "Ucircumflex\0A": -40,
  "Ucircumflex\0Aacute": -40,
  "Ucircumflex\0Abreve": -40,
  "Ucircumflex\0Acircumflex": -40,
  "Ucircumflex\0Adieresis": -40,
  "Ucircumflex\0Agrave": -40,
  "Ucircumflex\0Amacron": -40,
  "Ucircumflex\0Aogonek": -40,
  "Ucircumflex\0Aring": -40,
  "Ucircumflex\0Atilde": -40,
  "Ucircumflex\0comma": -40,
  "Ucircumflex\0period": -40,
  "Udieresis\0A": -40,
  "Udieresis\0Aacute": -40,
  "Udieresis\0Abreve": -40,
  "Udieresis\0Acircumflex": -40,
  "Udieresis\0Adieresis": -40,
  "Udieresis\0Agrave": -40,
  "Udieresis\0Amacron": -40,
  "Udieresis\0Aogonek": -40,
  "Udieresis\0Aring": -40,
  "Udieresis\0Atilde": -40,
  "Udieresis\0comma": -40,
  "Udieresis\0period": -40,
  "Ugrave\0A": -40,
  "Ugrave\0Aacute": -40,
  "Ugrave\0Abreve": -40,
  "Ugrave\0Acircumflex": -40,
  "Ugrave\0Adieresis": -40,
  "Ugrave\0Agrave": -40,
  "Ugrave\0Amacron": -40,
  "Ugrave\0Aogonek": -40,
  "Ugrave\0Aring": -40,
  "Ugrave\0Atilde": -40,
  "Ugrave\0comma": -40,
  "Ugrave\0period": -40,
  "Uhungarumlaut\0A": -40,
  "Uhungarumlaut\0Aacute": -40,
  "Uhungarumlaut\0Abreve": -40,
  "Uhungarumlaut\0Acircumflex": -40,
  "Uhungarumlaut\0Adieresis": -40,
  "Uhungarumlaut\0Agrave": -40,
  "Uhungarumlaut\0Amacron": -40,
  "Uhungarumlaut\0Aogonek": -40,
  "Uhungarumlaut\0Aring": -40,
  "Uhungarumlaut\0Atilde": -40,
  "Uhungarumlaut\0comma": -40,
  "Uhungarumlaut\0period": -40,
  "Umacron\0A": -40,
  "Umacron\0Aacute": -40,
  "Umacron\0Abreve": -40,
  "Umacron\0Acircumflex": -40,
  "Umacron\0Adieresis": -40,
  "Umacron\0Agrave": -40,
  "Umacron\0Amacron": -40,
  "Umacron\0Aogonek": -40,
  "Umacron\0Aring": -40,
  "Umacron\0Atilde": -40,
  "Umacron\0comma": -40,
  "Umacron\0period": -40,
  "Uogonek\0A": -40,
  "Uogonek\0Aacute": -40,
  "Uogonek\0Abreve": -40,
  "Uogonek\0Acircumflex": -40,
  "Uogonek\0Adieresis": -40,
  "Uogonek\0Agrave": -40,
  "Uogonek\0Amacron": -40,
  "Uogonek\0Aogonek": -40,
  "Uogonek\0Aring": -40,
  "Uogonek\0Atilde": -40,
  "Uogonek\0comma": -40,
  "Uogonek\0period": -40,
  "Uring\0A": -40,
  "Uring\0Aacute": -40,
  "Uring\0Abreve": -40,
  "Uring\0Acircumflex": -40,
  "Uring\0Adieresis": -40,
  "Uring\0Agrave": -40,
  "Uring\0Amacron": -40,
  "Uring\0Aogonek": -40,
  "Uring\0Aring": -40,
  "Uring\0Atilde": -40,
  "Uring\0comma": -40,
  "Uring\0period": -40,
  "V\0A": -80,
  "V\0Aacute": -80,
  "V\0Abreve": -80,
  "V\0Acircumflex": -80,
  "V\0Adieresis": -80,
  "V\0Agrave": -80,
  "V\0Amacron": -80,
  "V\0Aogonek": -80,
  "V\0Aring": -80,
  "V\0Atilde": -80,
  "V\0G": -40,
  "V\0Gbreve": -40,
  "V\0Gcommaaccent": -40,
  "V\0O": -40,
  "V\0Oacute": -40,
  "V\0Ocircumflex": -40,
  "V\0Odieresis": -40,
  "V\0Ograve": -40,
  "V\0Ohungarumlaut": -40,
  "V\0Omacron": -40,
  "V\0Oslash": -40,
  "V\0Otilde": -40,
  "V\0a": -70,
  "V\0aacute": -70,
  "V\0abreve": -70,
  "V\0acircumflex": -70,
  "V\0adieresis": -70,
  "V\0agrave": -70,
  "V\0amacron": -70,
  "V\0aogonek": -70,
  "V\0aring": -70,
  "V\0atilde": -70,
  "V\0colon": -40,
  "V\0comma": -125,
  "V\0e": -80,
  "V\0eacute": -80,
  "V\0ecaron": -80,
  "V\0ecircumflex": -80,
  "V\0edieresis": -80,
  "V\0edotaccent": -80,
  "V\0egrave": -80,
  "V\0emacron": -80,
  "V\0eogonek": -80,
  "V\0hyphen": -80,
  "V\0o": -80,
  "V\0oacute": -80,
  "V\0ocircumflex": -80,
  "V\0odieresis": -80,
  "V\0ograve": -80,
  "V\0ohungarumlaut": -80,
  "V\0omacron": -80,
  "V\0oslash": -80,
  "V\0otilde": -80,
  "V\0period": -125,
  "V\0semicolon": -40,
  "V\0u": -70,
  "V\0uacute": -70,
  "V\0ucircumflex": -70,
  "V\0udieresis": -70,
  "V\0ugrave": -70,
  "V\0uhungarumlaut": -70,
  "V\0umacron": -70,
  "V\0uogonek": -70,
  "V\0uring": -70,
  "W\0A": -50,
  "W\0Aacute": -50,
  "W\0Abreve": -50,
  "W\0Acircumflex": -50,
  "W\0Adieresis": -50,
  "W\0Agrave": -50,
  "W\0Amacron": -50,
  "W\0Aogonek": -50,
  "W\0Aring": -50,
  "W\0Atilde": -50,
  "W\0O": -20,
  "W\0Oacute": -20,
  "W\0Ocircumflex": -20,
  "W\0Odieresis": -20,
  "W\0Ograve": -20,
  "W\0Ohungarumlaut": -20,
  "W\0Omacron": -20,
  "W\0Oslash": -20,
  "W\0Otilde": -20,
  "W\0a": -40,
  "W\0aacute": -40,
  "W\0abreve": -40,
  "W\0acircumflex": -40,
  "W\0adieresis": -40,
  "W\0agrave": -40,
  "W\0amacron": -40,
  "W\0aogonek": -40,
  "W\0aring": -40,
  "W\0atilde": -40,
  "W\0comma": -80,
  "W\0e": -30,
  "W\0eacute": -30,
  "W\0ecaron": -30,
  "W\0ecircumflex": -30,
  "W\0edieresis": -30,
  "W\0edotaccent": -30,
  "W\0egrave": -30,
  "W\0emacron": -30,
  "W\0eogonek": -30,
  "W\0hyphen": -40,
  "W\0o": -30,
  "W\0oacute": -30,
  "W\0ocircumflex": -30,
  "W\0odieresis": -30,
  "W\0ograve": -30,
  "W\0ohungarumlaut": -30,
  "W\0omacron": -30,
  "W\0oslash": -30,
  "W\0otilde": -30,
  "W\0period": -80,
  "W\0u": -30,
  "W\0uacute": -30,
  "W\0ucircumflex": -30,
  "W\0udieresis": -30,
  "W\0ugrave": -30,
  "W\0uhungarumlaut": -30,
  "W\0umacron": -30,
  "W\0uogonek": -30,
  "W\0uring": -30,
  "W\0y": -20,
  "W\0yacute": -20,
  "W\0ydieresis": -20,
  "Y\0A": -110,
  "Y\0Aacute": -110,
  "Y\0Abreve": -110,
  "Y\0Acircumflex": -110,
  "Y\0Adieresis": -110,
  "Y\0Agrave": -110,
  "Y\0Amacron": -110,
  "Y\0Aogonek": -110,
  "Y\0Aring": -110,
  "Y\0Atilde": -110,
  "Y\0O": -85,
  "Y\0Oacute": -85,
  "Y\0Ocircumflex": -85,
  "Y\0Odieresis": -85,
  "Y\0Ograve": -85,
  "Y\0Ohungarumlaut": -85,
  "Y\0Omacron": -85,
  "Y\0Oslash": -85,
  "Y\0Otilde": -85,
  "Y\0a": -140,
  "Y\0aacute": -140,
  "Y\0abreve": -70,
  "Y\0acircumflex": -140,
  "Y\0adieresis": -140,
  "Y\0agrave": -140,
  "Y\0amacron": -70,
  "Y\0aogonek": -140,
  "Y\0aring": -140,
  "Y\0atilde": -140,
  "Y\0colon": -60,
  "Y\0comma": -140,
  "Y\0e": -140,
  "Y\0eacute": -140,
  "Y\0ecaron": -140,
  "Y\0ecircumflex": -140,
  "Y\0edieresis": -140,
  "Y\0edotaccent": -140,
  "Y\0egrave": -140,
  "Y\0emacron": -70,
  "Y\0eogonek": -140,
  "Y\0hyphen": -140,
  "Y\0i": -20,
  "Y\0iacute": -20,
  "Y\0iogonek": -20,
  "Y\0o": -140,
  "Y\0oacute": -140,
  "Y\0ocircumflex": -140,
  "Y\0odieresis": -140,
  "Y\0ograve": -140,
  "Y\0ohungarumlaut": -140,
  "Y\0omacron": -140,
  "Y\0oslash": -140,
  "Y\0otilde": -140,
  "Y\0period": -140,
  "Y\0semicolon": -60,
  "Y\0u": -110,
  "Y\0uacute": -110,
  "Y\0ucircumflex": -110,
  "Y\0udieresis": -110,
  "Y\0ugrave": -110,
  "Y\0uhungarumlaut": -110,
  "Y\0umacron": -110,
  "Y\0uogonek": -110,
  "Y\0uring": -110,
  "Yacute\0A": -110,
  "Yacute\0Aacute": -110,
  "Yacute\0Abreve": -110,
  "Yacute\0Acircumflex": -110,
  "Yacute\0Adieresis": -110,
  "Yacute\0Agrave": -110,
  "Yacute\0Amacron": -110,
  "Yacute\0Aogonek": -110,
  "Yacute\0Aring": -110,
  "Yacute\0Atilde": -110,
  "Yacute\0O": -85,
  "Yacute\0Oacute": -85,
  "Yacute\0Ocircumflex": -85,
  "Yacute\0Odieresis": -85,
  "Yacute\0Ograve": -85,
  "Yacute\0Ohungarumlaut": -85,
  "Yacute\0Omacron": -85,
  "Yacute\0Oslash": -85,
  "Yacute\0Otilde": -85,
  "Yacute\0a": -140,
  "Yacute\0aacute": -140,
  "Yacute\0abreve": -70,
  "Yacute\0acircumflex": -140,
  "Yacute\0adieresis": -140,
  "Yacute\0agrave": -140,
  "Yacute\0amacron": -70,
  "Yacute\0aogonek": -140,
  "Yacute\0aring": -140,
  "Yacute\0atilde": -70,
  "Yacute\0colon": -60,
  "Yacute\0comma": -140,
  "Yacute\0e": -140,
  "Yacute\0eacute": -140,
  "Yacute\0ecaron": -140,
  "Yacute\0ecircumflex": -140,
  "Yacute\0edieresis": -140,
  "Yacute\0edotaccent": -140,
  "Yacute\0egrave": -140,
  "Yacute\0emacron": -70,
  "Yacute\0eogonek": -140,
  "Yacute\0hyphen": -140,
  "Yacute\0i": -20,
  "Yacute\0iacute": -20,
  "Yacute\0iogonek": -20,
  "Yacute\0o": -140,
  "Yacute\0oacute": -140,
  "Yacute\0ocircumflex": -140,
  "Yacute\0odieresis": -140,
  "Yacute\0ograve": -140,
  "Yacute\0ohungarumlaut": -140,
  "Yacute\0omacron": -70,
  "Yacute\0oslash": -140,
  "Yacute\0otilde": -140,
  "Yacute\0period": -140,
  "Yacute\0semicolon": -60,
  "Yacute\0u": -110,
  "Yacute\0uacute": -110,
  "Yacute\0ucircumflex": -110,
  "Yacute\0udieresis": -110,
  "Yacute\0ugrave": -110,
  "Yacute\0uhungarumlaut": -110,
  "Yacute\0umacron": -110,
  "Yacute\0uogonek": -110,
  "Yacute\0uring": -110,
  "Ydieresis\0A": -110,
  "Ydieresis\0Aacute": -110,
  "Ydieresis\0Abreve": -110,
  "Ydieresis\0Acircumflex": -110,
  "Ydieresis\0Adieresis": -110,
  "Ydieresis\0Agrave": -110,
  "Ydieresis\0Amacron": -110,
  "Ydieresis\0Aogonek": -110,
  "Ydieresis\0Aring": -110,
  "Ydieresis\0Atilde": -110,
  "Ydieresis\0O": -85,
  "Ydieresis\0Oacute": -85,
  "Ydieresis\0Ocircumflex": -85,
  "Ydieresis\0Odieresis": -85,
  "Ydieresis\0Ograve": -85,
  "Ydieresis\0Ohungarumlaut": -85,
  "Ydieresis\0Omacron": -85,
  "Ydieresis\0Oslash": -85,
  "Ydieresis\0Otilde": -85,
  "Ydieresis\0a": -140,
  "Ydieresis\0aacute": -140,
  "Ydieresis\0abreve": -70,
  "Ydieresis\0acircumflex": -140,
  "Ydieresis\0adieresis": -140,
  "Ydieresis\0agrave": -140,
  "Ydieresis\0amacron": -70,
  "Ydieresis\0aogonek": -140,
  "Ydieresis\0aring": -140,
  "Ydieresis\0atilde": -70,
  "Ydieresis\0colon": -60,
  "Ydieresis\0comma": -140,
  "Ydieresis\0e": -140,
  "Ydieresis\0eacute": -140,
  "Ydieresis\0ecaron": -140,
  "Ydieresis\0ecircumflex": -140,
  "Ydieresis\0edieresis": -140,
  "Ydieresis\0edotaccent": -140,
  "Ydieresis\0egrave": -140,
  "Ydieresis\0emacron": -70,
  "Ydieresis\0eogonek": -140,
  "Ydieresis\0hyphen": -140,
  "Ydieresis\0i": -20,
  "Ydieresis\0iacute": -20,
  "Ydieresis\0iogonek": -20,
  "Ydieresis\0o": -140,
  "Ydieresis\0oacute": -140,
  "Ydieresis\0ocircumflex": -140,
  "Ydieresis\0odieresis": -140,
  "Ydieresis\0ograve": -140,
  "Ydieresis\0ohungarumlaut": -140,
  "Ydieresis\0omacron": -140,
  "Ydieresis\0oslash": -140,
  "Ydieresis\0otilde": -140,
  "Ydieresis\0period": -140,
  "Ydieresis\0semicolon": -60,
  "Ydieresis\0u": -110,
  "Ydieresis\0uacute": -110,
  "Ydieresis\0ucircumflex": -110,
  "Ydieresis\0udieresis": -110,
  "Ydieresis\0ugrave": -110,
  "Ydieresis\0uhungarumlaut": -110,
  "Ydieresis\0umacron": -110,
  "Ydieresis\0uogonek": -110,
  "Ydieresis\0uring": -110,
  "a\0v": -20,
  "a\0w": -20,
  "a\0y": -30,
  "a\0yacute": -30,
  "a\0ydieresis": -30,
  "aacute\0v": -20,
  "aacute\0w": -20,
  "aacute\0y": -30,
  "aacute\0yacute": -30,
  "aacute\0ydieresis": -30,
  "abreve\0v": -20,
  "abreve\0w": -20,
  "abreve\0y": -30,
  "abreve\0yacute": -30,
  "abreve\0ydieresis": -30,
  "acircumflex\0v": -20,
  "acircumflex\0w": -20,
  "acircumflex\0y": -30,
  "acircumflex\0yacute": -30,
  "acircumflex\0ydieresis": -30,
  "adieresis\0v": -20,
  "adieresis\0w": -20,
  "adieresis\0y": -30,
  "adieresis\0yacute": -30,
  "adieresis\0ydieresis": -30,
  "agrave\0v": -20,
  "agrave\0w": -20,
  "agrave\0y": -30,
  "agrave\0yacute": -30,
  "agrave\0ydieresis": -30,
  "amacron\0v": -20,
  "amacron\0w": -20,
  "amacron\0y": -30,
  "amacron\0yacute": -30,
  "amacron\0ydieresis": -30,
  "aogonek\0v": -20,
  "aogonek\0w": -20,
  "aogonek\0y": -30,
  "aogonek\0yacute": -30,
  "aogonek\0ydieresis": -30,
  "aring\0v": -20,
  "aring\0w": -20,
  "aring\0y": -30,
  "aring\0yacute": -30,
  "aring\0ydieresis": -30,
  "atilde\0v": -20,
  "atilde\0w": -20,
  "atilde\0y": -30,
  "atilde\0yacute": -30,
  "atilde\0ydieresis": -30,
  "b\0b": -10,
  "b\0comma": -40,
  "b\0l": -20,
  "b\0lacute": -20,
  "b\0lcommaaccent": -20,
  "b\0lslash": -20,
  "b\0period": -40,
  "b\0u": -20,
  "b\0uacute": -20,
  "b\0ucircumflex": -20,
  "b\0udieresis": -20,
  "b\0ugrave": -20,
  "b\0uhungarumlaut": -20,
  "b\0umacron": -20,
  "b\0uogonek": -20,
  "b\0uring": -20,
  "b\0v": -20,
  "b\0y": -20,
  "b\0yacute": -20,
  "b\0ydieresis": -20,
  "c\0comma": -15,
  "c\0k": -20,
  "c\0kcommaaccent": -20,
  "cacute\0comma": -15,
  "cacute\0k": -20,
  "cacute\0kcommaaccent": -20,
  "ccaron\0comma": -15,
  "ccaron\0k": -20,
  "ccaron\0kcommaaccent": -20,
  "ccedilla\0comma": -15,
  "ccedilla\0k": -20,
  "ccedilla\0kcommaaccent": -20,
  "colon\0space": -50,
  "comma\0quotedblright": -100,
  "comma\0quoteright": -100,
  "e\0comma": -15,
  "e\0period": -15,
  "e\0v": -30,
  "e\0w": -20,
  "e\0x": -30,
  "e\0y": -20,
  "e\0yacute": -20,
  "e\0ydieresis": -20,
  "eacute\0comma": -15,
  "eacute\0period": -15,
  "eacute\0v": -30,
  "eacute\0w": -20,
  "eacute\0x": -30,
  "eacute\0y": -20,
  "eacute\0yacute": -20,
  "eacute\0ydieresis": -20,
  "ecaron\0comma": -15,
  "ecaron\0period": -15,
  "ecaron\0v": -30,
  "ecaron\0w": -20,
  "ecaron\0x": -30,
  "ecaron\0y": -20,
  "ecaron\0yacute": -20,
  "ecaron\0ydieresis": -20,
  "ecircumflex\0comma": -15,
  "ecircumflex\0period": -15,
  "ecircumflex\0v": -30,
  "ecircumflex\0w": -20,
  "ecircumflex\0x": -30,
  "ecircumflex\0y": -20,
  "ecircumflex\0yacute": -20,
  "ecircumflex\0ydieresis": -20,
  "edieresis\0comma": -15,
  "edieresis\0period": -15,
  "edieresis\0v": -30,
  "edieresis\0w": -20,
  "edieresis\0x": -30,
  "edieresis\0y": -20,
  "edieresis\0yacute": -20,
  "edieresis\0ydieresis": -20,
  "edotaccent\0comma": -15,
  "edotaccent\0period": -15,
  "edotaccent\0v": -30,
  "edotaccent\0w": -20,
  "edotaccent\0x": -30,
  "edotaccent\0y": -20,
  "edotaccent\0yacute": -20,
  "edotaccent\0ydieresis": -20,
  "egrave\0comma": -15,
  "egrave\0period": -15,
  "egrave\0v": -30,
  "egrave\0w": -20,
  "egrave\0x": -30,
  "egrave\0y": -20,
  "egrave\0yacute": -20,
  "egrave\0ydieresis": -20,
  "emacron\0comma": -15,
  "emacron\0period": -15,
  "emacron\0v": -30,
  "emacron\0w": -20,
  "emacron\0x": -30,
  "emacron\0y": -20,
  "emacron\0yacute": -20,
  "emacron\0ydieresis": -20,
  "eogonek\0comma": -15,
  "eogonek\0period": -15,
  "eogonek\0v": -30,
  "eogonek\0w": -20,
  "eogonek\0x": -30,
  "eogonek\0y": -20,
  "eogonek\0yacute": -20,
  "eogonek\0ydieresis": -20,
  "f\0a": -30,
  "f\0aacute": -30,
  "f\0abreve": -30,
  "f\0acircumflex": -30,
  "f\0adieresis": -30,
  "f\0agrave": -30,
  "f\0amacron": -30,
  "f\0aogonek": -30,
  "f\0aring": -30,
  "f\0atilde": -30,
  "f\0comma": -30,
  "f\0dotlessi": -28,
  "f\0e": -30,
  "f\0eacute": -30,
  "f\0ecaron": -30,
  "f\0ecircumflex": -30,
  "f\0edieresis": -30,
  "f\0edotaccent": -30,
  "f\0egrave": -30,
  "f\0emacron": -30,
  "f\0eogonek": -30,
  "f\0o": -30,
  "f\0oacute": -30,
  "f\0ocircumflex": -30,
  "f\0odieresis": -30,
  "f\0ograve": -30,
  "f\0ohungarumlaut": -30,
  "f\0omacron": -30,
  "f\0oslash": -30,
  "f\0otilde": -30,
  "f\0period": -30,
  "f\0quotedblright": 60,
  "f\0quoteright": 50,
  "g\0r": -10,
  "g\0racute": -10,
  "g\0rcaron": -10,
  "g\0rcommaaccent": -10,
  "gbreve\0r": -10,
  "gbreve\0racute": -10,
  "gbreve\0rcaron": -10,
  "gbreve\0rcommaaccent": -10,
  "gcommaaccent\0r": -10,
  "gcommaaccent\0racute": -10,
  "gcommaaccent\0rcaron": -10,
  "gcommaaccent\0rcommaaccent": -10,
  "h\0y": -30,
  "h\0yacute": -30,
  "h\0ydieresis": -30,
  "k\0e": -20,
  "k\0eacute": -20,
  "k\0ecaron": -20,
  "k\0ecircumflex": -20,
  "k\0edieresis": -20,
  "k\0edotaccent": -20,
  "k\0egrave": -20,
  "k\0emacron": -20,
  "k\0eogonek": -20,
  "k\0o": -20,
  "k\0oacute": -20,
  "k\0ocircumflex": -20,
  "k\0odieresis": -20,
  "k\0ograve": -20,
  "k\0ohungarumlaut": -20,
  "k\0omacron": -20,
  "k\0oslash": -20,
  "k\0otilde": -20,
  "kcommaaccent\0e": -20,
  "kcommaaccent\0eacute": -20,
  "kcommaaccent\0ecaron": -20,
  "kcommaaccent\0ecircumflex": -20,
  "kcommaaccent\0edieresis": -20,
  "kcommaaccent\0edotaccent": -20,
  "kcommaaccent\0egrave": -20,
  "kcommaaccent\0emacron": -20,
  "kcommaaccent\0eogonek": -20,
  "kcommaaccent\0o": -20,
  "kcommaaccent\0oacute": -20,
  "kcommaaccent\0ocircumflex": -20,
  "kcommaaccent\0odieresis": -20,
  "kcommaaccent\0ograve": -20,
  "kcommaaccent\0ohungarumlaut": -20,
  "kcommaaccent\0omacron": -20,
  "kcommaaccent\0oslash": -20,
  "kcommaaccent\0otilde": -20,
  "m\0u": -10,
  "m\0uacute": -10,
  "m\0ucircumflex": -10,
  "m\0udieresis": -10,
  "m\0ugrave": -10,
  "m\0uhungarumlaut": -10,
  "m\0umacron": -10,
  "m\0uogonek": -10,
  "m\0uring": -10,
  "m\0y": -15,
  "m\0yacute": -15,
  "m\0ydieresis": -15,
  "n\0u": -10,
  "n\0uacute": -10,
  "n\0ucircumflex": -10,
  "n\0udieresis": -10,
  "n\0ugrave": -10,
  "n\0uhungarumlaut": -10,
  "n\0umacron": -10,
  "n\0uogonek": -10,
  "n\0uring": -10,
  "n\0v": -20,
  "n\0y": -15,
  "n\0yacute": -15,
  "n\0ydieresis": -15,
  "nacute\0u": -10,
  "nacute\0uacute": -10,
  "nacute\0ucircumflex": -10,
  "nacute\0udieresis": -10,
  "nacute\0ugrave": -10,
  "nacute\0uhungarumlaut": -10,
  "nacute\0umacron": -10,
  "nacute\0uogonek": -10,
  "nacute\0uring": -10,
  "nacute\0v": -20,
  "nacute\0y": -15,
  "nacute\0yacute": -15,
  "nacute\0ydieresis": -15,
  "ncaron\0u": -10,
  "ncaron\0uacute": -10,
  "ncaron\0ucircumflex": -10,
  "ncaron\0udieresis": -10,
  "ncaron\0ugrave": -10,
  "ncaron\0uhungarumlaut": -10,
  "ncaron\0umacron": -10,
  "ncaron\0uogonek": -10,
  "ncaron\0uring": -10,
  "ncaron\0v": -20,
  "ncaron\0y": -15,
  "ncaron\0yacute": -15,
  "ncaron\0ydieresis": -15,
  "ncommaaccent\0u": -10,
  "ncommaaccent\0uacute": -10,
  "ncommaaccent\0ucircumflex": -10,
  "ncommaaccent\0udieresis": -10,
  "ncommaaccent\0ugrave": -10,
  "ncommaaccent\0uhungarumlaut": -10,
  "ncommaaccent\0umacron": -10,
  "ncommaaccent\0uogonek": -10,
  "ncommaaccent\0uring": -10,
  "ncommaaccent\0v": -20,
  "ncommaaccent\0y": -15,
  "ncommaaccent\0yacute": -15,
  "ncommaaccent\0ydieresis": -15,
  "ntilde\0u": -10,
  "ntilde\0uacute": -10,
  "ntilde\0ucircumflex": -10,
  "ntilde\0udieresis": -10,
  "ntilde\0ugrave": -10,
  "ntilde\0uhungarumlaut": -10,
  "ntilde\0umacron": -10,
  "ntilde\0uogonek": -10,
  "ntilde\0uring": -10,
  "ntilde\0v": -20,
  "ntilde\0y": -15,
  "ntilde\0yacute": -15,
  "ntilde\0ydieresis": -15,
  "o\0comma": -40,
  "o\0period": -40,
  "o\0v": -15,
  "o\0w": -15,
  "o\0x": -30,
  "o\0y": -30,
  "o\0yacute": -30,
  "o\0ydieresis": -30,
  "oacute\0comma": -40,
  "oacute\0period": -40,
  "oacute\0v": -15,
  "oacute\0w": -15,
  "oacute\0x": -30,
  "oacute\0y": -30,
  "oacute\0yacute": -30,
  "oacute\0ydieresis": -30,
  "ocircumflex\0comma": -40,
  "ocircumflex\0period": -40,
  "ocircumflex\0v": -15,
  "ocircumflex\0w": -15,
  "ocircumflex\0x": -30,
  "ocircumflex\0y": -30,
  "ocircumflex\0yacute": -30,
  "ocircumflex\0ydieresis": -30,
  "odieresis\0comma": -40,
  "odieresis\0period": -40,
  "odieresis\0v": -15,
  "odieresis\0w": -15,
  "odieresis\0x": -30,
  "odieresis\0y": -30,
  "odieresis\0yacute": -30,
  "odieresis\0ydieresis": -30,
  "ograve\0comma": -40,
  "ograve\0period": -40,
  "ograve\0v": -15,
  "ograve\0w": -15,
  "ograve\0x": -30,
  "ograve\0y": -30,
  "ograve\0yacute": -30,
  "ograve\0ydieresis": -30,
  "ohungarumlaut\0comma": -40,
  "ohungarumlaut\0period": -40,
  "ohungarumlaut\0v": -15,
  "ohungarumlaut\0w": -15,
  "ohungarumlaut\0x": -30,
  "ohungarumlaut\0y": -30,
  "ohungarumlaut\0yacute": -30,
  "ohungarumlaut\0ydieresis": -30,
  "omacron\0comma": -40,
  "omacron\0period": -40,
  "omacron\0v": -15,
  "omacron\0w": -15,
  "omacron\0x": -30,
  "omacron\0y": -30,
  "omacron\0yacute": -30,
  "omacron\0ydieresis": -30,
  "oslash\0a": -55,
  "oslash\0aacute": -55,
  "oslash\0abreve": -55,
  "oslash\0acircumflex": -55,
  "oslash\0adieresis": -55,
  "oslash\0agrave": -55,
  "oslash\0amacron": -55,
  "oslash\0aogonek": -55,
  "oslash\0aring": -55,
  "oslash\0atilde": -55,
  "oslash\0b": -55,
  "oslash\0c": -55,
  "oslash\0cacute": -55,
  "oslash\0ccaron": -55,
  "oslash\0ccedilla": -55,
  "oslash\0comma": -95,
  "oslash\0d": -55,
  "oslash\0dcroat": -55,
  "oslash\0e": -55,
  "oslash\0eacute": -55,
  "oslash\0ecaron": -55,
  "oslash\0ecircumflex": -55,
  "oslash\0edieresis": -55,
  "oslash\0edotaccent": -55,
  "oslash\0egrave": -55,
  "oslash\0emacron": -55,
  "oslash\0eogonek": -55,
  "oslash\0f": -55,
  "oslash\0g": -55,
  "oslash\0gbreve": -55,
  "oslash\0gcommaaccent": -55,
  "oslash\0h": -55,
  "oslash\0i": -55,
  "oslash\0iacute": -55,
  "oslash\0icircumflex": -55,
  "oslash\0idieresis": -55,
  "oslash\0igrave": -55,
  "oslash\0imacron": -55,
  "oslash\0iogonek": -55,
  "oslash\0j": -55,
  "oslash\0k": -55,
  "oslash\0kcommaaccent": -55,
  "oslash\0l": -55,
  "oslash\0lacute": -55,
  "oslash\0lcommaaccent": -55,
  "oslash\0lslash": -55,
  "oslash\0m": -55,
  "oslash\0n": -55,
  "oslash\0nacute": -55,
  "oslash\0ncaron": -55,
  "oslash\0ncommaaccent": -55,
  "oslash\0ntilde": -55,
  "oslash\0o": -55,
  "oslash\0oacute": -55,
  "oslash\0ocircumflex": -55,
  "oslash\0odieresis": -55,
  "oslash\0ograve": -55,
  "oslash\0ohungarumlaut": -55,
  "oslash\0omacron": -55,
  "oslash\0oslash": -55,
  "oslash\0otilde": -55,
  "oslash\0p": -55,
  "oslash\0period": -95,
  "oslash\0q": -55,
  "oslash\0r": -55,
  "oslash\0racute": -55,
  "oslash\0rcaron": -55,
  "oslash\0rcommaaccent": -55,
  "oslash\0s": -55,
  "oslash\0sacute": -55,
  "oslash\0scaron": -55,
  "oslash\0scedilla": -55,
  "oslash\0scommaaccent": -55,
  "oslash\0t": -55,
  "oslash\0tcommaaccent": -55,
  "oslash\0u": -55,
  "oslash\0uacute": -55,
  "oslash\0ucircumflex": -55,
  "oslash\0udieresis": -55,
  "oslash\0ugrave": -55,
  "oslash\0uhungarumlaut": -55,
  "oslash\0umacron": -55,
  "oslash\0uogonek": -55,
  "oslash\0uring": -55,
  "oslash\0v": -70,
  "oslash\0w": -70,
  "oslash\0x": -85,
  "oslash\0y": -70,
  "oslash\0yacute": -70,
  "oslash\0ydieresis": -70,
  "oslash\0z": -55,
  "oslash\0zacute": -55,
  "oslash\0zcaron": -55,
  "oslash\0zdotaccent": -55,
  "otilde\0comma": -40,
  "otilde\0period": -40,
  "otilde\0v": -15,
  "otilde\0w": -15,
  "otilde\0x": -30,
  "otilde\0y": -30,
  "otilde\0yacute": -30,
  "otilde\0ydieresis": -30,
  "p\0comma": -35,
  "p\0period": -35,
  "p\0y": -30,
  "p\0yacute": -30,
  "p\0ydieresis": -30,
  "period\0quotedblright": -100,
  "period\0quoteright": -100,
  "period\0space": -60,
  "quotedblright\0space": -40,
  "quoteleft\0quoteleft": -57,
  "quoteright\0d": -50,
  "quoteright\0dcroat": -50,
  "quoteright\0quoteright": -57,
  "quoteright\0r": -50,
  "quoteright\0racute": -50,
  "quoteright\0rcaron": -50,
  "quoteright\0rcommaaccent": -50,
  "quoteright\0s": -50,
  "quoteright\0sacute": -50,
  "quoteright\0scaron": -50,
  "quoteright\0scedilla": -50,
  "quoteright\0scommaaccent": -50,
  "quoteright\0space": -70,
  "r\0a": -10,
  "r\0aacute": -10,
  "r\0abreve": -10,
  "r\0acircumflex": -10,
  "r\0adieresis": -10,
  "r\0agrave": -10,
  "r\0amacron": -10,
  "r\0aogonek": -10,
  "r\0aring": -10,
  "r\0atilde": -10,
  "r\0colon": 30,
  "r\0comma": -50,
  "r\0i": 15,
  "r\0iacute": 15,
  "r\0icircumflex": 15,
  "r\0idieresis": 15,
  "r\0igrave": 15,
  "r\0imacron": 15,
  "r\0iogonek": 15,
  "r\0k": 15,
  "r\0kcommaaccent": 15,
  "r\0l": 15,
  "r\0lacute": 15,
  "r\0lcommaaccent": 15,
  "r\0lslash": 15,
  "r\0m": 25,
  "r\0n": 25,
  "r\0nacute": 25,
  "r\0ncaron": 25,
  "r\0ncommaaccent": 25,
  "r\0ntilde": 25,
  "r\0p": 30,
  "r\0period": -50,
  "r\0semicolon": 30,
  "r\0t": 40,
  "r\0tcommaaccent": 40,
  "r\0u": 15,
  "r\0uacute": 15,
  "r\0ucircumflex": 15,
  "r\0udieresis": 15,
  "r\0ugrave": 15,
  "r\0uhungarumlaut": 15,
  "r\0umacron": 15,
  "r\0uogonek": 15,
  "r\0uring": 15,
  "r\0v": 30,
  "r\0y": 30,
  "r\0yacute": 30,
  "r\0ydieresis": 30,
  "racute\0a": -10,
  "racute\0aacute": -10,
  "racute\0abreve": -10,
  "racute\0acircumflex": -10,
  "racute\0adieresis": -10,
  "racute\0agrave": -10,
  "racute\0amacron": -10,
  "racute\0aogonek": -10,
  "racute\0aring": -10,
  "racute\0atilde": -10,
  "racute\0colon": 30,
  "racute\0comma": -50,
  "racute\0i": 15,
  "racute\0iacute": 15,
  "racute\0icircumflex": 15,
  "racute\0idieresis": 15,
  "racute\0igrave": 15,
  "racute\0imacron": 15,
  "racute\0iogonek": 15,
  "racute\0k": 15,
  "racute\0kcommaaccent": 15,
  "racute\0l": 15,
  "racute\0lacute": 15,
  "racute\0lcommaaccent": 15,
  "racute\0lslash": 15,
  "racute\0m": 25,
  "racute\0n": 25,
  "racute\0nacute": 25,
  "racute\0ncaron": 25,
  "racute\0ncommaaccent": 25,
  "racute\0ntilde": 25,
  "racute\0p": 30,
  "racute\0period": -50,
  "racute\0semicolon": 30,
  "racute\0t": 40,
  "racute\0tcommaaccent": 40,
  "racute\0u": 15,
  "racute\0uacute": 15,
  "racute\0ucircumflex": 15,
  "racute\0udieresis": 15,
  "racute\0ugrave": 15,
  "racute\0uhungarumlaut": 15,
  "racute\0umacron": 15,
  "racute\0uogonek": 15,
  "racute\0uring": 15,
  "racute\0v": 30,
  "racute\0y": 30,
  "racute\0yacute": 30,
  "racute\0ydieresis": 30,
  "rcaron\0a": -10,
  "rcaron\0aacute": -10,
  "rcaron\0abreve": -10,
  "rcaron\0acircumflex": -10,
  "rcaron\0adieresis": -10,
  "rcaron\0agrave": -10,
  "rcaron\0amacron": -10,
  "rcaron\0aogonek": -10,
  "rcaron\0aring": -10,
  "rcaron\0atilde": -10,
  "rcaron\0colon": 30,
  "rcaron\0comma": -50,
  "rcaron\0i": 15,
  "rcaron\0iacute": 15,
  "rcaron\0icircumflex": 15,
  "rcaron\0idieresis": 15,
  "rcaron\0igrave": 15,
  "rcaron\0imacron": 15,
  "rcaron\0iogonek": 15,
  "rcaron\0k": 15,
  "rcaron\0kcommaaccent": 15,
  "rcaron\0l": 15,
  "rcaron\0lacute": 15,
  "rcaron\0lcommaaccent": 15,
  "rcaron\0lslash": 15,
  "rcaron\0m": 25,
  "rcaron\0n": 25,
  "rcaron\0nacute": 25,
  "rcaron\0ncaron": 25,
  "rcaron\0ncommaaccent": 25,
  "rcaron\0ntilde": 25,
  "rcaron\0p": 30,
  "rcaron\0period": -50,
  "rcaron\0semicolon": 30,
  "rcaron\0t": 40,
  "rcaron\0tcommaaccent": 40,
  "rcaron\0u": 15,
  "rcaron\0uacute": 15,
  "rcaron\0ucircumflex": 15,
  "rcaron\0udieresis": 15,
  "rcaron\0ugrave": 15,
  "rcaron\0uhungarumlaut": 15,
  "rcaron\0umacron": 15,
  "rcaron\0uogonek": 15,
  "rcaron\0uring": 15,
  "rcaron\0v": 30,
  "rcaron\0y": 30,
  "rcaron\0yacute": 30,
  "rcaron\0ydieresis": 30,
  "rcommaaccent\0a": -10,
  "rcommaaccent\0aacute": -10,
  "rcommaaccent\0abreve": -10,
  "rcommaaccent\0acircumflex": -10,
  "rcommaaccent\0adieresis": -10,
  "rcommaaccent\0agrave": -10,
  "rcommaaccent\0amacron": -10,
  "rcommaaccent\0aogonek": -10,
  "rcommaaccent\0aring": -10,
  "rcommaaccent\0atilde": -10,
  "rcommaaccent\0colon": 30,
  "rcommaaccent\0comma": -50,
  "rcommaaccent\0i": 15,
  "rcommaaccent\0iacute": 15,
  "rcommaaccent\0icircumflex": 15,
  "rcommaaccent\0idieresis": 15,
  "rcommaaccent\0igrave": 15,
  "rcommaaccent\0imacron": 15,
  "rcommaaccent\0iogonek": 15,
  "rcommaaccent\0k": 15,
  "rcommaaccent\0kcommaaccent": 15,
  "rcommaaccent\0l": 15,
  "rcommaaccent\0lacute": 15,
  "rcommaaccent\0lcommaaccent": 15,
  "rcommaaccent\0lslash": 15,
  "rcommaaccent\0m": 25,
  "rcommaaccent\0n": 25,
  "rcommaaccent\0nacute": 25,
  "rcommaaccent\0ncaron": 25,
  "rcommaaccent\0ncommaaccent": 25,
  "rcommaaccent\0ntilde": 25,
  "rcommaaccent\0p": 30,
  "rcommaaccent\0period": -50,
  "rcommaaccent\0semicolon": 30,
  "rcommaaccent\0t": 40,
  "rcommaaccent\0tcommaaccent": 40,
  "rcommaaccent\0u": 15,
  "rcommaaccent\0uacute": 15,
  "rcommaaccent\0ucircumflex": 15,
  "rcommaaccent\0udieresis": 15,
  "rcommaaccent\0ugrave": 15,
  "rcommaaccent\0uhungarumlaut": 15,
  "rcommaaccent\0umacron": 15,
  "rcommaaccent\0uogonek": 15,
  "rcommaaccent\0uring": 15,
  "rcommaaccent\0v": 30,
  "rcommaaccent\0y": 30,
  "rcommaaccent\0yacute": 30,
  "rcommaaccent\0ydieresis": 30,
  "s\0comma": -15,
  "s\0period": -15,
  "s\0w": -30,
  "sacute\0comma": -15,
  "sacute\0period": -15,
  "sacute\0w": -30,
  "scaron\0comma": -15,
  "scaron\0period": -15,
  "scaron\0w": -30,
  "scedilla\0comma": -15,
  "scedilla\0period": -15,
  "scedilla\0w": -30,
  "scommaaccent\0comma": -15,
  "scommaaccent\0period": -15,
  "scommaaccent\0w": -30,
  "semicolon\0space": -50,
  "space\0T": -50,
  "space\0Tcaron": -50,
  "space\0Tcommaaccent": -50,
  "space\0V": -50,
  "space\0W": -40,
  "space\0Y": -90,
  "space\0Yacute": -90,
  "space\0Ydieresis": -90,
  "space\0quotedblleft": -30,
  "space\0quoteleft": -60,
  "v\0a": -25,
  "v\0aacute": -25,
  "v\0abreve": -25,
  "v\0acircumflex": -25,
  "v\0adieresis": -25,
  "v\0agrave": -25,
  "v\0amacron": -25,
  "v\0aogonek": -25,
  "v\0aring": -25,
  "v\0atilde": -25,
  "v\0comma": -80,
  "v\0e": -25,
  "v\0eacute": -25,
  "v\0ecaron": -25,
  "v\0ecircumflex": -25,
  "v\0edieresis": -25,
  "v\0edotaccent": -25,
  "v\0egrave": -25,
  "v\0emacron": -25,
  "v\0eogonek": -25,
  "v\0o": -25,
  "v\0oacute": -25,
  "v\0ocircumflex": -25,
  "v\0odieresis": -25,
  "v\0ograve": -25,
  "v\0ohungarumlaut": -25,
  "v\0omacron": -25,
  "v\0oslash": -25,
  "v\0otilde": -25,
  "v\0period": -80,
  "w\0a": -15,
  "w\0aacute": -15,
  "w\0abreve": -15,
  "w\0acircumflex": -15,
  "w\0adieresis": -15,
  "w\0agrave": -15,
  "w\0amacron": -15,
  "w\0aogonek": -15,
  "w\0aring": -15,
  "w\0atilde": -15,
  "w\0comma": -60,
  "w\0e": -10,
  "w\0eacute": -10,
  "w\0ecaron": -10,
  "w\0ecircumflex": -10,
  "w\0edieresis": -10,
  "w\0edotaccent": -10,
  "w\0egrave": -10,
  "w\0emacron": -10,
  "w\0eogonek": -10,
  "w\0o": -10,
  "w\0oacute": -10,
  "w\0ocircumflex": -10,
  "w\0odieresis": -10,
  "w\0ograve": -10,
  "w\0ohungarumlaut": -10,
  "w\0omacron": -10,
  "w\0oslash": -10,
  "w\0otilde": -10,
  "w\0period": -60,
  "x\0e": -30,
  "x\0eacute": -30,
  "x\0ecaron": -30,
  "x\0ecircumflex": -30,
  "x\0edieresis": -30,
  "x\0edotaccent": -30,
  "x\0egrave": -30,
  "x\0emacron": -30,
  "x\0eogonek": -30,
  "y\0a": -20,
  "y\0aacute": -20,
  "y\0abreve": -20,
  "y\0acircumflex": -20,
  "y\0adieresis": -20,
  "y\0agrave": -20,
  "y\0amacron": -20,
  "y\0aogonek": -20,
  "y\0aring": -20,
  "y\0atilde": -20,
  "y\0comma": -100,
  "y\0e": -20,
  "y\0eacute": -20,
  "y\0ecaron": -20,
  "y\0ecircumflex": -20,
  "y\0edieresis": -20,
  "y\0edotaccent": -20,
  "y\0egrave": -20,
  "y\0emacron": -20,
  "y\0eogonek": -20,
  "y\0o": -20,
  "y\0oacute": -20,
  "y\0ocircumflex": -20,
  "y\0odieresis": -20,
  "y\0ograve": -20,
  "y\0ohungarumlaut": -20,
  "y\0omacron": -20,
  "y\0oslash": -20,
  "y\0otilde": -20,
  "y\0period": -100,
  "yacute\0a": -20,
  "yacute\0aacute": -20,
  "yacute\0abreve": -20,
  "yacute\0acircumflex": -20,
  "yacute\0adieresis": -20,
  "yacute\0agrave": -20,
  "yacute\0amacron": -20,
  "yacute\0aogonek": -20,
  "yacute\0aring": -20,
  "yacute\0atilde": -20,
  "yacute\0comma": -100,
  "yacute\0e": -20,
  "yacute\0eacute": -20,
  "yacute\0ecaron": -20,
  "yacute\0ecircumflex": -20,
  "yacute\0edieresis": -20,
  "yacute\0edotaccent": -20,
  "yacute\0egrave": -20,
  "yacute\0emacron": -20,
  "yacute\0eogonek": -20,
  "yacute\0o": -20,
  "yacute\0oacute": -20,
  "yacute\0ocircumflex": -20,
  "yacute\0odieresis": -20,
  "yacute\0ograve": -20,
  "yacute\0ohungarumlaut": -20,
  "yacute\0omacron": -20,
  "yacute\0oslash": -20,
  "yacute\0otilde": -20,
  "yacute\0period": -100,
  "ydieresis\0a": -20,
  "ydieresis\0aacute": -20,
  "ydieresis\0abreve": -20,
  "ydieresis\0acircumflex": -20,
  "ydieresis\0adieresis": -20,
  "ydieresis\0agrave": -20,
  "ydieresis\0amacron": -20,
  "ydieresis\0aogonek": -20,
  "ydieresis\0aring": -20,
  "ydieresis\0atilde": -20,
  "ydieresis\0comma": -100,
  "ydieresis\0e": -20,
  "ydieresis\0eacute": -20,
  "ydieresis\0ecaron": -20,
  "ydieresis\0ecircumflex": -20,
  "ydieresis\0edieresis": -20,
  "ydieresis\0edotaccent": -20,
  "ydieresis\0egrave": -20,
  "ydieresis\0emacron": -20,
  "ydieresis\0eogonek": -20,
  "ydieresis\0o": -20,
  "ydieresis\0oacute": -20,
  "ydieresis\0ocircumflex": -20,
  "ydieresis\0odieresis": -20,
  "ydieresis\0ograve": -20,
  "ydieresis\0ohungarumlaut": -20,
  "ydieresis\0omacron": -20,
  "ydieresis\0oslash": -20,
  "ydieresis\0otilde": -20,
  "ydieresis\0period": -100,
  "z\0e": -15,
  "z\0eacute": -15,
  "z\0ecaron": -15,
  "z\0ecircumflex": -15,
  "z\0edieresis": -15,
  "z\0edotaccent": -15,
  "z\0egrave": -15,
  "z\0emacron": -15,
  "z\0eogonek": -15,
  "z\0o": -15,
  "z\0oacute": -15,
  "z\0ocircumflex": -15,
  "z\0odieresis": -15,
  "z\0ograve": -15,
  "z\0ohungarumlaut": -15,
  "z\0omacron": -15,
  "z\0oslash": -15,
  "z\0otilde": -15,
  "zacute\0e": -15,
  "zacute\0eacute": -15,
  "zacute\0ecaron": -15,
  "zacute\0ecircumflex": -15,
  "zacute\0edieresis": -15,
  "zacute\0edotaccent": -15,
  "zacute\0egrave": -15,
  "zacute\0emacron": -15,
  "zacute\0eogonek": -15,
  "zacute\0o": -15,
  "zacute\0oacute": -15,
  "zacute\0ocircumflex": -15,
  "zacute\0odieresis": -15,
  "zacute\0ograve": -15,
  "zacute\0ohungarumlaut": -15,
  "zacute\0omacron": -15,
  "zacute\0oslash": -15,
  "zacute\0otilde": -15,
  "zcaron\0e": -15,
  "zcaron\0eacute": -15,
  "zcaron\0ecaron": -15,
  "zcaron\0ecircumflex": -15,
  "zcaron\0edieresis": -15,
  "zcaron\0edotaccent": -15,
  "zcaron\0egrave": -15,
  "zcaron\0emacron": -15,
  "zcaron\0eogonek": -15,
  "zcaron\0o": -15,
  "zcaron\0oacute": -15,
  "zcaron\0ocircumflex": -15,
  "zcaron\0odieresis": -15,
  "zcaron\0ograve": -15,
  "zcaron\0ohungarumlaut": -15,
  "zcaron\0omacron": -15,
  "zcaron\0oslash": -15,
  "zcaron\0otilde": -15,
  "zdotaccent\0e": -15,
  "zdotaccent\0eacute": -15,
  "zdotaccent\0ecaron": -15,
  "zdotaccent\0ecircumflex": -15,
  "zdotaccent\0edieresis": -15,
  "zdotaccent\0edotaccent": -15,
  "zdotaccent\0egrave": -15,
  "zdotaccent\0emacron": -15,
  "zdotaccent\0eogonek": -15,
  "zdotaccent\0o": -15,
  "zdotaccent\0oacute": -15,
  "zdotaccent\0ocircumflex": -15,
  "zdotaccent\0odieresis": -15,
  "zdotaccent\0ograve": -15,
  "zdotaccent\0ohungarumlaut": -15,
  "zdotaccent\0omacron": -15,
  "zdotaccent\0oslash": -15,
  "zdotaccent\0otilde": -15
};
var HelveticaOblique = {
  attributes: attributes$3,
  glyphWidths: glyphWidths$3,
  kernPairs: kernPairs$3
};
var attributes$2 = {
  Comment: ["Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 12:49:17 1997", "UniqueID 43068", "VMusage 43909 54934"],
  FontName: "Times-Roman",
  FullName: "Times Roman",
  FamilyName: "Times",
  Weight: "Roman",
  ItalicAngle: "0",
  IsFixedPitch: "false",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-168 -218 1000 898 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "002.000",
  Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "662",
  XHeight: "450",
  Ascender: "683",
  Descender: "-217",
  StdHW: "28",
  StdVW: "84"
};
var glyphWidths$2 = {
  space: 250,
  exclam: 333,
  quotedbl: 408,
  numbersign: 500,
  dollar: 500,
  percent: 833,
  ampersand: 778,
  quoteright: 333,
  parenleft: 333,
  parenright: 333,
  asterisk: 500,
  plus: 564,
  comma: 250,
  hyphen: 333,
  period: 250,
  slash: 278,
  zero: 500,
  one: 500,
  two: 500,
  three: 500,
  four: 500,
  five: 500,
  six: 500,
  seven: 500,
  eight: 500,
  nine: 500,
  colon: 278,
  semicolon: 278,
  less: 564,
  equal: 564,
  greater: 564,
  question: 444,
  at: 921,
  A: 722,
  B: 667,
  C: 667,
  D: 722,
  E: 611,
  F: 556,
  G: 722,
  H: 722,
  I: 333,
  J: 389,
  K: 722,
  L: 611,
  M: 889,
  N: 722,
  O: 722,
  P: 556,
  Q: 722,
  R: 667,
  S: 556,
  T: 611,
  U: 722,
  V: 722,
  W: 944,
  X: 722,
  Y: 722,
  Z: 611,
  bracketleft: 333,
  backslash: 278,
  bracketright: 333,
  asciicircum: 469,
  underscore: 500,
  quoteleft: 333,
  a: 444,
  b: 500,
  c: 444,
  d: 500,
  e: 444,
  f: 333,
  g: 500,
  h: 500,
  i: 278,
  j: 278,
  k: 500,
  l: 278,
  m: 778,
  n: 500,
  o: 500,
  p: 500,
  q: 500,
  r: 333,
  s: 389,
  t: 278,
  u: 500,
  v: 500,
  w: 722,
  x: 500,
  y: 500,
  z: 444,
  braceleft: 480,
  bar: 200,
  braceright: 480,
  asciitilde: 541,
  exclamdown: 333,
  cent: 500,
  sterling: 500,
  fraction: 167,
  yen: 500,
  florin: 500,
  section: 500,
  currency: 500,
  quotesingle: 180,
  quotedblleft: 444,
  guillemotleft: 500,
  guilsinglleft: 333,
  guilsinglright: 333,
  fi: 556,
  fl: 556,
  endash: 500,
  dagger: 500,
  daggerdbl: 500,
  periodcentered: 250,
  paragraph: 453,
  bullet: 350,
  quotesinglbase: 333,
  quotedblbase: 444,
  quotedblright: 444,
  guillemotright: 500,
  ellipsis: 1000,
  perthousand: 1000,
  questiondown: 444,
  grave: 333,
  acute: 333,
  circumflex: 333,
  tilde: 333,
  macron: 333,
  breve: 333,
  dotaccent: 333,
  dieresis: 333,
  ring: 333,
  cedilla: 333,
  hungarumlaut: 333,
  ogonek: 333,
  caron: 333,
  emdash: 1000,
  AE: 889,
  ordfeminine: 276,
  Lslash: 611,
  Oslash: 722,
  OE: 889,
  ordmasculine: 310,
  ae: 667,
  dotlessi: 278,
  lslash: 278,
  oslash: 500,
  oe: 722,
  germandbls: 500,
  Idieresis: 333,
  eacute: 444,
  abreve: 444,
  uhungarumlaut: 500,
  ecaron: 444,
  Ydieresis: 722,
  divide: 564,
  Yacute: 722,
  Acircumflex: 722,
  aacute: 444,
  Ucircumflex: 722,
  yacute: 500,
  scommaaccent: 389,
  ecircumflex: 444,
  Uring: 722,
  Udieresis: 722,
  aogonek: 444,
  Uacute: 722,
  uogonek: 500,
  Edieresis: 611,
  Dcroat: 722,
  commaaccent: 250,
  copyright: 760,
  Emacron: 611,
  ccaron: 444,
  aring: 444,
  Ncommaaccent: 722,
  lacute: 278,
  agrave: 444,
  Tcommaaccent: 611,
  Cacute: 667,
  atilde: 444,
  Edotaccent: 611,
  scaron: 389,
  scedilla: 389,
  iacute: 278,
  lozenge: 471,
  Rcaron: 667,
  Gcommaaccent: 722,
  ucircumflex: 500,
  acircumflex: 444,
  Amacron: 722,
  rcaron: 333,
  ccedilla: 444,
  Zdotaccent: 611,
  Thorn: 556,
  Omacron: 722,
  Racute: 667,
  Sacute: 556,
  dcaron: 588,
  Umacron: 722,
  uring: 500,
  threesuperior: 300,
  Ograve: 722,
  Agrave: 722,
  Abreve: 722,
  multiply: 564,
  uacute: 500,
  Tcaron: 611,
  partialdiff: 476,
  ydieresis: 500,
  Nacute: 722,
  icircumflex: 278,
  Ecircumflex: 611,
  adieresis: 444,
  edieresis: 444,
  cacute: 444,
  nacute: 500,
  umacron: 500,
  Ncaron: 722,
  Iacute: 333,
  plusminus: 564,
  brokenbar: 200,
  registered: 760,
  Gbreve: 722,
  Idotaccent: 333,
  summation: 600,
  Egrave: 611,
  racute: 333,
  omacron: 500,
  Zacute: 611,
  Zcaron: 611,
  greaterequal: 549,
  Eth: 722,
  Ccedilla: 667,
  lcommaaccent: 278,
  tcaron: 326,
  eogonek: 444,
  Uogonek: 722,
  Aacute: 722,
  Adieresis: 722,
  egrave: 444,
  zacute: 444,
  iogonek: 278,
  Oacute: 722,
  oacute: 500,
  amacron: 444,
  sacute: 389,
  idieresis: 278,
  Ocircumflex: 722,
  Ugrave: 722,
  Delta: 612,
  thorn: 500,
  twosuperior: 300,
  Odieresis: 722,
  mu: 500,
  igrave: 278,
  ohungarumlaut: 500,
  Eogonek: 611,
  dcroat: 500,
  threequarters: 750,
  Scedilla: 556,
  lcaron: 344,
  Kcommaaccent: 722,
  Lacute: 611,
  trademark: 980,
  edotaccent: 444,
  Igrave: 333,
  Imacron: 333,
  Lcaron: 611,
  onehalf: 750,
  lessequal: 549,
  ocircumflex: 500,
  ntilde: 500,
  Uhungarumlaut: 722,
  Eacute: 611,
  emacron: 444,
  gbreve: 500,
  onequarter: 750,
  Scaron: 556,
  Scommaaccent: 556,
  Ohungarumlaut: 722,
  degree: 400,
  ograve: 500,
  Ccaron: 667,
  ugrave: 500,
  radical: 453,
  Dcaron: 722,
  rcommaaccent: 333,
  Ntilde: 722,
  otilde: 500,
  Rcommaaccent: 667,
  Lcommaaccent: 611,
  Atilde: 722,
  Aogonek: 722,
  Aring: 722,
  Otilde: 722,
  zdotaccent: 444,
  Ecaron: 611,
  Iogonek: 333,
  kcommaaccent: 500,
  minus: 564,
  Icircumflex: 333,
  ncaron: 500,
  tcommaaccent: 278,
  logicalnot: 564,
  odieresis: 500,
  udieresis: 500,
  notequal: 549,
  gcommaaccent: 500,
  eth: 500,
  zcaron: 444,
  ncommaaccent: 500,
  onesuperior: 300,
  imacron: 278,
  Euro: 500
};
var kernPairs$2 = {
  "A\0C": -40,
  "A\0Cacute": -40,
  "A\0Ccaron": -40,
  "A\0Ccedilla": -40,
  "A\0G": -40,
  "A\0Gbreve": -40,
  "A\0Gcommaaccent": -40,
  "A\0O": -55,
  "A\0Oacute": -55,
  "A\0Ocircumflex": -55,
  "A\0Odieresis": -55,
  "A\0Ograve": -55,
  "A\0Ohungarumlaut": -55,
  "A\0Omacron": -55,
  "A\0Oslash": -55,
  "A\0Otilde": -55,
  "A\0Q": -55,
  "A\0T": -111,
  "A\0Tcaron": -111,
  "A\0Tcommaaccent": -111,
  "A\0U": -55,
  "A\0Uacute": -55,
  "A\0Ucircumflex": -55,
  "A\0Udieresis": -55,
  "A\0Ugrave": -55,
  "A\0Uhungarumlaut": -55,
  "A\0Umacron": -55,
  "A\0Uogonek": -55,
  "A\0Uring": -55,
  "A\0V": -135,
  "A\0W": -90,
  "A\0Y": -105,
  "A\0Yacute": -105,
  "A\0Ydieresis": -105,
  "A\0quoteright": -111,
  "A\0v": -74,
  "A\0w": -92,
  "A\0y": -92,
  "A\0yacute": -92,
  "A\0ydieresis": -92,
  "Aacute\0C": -40,
  "Aacute\0Cacute": -40,
  "Aacute\0Ccaron": -40,
  "Aacute\0Ccedilla": -40,
  "Aacute\0G": -40,
  "Aacute\0Gbreve": -40,
  "Aacute\0Gcommaaccent": -40,
  "Aacute\0O": -55,
  "Aacute\0Oacute": -55,
  "Aacute\0Ocircumflex": -55,
  "Aacute\0Odieresis": -55,
  "Aacute\0Ograve": -55,
  "Aacute\0Ohungarumlaut": -55,
  "Aacute\0Omacron": -55,
  "Aacute\0Oslash": -55,
  "Aacute\0Otilde": -55,
  "Aacute\0Q": -55,
  "Aacute\0T": -111,
  "Aacute\0Tcaron": -111,
  "Aacute\0Tcommaaccent": -111,
  "Aacute\0U": -55,
  "Aacute\0Uacute": -55,
  "Aacute\0Ucircumflex": -55,
  "Aacute\0Udieresis": -55,
  "Aacute\0Ugrave": -55,
  "Aacute\0Uhungarumlaut": -55,
  "Aacute\0Umacron": -55,
  "Aacute\0Uogonek": -55,
  "Aacute\0Uring": -55,
  "Aacute\0V": -135,
  "Aacute\0W": -90,
  "Aacute\0Y": -105,
  "Aacute\0Yacute": -105,
  "Aacute\0Ydieresis": -105,
  "Aacute\0quoteright": -111,
  "Aacute\0v": -74,
  "Aacute\0w": -92,
  "Aacute\0y": -92,
  "Aacute\0yacute": -92,
  "Aacute\0ydieresis": -92,
  "Abreve\0C": -40,
  "Abreve\0Cacute": -40,
  "Abreve\0Ccaron": -40,
  "Abreve\0Ccedilla": -40,
  "Abreve\0G": -40,
  "Abreve\0Gbreve": -40,
  "Abreve\0Gcommaaccent": -40,
  "Abreve\0O": -55,
  "Abreve\0Oacute": -55,
  "Abreve\0Ocircumflex": -55,
  "Abreve\0Odieresis": -55,
  "Abreve\0Ograve": -55,
  "Abreve\0Ohungarumlaut": -55,
  "Abreve\0Omacron": -55,
  "Abreve\0Oslash": -55,
  "Abreve\0Otilde": -55,
  "Abreve\0Q": -55,
  "Abreve\0T": -111,
  "Abreve\0Tcaron": -111,
  "Abreve\0Tcommaaccent": -111,
  "Abreve\0U": -55,
  "Abreve\0Uacute": -55,
  "Abreve\0Ucircumflex": -55,
  "Abreve\0Udieresis": -55,
  "Abreve\0Ugrave": -55,
  "Abreve\0Uhungarumlaut": -55,
  "Abreve\0Umacron": -55,
  "Abreve\0Uogonek": -55,
  "Abreve\0Uring": -55,
  "Abreve\0V": -135,
  "Abreve\0W": -90,
  "Abreve\0Y": -105,
  "Abreve\0Yacute": -105,
  "Abreve\0Ydieresis": -105,
  "Abreve\0quoteright": -111,
  "Abreve\0v": -74,
  "Abreve\0w": -92,
  "Abreve\0y": -92,
  "Abreve\0yacute": -92,
  "Abreve\0ydieresis": -92,
  "Acircumflex\0C": -40,
  "Acircumflex\0Cacute": -40,
  "Acircumflex\0Ccaron": -40,
  "Acircumflex\0Ccedilla": -40,
  "Acircumflex\0G": -40,
  "Acircumflex\0Gbreve": -40,
  "Acircumflex\0Gcommaaccent": -40,
  "Acircumflex\0O": -55,
  "Acircumflex\0Oacute": -55,
  "Acircumflex\0Ocircumflex": -55,
  "Acircumflex\0Odieresis": -55,
  "Acircumflex\0Ograve": -55,
  "Acircumflex\0Ohungarumlaut": -55,
  "Acircumflex\0Omacron": -55,
  "Acircumflex\0Oslash": -55,
  "Acircumflex\0Otilde": -55,
  "Acircumflex\0Q": -55,
  "Acircumflex\0T": -111,
  "Acircumflex\0Tcaron": -111,
  "Acircumflex\0Tcommaaccent": -111,
  "Acircumflex\0U": -55,
  "Acircumflex\0Uacute": -55,
  "Acircumflex\0Ucircumflex": -55,
  "Acircumflex\0Udieresis": -55,
  "Acircumflex\0Ugrave": -55,
  "Acircumflex\0Uhungarumlaut": -55,
  "Acircumflex\0Umacron": -55,
  "Acircumflex\0Uogonek": -55,
  "Acircumflex\0Uring": -55,
  "Acircumflex\0V": -135,
  "Acircumflex\0W": -90,
  "Acircumflex\0Y": -105,
  "Acircumflex\0Yacute": -105,
  "Acircumflex\0Ydieresis": -105,
  "Acircumflex\0quoteright": -111,
  "Acircumflex\0v": -74,
  "Acircumflex\0w": -92,
  "Acircumflex\0y": -92,
  "Acircumflex\0yacute": -92,
  "Acircumflex\0ydieresis": -92,
  "Adieresis\0C": -40,
  "Adieresis\0Cacute": -40,
  "Adieresis\0Ccaron": -40,
  "Adieresis\0Ccedilla": -40,
  "Adieresis\0G": -40,
  "Adieresis\0Gbreve": -40,
  "Adieresis\0Gcommaaccent": -40,
  "Adieresis\0O": -55,
  "Adieresis\0Oacute": -55,
  "Adieresis\0Ocircumflex": -55,
  "Adieresis\0Odieresis": -55,
  "Adieresis\0Ograve": -55,
  "Adieresis\0Ohungarumlaut": -55,
  "Adieresis\0Omacron": -55,
  "Adieresis\0Oslash": -55,
  "Adieresis\0Otilde": -55,
  "Adieresis\0Q": -55,
  "Adieresis\0T": -111,
  "Adieresis\0Tcaron": -111,
  "Adieresis\0Tcommaaccent": -111,
  "Adieresis\0U": -55,
  "Adieresis\0Uacute": -55,
  "Adieresis\0Ucircumflex": -55,
  "Adieresis\0Udieresis": -55,
  "Adieresis\0Ugrave": -55,
  "Adieresis\0Uhungarumlaut": -55,
  "Adieresis\0Umacron": -55,
  "Adieresis\0Uogonek": -55,
  "Adieresis\0Uring": -55,
  "Adieresis\0V": -135,
  "Adieresis\0W": -90,
  "Adieresis\0Y": -105,
  "Adieresis\0Yacute": -105,
  "Adieresis\0Ydieresis": -105,
  "Adieresis\0quoteright": -111,
  "Adieresis\0v": -74,
  "Adieresis\0w": -92,
  "Adieresis\0y": -92,
  "Adieresis\0yacute": -92,
  "Adieresis\0ydieresis": -92,
  "Agrave\0C": -40,
  "Agrave\0Cacute": -40,
  "Agrave\0Ccaron": -40,
  "Agrave\0Ccedilla": -40,
  "Agrave\0G": -40,
  "Agrave\0Gbreve": -40,
  "Agrave\0Gcommaaccent": -40,
  "Agrave\0O": -55,
  "Agrave\0Oacute": -55,
  "Agrave\0Ocircumflex": -55,
  "Agrave\0Odieresis": -55,
  "Agrave\0Ograve": -55,
  "Agrave\0Ohungarumlaut": -55,
  "Agrave\0Omacron": -55,
  "Agrave\0Oslash": -55,
  "Agrave\0Otilde": -55,
  "Agrave\0Q": -55,
  "Agrave\0T": -111,
  "Agrave\0Tcaron": -111,
  "Agrave\0Tcommaaccent": -111,
  "Agrave\0U": -55,
  "Agrave\0Uacute": -55,
  "Agrave\0Ucircumflex": -55,
  "Agrave\0Udieresis": -55,
  "Agrave\0Ugrave": -55,
  "Agrave\0Uhungarumlaut": -55,
  "Agrave\0Umacron": -55,
  "Agrave\0Uogonek": -55,
  "Agrave\0Uring": -55,
  "Agrave\0V": -135,
  "Agrave\0W": -90,
  "Agrave\0Y": -105,
  "Agrave\0Yacute": -105,
  "Agrave\0Ydieresis": -105,
  "Agrave\0quoteright": -111,
  "Agrave\0v": -74,
  "Agrave\0w": -92,
  "Agrave\0y": -92,
  "Agrave\0yacute": -92,
  "Agrave\0ydieresis": -92,
  "Amacron\0C": -40,
  "Amacron\0Cacute": -40,
  "Amacron\0Ccaron": -40,
  "Amacron\0Ccedilla": -40,
  "Amacron\0G": -40,
  "Amacron\0Gbreve": -40,
  "Amacron\0Gcommaaccent": -40,
  "Amacron\0O": -55,
  "Amacron\0Oacute": -55,
  "Amacron\0Ocircumflex": -55,
  "Amacron\0Odieresis": -55,
  "Amacron\0Ograve": -55,
  "Amacron\0Ohungarumlaut": -55,
  "Amacron\0Omacron": -55,
  "Amacron\0Oslash": -55,
  "Amacron\0Otilde": -55,
  "Amacron\0Q": -55,
  "Amacron\0T": -111,
  "Amacron\0Tcaron": -111,
  "Amacron\0Tcommaaccent": -111,
  "Amacron\0U": -55,
  "Amacron\0Uacute": -55,
  "Amacron\0Ucircumflex": -55,
  "Amacron\0Udieresis": -55,
  "Amacron\0Ugrave": -55,
  "Amacron\0Uhungarumlaut": -55,
  "Amacron\0Umacron": -55,
  "Amacron\0Uogonek": -55,
  "Amacron\0Uring": -55,
  "Amacron\0V": -135,
  "Amacron\0W": -90,
  "Amacron\0Y": -105,
  "Amacron\0Yacute": -105,
  "Amacron\0Ydieresis": -105,
  "Amacron\0quoteright": -111,
  "Amacron\0v": -74,
  "Amacron\0w": -92,
  "Amacron\0y": -92,
  "Amacron\0yacute": -92,
  "Amacron\0ydieresis": -92,
  "Aogonek\0C": -40,
  "Aogonek\0Cacute": -40,
  "Aogonek\0Ccaron": -40,
  "Aogonek\0Ccedilla": -40,
  "Aogonek\0G": -40,
  "Aogonek\0Gbreve": -40,
  "Aogonek\0Gcommaaccent": -40,
  "Aogonek\0O": -55,
  "Aogonek\0Oacute": -55,
  "Aogonek\0Ocircumflex": -55,
  "Aogonek\0Odieresis": -55,
  "Aogonek\0Ograve": -55,
  "Aogonek\0Ohungarumlaut": -55,
  "Aogonek\0Omacron": -55,
  "Aogonek\0Oslash": -55,
  "Aogonek\0Otilde": -55,
  "Aogonek\0Q": -55,
  "Aogonek\0T": -111,
  "Aogonek\0Tcaron": -111,
  "Aogonek\0Tcommaaccent": -111,
  "Aogonek\0U": -55,
  "Aogonek\0Uacute": -55,
  "Aogonek\0Ucircumflex": -55,
  "Aogonek\0Udieresis": -55,
  "Aogonek\0Ugrave": -55,
  "Aogonek\0Uhungarumlaut": -55,
  "Aogonek\0Umacron": -55,
  "Aogonek\0Uogonek": -55,
  "Aogonek\0Uring": -55,
  "Aogonek\0V": -135,
  "Aogonek\0W": -90,
  "Aogonek\0Y": -105,
  "Aogonek\0Yacute": -105,
  "Aogonek\0Ydieresis": -105,
  "Aogonek\0quoteright": -111,
  "Aogonek\0v": -74,
  "Aogonek\0w": -52,
  "Aogonek\0y": -52,
  "Aogonek\0yacute": -52,
  "Aogonek\0ydieresis": -52,
  "Aring\0C": -40,
  "Aring\0Cacute": -40,
  "Aring\0Ccaron": -40,
  "Aring\0Ccedilla": -40,
  "Aring\0G": -40,
  "Aring\0Gbreve": -40,
  "Aring\0Gcommaaccent": -40,
  "Aring\0O": -55,
  "Aring\0Oacute": -55,
  "Aring\0Ocircumflex": -55,
  "Aring\0Odieresis": -55,
  "Aring\0Ograve": -55,
  "Aring\0Ohungarumlaut": -55,
  "Aring\0Omacron": -55,
  "Aring\0Oslash": -55,
  "Aring\0Otilde": -55,
  "Aring\0Q": -55,
  "Aring\0T": -111,
  "Aring\0Tcaron": -111,
  "Aring\0Tcommaaccent": -111,
  "Aring\0U": -55,
  "Aring\0Uacute": -55,
  "Aring\0Ucircumflex": -55,
  "Aring\0Udieresis": -55,
  "Aring\0Ugrave": -55,
  "Aring\0Uhungarumlaut": -55,
  "Aring\0Umacron": -55,
  "Aring\0Uogonek": -55,
  "Aring\0Uring": -55,
  "Aring\0V": -135,
  "Aring\0W": -90,
  "Aring\0Y": -105,
  "Aring\0Yacute": -105,
  "Aring\0Ydieresis": -105,
  "Aring\0quoteright": -111,
  "Aring\0v": -74,
  "Aring\0w": -92,
  "Aring\0y": -92,
  "Aring\0yacute": -92,
  "Aring\0ydieresis": -92,
  "Atilde\0C": -40,
  "Atilde\0Cacute": -40,
  "Atilde\0Ccaron": -40,
  "Atilde\0Ccedilla": -40,
  "Atilde\0G": -40,
  "Atilde\0Gbreve": -40,
  "Atilde\0Gcommaaccent": -40,
  "Atilde\0O": -55,
  "Atilde\0Oacute": -55,
  "Atilde\0Ocircumflex": -55,
  "Atilde\0Odieresis": -55,
  "Atilde\0Ograve": -55,
  "Atilde\0Ohungarumlaut": -55,
  "Atilde\0Omacron": -55,
  "Atilde\0Oslash": -55,
  "Atilde\0Otilde": -55,
  "Atilde\0Q": -55,
  "Atilde\0T": -111,
  "Atilde\0Tcaron": -111,
  "Atilde\0Tcommaaccent": -111,
  "Atilde\0U": -55,
  "Atilde\0Uacute": -55,
  "Atilde\0Ucircumflex": -55,
  "Atilde\0Udieresis": -55,
  "Atilde\0Ugrave": -55,
  "Atilde\0Uhungarumlaut": -55,
  "Atilde\0Umacron": -55,
  "Atilde\0Uogonek": -55,
  "Atilde\0Uring": -55,
  "Atilde\0V": -135,
  "Atilde\0W": -90,
  "Atilde\0Y": -105,
  "Atilde\0Yacute": -105,
  "Atilde\0Ydieresis": -105,
  "Atilde\0quoteright": -111,
  "Atilde\0v": -74,
  "Atilde\0w": -92,
  "Atilde\0y": -92,
  "Atilde\0yacute": -92,
  "Atilde\0ydieresis": -92,
  "B\0A": -35,
  "B\0Aacute": -35,
  "B\0Abreve": -35,
  "B\0Acircumflex": -35,
  "B\0Adieresis": -35,
  "B\0Agrave": -35,
  "B\0Amacron": -35,
  "B\0Aogonek": -35,
  "B\0Aring": -35,
  "B\0Atilde": -35,
  "B\0U": -10,
  "B\0Uacute": -10,
  "B\0Ucircumflex": -10,
  "B\0Udieresis": -10,
  "B\0Ugrave": -10,
  "B\0Uhungarumlaut": -10,
  "B\0Umacron": -10,
  "B\0Uogonek": -10,
  "B\0Uring": -10,
  "D\0A": -40,
  "D\0Aacute": -40,
  "D\0Abreve": -40,
  "D\0Acircumflex": -40,
  "D\0Adieresis": -40,
  "D\0Agrave": -40,
  "D\0Amacron": -40,
  "D\0Aogonek": -40,
  "D\0Aring": -40,
  "D\0Atilde": -40,
  "D\0V": -40,
  "D\0W": -30,
  "D\0Y": -55,
  "D\0Yacute": -55,
  "D\0Ydieresis": -55,
  "Dcaron\0A": -40,
  "Dcaron\0Aacute": -40,
  "Dcaron\0Abreve": -40,
  "Dcaron\0Acircumflex": -40,
  "Dcaron\0Adieresis": -40,
  "Dcaron\0Agrave": -40,
  "Dcaron\0Amacron": -40,
  "Dcaron\0Aogonek": -40,
  "Dcaron\0Aring": -40,
  "Dcaron\0Atilde": -40,
  "Dcaron\0V": -40,
  "Dcaron\0W": -30,
  "Dcaron\0Y": -55,
  "Dcaron\0Yacute": -55,
  "Dcaron\0Ydieresis": -55,
  "Dcroat\0A": -40,
  "Dcroat\0Aacute": -40,
  "Dcroat\0Abreve": -40,
  "Dcroat\0Acircumflex": -40,
  "Dcroat\0Adieresis": -40,
  "Dcroat\0Agrave": -40,
  "Dcroat\0Amacron": -40,
  "Dcroat\0Aogonek": -40,
  "Dcroat\0Aring": -40,
  "Dcroat\0Atilde": -40,
  "Dcroat\0V": -40,
  "Dcroat\0W": -30,
  "Dcroat\0Y": -55,
  "Dcroat\0Yacute": -55,
  "Dcroat\0Ydieresis": -55,
  "F\0A": -74,
  "F\0Aacute": -74,
  "F\0Abreve": -74,
  "F\0Acircumflex": -74,
  "F\0Adieresis": -74,
  "F\0Agrave": -74,
  "F\0Amacron": -74,
  "F\0Aogonek": -74,
  "F\0Aring": -74,
  "F\0Atilde": -74,
  "F\0a": -15,
  "F\0aacute": -15,
  "F\0abreve": -15,
  "F\0acircumflex": -15,
  "F\0adieresis": -15,
  "F\0agrave": -15,
  "F\0amacron": -15,
  "F\0aogonek": -15,
  "F\0aring": -15,
  "F\0atilde": -15,
  "F\0comma": -80,
  "F\0o": -15,
  "F\0oacute": -15,
  "F\0ocircumflex": -15,
  "F\0odieresis": -15,
  "F\0ograve": -15,
  "F\0ohungarumlaut": -15,
  "F\0omacron": -15,
  "F\0oslash": -15,
  "F\0otilde": -15,
  "F\0period": -80,
  "J\0A": -60,
  "J\0Aacute": -60,
  "J\0Abreve": -60,
  "J\0Acircumflex": -60,
  "J\0Adieresis": -60,
  "J\0Agrave": -60,
  "J\0Amacron": -60,
  "J\0Aogonek": -60,
  "J\0Aring": -60,
  "J\0Atilde": -60,
  "K\0O": -30,
  "K\0Oacute": -30,
  "K\0Ocircumflex": -30,
  "K\0Odieresis": -30,
  "K\0Ograve": -30,
  "K\0Ohungarumlaut": -30,
  "K\0Omacron": -30,
  "K\0Oslash": -30,
  "K\0Otilde": -30,
  "K\0e": -25,
  "K\0eacute": -25,
  "K\0ecaron": -25,
  "K\0ecircumflex": -25,
  "K\0edieresis": -25,
  "K\0edotaccent": -25,
  "K\0egrave": -25,
  "K\0emacron": -25,
  "K\0eogonek": -25,
  "K\0o": -35,
  "K\0oacute": -35,
  "K\0ocircumflex": -35,
  "K\0odieresis": -35,
  "K\0ograve": -35,
  "K\0ohungarumlaut": -35,
  "K\0omacron": -35,
  "K\0oslash": -35,
  "K\0otilde": -35,
  "K\0u": -15,
  "K\0uacute": -15,
  "K\0ucircumflex": -15,
  "K\0udieresis": -15,
  "K\0ugrave": -15,
  "K\0uhungarumlaut": -15,
  "K\0umacron": -15,
  "K\0uogonek": -15,
  "K\0uring": -15,
  "K\0y": -25,
  "K\0yacute": -25,
  "K\0ydieresis": -25,
  "Kcommaaccent\0O": -30,
  "Kcommaaccent\0Oacute": -30,
  "Kcommaaccent\0Ocircumflex": -30,
  "Kcommaaccent\0Odieresis": -30,
  "Kcommaaccent\0Ograve": -30,
  "Kcommaaccent\0Ohungarumlaut": -30,
  "Kcommaaccent\0Omacron": -30,
  "Kcommaaccent\0Oslash": -30,
  "Kcommaaccent\0Otilde": -30,
  "Kcommaaccent\0e": -25,
  "Kcommaaccent\0eacute": -25,
  "Kcommaaccent\0ecaron": -25,
  "Kcommaaccent\0ecircumflex": -25,
  "Kcommaaccent\0edieresis": -25,
  "Kcommaaccent\0edotaccent": -25,
  "Kcommaaccent\0egrave": -25,
  "Kcommaaccent\0emacron": -25,
  "Kcommaaccent\0eogonek": -25,
  "Kcommaaccent\0o": -35,
  "Kcommaaccent\0oacute": -35,
  "Kcommaaccent\0ocircumflex": -35,
  "Kcommaaccent\0odieresis": -35,
  "Kcommaaccent\0ograve": -35,
  "Kcommaaccent\0ohungarumlaut": -35,
  "Kcommaaccent\0omacron": -35,
  "Kcommaaccent\0oslash": -35,
  "Kcommaaccent\0otilde": -35,
  "Kcommaaccent\0u": -15,
  "Kcommaaccent\0uacute": -15,
  "Kcommaaccent\0ucircumflex": -15,
  "Kcommaaccent\0udieresis": -15,
  "Kcommaaccent\0ugrave": -15,
  "Kcommaaccent\0uhungarumlaut": -15,
  "Kcommaaccent\0umacron": -15,
  "Kcommaaccent\0uogonek": -15,
  "Kcommaaccent\0uring": -15,
  "Kcommaaccent\0y": -25,
  "Kcommaaccent\0yacute": -25,
  "Kcommaaccent\0ydieresis": -25,
  "L\0T": -92,
  "L\0Tcaron": -92,
  "L\0Tcommaaccent": -92,
  "L\0V": -100,
  "L\0W": -74,
  "L\0Y": -100,
  "L\0Yacute": -100,
  "L\0Ydieresis": -100,
  "L\0quoteright": -92,
  "L\0y": -55,
  "L\0yacute": -55,
  "L\0ydieresis": -55,
  "Lacute\0T": -92,
  "Lacute\0Tcaron": -92,
  "Lacute\0Tcommaaccent": -92,
  "Lacute\0V": -100,
  "Lacute\0W": -74,
  "Lacute\0Y": -100,
  "Lacute\0Yacute": -100,
  "Lacute\0Ydieresis": -100,
  "Lacute\0quoteright": -92,
  "Lacute\0y": -55,
  "Lacute\0yacute": -55,
  "Lacute\0ydieresis": -55,
  "Lcaron\0quoteright": -92,
  "Lcaron\0y": -55,
  "Lcaron\0yacute": -55,
  "Lcaron\0ydieresis": -55,
  "Lcommaaccent\0T": -92,
  "Lcommaaccent\0Tcaron": -92,
  "Lcommaaccent\0Tcommaaccent": -92,
  "Lcommaaccent\0V": -100,
  "Lcommaaccent\0W": -74,
  "Lcommaaccent\0Y": -100,
  "Lcommaaccent\0Yacute": -100,
  "Lcommaaccent\0Ydieresis": -100,
  "Lcommaaccent\0quoteright": -92,
  "Lcommaaccent\0y": -55,
  "Lcommaaccent\0yacute": -55,
  "Lcommaaccent\0ydieresis": -55,
  "Lslash\0T": -92,
  "Lslash\0Tcaron": -92,
  "Lslash\0Tcommaaccent": -92,
  "Lslash\0V": -100,
  "Lslash\0W": -74,
  "Lslash\0Y": -100,
  "Lslash\0Yacute": -100,
  "Lslash\0Ydieresis": -100,
  "Lslash\0quoteright": -92,
  "Lslash\0y": -55,
  "Lslash\0yacute": -55,
  "Lslash\0ydieresis": -55,
  "N\0A": -35,
  "N\0Aacute": -35,
  "N\0Abreve": -35,
  "N\0Acircumflex": -35,
  "N\0Adieresis": -35,
  "N\0Agrave": -35,
  "N\0Amacron": -35,
  "N\0Aogonek": -35,
  "N\0Aring": -35,
  "N\0Atilde": -35,
  "Nacute\0A": -35,
  "Nacute\0Aacute": -35,
  "Nacute\0Abreve": -35,
  "Nacute\0Acircumflex": -35,
  "Nacute\0Adieresis": -35,
  "Nacute\0Agrave": -35,
  "Nacute\0Amacron": -35,
  "Nacute\0Aogonek": -35,
  "Nacute\0Aring": -35,
  "Nacute\0Atilde": -35,
  "Ncaron\0A": -35,
  "Ncaron\0Aacute": -35,
  "Ncaron\0Abreve": -35,
  "Ncaron\0Acircumflex": -35,
  "Ncaron\0Adieresis": -35,
  "Ncaron\0Agrave": -35,
  "Ncaron\0Amacron": -35,
  "Ncaron\0Aogonek": -35,
  "Ncaron\0Aring": -35,
  "Ncaron\0Atilde": -35,
  "Ncommaaccent\0A": -35,
  "Ncommaaccent\0Aacute": -35,
  "Ncommaaccent\0Abreve": -35,
  "Ncommaaccent\0Acircumflex": -35,
  "Ncommaaccent\0Adieresis": -35,
  "Ncommaaccent\0Agrave": -35,
  "Ncommaaccent\0Amacron": -35,
  "Ncommaaccent\0Aogonek": -35,
  "Ncommaaccent\0Aring": -35,
  "Ncommaaccent\0Atilde": -35,
  "Ntilde\0A": -35,
  "Ntilde\0Aacute": -35,
  "Ntilde\0Abreve": -35,
  "Ntilde\0Acircumflex": -35,
  "Ntilde\0Adieresis": -35,
  "Ntilde\0Agrave": -35,
  "Ntilde\0Amacron": -35,
  "Ntilde\0Aogonek": -35,
  "Ntilde\0Aring": -35,
  "Ntilde\0Atilde": -35,
  "O\0A": -35,
  "O\0Aacute": -35,
  "O\0Abreve": -35,
  "O\0Acircumflex": -35,
  "O\0Adieresis": -35,
  "O\0Agrave": -35,
  "O\0Amacron": -35,
  "O\0Aogonek": -35,
  "O\0Aring": -35,
  "O\0Atilde": -35,
  "O\0T": -40,
  "O\0Tcaron": -40,
  "O\0Tcommaaccent": -40,
  "O\0V": -50,
  "O\0W": -35,
  "O\0X": -40,
  "O\0Y": -50,
  "O\0Yacute": -50,
  "O\0Ydieresis": -50,
  "Oacute\0A": -35,
  "Oacute\0Aacute": -35,
  "Oacute\0Abreve": -35,
  "Oacute\0Acircumflex": -35,
  "Oacute\0Adieresis": -35,
  "Oacute\0Agrave": -35,
  "Oacute\0Amacron": -35,
  "Oacute\0Aogonek": -35,
  "Oacute\0Aring": -35,
  "Oacute\0Atilde": -35,
  "Oacute\0T": -40,
  "Oacute\0Tcaron": -40,
  "Oacute\0Tcommaaccent": -40,
  "Oacute\0V": -50,
  "Oacute\0W": -35,
  "Oacute\0X": -40,
  "Oacute\0Y": -50,
  "Oacute\0Yacute": -50,
  "Oacute\0Ydieresis": -50,
  "Ocircumflex\0A": -35,
  "Ocircumflex\0Aacute": -35,
  "Ocircumflex\0Abreve": -35,
  "Ocircumflex\0Acircumflex": -35,
  "Ocircumflex\0Adieresis": -35,
  "Ocircumflex\0Agrave": -35,
  "Ocircumflex\0Amacron": -35,
  "Ocircumflex\0Aogonek": -35,
  "Ocircumflex\0Aring": -35,
  "Ocircumflex\0Atilde": -35,
  "Ocircumflex\0T": -40,
  "Ocircumflex\0Tcaron": -40,
  "Ocircumflex\0Tcommaaccent": -40,
  "Ocircumflex\0V": -50,
  "Ocircumflex\0W": -35,
  "Ocircumflex\0X": -40,
  "Ocircumflex\0Y": -50,
  "Ocircumflex\0Yacute": -50,
  "Ocircumflex\0Ydieresis": -50,
  "Odieresis\0A": -35,
  "Odieresis\0Aacute": -35,
  "Odieresis\0Abreve": -35,
  "Odieresis\0Acircumflex": -35,
  "Odieresis\0Adieresis": -35,
  "Odieresis\0Agrave": -35,
  "Odieresis\0Amacron": -35,
  "Odieresis\0Aogonek": -35,
  "Odieresis\0Aring": -35,
  "Odieresis\0Atilde": -35,
  "Odieresis\0T": -40,
  "Odieresis\0Tcaron": -40,
  "Odieresis\0Tcommaaccent": -40,
  "Odieresis\0V": -50,
  "Odieresis\0W": -35,
  "Odieresis\0X": -40,
  "Odieresis\0Y": -50,
  "Odieresis\0Yacute": -50,
  "Odieresis\0Ydieresis": -50,
  "Ograve\0A": -35,
  "Ograve\0Aacute": -35,
  "Ograve\0Abreve": -35,
  "Ograve\0Acircumflex": -35,
  "Ograve\0Adieresis": -35,
  "Ograve\0Agrave": -35,
  "Ograve\0Amacron": -35,
  "Ograve\0Aogonek": -35,
  "Ograve\0Aring": -35,
  "Ograve\0Atilde": -35,
  "Ograve\0T": -40,
  "Ograve\0Tcaron": -40,
  "Ograve\0Tcommaaccent": -40,
  "Ograve\0V": -50,
  "Ograve\0W": -35,
  "Ograve\0X": -40,
  "Ograve\0Y": -50,
  "Ograve\0Yacute": -50,
  "Ograve\0Ydieresis": -50,
  "Ohungarumlaut\0A": -35,
  "Ohungarumlaut\0Aacute": -35,
  "Ohungarumlaut\0Abreve": -35,
  "Ohungarumlaut\0Acircumflex": -35,
  "Ohungarumlaut\0Adieresis": -35,
  "Ohungarumlaut\0Agrave": -35,
  "Ohungarumlaut\0Amacron": -35,
  "Ohungarumlaut\0Aogonek": -35,
  "Ohungarumlaut\0Aring": -35,
  "Ohungarumlaut\0Atilde": -35,
  "Ohungarumlaut\0T": -40,
  "Ohungarumlaut\0Tcaron": -40,
  "Ohungarumlaut\0Tcommaaccent": -40,
  "Ohungarumlaut\0V": -50,
  "Ohungarumlaut\0W": -35,
  "Ohungarumlaut\0X": -40,
  "Ohungarumlaut\0Y": -50,
  "Ohungarumlaut\0Yacute": -50,
  "Ohungarumlaut\0Ydieresis": -50,
  "Omacron\0A": -35,
  "Omacron\0Aacute": -35,
  "Omacron\0Abreve": -35,
  "Omacron\0Acircumflex": -35,
  "Omacron\0Adieresis": -35,
  "Omacron\0Agrave": -35,
  "Omacron\0Amacron": -35,
  "Omacron\0Aogonek": -35,
  "Omacron\0Aring": -35,
  "Omacron\0Atilde": -35,
  "Omacron\0T": -40,
  "Omacron\0Tcaron": -40,
  "Omacron\0Tcommaaccent": -40,
  "Omacron\0V": -50,
  "Omacron\0W": -35,
  "Omacron\0X": -40,
  "Omacron\0Y": -50,
  "Omacron\0Yacute": -50,
  "Omacron\0Ydieresis": -50,
  "Oslash\0A": -35,
  "Oslash\0Aacute": -35,
  "Oslash\0Abreve": -35,
  "Oslash\0Acircumflex": -35,
  "Oslash\0Adieresis": -35,
  "Oslash\0Agrave": -35,
  "Oslash\0Amacron": -35,
  "Oslash\0Aogonek": -35,
  "Oslash\0Aring": -35,
  "Oslash\0Atilde": -35,
  "Oslash\0T": -40,
  "Oslash\0Tcaron": -40,
  "Oslash\0Tcommaaccent": -40,
  "Oslash\0V": -50,
  "Oslash\0W": -35,
  "Oslash\0X": -40,
  "Oslash\0Y": -50,
  "Oslash\0Yacute": -50,
  "Oslash\0Ydieresis": -50,
  "Otilde\0A": -35,
  "Otilde\0Aacute": -35,
  "Otilde\0Abreve": -35,
  "Otilde\0Acircumflex": -35,
  "Otilde\0Adieresis": -35,
  "Otilde\0Agrave": -35,
  "Otilde\0Amacron": -35,
  "Otilde\0Aogonek": -35,
  "Otilde\0Aring": -35,
  "Otilde\0Atilde": -35,
  "Otilde\0T": -40,
  "Otilde\0Tcaron": -40,
  "Otilde\0Tcommaaccent": -40,
  "Otilde\0V": -50,
  "Otilde\0W": -35,
  "Otilde\0X": -40,
  "Otilde\0Y": -50,
  "Otilde\0Yacute": -50,
  "Otilde\0Ydieresis": -50,
  "P\0A": -92,
  "P\0Aacute": -92,
  "P\0Abreve": -92,
  "P\0Acircumflex": -92,
  "P\0Adieresis": -92,
  "P\0Agrave": -92,
  "P\0Amacron": -92,
  "P\0Aogonek": -92,
  "P\0Aring": -92,
  "P\0Atilde": -92,
  "P\0a": -15,
  "P\0aacute": -15,
  "P\0abreve": -15,
  "P\0acircumflex": -15,
  "P\0adieresis": -15,
  "P\0agrave": -15,
  "P\0amacron": -15,
  "P\0aogonek": -15,
  "P\0aring": -15,
  "P\0atilde": -15,
  "P\0comma": -111,
  "P\0period": -111,
  "Q\0U": -10,
  "Q\0Uacute": -10,
  "Q\0Ucircumflex": -10,
  "Q\0Udieresis": -10,
  "Q\0Ugrave": -10,
  "Q\0Uhungarumlaut": -10,
  "Q\0Umacron": -10,
  "Q\0Uogonek": -10,
  "Q\0Uring": -10,
  "R\0O": -40,
  "R\0Oacute": -40,
  "R\0Ocircumflex": -40,
  "R\0Odieresis": -40,
  "R\0Ograve": -40,
  "R\0Ohungarumlaut": -40,
  "R\0Omacron": -40,
  "R\0Oslash": -40,
  "R\0Otilde": -40,
  "R\0T": -60,
  "R\0Tcaron": -60,
  "R\0Tcommaaccent": -60,
  "R\0U": -40,
  "R\0Uacute": -40,
  "R\0Ucircumflex": -40,
  "R\0Udieresis": -40,
  "R\0Ugrave": -40,
  "R\0Uhungarumlaut": -40,
  "R\0Umacron": -40,
  "R\0Uogonek": -40,
  "R\0Uring": -40,
  "R\0V": -80,
  "R\0W": -55,
  "R\0Y": -65,
  "R\0Yacute": -65,
  "R\0Ydieresis": -65,
  "Racute\0O": -40,
  "Racute\0Oacute": -40,
  "Racute\0Ocircumflex": -40,
  "Racute\0Odieresis": -40,
  "Racute\0Ograve": -40,
  "Racute\0Ohungarumlaut": -40,
  "Racute\0Omacron": -40,
  "Racute\0Oslash": -40,
  "Racute\0Otilde": -40,
  "Racute\0T": -60,
  "Racute\0Tcaron": -60,
  "Racute\0Tcommaaccent": -60,
  "Racute\0U": -40,
  "Racute\0Uacute": -40,
  "Racute\0Ucircumflex": -40,
  "Racute\0Udieresis": -40,
  "Racute\0Ugrave": -40,
  "Racute\0Uhungarumlaut": -40,
  "Racute\0Umacron": -40,
  "Racute\0Uogonek": -40,
  "Racute\0Uring": -40,
  "Racute\0V": -80,
  "Racute\0W": -55,
  "Racute\0Y": -65,
  "Racute\0Yacute": -65,
  "Racute\0Ydieresis": -65,
  "Rcaron\0O": -40,
  "Rcaron\0Oacute": -40,
  "Rcaron\0Ocircumflex": -40,
  "Rcaron\0Odieresis": -40,
  "Rcaron\0Ograve": -40,
  "Rcaron\0Ohungarumlaut": -40,
  "Rcaron\0Omacron": -40,
  "Rcaron\0Oslash": -40,
  "Rcaron\0Otilde": -40,
  "Rcaron\0T": -60,
  "Rcaron\0Tcaron": -60,
  "Rcaron\0Tcommaaccent": -60,
  "Rcaron\0U": -40,
  "Rcaron\0Uacute": -40,
  "Rcaron\0Ucircumflex": -40,
  "Rcaron\0Udieresis": -40,
  "Rcaron\0Ugrave": -40,
  "Rcaron\0Uhungarumlaut": -40,
  "Rcaron\0Umacron": -40,
  "Rcaron\0Uogonek": -40,
  "Rcaron\0Uring": -40,
  "Rcaron\0V": -80,
  "Rcaron\0W": -55,
  "Rcaron\0Y": -65,
  "Rcaron\0Yacute": -65,
  "Rcaron\0Ydieresis": -65,
  "Rcommaaccent\0O": -40,
  "Rcommaaccent\0Oacute": -40,
  "Rcommaaccent\0Ocircumflex": -40,
  "Rcommaaccent\0Odieresis": -40,
  "Rcommaaccent\0Ograve": -40,
  "Rcommaaccent\0Ohungarumlaut": -40,
  "Rcommaaccent\0Omacron": -40,
  "Rcommaaccent\0Oslash": -40,
  "Rcommaaccent\0Otilde": -40,
  "Rcommaaccent\0T": -60,
  "Rcommaaccent\0Tcaron": -60,
  "Rcommaaccent\0Tcommaaccent": -60,
  "Rcommaaccent\0U": -40,
  "Rcommaaccent\0Uacute": -40,
  "Rcommaaccent\0Ucircumflex": -40,
  "Rcommaaccent\0Udieresis": -40,
  "Rcommaaccent\0Ugrave": -40,
  "Rcommaaccent\0Uhungarumlaut": -40,
  "Rcommaaccent\0Umacron": -40,
  "Rcommaaccent\0Uogonek": -40,
  "Rcommaaccent\0Uring": -40,
  "Rcommaaccent\0V": -80,
  "Rcommaaccent\0W": -55,
  "Rcommaaccent\0Y": -65,
  "Rcommaaccent\0Yacute": -65,
  "Rcommaaccent\0Ydieresis": -65,
  "T\0A": -93,
  "T\0Aacute": -93,
  "T\0Abreve": -93,
  "T\0Acircumflex": -93,
  "T\0Adieresis": -93,
  "T\0Agrave": -93,
  "T\0Amacron": -93,
  "T\0Aogonek": -93,
  "T\0Aring": -93,
  "T\0Atilde": -93,
  "T\0O": -18,
  "T\0Oacute": -18,
  "T\0Ocircumflex": -18,
  "T\0Odieresis": -18,
  "T\0Ograve": -18,
  "T\0Ohungarumlaut": -18,
  "T\0Omacron": -18,
  "T\0Oslash": -18,
  "T\0Otilde": -18,
  "T\0a": -80,
  "T\0aacute": -80,
  "T\0abreve": -80,
  "T\0acircumflex": -80,
  "T\0adieresis": -40,
  "T\0agrave": -40,
  "T\0amacron": -40,
  "T\0aogonek": -80,
  "T\0aring": -80,
  "T\0atilde": -40,
  "T\0colon": -50,
  "T\0comma": -74,
  "T\0e": -70,
  "T\0eacute": -70,
  "T\0ecaron": -70,
  "T\0ecircumflex": -70,
  "T\0edieresis": -30,
  "T\0edotaccent": -70,
  "T\0egrave": -70,
  "T\0emacron": -30,
  "T\0eogonek": -70,
  "T\0hyphen": -92,
  "T\0i": -35,
  "T\0iacute": -35,
  "T\0iogonek": -35,
  "T\0o": -80,
  "T\0oacute": -80,
  "T\0ocircumflex": -80,
  "T\0odieresis": -80,
  "T\0ograve": -80,
  "T\0ohungarumlaut": -80,
  "T\0omacron": -80,
  "T\0oslash": -80,
  "T\0otilde": -80,
  "T\0period": -74,
  "T\0r": -35,
  "T\0racute": -35,
  "T\0rcaron": -35,
  "T\0rcommaaccent": -35,
  "T\0semicolon": -55,
  "T\0u": -45,
  "T\0uacute": -45,
  "T\0ucircumflex": -45,
  "T\0udieresis": -45,
  "T\0ugrave": -45,
  "T\0uhungarumlaut": -45,
  "T\0umacron": -45,
  "T\0uogonek": -45,
  "T\0uring": -45,
  "T\0w": -80,
  "T\0y": -80,
  "T\0yacute": -80,
  "T\0ydieresis": -80,
  "Tcaron\0A": -93,
  "Tcaron\0Aacute": -93,
  "Tcaron\0Abreve": -93,
  "Tcaron\0Acircumflex": -93,
  "Tcaron\0Adieresis": -93,
  "Tcaron\0Agrave": -93,
  "Tcaron\0Amacron": -93,
  "Tcaron\0Aogonek": -93,
  "Tcaron\0Aring": -93,
  "Tcaron\0Atilde": -93,
  "Tcaron\0O": -18,
  "Tcaron\0Oacute": -18,
  "Tcaron\0Ocircumflex": -18,
  "Tcaron\0Odieresis": -18,
  "Tcaron\0Ograve": -18,
  "Tcaron\0Ohungarumlaut": -18,
  "Tcaron\0Omacron": -18,
  "Tcaron\0Oslash": -18,
  "Tcaron\0Otilde": -18,
  "Tcaron\0a": -80,
  "Tcaron\0aacute": -80,
  "Tcaron\0abreve": -80,
  "Tcaron\0acircumflex": -80,
  "Tcaron\0adieresis": -40,
  "Tcaron\0agrave": -40,
  "Tcaron\0amacron": -40,
  "Tcaron\0aogonek": -80,
  "Tcaron\0aring": -80,
  "Tcaron\0atilde": -40,
  "Tcaron\0colon": -50,
  "Tcaron\0comma": -74,
  "Tcaron\0e": -70,
  "Tcaron\0eacute": -70,
  "Tcaron\0ecaron": -70,
  "Tcaron\0ecircumflex": -30,
  "Tcaron\0edieresis": -30,
  "Tcaron\0edotaccent": -70,
  "Tcaron\0egrave": -70,
  "Tcaron\0emacron": -30,
  "Tcaron\0eogonek": -70,
  "Tcaron\0hyphen": -92,
  "Tcaron\0i": -35,
  "Tcaron\0iacute": -35,
  "Tcaron\0iogonek": -35,
  "Tcaron\0o": -80,
  "Tcaron\0oacute": -80,
  "Tcaron\0ocircumflex": -80,
  "Tcaron\0odieresis": -80,
  "Tcaron\0ograve": -80,
  "Tcaron\0ohungarumlaut": -80,
  "Tcaron\0omacron": -80,
  "Tcaron\0oslash": -80,
  "Tcaron\0otilde": -80,
  "Tcaron\0period": -74,
  "Tcaron\0r": -35,
  "Tcaron\0racute": -35,
  "Tcaron\0rcaron": -35,
  "Tcaron\0rcommaaccent": -35,
  "Tcaron\0semicolon": -55,
  "Tcaron\0u": -45,
  "Tcaron\0uacute": -45,
  "Tcaron\0ucircumflex": -45,
  "Tcaron\0udieresis": -45,
  "Tcaron\0ugrave": -45,
  "Tcaron\0uhungarumlaut": -45,
  "Tcaron\0umacron": -45,
  "Tcaron\0uogonek": -45,
  "Tcaron\0uring": -45,
  "Tcaron\0w": -80,
  "Tcaron\0y": -80,
  "Tcaron\0yacute": -80,
  "Tcaron\0ydieresis": -80,
  "Tcommaaccent\0A": -93,
  "Tcommaaccent\0Aacute": -93,
  "Tcommaaccent\0Abreve": -93,
  "Tcommaaccent\0Acircumflex": -93,
  "Tcommaaccent\0Adieresis": -93,
  "Tcommaaccent\0Agrave": -93,
  "Tcommaaccent\0Amacron": -93,
  "Tcommaaccent\0Aogonek": -93,
  "Tcommaaccent\0Aring": -93,
  "Tcommaaccent\0Atilde": -93,
  "Tcommaaccent\0O": -18,
  "Tcommaaccent\0Oacute": -18,
  "Tcommaaccent\0Ocircumflex": -18,
  "Tcommaaccent\0Odieresis": -18,
  "Tcommaaccent\0Ograve": -18,
  "Tcommaaccent\0Ohungarumlaut": -18,
  "Tcommaaccent\0Omacron": -18,
  "Tcommaaccent\0Oslash": -18,
  "Tcommaaccent\0Otilde": -18,
  "Tcommaaccent\0a": -80,
  "Tcommaaccent\0aacute": -80,
  "Tcommaaccent\0abreve": -80,
  "Tcommaaccent\0acircumflex": -80,
  "Tcommaaccent\0adieresis": -40,
  "Tcommaaccent\0agrave": -40,
  "Tcommaaccent\0amacron": -40,
  "Tcommaaccent\0aogonek": -80,
  "Tcommaaccent\0aring": -80,
  "Tcommaaccent\0atilde": -40,
  "Tcommaaccent\0colon": -50,
  "Tcommaaccent\0comma": -74,
  "Tcommaaccent\0e": -70,
  "Tcommaaccent\0eacute": -70,
  "Tcommaaccent\0ecaron": -70,
  "Tcommaaccent\0ecircumflex": -30,
  "Tcommaaccent\0edieresis": -30,
  "Tcommaaccent\0edotaccent": -70,
  "Tcommaaccent\0egrave": -30,
  "Tcommaaccent\0emacron": -70,
  "Tcommaaccent\0eogonek": -70,
  "Tcommaaccent\0hyphen": -92,
  "Tcommaaccent\0i": -35,
  "Tcommaaccent\0iacute": -35,
  "Tcommaaccent\0iogonek": -35,
  "Tcommaaccent\0o": -80,
  "Tcommaaccent\0oacute": -80,
  "Tcommaaccent\0ocircumflex": -80,
  "Tcommaaccent\0odieresis": -80,
  "Tcommaaccent\0ograve": -80,
  "Tcommaaccent\0ohungarumlaut": -80,
  "Tcommaaccent\0omacron": -80,
  "Tcommaaccent\0oslash": -80,
  "Tcommaaccent\0otilde": -80,
  "Tcommaaccent\0period": -74,
  "Tcommaaccent\0r": -35,
  "Tcommaaccent\0racute": -35,
  "Tcommaaccent\0rcaron": -35,
  "Tcommaaccent\0rcommaaccent": -35,
  "Tcommaaccent\0semicolon": -55,
  "Tcommaaccent\0u": -45,
  "Tcommaaccent\0uacute": -45,
  "Tcommaaccent\0ucircumflex": -45,
  "Tcommaaccent\0udieresis": -45,
  "Tcommaaccent\0ugrave": -45,
  "Tcommaaccent\0uhungarumlaut": -45,
  "Tcommaaccent\0umacron": -45,
  "Tcommaaccent\0uogonek": -45,
  "Tcommaaccent\0uring": -45,
  "Tcommaaccent\0w": -80,
  "Tcommaaccent\0y": -80,
  "Tcommaaccent\0yacute": -80,
  "Tcommaaccent\0ydieresis": -80,
  "U\0A": -40,
  "U\0Aacute": -40,
  "U\0Abreve": -40,
  "U\0Acircumflex": -40,
  "U\0Adieresis": -40,
  "U\0Agrave": -40,
  "U\0Amacron": -40,
  "U\0Aogonek": -40,
  "U\0Aring": -40,
  "U\0Atilde": -40,
  "Uacute\0A": -40,
  "Uacute\0Aacute": -40,
  "Uacute\0Abreve": -40,
  "Uacute\0Acircumflex": -40,
  "Uacute\0Adieresis": -40,
  "Uacute\0Agrave": -40,
  "Uacute\0Amacron": -40,
  "Uacute\0Aogonek": -40,
  "Uacute\0Aring": -40,
  "Uacute\0Atilde": -40,
  "Ucircumflex\0A": -40,
  "Ucircumflex\0Aacute": -40,
  "Ucircumflex\0Abreve": -40,
  "Ucircumflex\0Acircumflex": -40,
  "Ucircumflex\0Adieresis": -40,
  "Ucircumflex\0Agrave": -40,
  "Ucircumflex\0Amacron": -40,
  "Ucircumflex\0Aogonek": -40,
  "Ucircumflex\0Aring": -40,
  "Ucircumflex\0Atilde": -40,
  "Udieresis\0A": -40,
  "Udieresis\0Aacute": -40,
  "Udieresis\0Abreve": -40,
  "Udieresis\0Acircumflex": -40,
  "Udieresis\0Adieresis": -40,
  "Udieresis\0Agrave": -40,
  "Udieresis\0Amacron": -40,
  "Udieresis\0Aogonek": -40,
  "Udieresis\0Aring": -40,
  "Udieresis\0Atilde": -40,
  "Ugrave\0A": -40,
  "Ugrave\0Aacute": -40,
  "Ugrave\0Abreve": -40,
  "Ugrave\0Acircumflex": -40,
  "Ugrave\0Adieresis": -40,
  "Ugrave\0Agrave": -40,
  "Ugrave\0Amacron": -40,
  "Ugrave\0Aogonek": -40,
  "Ugrave\0Aring": -40,
  "Ugrave\0Atilde": -40,
  "Uhungarumlaut\0A": -40,
  "Uhungarumlaut\0Aacute": -40,
  "Uhungarumlaut\0Abreve": -40,
  "Uhungarumlaut\0Acircumflex": -40,
  "Uhungarumlaut\0Adieresis": -40,
  "Uhungarumlaut\0Agrave": -40,
  "Uhungarumlaut\0Amacron": -40,
  "Uhungarumlaut\0Aogonek": -40,
  "Uhungarumlaut\0Aring": -40,
  "Uhungarumlaut\0Atilde": -40,
  "Umacron\0A": -40,
  "Umacron\0Aacute": -40,
  "Umacron\0Abreve": -40,
  "Umacron\0Acircumflex": -40,
  "Umacron\0Adieresis": -40,
  "Umacron\0Agrave": -40,
  "Umacron\0Amacron": -40,
  "Umacron\0Aogonek": -40,
  "Umacron\0Aring": -40,
  "Umacron\0Atilde": -40,
  "Uogonek\0A": -40,
  "Uogonek\0Aacute": -40,
  "Uogonek\0Abreve": -40,
  "Uogonek\0Acircumflex": -40,
  "Uogonek\0Adieresis": -40,
  "Uogonek\0Agrave": -40,
  "Uogonek\0Amacron": -40,
  "Uogonek\0Aogonek": -40,
  "Uogonek\0Aring": -40,
  "Uogonek\0Atilde": -40,
  "Uring\0A": -40,
  "Uring\0Aacute": -40,
  "Uring\0Abreve": -40,
  "Uring\0Acircumflex": -40,
  "Uring\0Adieresis": -40,
  "Uring\0Agrave": -40,
  "Uring\0Amacron": -40,
  "Uring\0Aogonek": -40,
  "Uring\0Aring": -40,
  "Uring\0Atilde": -40,
  "V\0A": -135,
  "V\0Aacute": -135,
  "V\0Abreve": -135,
  "V\0Acircumflex": -135,
  "V\0Adieresis": -135,
  "V\0Agrave": -135,
  "V\0Amacron": -135,
  "V\0Aogonek": -135,
  "V\0Aring": -135,
  "V\0Atilde": -135,
  "V\0G": -15,
  "V\0Gbreve": -15,
  "V\0Gcommaaccent": -15,
  "V\0O": -40,
  "V\0Oacute": -40,
  "V\0Ocircumflex": -40,
  "V\0Odieresis": -40,
  "V\0Ograve": -40,
  "V\0Ohungarumlaut": -40,
  "V\0Omacron": -40,
  "V\0Oslash": -40,
  "V\0Otilde": -40,
  "V\0a": -111,
  "V\0aacute": -111,
  "V\0abreve": -111,
  "V\0acircumflex": -71,
  "V\0adieresis": -71,
  "V\0agrave": -71,
  "V\0amacron": -71,
  "V\0aogonek": -111,
  "V\0aring": -111,
  "V\0atilde": -71,
  "V\0colon": -74,
  "V\0comma": -129,
  "V\0e": -111,
  "V\0eacute": -111,
  "V\0ecaron": -71,
  "V\0ecircumflex": -71,
  "V\0edieresis": -71,
  "V\0edotaccent": -111,
  "V\0egrave": -71,
  "V\0emacron": -71,
  "V\0eogonek": -111,
  "V\0hyphen": -100,
  "V\0i": -60,
  "V\0iacute": -60,
  "V\0icircumflex": -20,
  "V\0idieresis": -20,
  "V\0igrave": -20,
  "V\0imacron": -20,
  "V\0iogonek": -60,
  "V\0o": -129,
  "V\0oacute": -129,
  "V\0ocircumflex": -129,
  "V\0odieresis": -89,
  "V\0ograve": -89,
  "V\0ohungarumlaut": -129,
  "V\0omacron": -89,
  "V\0oslash": -129,
  "V\0otilde": -89,
  "V\0period": -129,
  "V\0semicolon": -74,
  "V\0u": -75,
  "V\0uacute": -75,
  "V\0ucircumflex": -75,
  "V\0udieresis": -75,
  "V\0ugrave": -75,
  "V\0uhungarumlaut": -75,
  "V\0umacron": -75,
  "V\0uogonek": -75,
  "V\0uring": -75,
  "W\0A": -120,
  "W\0Aacute": -120,
  "W\0Abreve": -120,
  "W\0Acircumflex": -120,
  "W\0Adieresis": -120,
  "W\0Agrave": -120,
  "W\0Amacron": -120,
  "W\0Aogonek": -120,
  "W\0Aring": -120,
  "W\0Atilde": -120,
  "W\0O": -10,
  "W\0Oacute": -10,
  "W\0Ocircumflex": -10,
  "W\0Odieresis": -10,
  "W\0Ograve": -10,
  "W\0Ohungarumlaut": -10,
  "W\0Omacron": -10,
  "W\0Oslash": -10,
  "W\0Otilde": -10,
  "W\0a": -80,
  "W\0aacute": -80,
  "W\0abreve": -80,
  "W\0acircumflex": -80,
  "W\0adieresis": -80,
  "W\0agrave": -80,
  "W\0amacron": -80,
  "W\0aogonek": -80,
  "W\0aring": -80,
  "W\0atilde": -80,
  "W\0colon": -37,
  "W\0comma": -92,
  "W\0e": -80,
  "W\0eacute": -80,
  "W\0ecaron": -80,
  "W\0ecircumflex": -80,
  "W\0edieresis": -40,
  "W\0edotaccent": -80,
  "W\0egrave": -40,
  "W\0emacron": -40,
  "W\0eogonek": -80,
  "W\0hyphen": -65,
  "W\0i": -40,
  "W\0iacute": -40,
  "W\0iogonek": -40,
  "W\0o": -80,
  "W\0oacute": -80,
  "W\0ocircumflex": -80,
  "W\0odieresis": -80,
  "W\0ograve": -80,
  "W\0ohungarumlaut": -80,
  "W\0omacron": -80,
  "W\0oslash": -80,
  "W\0otilde": -80,
  "W\0period": -92,
  "W\0semicolon": -37,
  "W\0u": -50,
  "W\0uacute": -50,
  "W\0ucircumflex": -50,
  "W\0udieresis": -50,
  "W\0ugrave": -50,
  "W\0uhungarumlaut": -50,
  "W\0umacron": -50,
  "W\0uogonek": -50,
  "W\0uring": -50,
  "W\0y": -73,
  "W\0yacute": -73,
  "W\0ydieresis": -73,
  "Y\0A": -120,
  "Y\0Aacute": -120,
  "Y\0Abreve": -120,
  "Y\0Acircumflex": -120,
  "Y\0Adieresis": -120,
  "Y\0Agrave": -120,
  "Y\0Amacron": -120,
  "Y\0Aogonek": -120,
  "Y\0Aring": -120,
  "Y\0Atilde": -120,
  "Y\0O": -30,
  "Y\0Oacute": -30,
  "Y\0Ocircumflex": -30,
  "Y\0Odieresis": -30,
  "Y\0Ograve": -30,
  "Y\0Ohungarumlaut": -30,
  "Y\0Omacron": -30,
  "Y\0Oslash": -30,
  "Y\0Otilde": -30,
  "Y\0a": -100,
  "Y\0aacute": -100,
  "Y\0abreve": -100,
  "Y\0acircumflex": -100,
  "Y\0adieresis": -60,
  "Y\0agrave": -60,
  "Y\0amacron": -60,
  "Y\0aogonek": -100,
  "Y\0aring": -100,
  "Y\0atilde": -60,
  "Y\0colon": -92,
  "Y\0comma": -129,
  "Y\0e": -100,
  "Y\0eacute": -100,
  "Y\0ecaron": -100,
  "Y\0ecircumflex": -100,
  "Y\0edieresis": -60,
  "Y\0edotaccent": -100,
  "Y\0egrave": -60,
  "Y\0emacron": -60,
  "Y\0eogonek": -100,
  "Y\0hyphen": -111,
  "Y\0i": -55,
  "Y\0iacute": -55,
  "Y\0iogonek": -55,
  "Y\0o": -110,
  "Y\0oacute": -110,
  "Y\0ocircumflex": -110,
  "Y\0odieresis": -70,
  "Y\0ograve": -70,
  "Y\0ohungarumlaut": -110,
  "Y\0omacron": -70,
  "Y\0oslash": -110,
  "Y\0otilde": -70,
  "Y\0period": -129,
  "Y\0semicolon": -92,
  "Y\0u": -111,
  "Y\0uacute": -111,
  "Y\0ucircumflex": -111,
  "Y\0udieresis": -71,
  "Y\0ugrave": -71,
  "Y\0uhungarumlaut": -111,
  "Y\0umacron": -71,
  "Y\0uogonek": -111,
  "Y\0uring": -111,
  "Yacute\0A": -120,
  "Yacute\0Aacute": -120,
  "Yacute\0Abreve": -120,
  "Yacute\0Acircumflex": -120,
  "Yacute\0Adieresis": -120,
  "Yacute\0Agrave": -120,
  "Yacute\0Amacron": -120,
  "Yacute\0Aogonek": -120,
  "Yacute\0Aring": -120,
  "Yacute\0Atilde": -120,
  "Yacute\0O": -30,
  "Yacute\0Oacute": -30,
  "Yacute\0Ocircumflex": -30,
  "Yacute\0Odieresis": -30,
  "Yacute\0Ograve": -30,
  "Yacute\0Ohungarumlaut": -30,
  "Yacute\0Omacron": -30,
  "Yacute\0Oslash": -30,
  "Yacute\0Otilde": -30,
  "Yacute\0a": -100,
  "Yacute\0aacute": -100,
  "Yacute\0abreve": -100,
  "Yacute\0acircumflex": -100,
  "Yacute\0adieresis": -60,
  "Yacute\0agrave": -60,
  "Yacute\0amacron": -60,
  "Yacute\0aogonek": -100,
  "Yacute\0aring": -100,
  "Yacute\0atilde": -60,
  "Yacute\0colon": -92,
  "Yacute\0comma": -129,
  "Yacute\0e": -100,
  "Yacute\0eacute": -100,
  "Yacute\0ecaron": -100,
  "Yacute\0ecircumflex": -100,
  "Yacute\0edieresis": -60,
  "Yacute\0edotaccent": -100,
  "Yacute\0egrave": -60,
  "Yacute\0emacron": -60,
  "Yacute\0eogonek": -100,
  "Yacute\0hyphen": -111,
  "Yacute\0i": -55,
  "Yacute\0iacute": -55,
  "Yacute\0iogonek": -55,
  "Yacute\0o": -110,
  "Yacute\0oacute": -110,
  "Yacute\0ocircumflex": -110,
  "Yacute\0odieresis": -70,
  "Yacute\0ograve": -70,
  "Yacute\0ohungarumlaut": -110,
  "Yacute\0omacron": -70,
  "Yacute\0oslash": -110,
  "Yacute\0otilde": -70,
  "Yacute\0period": -129,
  "Yacute\0semicolon": -92,
  "Yacute\0u": -111,
  "Yacute\0uacute": -111,
  "Yacute\0ucircumflex": -111,
  "Yacute\0udieresis": -71,
  "Yacute\0ugrave": -71,
  "Yacute\0uhungarumlaut": -111,
  "Yacute\0umacron": -71,
  "Yacute\0uogonek": -111,
  "Yacute\0uring": -111,
  "Ydieresis\0A": -120,
  "Ydieresis\0Aacute": -120,
  "Ydieresis\0Abreve": -120,
  "Ydieresis\0Acircumflex": -120,
  "Ydieresis\0Adieresis": -120,
  "Ydieresis\0Agrave": -120,
  "Ydieresis\0Amacron": -120,
  "Ydieresis\0Aogonek": -120,
  "Ydieresis\0Aring": -120,
  "Ydieresis\0Atilde": -120,
  "Ydieresis\0O": -30,
  "Ydieresis\0Oacute": -30,
  "Ydieresis\0Ocircumflex": -30,
  "Ydieresis\0Odieresis": -30,
  "Ydieresis\0Ograve": -30,
  "Ydieresis\0Ohungarumlaut": -30,
  "Ydieresis\0Omacron": -30,
  "Ydieresis\0Oslash": -30,
  "Ydieresis\0Otilde": -30,
  "Ydieresis\0a": -100,
  "Ydieresis\0aacute": -100,
  "Ydieresis\0abreve": -100,
  "Ydieresis\0acircumflex": -100,
  "Ydieresis\0adieresis": -60,
  "Ydieresis\0agrave": -60,
  "Ydieresis\0amacron": -60,
  "Ydieresis\0aogonek": -100,
  "Ydieresis\0aring": -100,
  "Ydieresis\0atilde": -100,
  "Ydieresis\0colon": -92,
  "Ydieresis\0comma": -129,
  "Ydieresis\0e": -100,
  "Ydieresis\0eacute": -100,
  "Ydieresis\0ecaron": -100,
  "Ydieresis\0ecircumflex": -100,
  "Ydieresis\0edieresis": -60,
  "Ydieresis\0edotaccent": -100,
  "Ydieresis\0egrave": -60,
  "Ydieresis\0emacron": -60,
  "Ydieresis\0eogonek": -100,
  "Ydieresis\0hyphen": -111,
  "Ydieresis\0i": -55,
  "Ydieresis\0iacute": -55,
  "Ydieresis\0iogonek": -55,
  "Ydieresis\0o": -110,
  "Ydieresis\0oacute": -110,
  "Ydieresis\0ocircumflex": -110,
  "Ydieresis\0odieresis": -70,
  "Ydieresis\0ograve": -70,
  "Ydieresis\0ohungarumlaut": -110,
  "Ydieresis\0omacron": -70,
  "Ydieresis\0oslash": -110,
  "Ydieresis\0otilde": -70,
  "Ydieresis\0period": -129,
  "Ydieresis\0semicolon": -92,
  "Ydieresis\0u": -111,
  "Ydieresis\0uacute": -111,
  "Ydieresis\0ucircumflex": -111,
  "Ydieresis\0udieresis": -71,
  "Ydieresis\0ugrave": -71,
  "Ydieresis\0uhungarumlaut": -111,
  "Ydieresis\0umacron": -71,
  "Ydieresis\0uogonek": -111,
  "Ydieresis\0uring": -111,
  "a\0v": -20,
  "a\0w": -15,
  "aacute\0v": -20,
  "aacute\0w": -15,
  "abreve\0v": -20,
  "abreve\0w": -15,
  "acircumflex\0v": -20,
  "acircumflex\0w": -15,
  "adieresis\0v": -20,
  "adieresis\0w": -15,
  "agrave\0v": -20,
  "agrave\0w": -15,
  "amacron\0v": -20,
  "amacron\0w": -15,
  "aogonek\0v": -20,
  "aogonek\0w": -15,
  "aring\0v": -20,
  "aring\0w": -15,
  "atilde\0v": -20,
  "atilde\0w": -15,
  "b\0period": -40,
  "b\0u": -20,
  "b\0uacute": -20,
  "b\0ucircumflex": -20,
  "b\0udieresis": -20,
  "b\0ugrave": -20,
  "b\0uhungarumlaut": -20,
  "b\0umacron": -20,
  "b\0uogonek": -20,
  "b\0uring": -20,
  "b\0v": -15,
  "c\0y": -15,
  "c\0yacute": -15,
  "c\0ydieresis": -15,
  "cacute\0y": -15,
  "cacute\0yacute": -15,
  "cacute\0ydieresis": -15,
  "ccaron\0y": -15,
  "ccaron\0yacute": -15,
  "ccaron\0ydieresis": -15,
  "ccedilla\0y": -15,
  "ccedilla\0yacute": -15,
  "ccedilla\0ydieresis": -15,
  "comma\0quotedblright": -70,
  "comma\0quoteright": -70,
  "e\0g": -15,
  "e\0gbreve": -15,
  "e\0gcommaaccent": -15,
  "e\0v": -25,
  "e\0w": -25,
  "e\0x": -15,
  "e\0y": -15,
  "e\0yacute": -15,
  "e\0ydieresis": -15,
  "eacute\0g": -15,
  "eacute\0gbreve": -15,
  "eacute\0gcommaaccent": -15,
  "eacute\0v": -25,
  "eacute\0w": -25,
  "eacute\0x": -15,
  "eacute\0y": -15,
  "eacute\0yacute": -15,
  "eacute\0ydieresis": -15,
  "ecaron\0g": -15,
  "ecaron\0gbreve": -15,
  "ecaron\0gcommaaccent": -15,
  "ecaron\0v": -25,
  "ecaron\0w": -25,
  "ecaron\0x": -15,
  "ecaron\0y": -15,
  "ecaron\0yacute": -15,
  "ecaron\0ydieresis": -15,
  "ecircumflex\0g": -15,
  "ecircumflex\0gbreve": -15,
  "ecircumflex\0gcommaaccent": -15,
  "ecircumflex\0v": -25,
  "ecircumflex\0w": -25,
  "ecircumflex\0x": -15,
  "ecircumflex\0y": -15,
  "ecircumflex\0yacute": -15,
  "ecircumflex\0ydieresis": -15,
  "edieresis\0g": -15,
  "edieresis\0gbreve": -15,
  "edieresis\0gcommaaccent": -15,
  "edieresis\0v": -25,
  "edieresis\0w": -25,
  "edieresis\0x": -15,
  "edieresis\0y": -15,
  "edieresis\0yacute": -15,
  "edieresis\0ydieresis": -15,
  "edotaccent\0g": -15,
  "edotaccent\0gbreve": -15,
  "edotaccent\0gcommaaccent": -15,
  "edotaccent\0v": -25,
  "edotaccent\0w": -25,
  "edotaccent\0x": -15,
  "edotaccent\0y": -15,
  "edotaccent\0yacute": -15,
  "edotaccent\0ydieresis": -15,
  "egrave\0g": -15,
  "egrave\0gbreve": -15,
  "egrave\0gcommaaccent": -15,
  "egrave\0v": -25,
  "egrave\0w": -25,
  "egrave\0x": -15,
  "egrave\0y": -15,
  "egrave\0yacute": -15,
  "egrave\0ydieresis": -15,
  "emacron\0g": -15,
  "emacron\0gbreve": -15,
  "emacron\0gcommaaccent": -15,
  "emacron\0v": -25,
  "emacron\0w": -25,
  "emacron\0x": -15,
  "emacron\0y": -15,
  "emacron\0yacute": -15,
  "emacron\0ydieresis": -15,
  "eogonek\0g": -15,
  "eogonek\0gbreve": -15,
  "eogonek\0gcommaaccent": -15,
  "eogonek\0v": -25,
  "eogonek\0w": -25,
  "eogonek\0x": -15,
  "eogonek\0y": -15,
  "eogonek\0yacute": -15,
  "eogonek\0ydieresis": -15,
  "f\0a": -10,
  "f\0aacute": -10,
  "f\0abreve": -10,
  "f\0acircumflex": -10,
  "f\0adieresis": -10,
  "f\0agrave": -10,
  "f\0amacron": -10,
  "f\0aogonek": -10,
  "f\0aring": -10,
  "f\0atilde": -10,
  "f\0dotlessi": -50,
  "f\0f": -25,
  "f\0i": -20,
  "f\0iacute": -20,
  "f\0quoteright": 55,
  "g\0a": -5,
  "g\0aacute": -5,
  "g\0abreve": -5,
  "g\0acircumflex": -5,
  "g\0adieresis": -5,
  "g\0agrave": -5,
  "g\0amacron": -5,
  "g\0aogonek": -5,
  "g\0aring": -5,
  "g\0atilde": -5,
  "gbreve\0a": -5,
  "gbreve\0aacute": -5,
  "gbreve\0abreve": -5,
  "gbreve\0acircumflex": -5,
  "gbreve\0adieresis": -5,
  "gbreve\0agrave": -5,
  "gbreve\0amacron": -5,
  "gbreve\0aogonek": -5,
  "gbreve\0aring": -5,
  "gbreve\0atilde": -5,
  "gcommaaccent\0a": -5,
  "gcommaaccent\0aacute": -5,
  "gcommaaccent\0abreve": -5,
  "gcommaaccent\0acircumflex": -5,
  "gcommaaccent\0adieresis": -5,
  "gcommaaccent\0agrave": -5,
  "gcommaaccent\0amacron": -5,
  "gcommaaccent\0aogonek": -5,
  "gcommaaccent\0aring": -5,
  "gcommaaccent\0atilde": -5,
  "h\0y": -5,
  "h\0yacute": -5,
  "h\0ydieresis": -5,
  "i\0v": -25,
  "iacute\0v": -25,
  "icircumflex\0v": -25,
  "idieresis\0v": -25,
  "igrave\0v": -25,
  "imacron\0v": -25,
  "iogonek\0v": -25,
  "k\0e": -10,
  "k\0eacute": -10,
  "k\0ecaron": -10,
  "k\0ecircumflex": -10,
  "k\0edieresis": -10,
  "k\0edotaccent": -10,
  "k\0egrave": -10,
  "k\0emacron": -10,
  "k\0eogonek": -10,
  "k\0o": -10,
  "k\0oacute": -10,
  "k\0ocircumflex": -10,
  "k\0odieresis": -10,
  "k\0ograve": -10,
  "k\0ohungarumlaut": -10,
  "k\0omacron": -10,
  "k\0oslash": -10,
  "k\0otilde": -10,
  "k\0y": -15,
  "k\0yacute": -15,
  "k\0ydieresis": -15,
  "kcommaaccent\0e": -10,
  "kcommaaccent\0eacute": -10,
  "kcommaaccent\0ecaron": -10,
  "kcommaaccent\0ecircumflex": -10,
  "kcommaaccent\0edieresis": -10,
  "kcommaaccent\0edotaccent": -10,
  "kcommaaccent\0egrave": -10,
  "kcommaaccent\0emacron": -10,
  "kcommaaccent\0eogonek": -10,
  "kcommaaccent\0o": -10,
  "kcommaaccent\0oacute": -10,
  "kcommaaccent\0ocircumflex": -10,
  "kcommaaccent\0odieresis": -10,
  "kcommaaccent\0ograve": -10,
  "kcommaaccent\0ohungarumlaut": -10,
  "kcommaaccent\0omacron": -10,
  "kcommaaccent\0oslash": -10,
  "kcommaaccent\0otilde": -10,
  "kcommaaccent\0y": -15,
  "kcommaaccent\0yacute": -15,
  "kcommaaccent\0ydieresis": -15,
  "l\0w": -10,
  "lacute\0w": -10,
  "lcommaaccent\0w": -10,
  "lslash\0w": -10,
  "n\0v": -40,
  "n\0y": -15,
  "n\0yacute": -15,
  "n\0ydieresis": -15,
  "nacute\0v": -40,
  "nacute\0y": -15,
  "nacute\0yacute": -15,
  "nacute\0ydieresis": -15,
  "ncaron\0v": -40,
  "ncaron\0y": -15,
  "ncaron\0yacute": -15,
  "ncaron\0ydieresis": -15,
  "ncommaaccent\0v": -40,
  "ncommaaccent\0y": -15,
  "ncommaaccent\0yacute": -15,
  "ncommaaccent\0ydieresis": -15,
  "ntilde\0v": -40,
  "ntilde\0y": -15,
  "ntilde\0yacute": -15,
  "ntilde\0ydieresis": -15,
  "o\0v": -15,
  "o\0w": -25,
  "o\0y": -10,
  "o\0yacute": -10,
  "o\0ydieresis": -10,
  "oacute\0v": -15,
  "oacute\0w": -25,
  "oacute\0y": -10,
  "oacute\0yacute": -10,
  "oacute\0ydieresis": -10,
  "ocircumflex\0v": -15,
  "ocircumflex\0w": -25,
  "ocircumflex\0y": -10,
  "ocircumflex\0yacute": -10,
  "ocircumflex\0ydieresis": -10,
  "odieresis\0v": -15,
  "odieresis\0w": -25,
  "odieresis\0y": -10,
  "odieresis\0yacute": -10,
  "odieresis\0ydieresis": -10,
  "ograve\0v": -15,
  "ograve\0w": -25,
  "ograve\0y": -10,
  "ograve\0yacute": -10,
  "ograve\0ydieresis": -10,
  "ohungarumlaut\0v": -15,
  "ohungarumlaut\0w": -25,
  "ohungarumlaut\0y": -10,
  "ohungarumlaut\0yacute": -10,
  "ohungarumlaut\0ydieresis": -10,
  "omacron\0v": -15,
  "omacron\0w": -25,
  "omacron\0y": -10,
  "omacron\0yacute": -10,
  "omacron\0ydieresis": -10,
  "oslash\0v": -15,
  "oslash\0w": -25,
  "oslash\0y": -10,
  "oslash\0yacute": -10,
  "oslash\0ydieresis": -10,
  "otilde\0v": -15,
  "otilde\0w": -25,
  "otilde\0y": -10,
  "otilde\0yacute": -10,
  "otilde\0ydieresis": -10,
  "p\0y": -10,
  "p\0yacute": -10,
  "p\0ydieresis": -10,
  "period\0quotedblright": -70,
  "period\0quoteright": -70,
  "quotedblleft\0A": -80,
  "quotedblleft\0Aacute": -80,
  "quotedblleft\0Abreve": -80,
  "quotedblleft\0Acircumflex": -80,
  "quotedblleft\0Adieresis": -80,
  "quotedblleft\0Agrave": -80,
  "quotedblleft\0Amacron": -80,
  "quotedblleft\0Aogonek": -80,
  "quotedblleft\0Aring": -80,
  "quotedblleft\0Atilde": -80,
  "quoteleft\0A": -80,
  "quoteleft\0Aacute": -80,
  "quoteleft\0Abreve": -80,
  "quoteleft\0Acircumflex": -80,
  "quoteleft\0Adieresis": -80,
  "quoteleft\0Agrave": -80,
  "quoteleft\0Amacron": -80,
  "quoteleft\0Aogonek": -80,
  "quoteleft\0Aring": -80,
  "quoteleft\0Atilde": -80,
  "quoteleft\0quoteleft": -74,
  "quoteright\0d": -50,
  "quoteright\0dcroat": -50,
  "quoteright\0l": -10,
  "quoteright\0lacute": -10,
  "quoteright\0lcommaaccent": -10,
  "quoteright\0lslash": -10,
  "quoteright\0quoteright": -74,
  "quoteright\0r": -50,
  "quoteright\0racute": -50,
  "quoteright\0rcaron": -50,
  "quoteright\0rcommaaccent": -50,
  "quoteright\0s": -55,
  "quoteright\0sacute": -55,
  "quoteright\0scaron": -55,
  "quoteright\0scedilla": -55,
  "quoteright\0scommaaccent": -55,
  "quoteright\0space": -74,
  "quoteright\0t": -18,
  "quoteright\0tcommaaccent": -18,
  "quoteright\0v": -50,
  "r\0comma": -40,
  "r\0g": -18,
  "r\0gbreve": -18,
  "r\0gcommaaccent": -18,
  "r\0hyphen": -20,
  "r\0period": -55,
  "racute\0comma": -40,
  "racute\0g": -18,
  "racute\0gbreve": -18,
  "racute\0gcommaaccent": -18,
  "racute\0hyphen": -20,
  "racute\0period": -55,
  "rcaron\0comma": -40,
  "rcaron\0g": -18,
  "rcaron\0gbreve": -18,
  "rcaron\0gcommaaccent": -18,
  "rcaron\0hyphen": -20,
  "rcaron\0period": -55,
  "rcommaaccent\0comma": -40,
  "rcommaaccent\0g": -18,
  "rcommaaccent\0gbreve": -18,
  "rcommaaccent\0gcommaaccent": -18,
  "rcommaaccent\0hyphen": -20,
  "rcommaaccent\0period": -55,
  "space\0A": -55,
  "space\0Aacute": -55,
  "space\0Abreve": -55,
  "space\0Acircumflex": -55,
  "space\0Adieresis": -55,
  "space\0Agrave": -55,
  "space\0Amacron": -55,
  "space\0Aogonek": -55,
  "space\0Aring": -55,
  "space\0Atilde": -55,
  "space\0T": -18,
  "space\0Tcaron": -18,
  "space\0Tcommaaccent": -18,
  "space\0V": -50,
  "space\0W": -30,
  "space\0Y": -90,
  "space\0Yacute": -90,
  "space\0Ydieresis": -90,
  "v\0a": -25,
  "v\0aacute": -25,
  "v\0abreve": -25,
  "v\0acircumflex": -25,
  "v\0adieresis": -25,
  "v\0agrave": -25,
  "v\0amacron": -25,
  "v\0aogonek": -25,
  "v\0aring": -25,
  "v\0atilde": -25,
  "v\0comma": -65,
  "v\0e": -15,
  "v\0eacute": -15,
  "v\0ecaron": -15,
  "v\0ecircumflex": -15,
  "v\0edieresis": -15,
  "v\0edotaccent": -15,
  "v\0egrave": -15,
  "v\0emacron": -15,
  "v\0eogonek": -15,
  "v\0o": -20,
  "v\0oacute": -20,
  "v\0ocircumflex": -20,
  "v\0odieresis": -20,
  "v\0ograve": -20,
  "v\0ohungarumlaut": -20,
  "v\0omacron": -20,
  "v\0oslash": -20,
  "v\0otilde": -20,
  "v\0period": -65,
  "w\0a": -10,
  "w\0aacute": -10,
  "w\0abreve": -10,
  "w\0acircumflex": -10,
  "w\0adieresis": -10,
  "w\0agrave": -10,
  "w\0amacron": -10,
  "w\0aogonek": -10,
  "w\0aring": -10,
  "w\0atilde": -10,
  "w\0comma": -65,
  "w\0o": -10,
  "w\0oacute": -10,
  "w\0ocircumflex": -10,
  "w\0odieresis": -10,
  "w\0ograve": -10,
  "w\0ohungarumlaut": -10,
  "w\0omacron": -10,
  "w\0oslash": -10,
  "w\0otilde": -10,
  "w\0period": -65,
  "x\0e": -15,
  "x\0eacute": -15,
  "x\0ecaron": -15,
  "x\0ecircumflex": -15,
  "x\0edieresis": -15,
  "x\0edotaccent": -15,
  "x\0egrave": -15,
  "x\0emacron": -15,
  "x\0eogonek": -15,
  "y\0comma": -65,
  "y\0period": -65,
  "yacute\0comma": -65,
  "yacute\0period": -65,
  "ydieresis\0comma": -65,
  "ydieresis\0period": -65
};
var TimesRoman = {
  attributes: attributes$2,
  glyphWidths: glyphWidths$2,
  kernPairs: kernPairs$2
};
var attributes$1 = {
  Comment: ["Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 12:52:56 1997", "UniqueID 43065", "VMusage 41636 52661"],
  FontName: "Times-Bold",
  FullName: "Times Bold",
  FamilyName: "Times",
  Weight: "Bold",
  ItalicAngle: "0",
  IsFixedPitch: "false",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-168 -218 1000 935 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "002.000",
  Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "676",
  XHeight: "461",
  Ascender: "683",
  Descender: "-217",
  StdHW: "44",
  StdVW: "139"
};
var glyphWidths$1 = {
  space: 250,
  exclam: 333,
  quotedbl: 555,
  numbersign: 500,
  dollar: 500,
  percent: 1000,
  ampersand: 833,
  quoteright: 333,
  parenleft: 333,
  parenright: 333,
  asterisk: 500,
  plus: 570,
  comma: 250,
  hyphen: 333,
  period: 250,
  slash: 278,
  zero: 500,
  one: 500,
  two: 500,
  three: 500,
  four: 500,
  five: 500,
  six: 500,
  seven: 500,
  eight: 500,
  nine: 500,
  colon: 333,
  semicolon: 333,
  less: 570,
  equal: 570,
  greater: 570,
  question: 500,
  at: 930,
  A: 722,
  B: 667,
  C: 722,
  D: 722,
  E: 667,
  F: 611,
  G: 778,
  H: 778,
  I: 389,
  J: 500,
  K: 778,
  L: 667,
  M: 944,
  N: 722,
  O: 778,
  P: 611,
  Q: 778,
  R: 722,
  S: 556,
  T: 667,
  U: 722,
  V: 722,
  W: 1000,
  X: 722,
  Y: 722,
  Z: 667,
  bracketleft: 333,
  backslash: 278,
  bracketright: 333,
  asciicircum: 581,
  underscore: 500,
  quoteleft: 333,
  a: 500,
  b: 556,
  c: 444,
  d: 556,
  e: 444,
  f: 333,
  g: 500,
  h: 556,
  i: 278,
  j: 333,
  k: 556,
  l: 278,
  m: 833,
  n: 556,
  o: 500,
  p: 556,
  q: 556,
  r: 444,
  s: 389,
  t: 333,
  u: 556,
  v: 500,
  w: 722,
  x: 500,
  y: 500,
  z: 444,
  braceleft: 394,
  bar: 220,
  braceright: 394,
  asciitilde: 520,
  exclamdown: 333,
  cent: 500,
  sterling: 500,
  fraction: 167,
  yen: 500,
  florin: 500,
  section: 500,
  currency: 500,
  quotesingle: 278,
  quotedblleft: 500,
  guillemotleft: 500,
  guilsinglleft: 333,
  guilsinglright: 333,
  fi: 556,
  fl: 556,
  endash: 500,
  dagger: 500,
  daggerdbl: 500,
  periodcentered: 250,
  paragraph: 540,
  bullet: 350,
  quotesinglbase: 333,
  quotedblbase: 500,
  quotedblright: 500,
  guillemotright: 500,
  ellipsis: 1000,
  perthousand: 1000,
  questiondown: 500,
  grave: 333,
  acute: 333,
  circumflex: 333,
  tilde: 333,
  macron: 333,
  breve: 333,
  dotaccent: 333,
  dieresis: 333,
  ring: 333,
  cedilla: 333,
  hungarumlaut: 333,
  ogonek: 333,
  caron: 333,
  emdash: 1000,
  AE: 1000,
  ordfeminine: 300,
  Lslash: 667,
  Oslash: 778,
  OE: 1000,
  ordmasculine: 330,
  ae: 722,
  dotlessi: 278,
  lslash: 278,
  oslash: 500,
  oe: 722,
  germandbls: 556,
  Idieresis: 389,
  eacute: 444,
  abreve: 500,
  uhungarumlaut: 556,
  ecaron: 444,
  Ydieresis: 722,
  divide: 570,
  Yacute: 722,
  Acircumflex: 722,
  aacute: 500,
  Ucircumflex: 722,
  yacute: 500,
  scommaaccent: 389,
  ecircumflex: 444,
  Uring: 722,
  Udieresis: 722,
  aogonek: 500,
  Uacute: 722,
  uogonek: 556,
  Edieresis: 667,
  Dcroat: 722,
  commaaccent: 250,
  copyright: 747,
  Emacron: 667,
  ccaron: 444,
  aring: 500,
  Ncommaaccent: 722,
  lacute: 278,
  agrave: 500,
  Tcommaaccent: 667,
  Cacute: 722,
  atilde: 500,
  Edotaccent: 667,
  scaron: 389,
  scedilla: 389,
  iacute: 278,
  lozenge: 494,
  Rcaron: 722,
  Gcommaaccent: 778,
  ucircumflex: 556,
  acircumflex: 500,
  Amacron: 722,
  rcaron: 444,
  ccedilla: 444,
  Zdotaccent: 667,
  Thorn: 611,
  Omacron: 778,
  Racute: 722,
  Sacute: 556,
  dcaron: 672,
  Umacron: 722,
  uring: 556,
  threesuperior: 300,
  Ograve: 778,
  Agrave: 722,
  Abreve: 722,
  multiply: 570,
  uacute: 556,
  Tcaron: 667,
  partialdiff: 494,
  ydieresis: 500,
  Nacute: 722,
  icircumflex: 278,
  Ecircumflex: 667,
  adieresis: 500,
  edieresis: 444,
  cacute: 444,
  nacute: 556,
  umacron: 556,
  Ncaron: 722,
  Iacute: 389,
  plusminus: 570,
  brokenbar: 220,
  registered: 747,
  Gbreve: 778,
  Idotaccent: 389,
  summation: 600,
  Egrave: 667,
  racute: 444,
  omacron: 500,
  Zacute: 667,
  Zcaron: 667,
  greaterequal: 549,
  Eth: 722,
  Ccedilla: 722,
  lcommaaccent: 278,
  tcaron: 416,
  eogonek: 444,
  Uogonek: 722,
  Aacute: 722,
  Adieresis: 722,
  egrave: 444,
  zacute: 444,
  iogonek: 278,
  Oacute: 778,
  oacute: 500,
  amacron: 500,
  sacute: 389,
  idieresis: 278,
  Ocircumflex: 778,
  Ugrave: 722,
  Delta: 612,
  thorn: 556,
  twosuperior: 300,
  Odieresis: 778,
  mu: 556,
  igrave: 278,
  ohungarumlaut: 500,
  Eogonek: 667,
  dcroat: 556,
  threequarters: 750,
  Scedilla: 556,
  lcaron: 394,
  Kcommaaccent: 778,
  Lacute: 667,
  trademark: 1000,
  edotaccent: 444,
  Igrave: 389,
  Imacron: 389,
  Lcaron: 667,
  onehalf: 750,
  lessequal: 549,
  ocircumflex: 500,
  ntilde: 556,
  Uhungarumlaut: 722,
  Eacute: 667,
  emacron: 444,
  gbreve: 500,
  onequarter: 750,
  Scaron: 556,
  Scommaaccent: 556,
  Ohungarumlaut: 778,
  degree: 400,
  ograve: 500,
  Ccaron: 722,
  ugrave: 556,
  radical: 549,
  Dcaron: 722,
  rcommaaccent: 444,
  Ntilde: 722,
  otilde: 500,
  Rcommaaccent: 722,
  Lcommaaccent: 667,
  Atilde: 722,
  Aogonek: 722,
  Aring: 722,
  Otilde: 778,
  zdotaccent: 444,
  Ecaron: 667,
  Iogonek: 389,
  kcommaaccent: 556,
  minus: 570,
  Icircumflex: 389,
  ncaron: 556,
  tcommaaccent: 333,
  logicalnot: 570,
  odieresis: 500,
  udieresis: 556,
  notequal: 549,
  gcommaaccent: 500,
  eth: 500,
  zcaron: 444,
  ncommaaccent: 556,
  onesuperior: 300,
  imacron: 278,
  Euro: 500
};
var kernPairs$1 = {
  "A\0C": -55,
  "A\0Cacute": -55,
  "A\0Ccaron": -55,
  "A\0Ccedilla": -55,
  "A\0G": -55,
  "A\0Gbreve": -55,
  "A\0Gcommaaccent": -55,
  "A\0O": -45,
  "A\0Oacute": -45,
  "A\0Ocircumflex": -45,
  "A\0Odieresis": -45,
  "A\0Ograve": -45,
  "A\0Ohungarumlaut": -45,
  "A\0Omacron": -45,
  "A\0Oslash": -45,
  "A\0Otilde": -45,
  "A\0Q": -45,
  "A\0T": -95,
  "A\0Tcaron": -95,
  "A\0Tcommaaccent": -95,
  "A\0U": -50,
  "A\0Uacute": -50,
  "A\0Ucircumflex": -50,
  "A\0Udieresis": -50,
  "A\0Ugrave": -50,
  "A\0Uhungarumlaut": -50,
  "A\0Umacron": -50,
  "A\0Uogonek": -50,
  "A\0Uring": -50,
  "A\0V": -145,
  "A\0W": -130,
  "A\0Y": -100,
  "A\0Yacute": -100,
  "A\0Ydieresis": -100,
  "A\0p": -25,
  "A\0quoteright": -74,
  "A\0u": -50,
  "A\0uacute": -50,
  "A\0ucircumflex": -50,
  "A\0udieresis": -50,
  "A\0ugrave": -50,
  "A\0uhungarumlaut": -50,
  "A\0umacron": -50,
  "A\0uogonek": -50,
  "A\0uring": -50,
  "A\0v": -100,
  "A\0w": -90,
  "A\0y": -74,
  "A\0yacute": -74,
  "A\0ydieresis": -74,
  "Aacute\0C": -55,
  "Aacute\0Cacute": -55,
  "Aacute\0Ccaron": -55,
  "Aacute\0Ccedilla": -55,
  "Aacute\0G": -55,
  "Aacute\0Gbreve": -55,
  "Aacute\0Gcommaaccent": -55,
  "Aacute\0O": -45,
  "Aacute\0Oacute": -45,
  "Aacute\0Ocircumflex": -45,
  "Aacute\0Odieresis": -45,
  "Aacute\0Ograve": -45,
  "Aacute\0Ohungarumlaut": -45,
  "Aacute\0Omacron": -45,
  "Aacute\0Oslash": -45,
  "Aacute\0Otilde": -45,
  "Aacute\0Q": -45,
  "Aacute\0T": -95,
  "Aacute\0Tcaron": -95,
  "Aacute\0Tcommaaccent": -95,
  "Aacute\0U": -50,
  "Aacute\0Uacute": -50,
  "Aacute\0Ucircumflex": -50,
  "Aacute\0Udieresis": -50,
  "Aacute\0Ugrave": -50,
  "Aacute\0Uhungarumlaut": -50,
  "Aacute\0Umacron": -50,
  "Aacute\0Uogonek": -50,
  "Aacute\0Uring": -50,
  "Aacute\0V": -145,
  "Aacute\0W": -130,
  "Aacute\0Y": -100,
  "Aacute\0Yacute": -100,
  "Aacute\0Ydieresis": -100,
  "Aacute\0p": -25,
  "Aacute\0quoteright": -74,
  "Aacute\0u": -50,
  "Aacute\0uacute": -50,
  "Aacute\0ucircumflex": -50,
  "Aacute\0udieresis": -50,
  "Aacute\0ugrave": -50,
  "Aacute\0uhungarumlaut": -50,
  "Aacute\0umacron": -50,
  "Aacute\0uogonek": -50,
  "Aacute\0uring": -50,
  "Aacute\0v": -100,
  "Aacute\0w": -90,
  "Aacute\0y": -74,
  "Aacute\0yacute": -74,
  "Aacute\0ydieresis": -74,
  "Abreve\0C": -55,
  "Abreve\0Cacute": -55,
  "Abreve\0Ccaron": -55,
  "Abreve\0Ccedilla": -55,
  "Abreve\0G": -55,
  "Abreve\0Gbreve": -55,
  "Abreve\0Gcommaaccent": -55,
  "Abreve\0O": -45,
  "Abreve\0Oacute": -45,
  "Abreve\0Ocircumflex": -45,
  "Abreve\0Odieresis": -45,
  "Abreve\0Ograve": -45,
  "Abreve\0Ohungarumlaut": -45,
  "Abreve\0Omacron": -45,
  "Abreve\0Oslash": -45,
  "Abreve\0Otilde": -45,
  "Abreve\0Q": -45,
  "Abreve\0T": -95,
  "Abreve\0Tcaron": -95,
  "Abreve\0Tcommaaccent": -95,
  "Abreve\0U": -50,
  "Abreve\0Uacute": -50,
  "Abreve\0Ucircumflex": -50,
  "Abreve\0Udieresis": -50,
  "Abreve\0Ugrave": -50,
  "Abreve\0Uhungarumlaut": -50,
  "Abreve\0Umacron": -50,
  "Abreve\0Uogonek": -50,
  "Abreve\0Uring": -50,
  "Abreve\0V": -145,
  "Abreve\0W": -130,
  "Abreve\0Y": -100,
  "Abreve\0Yacute": -100,
  "Abreve\0Ydieresis": -100,
  "Abreve\0p": -25,
  "Abreve\0quoteright": -74,
  "Abreve\0u": -50,
  "Abreve\0uacute": -50,
  "Abreve\0ucircumflex": -50,
  "Abreve\0udieresis": -50,
  "Abreve\0ugrave": -50,
  "Abreve\0uhungarumlaut": -50,
  "Abreve\0umacron": -50,
  "Abreve\0uogonek": -50,
  "Abreve\0uring": -50,
  "Abreve\0v": -100,
  "Abreve\0w": -90,
  "Abreve\0y": -74,
  "Abreve\0yacute": -74,
  "Abreve\0ydieresis": -74,
  "Acircumflex\0C": -55,
  "Acircumflex\0Cacute": -55,
  "Acircumflex\0Ccaron": -55,
  "Acircumflex\0Ccedilla": -55,
  "Acircumflex\0G": -55,
  "Acircumflex\0Gbreve": -55,
  "Acircumflex\0Gcommaaccent": -55,
  "Acircumflex\0O": -45,
  "Acircumflex\0Oacute": -45,
  "Acircumflex\0Ocircumflex": -45,
  "Acircumflex\0Odieresis": -45,
  "Acircumflex\0Ograve": -45,
  "Acircumflex\0Ohungarumlaut": -45,
  "Acircumflex\0Omacron": -45,
  "Acircumflex\0Oslash": -45,
  "Acircumflex\0Otilde": -45,
  "Acircumflex\0Q": -45,
  "Acircumflex\0T": -95,
  "Acircumflex\0Tcaron": -95,
  "Acircumflex\0Tcommaaccent": -95,
  "Acircumflex\0U": -50,
  "Acircumflex\0Uacute": -50,
  "Acircumflex\0Ucircumflex": -50,
  "Acircumflex\0Udieresis": -50,
  "Acircumflex\0Ugrave": -50,
  "Acircumflex\0Uhungarumlaut": -50,
  "Acircumflex\0Umacron": -50,
  "Acircumflex\0Uogonek": -50,
  "Acircumflex\0Uring": -50,
  "Acircumflex\0V": -145,
  "Acircumflex\0W": -130,
  "Acircumflex\0Y": -100,
  "Acircumflex\0Yacute": -100,
  "Acircumflex\0Ydieresis": -100,
  "Acircumflex\0p": -25,
  "Acircumflex\0quoteright": -74,
  "Acircumflex\0u": -50,
  "Acircumflex\0uacute": -50,
  "Acircumflex\0ucircumflex": -50,
  "Acircumflex\0udieresis": -50,
  "Acircumflex\0ugrave": -50,
  "Acircumflex\0uhungarumlaut": -50,
  "Acircumflex\0umacron": -50,
  "Acircumflex\0uogonek": -50,
  "Acircumflex\0uring": -50,
  "Acircumflex\0v": -100,
  "Acircumflex\0w": -90,
  "Acircumflex\0y": -74,
  "Acircumflex\0yacute": -74,
  "Acircumflex\0ydieresis": -74,
  "Adieresis\0C": -55,
  "Adieresis\0Cacute": -55,
  "Adieresis\0Ccaron": -55,
  "Adieresis\0Ccedilla": -55,
  "Adieresis\0G": -55,
  "Adieresis\0Gbreve": -55,
  "Adieresis\0Gcommaaccent": -55,
  "Adieresis\0O": -45,
  "Adieresis\0Oacute": -45,
  "Adieresis\0Ocircumflex": -45,
  "Adieresis\0Odieresis": -45,
  "Adieresis\0Ograve": -45,
  "Adieresis\0Ohungarumlaut": -45,
  "Adieresis\0Omacron": -45,
  "Adieresis\0Oslash": -45,
  "Adieresis\0Otilde": -45,
  "Adieresis\0Q": -45,
  "Adieresis\0T": -95,
  "Adieresis\0Tcaron": -95,
  "Adieresis\0Tcommaaccent": -95,
  "Adieresis\0U": -50,
  "Adieresis\0Uacute": -50,
  "Adieresis\0Ucircumflex": -50,
  "Adieresis\0Udieresis": -50,
  "Adieresis\0Ugrave": -50,
  "Adieresis\0Uhungarumlaut": -50,
  "Adieresis\0Umacron": -50,
  "Adieresis\0Uogonek": -50,
  "Adieresis\0Uring": -50,
  "Adieresis\0V": -145,
  "Adieresis\0W": -130,
  "Adieresis\0Y": -100,
  "Adieresis\0Yacute": -100,
  "Adieresis\0Ydieresis": -100,
  "Adieresis\0p": -25,
  "Adieresis\0quoteright": -74,
  "Adieresis\0u": -50,
  "Adieresis\0uacute": -50,
  "Adieresis\0ucircumflex": -50,
  "Adieresis\0udieresis": -50,
  "Adieresis\0ugrave": -50,
  "Adieresis\0uhungarumlaut": -50,
  "Adieresis\0umacron": -50,
  "Adieresis\0uogonek": -50,
  "Adieresis\0uring": -50,
  "Adieresis\0v": -100,
  "Adieresis\0w": -90,
  "Adieresis\0y": -74,
  "Adieresis\0yacute": -74,
  "Adieresis\0ydieresis": -74,
  "Agrave\0C": -55,
  "Agrave\0Cacute": -55,
  "Agrave\0Ccaron": -55,
  "Agrave\0Ccedilla": -55,
  "Agrave\0G": -55,
  "Agrave\0Gbreve": -55,
  "Agrave\0Gcommaaccent": -55,
  "Agrave\0O": -45,
  "Agrave\0Oacute": -45,
  "Agrave\0Ocircumflex": -45,
  "Agrave\0Odieresis": -45,
  "Agrave\0Ograve": -45,
  "Agrave\0Ohungarumlaut": -45,
  "Agrave\0Omacron": -45,
  "Agrave\0Oslash": -45,
  "Agrave\0Otilde": -45,
  "Agrave\0Q": -45,
  "Agrave\0T": -95,
  "Agrave\0Tcaron": -95,
  "Agrave\0Tcommaaccent": -95,
  "Agrave\0U": -50,
  "Agrave\0Uacute": -50,
  "Agrave\0Ucircumflex": -50,
  "Agrave\0Udieresis": -50,
  "Agrave\0Ugrave": -50,
  "Agrave\0Uhungarumlaut": -50,
  "Agrave\0Umacron": -50,
  "Agrave\0Uogonek": -50,
  "Agrave\0Uring": -50,
  "Agrave\0V": -145,
  "Agrave\0W": -130,
  "Agrave\0Y": -100,
  "Agrave\0Yacute": -100,
  "Agrave\0Ydieresis": -100,
  "Agrave\0p": -25,
  "Agrave\0quoteright": -74,
  "Agrave\0u": -50,
  "Agrave\0uacute": -50,
  "Agrave\0ucircumflex": -50,
  "Agrave\0udieresis": -50,
  "Agrave\0ugrave": -50,
  "Agrave\0uhungarumlaut": -50,
  "Agrave\0umacron": -50,
  "Agrave\0uogonek": -50,
  "Agrave\0uring": -50,
  "Agrave\0v": -100,
  "Agrave\0w": -90,
  "Agrave\0y": -74,
  "Agrave\0yacute": -74,
  "Agrave\0ydieresis": -74,
  "Amacron\0C": -55,
  "Amacron\0Cacute": -55,
  "Amacron\0Ccaron": -55,
  "Amacron\0Ccedilla": -55,
  "Amacron\0G": -55,
  "Amacron\0Gbreve": -55,
  "Amacron\0Gcommaaccent": -55,
  "Amacron\0O": -45,
  "Amacron\0Oacute": -45,
  "Amacron\0Ocircumflex": -45,
  "Amacron\0Odieresis": -45,
  "Amacron\0Ograve": -45,
  "Amacron\0Ohungarumlaut": -45,
  "Amacron\0Omacron": -45,
  "Amacron\0Oslash": -45,
  "Amacron\0Otilde": -45,
  "Amacron\0Q": -45,
  "Amacron\0T": -95,
  "Amacron\0Tcaron": -95,
  "Amacron\0Tcommaaccent": -95,
  "Amacron\0U": -50,
  "Amacron\0Uacute": -50,
  "Amacron\0Ucircumflex": -50,
  "Amacron\0Udieresis": -50,
  "Amacron\0Ugrave": -50,
  "Amacron\0Uhungarumlaut": -50,
  "Amacron\0Umacron": -50,
  "Amacron\0Uogonek": -50,
  "Amacron\0Uring": -50,
  "Amacron\0V": -145,
  "Amacron\0W": -130,
  "Amacron\0Y": -100,
  "Amacron\0Yacute": -100,
  "Amacron\0Ydieresis": -100,
  "Amacron\0p": -25,
  "Amacron\0quoteright": -74,
  "Amacron\0u": -50,
  "Amacron\0uacute": -50,
  "Amacron\0ucircumflex": -50,
  "Amacron\0udieresis": -50,
  "Amacron\0ugrave": -50,
  "Amacron\0uhungarumlaut": -50,
  "Amacron\0umacron": -50,
  "Amacron\0uogonek": -50,
  "Amacron\0uring": -50,
  "Amacron\0v": -100,
  "Amacron\0w": -90,
  "Amacron\0y": -74,
  "Amacron\0yacute": -74,
  "Amacron\0ydieresis": -74,
  "Aogonek\0C": -55,
  "Aogonek\0Cacute": -55,
  "Aogonek\0Ccaron": -55,
  "Aogonek\0Ccedilla": -55,
  "Aogonek\0G": -55,
  "Aogonek\0Gbreve": -55,
  "Aogonek\0Gcommaaccent": -55,
  "Aogonek\0O": -45,
  "Aogonek\0Oacute": -45,
  "Aogonek\0Ocircumflex": -45,
  "Aogonek\0Odieresis": -45,
  "Aogonek\0Ograve": -45,
  "Aogonek\0Ohungarumlaut": -45,
  "Aogonek\0Omacron": -45,
  "Aogonek\0Oslash": -45,
  "Aogonek\0Otilde": -45,
  "Aogonek\0Q": -45,
  "Aogonek\0T": -95,
  "Aogonek\0Tcaron": -95,
  "Aogonek\0Tcommaaccent": -95,
  "Aogonek\0U": -50,
  "Aogonek\0Uacute": -50,
  "Aogonek\0Ucircumflex": -50,
  "Aogonek\0Udieresis": -50,
  "Aogonek\0Ugrave": -50,
  "Aogonek\0Uhungarumlaut": -50,
  "Aogonek\0Umacron": -50,
  "Aogonek\0Uogonek": -50,
  "Aogonek\0Uring": -50,
  "Aogonek\0V": -145,
  "Aogonek\0W": -130,
  "Aogonek\0Y": -100,
  "Aogonek\0Yacute": -100,
  "Aogonek\0Ydieresis": -100,
  "Aogonek\0p": -25,
  "Aogonek\0quoteright": -74,
  "Aogonek\0u": -50,
  "Aogonek\0uacute": -50,
  "Aogonek\0ucircumflex": -50,
  "Aogonek\0udieresis": -50,
  "Aogonek\0ugrave": -50,
  "Aogonek\0uhungarumlaut": -50,
  "Aogonek\0umacron": -50,
  "Aogonek\0uogonek": -50,
  "Aogonek\0uring": -50,
  "Aogonek\0v": -100,
  "Aogonek\0w": -90,
  "Aogonek\0y": -34,
  "Aogonek\0yacute": -34,
  "Aogonek\0ydieresis": -34,
  "Aring\0C": -55,
  "Aring\0Cacute": -55,
  "Aring\0Ccaron": -55,
  "Aring\0Ccedilla": -55,
  "Aring\0G": -55,
  "Aring\0Gbreve": -55,
  "Aring\0Gcommaaccent": -55,
  "Aring\0O": -45,
  "Aring\0Oacute": -45,
  "Aring\0Ocircumflex": -45,
  "Aring\0Odieresis": -45,
  "Aring\0Ograve": -45,
  "Aring\0Ohungarumlaut": -45,
  "Aring\0Omacron": -45,
  "Aring\0Oslash": -45,
  "Aring\0Otilde": -45,
  "Aring\0Q": -45,
  "Aring\0T": -95,
  "Aring\0Tcaron": -95,
  "Aring\0Tcommaaccent": -95,
  "Aring\0U": -50,
  "Aring\0Uacute": -50,
  "Aring\0Ucircumflex": -50,
  "Aring\0Udieresis": -50,
  "Aring\0Ugrave": -50,
  "Aring\0Uhungarumlaut": -50,
  "Aring\0Umacron": -50,
  "Aring\0Uogonek": -50,
  "Aring\0Uring": -50,
  "Aring\0V": -145,
  "Aring\0W": -130,
  "Aring\0Y": -100,
  "Aring\0Yacute": -100,
  "Aring\0Ydieresis": -100,
  "Aring\0p": -25,
  "Aring\0quoteright": -74,
  "Aring\0u": -50,
  "Aring\0uacute": -50,
  "Aring\0ucircumflex": -50,
  "Aring\0udieresis": -50,
  "Aring\0ugrave": -50,
  "Aring\0uhungarumlaut": -50,
  "Aring\0umacron": -50,
  "Aring\0uogonek": -50,
  "Aring\0uring": -50,
  "Aring\0v": -100,
  "Aring\0w": -90,
  "Aring\0y": -74,
  "Aring\0yacute": -74,
  "Aring\0ydieresis": -74,
  "Atilde\0C": -55,
  "Atilde\0Cacute": -55,
  "Atilde\0Ccaron": -55,
  "Atilde\0Ccedilla": -55,
  "Atilde\0G": -55,
  "Atilde\0Gbreve": -55,
  "Atilde\0Gcommaaccent": -55,
  "Atilde\0O": -45,
  "Atilde\0Oacute": -45,
  "Atilde\0Ocircumflex": -45,
  "Atilde\0Odieresis": -45,
  "Atilde\0Ograve": -45,
  "Atilde\0Ohungarumlaut": -45,
  "Atilde\0Omacron": -45,
  "Atilde\0Oslash": -45,
  "Atilde\0Otilde": -45,
  "Atilde\0Q": -45,
  "Atilde\0T": -95,
  "Atilde\0Tcaron": -95,
  "Atilde\0Tcommaaccent": -95,
  "Atilde\0U": -50,
  "Atilde\0Uacute": -50,
  "Atilde\0Ucircumflex": -50,
  "Atilde\0Udieresis": -50,
  "Atilde\0Ugrave": -50,
  "Atilde\0Uhungarumlaut": -50,
  "Atilde\0Umacron": -50,
  "Atilde\0Uogonek": -50,
  "Atilde\0Uring": -50,
  "Atilde\0V": -145,
  "Atilde\0W": -130,
  "Atilde\0Y": -100,
  "Atilde\0Yacute": -100,
  "Atilde\0Ydieresis": -100,
  "Atilde\0p": -25,
  "Atilde\0quoteright": -74,
  "Atilde\0u": -50,
  "Atilde\0uacute": -50,
  "Atilde\0ucircumflex": -50,
  "Atilde\0udieresis": -50,
  "Atilde\0ugrave": -50,
  "Atilde\0uhungarumlaut": -50,
  "Atilde\0umacron": -50,
  "Atilde\0uogonek": -50,
  "Atilde\0uring": -50,
  "Atilde\0v": -100,
  "Atilde\0w": -90,
  "Atilde\0y": -74,
  "Atilde\0yacute": -74,
  "Atilde\0ydieresis": -74,
  "B\0A": -30,
  "B\0Aacute": -30,
  "B\0Abreve": -30,
  "B\0Acircumflex": -30,
  "B\0Adieresis": -30,
  "B\0Agrave": -30,
  "B\0Amacron": -30,
  "B\0Aogonek": -30,
  "B\0Aring": -30,
  "B\0Atilde": -30,
  "B\0U": -10,
  "B\0Uacute": -10,
  "B\0Ucircumflex": -10,
  "B\0Udieresis": -10,
  "B\0Ugrave": -10,
  "B\0Uhungarumlaut": -10,
  "B\0Umacron": -10,
  "B\0Uogonek": -10,
  "B\0Uring": -10,
  "D\0A": -35,
  "D\0Aacute": -35,
  "D\0Abreve": -35,
  "D\0Acircumflex": -35,
  "D\0Adieresis": -35,
  "D\0Agrave": -35,
  "D\0Amacron": -35,
  "D\0Aogonek": -35,
  "D\0Aring": -35,
  "D\0Atilde": -35,
  "D\0V": -40,
  "D\0W": -40,
  "D\0Y": -40,
  "D\0Yacute": -40,
  "D\0Ydieresis": -40,
  "D\0period": -20,
  "Dcaron\0A": -35,
  "Dcaron\0Aacute": -35,
  "Dcaron\0Abreve": -35,
  "Dcaron\0Acircumflex": -35,
  "Dcaron\0Adieresis": -35,
  "Dcaron\0Agrave": -35,
  "Dcaron\0Amacron": -35,
  "Dcaron\0Aogonek": -35,
  "Dcaron\0Aring": -35,
  "Dcaron\0Atilde": -35,
  "Dcaron\0V": -40,
  "Dcaron\0W": -40,
  "Dcaron\0Y": -40,
  "Dcaron\0Yacute": -40,
  "Dcaron\0Ydieresis": -40,
  "Dcaron\0period": -20,
  "Dcroat\0A": -35,
  "Dcroat\0Aacute": -35,
  "Dcroat\0Abreve": -35,
  "Dcroat\0Acircumflex": -35,
  "Dcroat\0Adieresis": -35,
  "Dcroat\0Agrave": -35,
  "Dcroat\0Amacron": -35,
  "Dcroat\0Aogonek": -35,
  "Dcroat\0Aring": -35,
  "Dcroat\0Atilde": -35,
  "Dcroat\0V": -40,
  "Dcroat\0W": -40,
  "Dcroat\0Y": -40,
  "Dcroat\0Yacute": -40,
  "Dcroat\0Ydieresis": -40,
  "Dcroat\0period": -20,
  "F\0A": -90,
  "F\0Aacute": -90,
  "F\0Abreve": -90,
  "F\0Acircumflex": -90,
  "F\0Adieresis": -90,
  "F\0Agrave": -90,
  "F\0Amacron": -90,
  "F\0Aogonek": -90,
  "F\0Aring": -90,
  "F\0Atilde": -90,
  "F\0a": -25,
  "F\0aacute": -25,
  "F\0abreve": -25,
  "F\0acircumflex": -25,
  "F\0adieresis": -25,
  "F\0agrave": -25,
  "F\0amacron": -25,
  "F\0aogonek": -25,
  "F\0aring": -25,
  "F\0atilde": -25,
  "F\0comma": -92,
  "F\0e": -25,
  "F\0eacute": -25,
  "F\0ecaron": -25,
  "F\0ecircumflex": -25,
  "F\0edieresis": -25,
  "F\0edotaccent": -25,
  "F\0egrave": -25,
  "F\0emacron": -25,
  "F\0eogonek": -25,
  "F\0o": -25,
  "F\0oacute": -25,
  "F\0ocircumflex": -25,
  "F\0odieresis": -25,
  "F\0ograve": -25,
  "F\0ohungarumlaut": -25,
  "F\0omacron": -25,
  "F\0oslash": -25,
  "F\0otilde": -25,
  "F\0period": -110,
  "J\0A": -30,
  "J\0Aacute": -30,
  "J\0Abreve": -30,
  "J\0Acircumflex": -30,
  "J\0Adieresis": -30,
  "J\0Agrave": -30,
  "J\0Amacron": -30,
  "J\0Aogonek": -30,
  "J\0Aring": -30,
  "J\0Atilde": -30,
  "J\0a": -15,
  "J\0aacute": -15,
  "J\0abreve": -15,
  "J\0acircumflex": -15,
  "J\0adieresis": -15,
  "J\0agrave": -15,
  "J\0amacron": -15,
  "J\0aogonek": -15,
  "J\0aring": -15,
  "J\0atilde": -15,
  "J\0e": -15,
  "J\0eacute": -15,
  "J\0ecaron": -15,
  "J\0ecircumflex": -15,
  "J\0edieresis": -15,
  "J\0edotaccent": -15,
  "J\0egrave": -15,
  "J\0emacron": -15,
  "J\0eogonek": -15,
  "J\0o": -15,
  "J\0oacute": -15,
  "J\0ocircumflex": -15,
  "J\0odieresis": -15,
  "J\0ograve": -15,
  "J\0ohungarumlaut": -15,
  "J\0omacron": -15,
  "J\0oslash": -15,
  "J\0otilde": -15,
  "J\0period": -20,
  "J\0u": -15,
  "J\0uacute": -15,
  "J\0ucircumflex": -15,
  "J\0udieresis": -15,
  "J\0ugrave": -15,
  "J\0uhungarumlaut": -15,
  "J\0umacron": -15,
  "J\0uogonek": -15,
  "J\0uring": -15,
  "K\0O": -30,
  "K\0Oacute": -30,
  "K\0Ocircumflex": -30,
  "K\0Odieresis": -30,
  "K\0Ograve": -30,
  "K\0Ohungarumlaut": -30,
  "K\0Omacron": -30,
  "K\0Oslash": -30,
  "K\0Otilde": -30,
  "K\0e": -25,
  "K\0eacute": -25,
  "K\0ecaron": -25,
  "K\0ecircumflex": -25,
  "K\0edieresis": -25,
  "K\0edotaccent": -25,
  "K\0egrave": -25,
  "K\0emacron": -25,
  "K\0eogonek": -25,
  "K\0o": -25,
  "K\0oacute": -25,
  "K\0ocircumflex": -25,
  "K\0odieresis": -25,
  "K\0ograve": -25,
  "K\0ohungarumlaut": -25,
  "K\0omacron": -25,
  "K\0oslash": -25,
  "K\0otilde": -25,
  "K\0u": -15,
  "K\0uacute": -15,
  "K\0ucircumflex": -15,
  "K\0udieresis": -15,
  "K\0ugrave": -15,
  "K\0uhungarumlaut": -15,
  "K\0umacron": -15,
  "K\0uogonek": -15,
  "K\0uring": -15,
  "K\0y": -45,
  "K\0yacute": -45,
  "K\0ydieresis": -45,
  "Kcommaaccent\0O": -30,
  "Kcommaaccent\0Oacute": -30,
  "Kcommaaccent\0Ocircumflex": -30,
  "Kcommaaccent\0Odieresis": -30,
  "Kcommaaccent\0Ograve": -30,
  "Kcommaaccent\0Ohungarumlaut": -30,
  "Kcommaaccent\0Omacron": -30,
  "Kcommaaccent\0Oslash": -30,
  "Kcommaaccent\0Otilde": -30,
  "Kcommaaccent\0e": -25,
  "Kcommaaccent\0eacute": -25,
  "Kcommaaccent\0ecaron": -25,
  "Kcommaaccent\0ecircumflex": -25,
  "Kcommaaccent\0edieresis": -25,
  "Kcommaaccent\0edotaccent": -25,
  "Kcommaaccent\0egrave": -25,
  "Kcommaaccent\0emacron": -25,
  "Kcommaaccent\0eogonek": -25,
  "Kcommaaccent\0o": -25,
  "Kcommaaccent\0oacute": -25,
  "Kcommaaccent\0ocircumflex": -25,
  "Kcommaaccent\0odieresis": -25,
  "Kcommaaccent\0ograve": -25,
  "Kcommaaccent\0ohungarumlaut": -25,
  "Kcommaaccent\0omacron": -25,
  "Kcommaaccent\0oslash": -25,
  "Kcommaaccent\0otilde": -25,
  "Kcommaaccent\0u": -15,
  "Kcommaaccent\0uacute": -15,
  "Kcommaaccent\0ucircumflex": -15,
  "Kcommaaccent\0udieresis": -15,
  "Kcommaaccent\0ugrave": -15,
  "Kcommaaccent\0uhungarumlaut": -15,
  "Kcommaaccent\0umacron": -15,
  "Kcommaaccent\0uogonek": -15,
  "Kcommaaccent\0uring": -15,
  "Kcommaaccent\0y": -45,
  "Kcommaaccent\0yacute": -45,
  "Kcommaaccent\0ydieresis": -45,
  "L\0T": -92,
  "L\0Tcaron": -92,
  "L\0Tcommaaccent": -92,
  "L\0V": -92,
  "L\0W": -92,
  "L\0Y": -92,
  "L\0Yacute": -92,
  "L\0Ydieresis": -92,
  "L\0quotedblright": -20,
  "L\0quoteright": -110,
  "L\0y": -55,
  "L\0yacute": -55,
  "L\0ydieresis": -55,
  "Lacute\0T": -92,
  "Lacute\0Tcaron": -92,
  "Lacute\0Tcommaaccent": -92,
  "Lacute\0V": -92,
  "Lacute\0W": -92,
  "Lacute\0Y": -92,
  "Lacute\0Yacute": -92,
  "Lacute\0Ydieresis": -92,
  "Lacute\0quotedblright": -20,
  "Lacute\0quoteright": -110,
  "Lacute\0y": -55,
  "Lacute\0yacute": -55,
  "Lacute\0ydieresis": -55,
  "Lcommaaccent\0T": -92,
  "Lcommaaccent\0Tcaron": -92,
  "Lcommaaccent\0Tcommaaccent": -92,
  "Lcommaaccent\0V": -92,
  "Lcommaaccent\0W": -92,
  "Lcommaaccent\0Y": -92,
  "Lcommaaccent\0Yacute": -92,
  "Lcommaaccent\0Ydieresis": -92,
  "Lcommaaccent\0quotedblright": -20,
  "Lcommaaccent\0quoteright": -110,
  "Lcommaaccent\0y": -55,
  "Lcommaaccent\0yacute": -55,
  "Lcommaaccent\0ydieresis": -55,
  "Lslash\0T": -92,
  "Lslash\0Tcaron": -92,
  "Lslash\0Tcommaaccent": -92,
  "Lslash\0V": -92,
  "Lslash\0W": -92,
  "Lslash\0Y": -92,
  "Lslash\0Yacute": -92,
  "Lslash\0Ydieresis": -92,
  "Lslash\0quotedblright": -20,
  "Lslash\0quoteright": -110,
  "Lslash\0y": -55,
  "Lslash\0yacute": -55,
  "Lslash\0ydieresis": -55,
  "N\0A": -20,
  "N\0Aacute": -20,
  "N\0Abreve": -20,
  "N\0Acircumflex": -20,
  "N\0Adieresis": -20,
  "N\0Agrave": -20,
  "N\0Amacron": -20,
  "N\0Aogonek": -20,
  "N\0Aring": -20,
  "N\0Atilde": -20,
  "Nacute\0A": -20,
  "Nacute\0Aacute": -20,
  "Nacute\0Abreve": -20,
  "Nacute\0Acircumflex": -20,
  "Nacute\0Adieresis": -20,
  "Nacute\0Agrave": -20,
  "Nacute\0Amacron": -20,
  "Nacute\0Aogonek": -20,
  "Nacute\0Aring": -20,
  "Nacute\0Atilde": -20,
  "Ncaron\0A": -20,
  "Ncaron\0Aacute": -20,
  "Ncaron\0Abreve": -20,
  "Ncaron\0Acircumflex": -20,
  "Ncaron\0Adieresis": -20,
  "Ncaron\0Agrave": -20,
  "Ncaron\0Amacron": -20,
  "Ncaron\0Aogonek": -20,
  "Ncaron\0Aring": -20,
  "Ncaron\0Atilde": -20,
  "Ncommaaccent\0A": -20,
  "Ncommaaccent\0Aacute": -20,
  "Ncommaaccent\0Abreve": -20,
  "Ncommaaccent\0Acircumflex": -20,
  "Ncommaaccent\0Adieresis": -20,
  "Ncommaaccent\0Agrave": -20,
  "Ncommaaccent\0Amacron": -20,
  "Ncommaaccent\0Aogonek": -20,
  "Ncommaaccent\0Aring": -20,
  "Ncommaaccent\0Atilde": -20,
  "Ntilde\0A": -20,
  "Ntilde\0Aacute": -20,
  "Ntilde\0Abreve": -20,
  "Ntilde\0Acircumflex": -20,
  "Ntilde\0Adieresis": -20,
  "Ntilde\0Agrave": -20,
  "Ntilde\0Amacron": -20,
  "Ntilde\0Aogonek": -20,
  "Ntilde\0Aring": -20,
  "Ntilde\0Atilde": -20,
  "O\0A": -40,
  "O\0Aacute": -40,
  "O\0Abreve": -40,
  "O\0Acircumflex": -40,
  "O\0Adieresis": -40,
  "O\0Agrave": -40,
  "O\0Amacron": -40,
  "O\0Aogonek": -40,
  "O\0Aring": -40,
  "O\0Atilde": -40,
  "O\0T": -40,
  "O\0Tcaron": -40,
  "O\0Tcommaaccent": -40,
  "O\0V": -50,
  "O\0W": -50,
  "O\0X": -40,
  "O\0Y": -50,
  "O\0Yacute": -50,
  "O\0Ydieresis": -50,
  "Oacute\0A": -40,
  "Oacute\0Aacute": -40,
  "Oacute\0Abreve": -40,
  "Oacute\0Acircumflex": -40,
  "Oacute\0Adieresis": -40,
  "Oacute\0Agrave": -40,
  "Oacute\0Amacron": -40,
  "Oacute\0Aogonek": -40,
  "Oacute\0Aring": -40,
  "Oacute\0Atilde": -40,
  "Oacute\0T": -40,
  "Oacute\0Tcaron": -40,
  "Oacute\0Tcommaaccent": -40,
  "Oacute\0V": -50,
  "Oacute\0W": -50,
  "Oacute\0X": -40,
  "Oacute\0Y": -50,
  "Oacute\0Yacute": -50,
  "Oacute\0Ydieresis": -50,
  "Ocircumflex\0A": -40,
  "Ocircumflex\0Aacute": -40,
  "Ocircumflex\0Abreve": -40,
  "Ocircumflex\0Acircumflex": -40,
  "Ocircumflex\0Adieresis": -40,
  "Ocircumflex\0Agrave": -40,
  "Ocircumflex\0Amacron": -40,
  "Ocircumflex\0Aogonek": -40,
  "Ocircumflex\0Aring": -40,
  "Ocircumflex\0Atilde": -40,
  "Ocircumflex\0T": -40,
  "Ocircumflex\0Tcaron": -40,
  "Ocircumflex\0Tcommaaccent": -40,
  "Ocircumflex\0V": -50,
  "Ocircumflex\0W": -50,
  "Ocircumflex\0X": -40,
  "Ocircumflex\0Y": -50,
  "Ocircumflex\0Yacute": -50,
  "Ocircumflex\0Ydieresis": -50,
  "Odieresis\0A": -40,
  "Odieresis\0Aacute": -40,
  "Odieresis\0Abreve": -40,
  "Odieresis\0Acircumflex": -40,
  "Odieresis\0Adieresis": -40,
  "Odieresis\0Agrave": -40,
  "Odieresis\0Amacron": -40,
  "Odieresis\0Aogonek": -40,
  "Odieresis\0Aring": -40,
  "Odieresis\0Atilde": -40,
  "Odieresis\0T": -40,
  "Odieresis\0Tcaron": -40,
  "Odieresis\0Tcommaaccent": -40,
  "Odieresis\0V": -50,
  "Odieresis\0W": -50,
  "Odieresis\0X": -40,
  "Odieresis\0Y": -50,
  "Odieresis\0Yacute": -50,
  "Odieresis\0Ydieresis": -50,
  "Ograve\0A": -40,
  "Ograve\0Aacute": -40,
  "Ograve\0Abreve": -40,
  "Ograve\0Acircumflex": -40,
  "Ograve\0Adieresis": -40,
  "Ograve\0Agrave": -40,
  "Ograve\0Amacron": -40,
  "Ograve\0Aogonek": -40,
  "Ograve\0Aring": -40,
  "Ograve\0Atilde": -40,
  "Ograve\0T": -40,
  "Ograve\0Tcaron": -40,
  "Ograve\0Tcommaaccent": -40,
  "Ograve\0V": -50,
  "Ograve\0W": -50,
  "Ograve\0X": -40,
  "Ograve\0Y": -50,
  "Ograve\0Yacute": -50,
  "Ograve\0Ydieresis": -50,
  "Ohungarumlaut\0A": -40,
  "Ohungarumlaut\0Aacute": -40,
  "Ohungarumlaut\0Abreve": -40,
  "Ohungarumlaut\0Acircumflex": -40,
  "Ohungarumlaut\0Adieresis": -40,
  "Ohungarumlaut\0Agrave": -40,
  "Ohungarumlaut\0Amacron": -40,
  "Ohungarumlaut\0Aogonek": -40,
  "Ohungarumlaut\0Aring": -40,
  "Ohungarumlaut\0Atilde": -40,
  "Ohungarumlaut\0T": -40,
  "Ohungarumlaut\0Tcaron": -40,
  "Ohungarumlaut\0Tcommaaccent": -40,
  "Ohungarumlaut\0V": -50,
  "Ohungarumlaut\0W": -50,
  "Ohungarumlaut\0X": -40,
  "Ohungarumlaut\0Y": -50,
  "Ohungarumlaut\0Yacute": -50,
  "Ohungarumlaut\0Ydieresis": -50,
  "Omacron\0A": -40,
  "Omacron\0Aacute": -40,
  "Omacron\0Abreve": -40,
  "Omacron\0Acircumflex": -40,
  "Omacron\0Adieresis": -40,
  "Omacron\0Agrave": -40,
  "Omacron\0Amacron": -40,
  "Omacron\0Aogonek": -40,
  "Omacron\0Aring": -40,
  "Omacron\0Atilde": -40,
  "Omacron\0T": -40,
  "Omacron\0Tcaron": -40,
  "Omacron\0Tcommaaccent": -40,
  "Omacron\0V": -50,
  "Omacron\0W": -50,
  "Omacron\0X": -40,
  "Omacron\0Y": -50,
  "Omacron\0Yacute": -50,
  "Omacron\0Ydieresis": -50,
  "Oslash\0A": -40,
  "Oslash\0Aacute": -40,
  "Oslash\0Abreve": -40,
  "Oslash\0Acircumflex": -40,
  "Oslash\0Adieresis": -40,
  "Oslash\0Agrave": -40,
  "Oslash\0Amacron": -40,
  "Oslash\0Aogonek": -40,
  "Oslash\0Aring": -40,
  "Oslash\0Atilde": -40,
  "Oslash\0T": -40,
  "Oslash\0Tcaron": -40,
  "Oslash\0Tcommaaccent": -40,
  "Oslash\0V": -50,
  "Oslash\0W": -50,
  "Oslash\0X": -40,
  "Oslash\0Y": -50,
  "Oslash\0Yacute": -50,
  "Oslash\0Ydieresis": -50,
  "Otilde\0A": -40,
  "Otilde\0Aacute": -40,
  "Otilde\0Abreve": -40,
  "Otilde\0Acircumflex": -40,
  "Otilde\0Adieresis": -40,
  "Otilde\0Agrave": -40,
  "Otilde\0Amacron": -40,
  "Otilde\0Aogonek": -40,
  "Otilde\0Aring": -40,
  "Otilde\0Atilde": -40,
  "Otilde\0T": -40,
  "Otilde\0Tcaron": -40,
  "Otilde\0Tcommaaccent": -40,
  "Otilde\0V": -50,
  "Otilde\0W": -50,
  "Otilde\0X": -40,
  "Otilde\0Y": -50,
  "Otilde\0Yacute": -50,
  "Otilde\0Ydieresis": -50,
  "P\0A": -74,
  "P\0Aacute": -74,
  "P\0Abreve": -74,
  "P\0Acircumflex": -74,
  "P\0Adieresis": -74,
  "P\0Agrave": -74,
  "P\0Amacron": -74,
  "P\0Aogonek": -74,
  "P\0Aring": -74,
  "P\0Atilde": -74,
  "P\0a": -10,
  "P\0aacute": -10,
  "P\0abreve": -10,
  "P\0acircumflex": -10,
  "P\0adieresis": -10,
  "P\0agrave": -10,
  "P\0amacron": -10,
  "P\0aogonek": -10,
  "P\0aring": -10,
  "P\0atilde": -10,
  "P\0comma": -92,
  "P\0e": -20,
  "P\0eacute": -20,
  "P\0ecaron": -20,
  "P\0ecircumflex": -20,
  "P\0edieresis": -20,
  "P\0edotaccent": -20,
  "P\0egrave": -20,
  "P\0emacron": -20,
  "P\0eogonek": -20,
  "P\0o": -20,
  "P\0oacute": -20,
  "P\0ocircumflex": -20,
  "P\0odieresis": -20,
  "P\0ograve": -20,
  "P\0ohungarumlaut": -20,
  "P\0omacron": -20,
  "P\0oslash": -20,
  "P\0otilde": -20,
  "P\0period": -110,
  "Q\0U": -10,
  "Q\0Uacute": -10,
  "Q\0Ucircumflex": -10,
  "Q\0Udieresis": -10,
  "Q\0Ugrave": -10,
  "Q\0Uhungarumlaut": -10,
  "Q\0Umacron": -10,
  "Q\0Uogonek": -10,
  "Q\0Uring": -10,
  "Q\0period": -20,
  "R\0O": -30,
  "R\0Oacute": -30,
  "R\0Ocircumflex": -30,
  "R\0Odieresis": -30,
  "R\0Ograve": -30,
  "R\0Ohungarumlaut": -30,
  "R\0Omacron": -30,
  "R\0Oslash": -30,
  "R\0Otilde": -30,
  "R\0T": -40,
  "R\0Tcaron": -40,
  "R\0Tcommaaccent": -40,
  "R\0U": -30,
  "R\0Uacute": -30,
  "R\0Ucircumflex": -30,
  "R\0Udieresis": -30,
  "R\0Ugrave": -30,
  "R\0Uhungarumlaut": -30,
  "R\0Umacron": -30,
  "R\0Uogonek": -30,
  "R\0Uring": -30,
  "R\0V": -55,
  "R\0W": -35,
  "R\0Y": -35,
  "R\0Yacute": -35,
  "R\0Ydieresis": -35,
  "Racute\0O": -30,
  "Racute\0Oacute": -30,
  "Racute\0Ocircumflex": -30,
  "Racute\0Odieresis": -30,
  "Racute\0Ograve": -30,
  "Racute\0Ohungarumlaut": -30,
  "Racute\0Omacron": -30,
  "Racute\0Oslash": -30,
  "Racute\0Otilde": -30,
  "Racute\0T": -40,
  "Racute\0Tcaron": -40,
  "Racute\0Tcommaaccent": -40,
  "Racute\0U": -30,
  "Racute\0Uacute": -30,
  "Racute\0Ucircumflex": -30,
  "Racute\0Udieresis": -30,
  "Racute\0Ugrave": -30,
  "Racute\0Uhungarumlaut": -30,
  "Racute\0Umacron": -30,
  "Racute\0Uogonek": -30,
  "Racute\0Uring": -30,
  "Racute\0V": -55,
  "Racute\0W": -35,
  "Racute\0Y": -35,
  "Racute\0Yacute": -35,
  "Racute\0Ydieresis": -35,
  "Rcaron\0O": -30,
  "Rcaron\0Oacute": -30,
  "Rcaron\0Ocircumflex": -30,
  "Rcaron\0Odieresis": -30,
  "Rcaron\0Ograve": -30,
  "Rcaron\0Ohungarumlaut": -30,
  "Rcaron\0Omacron": -30,
  "Rcaron\0Oslash": -30,
  "Rcaron\0Otilde": -30,
  "Rcaron\0T": -40,
  "Rcaron\0Tcaron": -40,
  "Rcaron\0Tcommaaccent": -40,
  "Rcaron\0U": -30,
  "Rcaron\0Uacute": -30,
  "Rcaron\0Ucircumflex": -30,
  "Rcaron\0Udieresis": -30,
  "Rcaron\0Ugrave": -30,
  "Rcaron\0Uhungarumlaut": -30,
  "Rcaron\0Umacron": -30,
  "Rcaron\0Uogonek": -30,
  "Rcaron\0Uring": -30,
  "Rcaron\0V": -55,
  "Rcaron\0W": -35,
  "Rcaron\0Y": -35,
  "Rcaron\0Yacute": -35,
  "Rcaron\0Ydieresis": -35,
  "Rcommaaccent\0O": -30,
  "Rcommaaccent\0Oacute": -30,
  "Rcommaaccent\0Ocircumflex": -30,
  "Rcommaaccent\0Odieresis": -30,
  "Rcommaaccent\0Ograve": -30,
  "Rcommaaccent\0Ohungarumlaut": -30,
  "Rcommaaccent\0Omacron": -30,
  "Rcommaaccent\0Oslash": -30,
  "Rcommaaccent\0Otilde": -30,
  "Rcommaaccent\0T": -40,
  "Rcommaaccent\0Tcaron": -40,
  "Rcommaaccent\0Tcommaaccent": -40,
  "Rcommaaccent\0U": -30,
  "Rcommaaccent\0Uacute": -30,
  "Rcommaaccent\0Ucircumflex": -30,
  "Rcommaaccent\0Udieresis": -30,
  "Rcommaaccent\0Ugrave": -30,
  "Rcommaaccent\0Uhungarumlaut": -30,
  "Rcommaaccent\0Umacron": -30,
  "Rcommaaccent\0Uogonek": -30,
  "Rcommaaccent\0Uring": -30,
  "Rcommaaccent\0V": -55,
  "Rcommaaccent\0W": -35,
  "Rcommaaccent\0Y": -35,
  "Rcommaaccent\0Yacute": -35,
  "Rcommaaccent\0Ydieresis": -35,
  "T\0A": -90,
  "T\0Aacute": -90,
  "T\0Abreve": -90,
  "T\0Acircumflex": -90,
  "T\0Adieresis": -90,
  "T\0Agrave": -90,
  "T\0Amacron": -90,
  "T\0Aogonek": -90,
  "T\0Aring": -90,
  "T\0Atilde": -90,
  "T\0O": -18,
  "T\0Oacute": -18,
  "T\0Ocircumflex": -18,
  "T\0Odieresis": -18,
  "T\0Ograve": -18,
  "T\0Ohungarumlaut": -18,
  "T\0Omacron": -18,
  "T\0Oslash": -18,
  "T\0Otilde": -18,
  "T\0a": -92,
  "T\0aacute": -92,
  "T\0abreve": -52,
  "T\0acircumflex": -52,
  "T\0adieresis": -52,
  "T\0agrave": -52,
  "T\0amacron": -52,
  "T\0aogonek": -92,
  "T\0aring": -92,
  "T\0atilde": -52,
  "T\0colon": -74,
  "T\0comma": -74,
  "T\0e": -92,
  "T\0eacute": -92,
  "T\0ecaron": -92,
  "T\0ecircumflex": -92,
  "T\0edieresis": -52,
  "T\0edotaccent": -92,
  "T\0egrave": -52,
  "T\0emacron": -52,
  "T\0eogonek": -92,
  "T\0hyphen": -92,
  "T\0i": -18,
  "T\0iacute": -18,
  "T\0iogonek": -18,
  "T\0o": -92,
  "T\0oacute": -92,
  "T\0ocircumflex": -92,
  "T\0odieresis": -92,
  "T\0ograve": -92,
  "T\0ohungarumlaut": -92,
  "T\0omacron": -92,
  "T\0oslash": -92,
  "T\0otilde": -92,
  "T\0period": -90,
  "T\0r": -74,
  "T\0racute": -74,
  "T\0rcaron": -74,
  "T\0rcommaaccent": -74,
  "T\0semicolon": -74,
  "T\0u": -92,
  "T\0uacute": -92,
  "T\0ucircumflex": -92,
  "T\0udieresis": -92,
  "T\0ugrave": -92,
  "T\0uhungarumlaut": -92,
  "T\0umacron": -92,
  "T\0uogonek": -92,
  "T\0uring": -92,
  "T\0w": -74,
  "T\0y": -34,
  "T\0yacute": -34,
  "T\0ydieresis": -34,
  "Tcaron\0A": -90,
  "Tcaron\0Aacute": -90,
  "Tcaron\0Abreve": -90,
  "Tcaron\0Acircumflex": -90,
  "Tcaron\0Adieresis": -90,
  "Tcaron\0Agrave": -90,
  "Tcaron\0Amacron": -90,
  "Tcaron\0Aogonek": -90,
  "Tcaron\0Aring": -90,
  "Tcaron\0Atilde": -90,
  "Tcaron\0O": -18,
  "Tcaron\0Oacute": -18,
  "Tcaron\0Ocircumflex": -18,
  "Tcaron\0Odieresis": -18,
  "Tcaron\0Ograve": -18,
  "Tcaron\0Ohungarumlaut": -18,
  "Tcaron\0Omacron": -18,
  "Tcaron\0Oslash": -18,
  "Tcaron\0Otilde": -18,
  "Tcaron\0a": -92,
  "Tcaron\0aacute": -92,
  "Tcaron\0abreve": -52,
  "Tcaron\0acircumflex": -52,
  "Tcaron\0adieresis": -52,
  "Tcaron\0agrave": -52,
  "Tcaron\0amacron": -52,
  "Tcaron\0aogonek": -92,
  "Tcaron\0aring": -92,
  "Tcaron\0atilde": -52,
  "Tcaron\0colon": -74,
  "Tcaron\0comma": -74,
  "Tcaron\0e": -92,
  "Tcaron\0eacute": -92,
  "Tcaron\0ecaron": -92,
  "Tcaron\0ecircumflex": -92,
  "Tcaron\0edieresis": -52,
  "Tcaron\0edotaccent": -92,
  "Tcaron\0egrave": -52,
  "Tcaron\0emacron": -52,
  "Tcaron\0eogonek": -92,
  "Tcaron\0hyphen": -92,
  "Tcaron\0i": -18,
  "Tcaron\0iacute": -18,
  "Tcaron\0iogonek": -18,
  "Tcaron\0o": -92,
  "Tcaron\0oacute": -92,
  "Tcaron\0ocircumflex": -92,
  "Tcaron\0odieresis": -92,
  "Tcaron\0ograve": -92,
  "Tcaron\0ohungarumlaut": -92,
  "Tcaron\0omacron": -92,
  "Tcaron\0oslash": -92,
  "Tcaron\0otilde": -92,
  "Tcaron\0period": -90,
  "Tcaron\0r": -74,
  "Tcaron\0racute": -74,
  "Tcaron\0rcaron": -74,
  "Tcaron\0rcommaaccent": -74,
  "Tcaron\0semicolon": -74,
  "Tcaron\0u": -92,
  "Tcaron\0uacute": -92,
  "Tcaron\0ucircumflex": -92,
  "Tcaron\0udieresis": -92,
  "Tcaron\0ugrave": -92,
  "Tcaron\0uhungarumlaut": -92,
  "Tcaron\0umacron": -92,
  "Tcaron\0uogonek": -92,
  "Tcaron\0uring": -92,
  "Tcaron\0w": -74,
  "Tcaron\0y": -34,
  "Tcaron\0yacute": -34,
  "Tcaron\0ydieresis": -34,
  "Tcommaaccent\0A": -90,
  "Tcommaaccent\0Aacute": -90,
  "Tcommaaccent\0Abreve": -90,
  "Tcommaaccent\0Acircumflex": -90,
  "Tcommaaccent\0Adieresis": -90,
  "Tcommaaccent\0Agrave": -90,
  "Tcommaaccent\0Amacron": -90,
  "Tcommaaccent\0Aogonek": -90,
  "Tcommaaccent\0Aring": -90,
  "Tcommaaccent\0Atilde": -90,
  "Tcommaaccent\0O": -18,
  "Tcommaaccent\0Oacute": -18,
  "Tcommaaccent\0Ocircumflex": -18,
  "Tcommaaccent\0Odieresis": -18,
  "Tcommaaccent\0Ograve": -18,
  "Tcommaaccent\0Ohungarumlaut": -18,
  "Tcommaaccent\0Omacron": -18,
  "Tcommaaccent\0Oslash": -18,
  "Tcommaaccent\0Otilde": -18,
  "Tcommaaccent\0a": -92,
  "Tcommaaccent\0aacute": -92,
  "Tcommaaccent\0abreve": -52,
  "Tcommaaccent\0acircumflex": -52,
  "Tcommaaccent\0adieresis": -52,
  "Tcommaaccent\0agrave": -52,
  "Tcommaaccent\0amacron": -52,
  "Tcommaaccent\0aogonek": -92,
  "Tcommaaccent\0aring": -92,
  "Tcommaaccent\0atilde": -52,
  "Tcommaaccent\0colon": -74,
  "Tcommaaccent\0comma": -74,
  "Tcommaaccent\0e": -92,
  "Tcommaaccent\0eacute": -92,
  "Tcommaaccent\0ecaron": -92,
  "Tcommaaccent\0ecircumflex": -92,
  "Tcommaaccent\0edieresis": -52,
  "Tcommaaccent\0edotaccent": -92,
  "Tcommaaccent\0egrave": -52,
  "Tcommaaccent\0emacron": -52,
  "Tcommaaccent\0eogonek": -92,
  "Tcommaaccent\0hyphen": -92,
  "Tcommaaccent\0i": -18,
  "Tcommaaccent\0iacute": -18,
  "Tcommaaccent\0iogonek": -18,
  "Tcommaaccent\0o": -92,
  "Tcommaaccent\0oacute": -92,
  "Tcommaaccent\0ocircumflex": -92,
  "Tcommaaccent\0odieresis": -92,
  "Tcommaaccent\0ograve": -92,
  "Tcommaaccent\0ohungarumlaut": -92,
  "Tcommaaccent\0omacron": -92,
  "Tcommaaccent\0oslash": -92,
  "Tcommaaccent\0otilde": -92,
  "Tcommaaccent\0period": -90,
  "Tcommaaccent\0r": -74,
  "Tcommaaccent\0racute": -74,
  "Tcommaaccent\0rcaron": -74,
  "Tcommaaccent\0rcommaaccent": -74,
  "Tcommaaccent\0semicolon": -74,
  "Tcommaaccent\0u": -92,
  "Tcommaaccent\0uacute": -92,
  "Tcommaaccent\0ucircumflex": -92,
  "Tcommaaccent\0udieresis": -92,
  "Tcommaaccent\0ugrave": -92,
  "Tcommaaccent\0uhungarumlaut": -92,
  "Tcommaaccent\0umacron": -92,
  "Tcommaaccent\0uogonek": -92,
  "Tcommaaccent\0uring": -92,
  "Tcommaaccent\0w": -74,
  "Tcommaaccent\0y": -34,
  "Tcommaaccent\0yacute": -34,
  "Tcommaaccent\0ydieresis": -34,
  "U\0A": -60,
  "U\0Aacute": -60,
  "U\0Abreve": -60,
  "U\0Acircumflex": -60,
  "U\0Adieresis": -60,
  "U\0Agrave": -60,
  "U\0Amacron": -60,
  "U\0Aogonek": -60,
  "U\0Aring": -60,
  "U\0Atilde": -60,
  "U\0comma": -50,
  "U\0period": -50,
  "Uacute\0A": -60,
  "Uacute\0Aacute": -60,
  "Uacute\0Abreve": -60,
  "Uacute\0Acircumflex": -60,
  "Uacute\0Adieresis": -60,
  "Uacute\0Agrave": -60,
  "Uacute\0Amacron": -60,
  "Uacute\0Aogonek": -60,
  "Uacute\0Aring": -60,
  "Uacute\0Atilde": -60,
  "Uacute\0comma": -50,
  "Uacute\0period": -50,
  "Ucircumflex\0A": -60,
  "Ucircumflex\0Aacute": -60,
  "Ucircumflex\0Abreve": -60,
  "Ucircumflex\0Acircumflex": -60,
  "Ucircumflex\0Adieresis": -60,
  "Ucircumflex\0Agrave": -60,
  "Ucircumflex\0Amacron": -60,
  "Ucircumflex\0Aogonek": -60,
  "Ucircumflex\0Aring": -60,
  "Ucircumflex\0Atilde": -60,
  "Ucircumflex\0comma": -50,
  "Ucircumflex\0period": -50,
  "Udieresis\0A": -60,
  "Udieresis\0Aacute": -60,
  "Udieresis\0Abreve": -60,
  "Udieresis\0Acircumflex": -60,
  "Udieresis\0Adieresis": -60,
  "Udieresis\0Agrave": -60,
  "Udieresis\0Amacron": -60,
  "Udieresis\0Aogonek": -60,
  "Udieresis\0Aring": -60,
  "Udieresis\0Atilde": -60,
  "Udieresis\0comma": -50,
  "Udieresis\0period": -50,
  "Ugrave\0A": -60,
  "Ugrave\0Aacute": -60,
  "Ugrave\0Abreve": -60,
  "Ugrave\0Acircumflex": -60,
  "Ugrave\0Adieresis": -60,
  "Ugrave\0Agrave": -60,
  "Ugrave\0Amacron": -60,
  "Ugrave\0Aogonek": -60,
  "Ugrave\0Aring": -60,
  "Ugrave\0Atilde": -60,
  "Ugrave\0comma": -50,
  "Ugrave\0period": -50,
  "Uhungarumlaut\0A": -60,
  "Uhungarumlaut\0Aacute": -60,
  "Uhungarumlaut\0Abreve": -60,
  "Uhungarumlaut\0Acircumflex": -60,
  "Uhungarumlaut\0Adieresis": -60,
  "Uhungarumlaut\0Agrave": -60,
  "Uhungarumlaut\0Amacron": -60,
  "Uhungarumlaut\0Aogonek": -60,
  "Uhungarumlaut\0Aring": -60,
  "Uhungarumlaut\0Atilde": -60,
  "Uhungarumlaut\0comma": -50,
  "Uhungarumlaut\0period": -50,
  "Umacron\0A": -60,
  "Umacron\0Aacute": -60,
  "Umacron\0Abreve": -60,
  "Umacron\0Acircumflex": -60,
  "Umacron\0Adieresis": -60,
  "Umacron\0Agrave": -60,
  "Umacron\0Amacron": -60,
  "Umacron\0Aogonek": -60,
  "Umacron\0Aring": -60,
  "Umacron\0Atilde": -60,
  "Umacron\0comma": -50,
  "Umacron\0period": -50,
  "Uogonek\0A": -60,
  "Uogonek\0Aacute": -60,
  "Uogonek\0Abreve": -60,
  "Uogonek\0Acircumflex": -60,
  "Uogonek\0Adieresis": -60,
  "Uogonek\0Agrave": -60,
  "Uogonek\0Amacron": -60,
  "Uogonek\0Aogonek": -60,
  "Uogonek\0Aring": -60,
  "Uogonek\0Atilde": -60,
  "Uogonek\0comma": -50,
  "Uogonek\0period": -50,
  "Uring\0A": -60,
  "Uring\0Aacute": -60,
  "Uring\0Abreve": -60,
  "Uring\0Acircumflex": -60,
  "Uring\0Adieresis": -60,
  "Uring\0Agrave": -60,
  "Uring\0Amacron": -60,
  "Uring\0Aogonek": -60,
  "Uring\0Aring": -60,
  "Uring\0Atilde": -60,
  "Uring\0comma": -50,
  "Uring\0period": -50,
  "V\0A": -135,
  "V\0Aacute": -135,
  "V\0Abreve": -135,
  "V\0Acircumflex": -135,
  "V\0Adieresis": -135,
  "V\0Agrave": -135,
  "V\0Amacron": -135,
  "V\0Aogonek": -135,
  "V\0Aring": -135,
  "V\0Atilde": -135,
  "V\0G": -30,
  "V\0Gbreve": -30,
  "V\0Gcommaaccent": -30,
  "V\0O": -45,
  "V\0Oacute": -45,
  "V\0Ocircumflex": -45,
  "V\0Odieresis": -45,
  "V\0Ograve": -45,
  "V\0Ohungarumlaut": -45,
  "V\0Omacron": -45,
  "V\0Oslash": -45,
  "V\0Otilde": -45,
  "V\0a": -92,
  "V\0aacute": -92,
  "V\0abreve": -92,
  "V\0acircumflex": -92,
  "V\0adieresis": -92,
  "V\0agrave": -92,
  "V\0amacron": -92,
  "V\0aogonek": -92,
  "V\0aring": -92,
  "V\0atilde": -92,
  "V\0colon": -92,
  "V\0comma": -129,
  "V\0e": -100,
  "V\0eacute": -100,
  "V\0ecaron": -100,
  "V\0ecircumflex": -100,
  "V\0edieresis": -100,
  "V\0edotaccent": -100,
  "V\0egrave": -100,
  "V\0emacron": -100,
  "V\0eogonek": -100,
  "V\0hyphen": -74,
  "V\0i": -37,
  "V\0iacute": -37,
  "V\0icircumflex": -37,
  "V\0idieresis": -37,
  "V\0igrave": -37,
  "V\0imacron": -37,
  "V\0iogonek": -37,
  "V\0o": -100,
  "V\0oacute": -100,
  "V\0ocircumflex": -100,
  "V\0odieresis": -100,
  "V\0ograve": -100,
  "V\0ohungarumlaut": -100,
  "V\0omacron": -100,
  "V\0oslash": -100,
  "V\0otilde": -100,
  "V\0period": -145,
  "V\0semicolon": -92,
  "V\0u": -92,
  "V\0uacute": -92,
  "V\0ucircumflex": -92,
  "V\0udieresis": -92,
  "V\0ugrave": -92,
  "V\0uhungarumlaut": -92,
  "V\0umacron": -92,
  "V\0uogonek": -92,
  "V\0uring": -92,
  "W\0A": -120,
  "W\0Aacute": -120,
  "W\0Abreve": -120,
  "W\0Acircumflex": -120,
  "W\0Adieresis": -120,
  "W\0Agrave": -120,
  "W\0Amacron": -120,
  "W\0Aogonek": -120,
  "W\0Aring": -120,
  "W\0Atilde": -120,
  "W\0O": -10,
  "W\0Oacute": -10,
  "W\0Ocircumflex": -10,
  "W\0Odieresis": -10,
  "W\0Ograve": -10,
  "W\0Ohungarumlaut": -10,
  "W\0Omacron": -10,
  "W\0Oslash": -10,
  "W\0Otilde": -10,
  "W\0a": -65,
  "W\0aacute": -65,
  "W\0abreve": -65,
  "W\0acircumflex": -65,
  "W\0adieresis": -65,
  "W\0agrave": -65,
  "W\0amacron": -65,
  "W\0aogonek": -65,
  "W\0aring": -65,
  "W\0atilde": -65,
  "W\0colon": -55,
  "W\0comma": -92,
  "W\0e": -65,
  "W\0eacute": -65,
  "W\0ecaron": -65,
  "W\0ecircumflex": -65,
  "W\0edieresis": -65,
  "W\0edotaccent": -65,
  "W\0egrave": -65,
  "W\0emacron": -65,
  "W\0eogonek": -65,
  "W\0hyphen": -37,
  "W\0i": -18,
  "W\0iacute": -18,
  "W\0iogonek": -18,
  "W\0o": -75,
  "W\0oacute": -75,
  "W\0ocircumflex": -75,
  "W\0odieresis": -75,
  "W\0ograve": -75,
  "W\0ohungarumlaut": -75,
  "W\0omacron": -75,
  "W\0oslash": -75,
  "W\0otilde": -75,
  "W\0period": -92,
  "W\0semicolon": -55,
  "W\0u": -50,
  "W\0uacute": -50,
  "W\0ucircumflex": -50,
  "W\0udieresis": -50,
  "W\0ugrave": -50,
  "W\0uhungarumlaut": -50,
  "W\0umacron": -50,
  "W\0uogonek": -50,
  "W\0uring": -50,
  "W\0y": -60,
  "W\0yacute": -60,
  "W\0ydieresis": -60,
  "Y\0A": -110,
  "Y\0Aacute": -110,
  "Y\0Abreve": -110,
  "Y\0Acircumflex": -110,
  "Y\0Adieresis": -110,
  "Y\0Agrave": -110,
  "Y\0Amacron": -110,
  "Y\0Aogonek": -110,
  "Y\0Aring": -110,
  "Y\0Atilde": -110,
  "Y\0O": -35,
  "Y\0Oacute": -35,
  "Y\0Ocircumflex": -35,
  "Y\0Odieresis": -35,
  "Y\0Ograve": -35,
  "Y\0Ohungarumlaut": -35,
  "Y\0Omacron": -35,
  "Y\0Oslash": -35,
  "Y\0Otilde": -35,
  "Y\0a": -85,
  "Y\0aacute": -85,
  "Y\0abreve": -85,
  "Y\0acircumflex": -85,
  "Y\0adieresis": -85,
  "Y\0agrave": -85,
  "Y\0amacron": -85,
  "Y\0aogonek": -85,
  "Y\0aring": -85,
  "Y\0atilde": -85,
  "Y\0colon": -92,
  "Y\0comma": -92,
  "Y\0e": -111,
  "Y\0eacute": -111,
  "Y\0ecaron": -111,
  "Y\0ecircumflex": -111,
  "Y\0edieresis": -71,
  "Y\0edotaccent": -111,
  "Y\0egrave": -71,
  "Y\0emacron": -71,
  "Y\0eogonek": -111,
  "Y\0hyphen": -92,
  "Y\0i": -37,
  "Y\0iacute": -37,
  "Y\0iogonek": -37,
  "Y\0o": -111,
  "Y\0oacute": -111,
  "Y\0ocircumflex": -111,
  "Y\0odieresis": -111,
  "Y\0ograve": -111,
  "Y\0ohungarumlaut": -111,
  "Y\0omacron": -111,
  "Y\0oslash": -111,
  "Y\0otilde": -111,
  "Y\0period": -92,
  "Y\0semicolon": -92,
  "Y\0u": -92,
  "Y\0uacute": -92,
  "Y\0ucircumflex": -92,
  "Y\0udieresis": -92,
  "Y\0ugrave": -92,
  "Y\0uhungarumlaut": -92,
  "Y\0umacron": -92,
  "Y\0uogonek": -92,
  "Y\0uring": -92,
  "Yacute\0A": -110,
  "Yacute\0Aacute": -110,
  "Yacute\0Abreve": -110,
  "Yacute\0Acircumflex": -110,
  "Yacute\0Adieresis": -110,
  "Yacute\0Agrave": -110,
  "Yacute\0Amacron": -110,
  "Yacute\0Aogonek": -110,
  "Yacute\0Aring": -110,
  "Yacute\0Atilde": -110,
  "Yacute\0O": -35,
  "Yacute\0Oacute": -35,
  "Yacute\0Ocircumflex": -35,
  "Yacute\0Odieresis": -35,
  "Yacute\0Ograve": -35,
  "Yacute\0Ohungarumlaut": -35,
  "Yacute\0Omacron": -35,
  "Yacute\0Oslash": -35,
  "Yacute\0Otilde": -35,
  "Yacute\0a": -85,
  "Yacute\0aacute": -85,
  "Yacute\0abreve": -85,
  "Yacute\0acircumflex": -85,
  "Yacute\0adieresis": -85,
  "Yacute\0agrave": -85,
  "Yacute\0amacron": -85,
  "Yacute\0aogonek": -85,
  "Yacute\0aring": -85,
  "Yacute\0atilde": -85,
  "Yacute\0colon": -92,
  "Yacute\0comma": -92,
  "Yacute\0e": -111,
  "Yacute\0eacute": -111,
  "Yacute\0ecaron": -111,
  "Yacute\0ecircumflex": -111,
  "Yacute\0edieresis": -71,
  "Yacute\0edotaccent": -111,
  "Yacute\0egrave": -71,
  "Yacute\0emacron": -71,
  "Yacute\0eogonek": -111,
  "Yacute\0hyphen": -92,
  "Yacute\0i": -37,
  "Yacute\0iacute": -37,
  "Yacute\0iogonek": -37,
  "Yacute\0o": -111,
  "Yacute\0oacute": -111,
  "Yacute\0ocircumflex": -111,
  "Yacute\0odieresis": -111,
  "Yacute\0ograve": -111,
  "Yacute\0ohungarumlaut": -111,
  "Yacute\0omacron": -111,
  "Yacute\0oslash": -111,
  "Yacute\0otilde": -111,
  "Yacute\0period": -92,
  "Yacute\0semicolon": -92,
  "Yacute\0u": -92,
  "Yacute\0uacute": -92,
  "Yacute\0ucircumflex": -92,
  "Yacute\0udieresis": -92,
  "Yacute\0ugrave": -92,
  "Yacute\0uhungarumlaut": -92,
  "Yacute\0umacron": -92,
  "Yacute\0uogonek": -92,
  "Yacute\0uring": -92,
  "Ydieresis\0A": -110,
  "Ydieresis\0Aacute": -110,
  "Ydieresis\0Abreve": -110,
  "Ydieresis\0Acircumflex": -110,
  "Ydieresis\0Adieresis": -110,
  "Ydieresis\0Agrave": -110,
  "Ydieresis\0Amacron": -110,
  "Ydieresis\0Aogonek": -110,
  "Ydieresis\0Aring": -110,
  "Ydieresis\0Atilde": -110,
  "Ydieresis\0O": -35,
  "Ydieresis\0Oacute": -35,
  "Ydieresis\0Ocircumflex": -35,
  "Ydieresis\0Odieresis": -35,
  "Ydieresis\0Ograve": -35,
  "Ydieresis\0Ohungarumlaut": -35,
  "Ydieresis\0Omacron": -35,
  "Ydieresis\0Oslash": -35,
  "Ydieresis\0Otilde": -35,
  "Ydieresis\0a": -85,
  "Ydieresis\0aacute": -85,
  "Ydieresis\0abreve": -85,
  "Ydieresis\0acircumflex": -85,
  "Ydieresis\0adieresis": -85,
  "Ydieresis\0agrave": -85,
  "Ydieresis\0amacron": -85,
  "Ydieresis\0aogonek": -85,
  "Ydieresis\0aring": -85,
  "Ydieresis\0atilde": -85,
  "Ydieresis\0colon": -92,
  "Ydieresis\0comma": -92,
  "Ydieresis\0e": -111,
  "Ydieresis\0eacute": -111,
  "Ydieresis\0ecaron": -111,
  "Ydieresis\0ecircumflex": -111,
  "Ydieresis\0edieresis": -71,
  "Ydieresis\0edotaccent": -111,
  "Ydieresis\0egrave": -71,
  "Ydieresis\0emacron": -71,
  "Ydieresis\0eogonek": -111,
  "Ydieresis\0hyphen": -92,
  "Ydieresis\0i": -37,
  "Ydieresis\0iacute": -37,
  "Ydieresis\0iogonek": -37,
  "Ydieresis\0o": -111,
  "Ydieresis\0oacute": -111,
  "Ydieresis\0ocircumflex": -111,
  "Ydieresis\0odieresis": -111,
  "Ydieresis\0ograve": -111,
  "Ydieresis\0ohungarumlaut": -111,
  "Ydieresis\0omacron": -111,
  "Ydieresis\0oslash": -111,
  "Ydieresis\0otilde": -111,
  "Ydieresis\0period": -92,
  "Ydieresis\0semicolon": -92,
  "Ydieresis\0u": -92,
  "Ydieresis\0uacute": -92,
  "Ydieresis\0ucircumflex": -92,
  "Ydieresis\0udieresis": -92,
  "Ydieresis\0ugrave": -92,
  "Ydieresis\0uhungarumlaut": -92,
  "Ydieresis\0umacron": -92,
  "Ydieresis\0uogonek": -92,
  "Ydieresis\0uring": -92,
  "a\0v": -25,
  "aacute\0v": -25,
  "abreve\0v": -25,
  "acircumflex\0v": -25,
  "adieresis\0v": -25,
  "agrave\0v": -25,
  "amacron\0v": -25,
  "aogonek\0v": -25,
  "aring\0v": -25,
  "atilde\0v": -25,
  "b\0b": -10,
  "b\0period": -40,
  "b\0u": -20,
  "b\0uacute": -20,
  "b\0ucircumflex": -20,
  "b\0udieresis": -20,
  "b\0ugrave": -20,
  "b\0uhungarumlaut": -20,
  "b\0umacron": -20,
  "b\0uogonek": -20,
  "b\0uring": -20,
  "b\0v": -15,
  "comma\0quotedblright": -45,
  "comma\0quoteright": -55,
  "d\0w": -15,
  "dcroat\0w": -15,
  "e\0v": -15,
  "eacute\0v": -15,
  "ecaron\0v": -15,
  "ecircumflex\0v": -15,
  "edieresis\0v": -15,
  "edotaccent\0v": -15,
  "egrave\0v": -15,
  "emacron\0v": -15,
  "eogonek\0v": -15,
  "f\0comma": -15,
  "f\0dotlessi": -35,
  "f\0i": -25,
  "f\0o": -25,
  "f\0oacute": -25,
  "f\0ocircumflex": -25,
  "f\0odieresis": -25,
  "f\0ograve": -25,
  "f\0ohungarumlaut": -25,
  "f\0omacron": -25,
  "f\0oslash": -25,
  "f\0otilde": -25,
  "f\0period": -15,
  "f\0quotedblright": 50,
  "f\0quoteright": 55,
  "g\0period": -15,
  "gbreve\0period": -15,
  "gcommaaccent\0period": -15,
  "h\0y": -15,
  "h\0yacute": -15,
  "h\0ydieresis": -15,
  "i\0v": -10,
  "iacute\0v": -10,
  "icircumflex\0v": -10,
  "idieresis\0v": -10,
  "igrave\0v": -10,
  "imacron\0v": -10,
  "iogonek\0v": -10,
  "k\0e": -10,
  "k\0eacute": -10,
  "k\0ecaron": -10,
  "k\0ecircumflex": -10,
  "k\0edieresis": -10,
  "k\0edotaccent": -10,
  "k\0egrave": -10,
  "k\0emacron": -10,
  "k\0eogonek": -10,
  "k\0o": -15,
  "k\0oacute": -15,
  "k\0ocircumflex": -15,
  "k\0odieresis": -15,
  "k\0ograve": -15,
  "k\0ohungarumlaut": -15,
  "k\0omacron": -15,
  "k\0oslash": -15,
  "k\0otilde": -15,
  "k\0y": -15,
  "k\0yacute": -15,
  "k\0ydieresis": -15,
  "kcommaaccent\0e": -10,
  "kcommaaccent\0eacute": -10,
  "kcommaaccent\0ecaron": -10,
  "kcommaaccent\0ecircumflex": -10,
  "kcommaaccent\0edieresis": -10,
  "kcommaaccent\0edotaccent": -10,
  "kcommaaccent\0egrave": -10,
  "kcommaaccent\0emacron": -10,
  "kcommaaccent\0eogonek": -10,
  "kcommaaccent\0o": -15,
  "kcommaaccent\0oacute": -15,
  "kcommaaccent\0ocircumflex": -15,
  "kcommaaccent\0odieresis": -15,
  "kcommaaccent\0ograve": -15,
  "kcommaaccent\0ohungarumlaut": -15,
  "kcommaaccent\0omacron": -15,
  "kcommaaccent\0oslash": -15,
  "kcommaaccent\0otilde": -15,
  "kcommaaccent\0y": -15,
  "kcommaaccent\0yacute": -15,
  "kcommaaccent\0ydieresis": -15,
  "n\0v": -40,
  "nacute\0v": -40,
  "ncaron\0v": -40,
  "ncommaaccent\0v": -40,
  "ntilde\0v": -40,
  "o\0v": -10,
  "o\0w": -10,
  "oacute\0v": -10,
  "oacute\0w": -10,
  "ocircumflex\0v": -10,
  "ocircumflex\0w": -10,
  "odieresis\0v": -10,
  "odieresis\0w": -10,
  "ograve\0v": -10,
  "ograve\0w": -10,
  "ohungarumlaut\0v": -10,
  "ohungarumlaut\0w": -10,
  "omacron\0v": -10,
  "omacron\0w": -10,
  "oslash\0v": -10,
  "oslash\0w": -10,
  "otilde\0v": -10,
  "otilde\0w": -10,
  "period\0quotedblright": -55,
  "period\0quoteright": -55,
  "quotedblleft\0A": -10,
  "quotedblleft\0Aacute": -10,
  "quotedblleft\0Abreve": -10,
  "quotedblleft\0Acircumflex": -10,
  "quotedblleft\0Adieresis": -10,
  "quotedblleft\0Agrave": -10,
  "quotedblleft\0Amacron": -10,
  "quotedblleft\0Aogonek": -10,
  "quotedblleft\0Aring": -10,
  "quotedblleft\0Atilde": -10,
  "quoteleft\0A": -10,
  "quoteleft\0Aacute": -10,
  "quoteleft\0Abreve": -10,
  "quoteleft\0Acircumflex": -10,
  "quoteleft\0Adieresis": -10,
  "quoteleft\0Agrave": -10,
  "quoteleft\0Amacron": -10,
  "quoteleft\0Aogonek": -10,
  "quoteleft\0Aring": -10,
  "quoteleft\0Atilde": -10,
  "quoteleft\0quoteleft": -63,
  "quoteright\0d": -20,
  "quoteright\0dcroat": -20,
  "quoteright\0quoteright": -63,
  "quoteright\0r": -20,
  "quoteright\0racute": -20,
  "quoteright\0rcaron": -20,
  "quoteright\0rcommaaccent": -20,
  "quoteright\0s": -37,
  "quoteright\0sacute": -37,
  "quoteright\0scaron": -37,
  "quoteright\0scedilla": -37,
  "quoteright\0scommaaccent": -37,
  "quoteright\0space": -74,
  "quoteright\0v": -20,
  "r\0c": -18,
  "r\0cacute": -18,
  "r\0ccaron": -18,
  "r\0ccedilla": -18,
  "r\0comma": -92,
  "r\0e": -18,
  "r\0eacute": -18,
  "r\0ecaron": -18,
  "r\0ecircumflex": -18,
  "r\0edieresis": -18,
  "r\0edotaccent": -18,
  "r\0egrave": -18,
  "r\0emacron": -18,
  "r\0eogonek": -18,
  "r\0g": -10,
  "r\0gbreve": -10,
  "r\0gcommaaccent": -10,
  "r\0hyphen": -37,
  "r\0n": -15,
  "r\0nacute": -15,
  "r\0ncaron": -15,
  "r\0ncommaaccent": -15,
  "r\0ntilde": -15,
  "r\0o": -18,
  "r\0oacute": -18,
  "r\0ocircumflex": -18,
  "r\0odieresis": -18,
  "r\0ograve": -18,
  "r\0ohungarumlaut": -18,
  "r\0omacron": -18,
  "r\0oslash": -18,
  "r\0otilde": -18,
  "r\0p": -10,
  "r\0period": -100,
  "r\0q": -18,
  "r\0v": -10,
  "racute\0c": -18,
  "racute\0cacute": -18,
  "racute\0ccaron": -18,
  "racute\0ccedilla": -18,
  "racute\0comma": -92,
  "racute\0e": -18,
  "racute\0eacute": -18,
  "racute\0ecaron": -18,
  "racute\0ecircumflex": -18,
  "racute\0edieresis": -18,
  "racute\0edotaccent": -18,
  "racute\0egrave": -18,
  "racute\0emacron": -18,
  "racute\0eogonek": -18,
  "racute\0g": -10,
  "racute\0gbreve": -10,
  "racute\0gcommaaccent": -10,
  "racute\0hyphen": -37,
  "racute\0n": -15,
  "racute\0nacute": -15,
  "racute\0ncaron": -15,
  "racute\0ncommaaccent": -15,
  "racute\0ntilde": -15,
  "racute\0o": -18,
  "racute\0oacute": -18,
  "racute\0ocircumflex": -18,
  "racute\0odieresis": -18,
  "racute\0ograve": -18,
  "racute\0ohungarumlaut": -18,
  "racute\0omacron": -18,
  "racute\0oslash": -18,
  "racute\0otilde": -18,
  "racute\0p": -10,
  "racute\0period": -100,
  "racute\0q": -18,
  "racute\0v": -10,
  "rcaron\0c": -18,
  "rcaron\0cacute": -18,
  "rcaron\0ccaron": -18,
  "rcaron\0ccedilla": -18,
  "rcaron\0comma": -92,
  "rcaron\0e": -18,
  "rcaron\0eacute": -18,
  "rcaron\0ecaron": -18,
  "rcaron\0ecircumflex": -18,
  "rcaron\0edieresis": -18,
  "rcaron\0edotaccent": -18,
  "rcaron\0egrave": -18,
  "rcaron\0emacron": -18,
  "rcaron\0eogonek": -18,
  "rcaron\0g": -10,
  "rcaron\0gbreve": -10,
  "rcaron\0gcommaaccent": -10,
  "rcaron\0hyphen": -37,
  "rcaron\0n": -15,
  "rcaron\0nacute": -15,
  "rcaron\0ncaron": -15,
  "rcaron\0ncommaaccent": -15,
  "rcaron\0ntilde": -15,
  "rcaron\0o": -18,
  "rcaron\0oacute": -18,
  "rcaron\0ocircumflex": -18,
  "rcaron\0odieresis": -18,
  "rcaron\0ograve": -18,
  "rcaron\0ohungarumlaut": -18,
  "rcaron\0omacron": -18,
  "rcaron\0oslash": -18,
  "rcaron\0otilde": -18,
  "rcaron\0p": -10,
  "rcaron\0period": -100,
  "rcaron\0q": -18,
  "rcaron\0v": -10,
  "rcommaaccent\0c": -18,
  "rcommaaccent\0cacute": -18,
  "rcommaaccent\0ccaron": -18,
  "rcommaaccent\0ccedilla": -18,
  "rcommaaccent\0comma": -92,
  "rcommaaccent\0e": -18,
  "rcommaaccent\0eacute": -18,
  "rcommaaccent\0ecaron": -18,
  "rcommaaccent\0ecircumflex": -18,
  "rcommaaccent\0edieresis": -18,
  "rcommaaccent\0edotaccent": -18,
  "rcommaaccent\0egrave": -18,
  "rcommaaccent\0emacron": -18,
  "rcommaaccent\0eogonek": -18,
  "rcommaaccent\0g": -10,
  "rcommaaccent\0gbreve": -10,
  "rcommaaccent\0gcommaaccent": -10,
  "rcommaaccent\0hyphen": -37,
  "rcommaaccent\0n": -15,
  "rcommaaccent\0nacute": -15,
  "rcommaaccent\0ncaron": -15,
  "rcommaaccent\0ncommaaccent": -15,
  "rcommaaccent\0ntilde": -15,
  "rcommaaccent\0o": -18,
  "rcommaaccent\0oacute": -18,
  "rcommaaccent\0ocircumflex": -18,
  "rcommaaccent\0odieresis": -18,
  "rcommaaccent\0ograve": -18,
  "rcommaaccent\0ohungarumlaut": -18,
  "rcommaaccent\0omacron": -18,
  "rcommaaccent\0oslash": -18,
  "rcommaaccent\0otilde": -18,
  "rcommaaccent\0p": -10,
  "rcommaaccent\0period": -100,
  "rcommaaccent\0q": -18,
  "rcommaaccent\0v": -10,
  "space\0A": -55,
  "space\0Aacute": -55,
  "space\0Abreve": -55,
  "space\0Acircumflex": -55,
  "space\0Adieresis": -55,
  "space\0Agrave": -55,
  "space\0Amacron": -55,
  "space\0Aogonek": -55,
  "space\0Aring": -55,
  "space\0Atilde": -55,
  "space\0T": -30,
  "space\0Tcaron": -30,
  "space\0Tcommaaccent": -30,
  "space\0V": -45,
  "space\0W": -30,
  "space\0Y": -55,
  "space\0Yacute": -55,
  "space\0Ydieresis": -55,
  "v\0a": -10,
  "v\0aacute": -10,
  "v\0abreve": -10,
  "v\0acircumflex": -10,
  "v\0adieresis": -10,
  "v\0agrave": -10,
  "v\0amacron": -10,
  "v\0aogonek": -10,
  "v\0aring": -10,
  "v\0atilde": -10,
  "v\0comma": -55,
  "v\0e": -10,
  "v\0eacute": -10,
  "v\0ecaron": -10,
  "v\0ecircumflex": -10,
  "v\0edieresis": -10,
  "v\0edotaccent": -10,
  "v\0egrave": -10,
  "v\0emacron": -10,
  "v\0eogonek": -10,
  "v\0o": -10,
  "v\0oacute": -10,
  "v\0ocircumflex": -10,
  "v\0odieresis": -10,
  "v\0ograve": -10,
  "v\0ohungarumlaut": -10,
  "v\0omacron": -10,
  "v\0oslash": -10,
  "v\0otilde": -10,
  "v\0period": -70,
  "w\0comma": -55,
  "w\0o": -10,
  "w\0oacute": -10,
  "w\0ocircumflex": -10,
  "w\0odieresis": -10,
  "w\0ograve": -10,
  "w\0ohungarumlaut": -10,
  "w\0omacron": -10,
  "w\0oslash": -10,
  "w\0otilde": -10,
  "w\0period": -70,
  "y\0comma": -55,
  "y\0e": -10,
  "y\0eacute": -10,
  "y\0ecaron": -10,
  "y\0ecircumflex": -10,
  "y\0edieresis": -10,
  "y\0edotaccent": -10,
  "y\0egrave": -10,
  "y\0emacron": -10,
  "y\0eogonek": -10,
  "y\0o": -25,
  "y\0oacute": -25,
  "y\0ocircumflex": -25,
  "y\0odieresis": -25,
  "y\0ograve": -25,
  "y\0ohungarumlaut": -25,
  "y\0omacron": -25,
  "y\0oslash": -25,
  "y\0otilde": -25,
  "y\0period": -70,
  "yacute\0comma": -55,
  "yacute\0e": -10,
  "yacute\0eacute": -10,
  "yacute\0ecaron": -10,
  "yacute\0ecircumflex": -10,
  "yacute\0edieresis": -10,
  "yacute\0edotaccent": -10,
  "yacute\0egrave": -10,
  "yacute\0emacron": -10,
  "yacute\0eogonek": -10,
  "yacute\0o": -25,
  "yacute\0oacute": -25,
  "yacute\0ocircumflex": -25,
  "yacute\0odieresis": -25,
  "yacute\0ograve": -25,
  "yacute\0ohungarumlaut": -25,
  "yacute\0omacron": -25,
  "yacute\0oslash": -25,
  "yacute\0otilde": -25,
  "yacute\0period": -70,
  "ydieresis\0comma": -55,
  "ydieresis\0e": -10,
  "ydieresis\0eacute": -10,
  "ydieresis\0ecaron": -10,
  "ydieresis\0ecircumflex": -10,
  "ydieresis\0edieresis": -10,
  "ydieresis\0edotaccent": -10,
  "ydieresis\0egrave": -10,
  "ydieresis\0emacron": -10,
  "ydieresis\0eogonek": -10,
  "ydieresis\0o": -25,
  "ydieresis\0oacute": -25,
  "ydieresis\0ocircumflex": -25,
  "ydieresis\0odieresis": -25,
  "ydieresis\0ograve": -25,
  "ydieresis\0ohungarumlaut": -25,
  "ydieresis\0omacron": -25,
  "ydieresis\0oslash": -25,
  "ydieresis\0otilde": -25,
  "ydieresis\0period": -70
};
var TimesBold = {
  attributes: attributes$1,
  glyphWidths: glyphWidths$1,
  kernPairs: kernPairs$1
};
var attributes = {
  Comment: ["Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.", "Creation Date: Thu May  1 12:56:55 1997", "UniqueID 43067", "VMusage 47727 58752"],
  FontName: "Times-Italic",
  FullName: "Times Italic",
  FamilyName: "Times",
  Weight: "Medium",
  ItalicAngle: "-15.5",
  IsFixedPitch: "false",
  CharacterSet: "ExtendedRoman",
  FontBBox: "-169 -217 1010 883 ",
  UnderlinePosition: "-100",
  UnderlineThickness: "50",
  Version: "002.000",
  Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
  EncodingScheme: "AdobeStandardEncoding",
  CapHeight: "653",
  XHeight: "441",
  Ascender: "683",
  Descender: "-217",
  StdHW: "32",
  StdVW: "76"
};
var glyphWidths = {
  space: 250,
  exclam: 333,
  quotedbl: 420,
  numbersign: 500,
  dollar: 500,
  percent: 833,
  ampersand: 778,
  quoteright: 333,
  parenleft: 333,
  parenright: 333,
  asterisk: 500,
  plus: 675,
  comma: 250,
  hyphen: 333,
  period: 250,
  slash: 278,
  zero: 500,
  one: 500,
  two: 500,
  three: 500,
  four: 500,
  five: 500,
  six: 500,
  seven: 500,
  eight: 500,
  nine: 500,
  colon: 333,
  semicolon: 333,
  less: 675,
  equal: 675,
  greater: 675,
  question: 500,
  at: 920,
  A: 611,
  B: 611,
  C: 667,
  D: 722,
  E: 611,
  F: 611,
  G: 722,
  H: 722,
  I: 333,
  J: 444,
  K: 667,
  L: 556,
  M: 833,
  N: 667,
  O: 722,
  P: 611,
  Q: 722,
  R: 611,
  S: 500,
  T: 556,
  U: 722,
  V: 611,
  W: 833,
  X: 611,
  Y: 556,
  Z: 556,
  bracketleft: 389,
  backslash: 278,
  bracketright: 389,
  asciicircum: 422,
  underscore: 500,
  quoteleft: 333,
  a: 500,
  b: 500,
  c: 444,
  d: 500,
  e: 444,
  f: 278,
  g: 500,
  h: 500,
  i: 278,
  j: 278,
  k: 444,
  l: 278,
  m: 722,
  n: 500,
  o: 500,
  p: 500,
  q: 500,
  r: 389,
  s: 389,
  t: 278,
  u: 500,
  v: 444,
  w: 667,
  x: 444,
  y: 444,
  z: 389,
  braceleft: 400,
  bar: 275,
  braceright: 400,
  asciitilde: 541,
  exclamdown: 389,
  cent: 500,
  sterling: 500,
  fraction: 167,
  yen: 500,
  florin: 500,
  section: 500,
  currency: 500,
  quotesingle: 214,
  quotedblleft: 556,
  guillemotleft: 500,
  guilsinglleft: 333,
  guilsinglright: 333,
  fi: 500,
  fl: 500,
  endash: 500,
  dagger: 500,
  daggerdbl: 500,
  periodcentered: 250,
  paragraph: 523,
  bullet: 350,
  quotesinglbase: 333,
  quotedblbase: 556,
  quotedblright: 556,
  guillemotright: 500,
  ellipsis: 889,
  perthousand: 1000,
  questiondown: 500,
  grave: 333,
  acute: 333,
  circumflex: 333,
  tilde: 333,
  macron: 333,
  breve: 333,
  dotaccent: 333,
  dieresis: 333,
  ring: 333,
  cedilla: 333,
  hungarumlaut: 333,
  ogonek: 333,
  caron: 333,
  emdash: 889,
  AE: 889,
  ordfeminine: 276,
  Lslash: 556,
  Oslash: 722,
  OE: 944,
  ordmasculine: 310,
  ae: 667,
  dotlessi: 278,
  lslash: 278,
  oslash: 500,
  oe: 667,
  germandbls: 500,
  Idieresis: 333,
  eacute: 444,
  abreve: 500,
  uhungarumlaut: 500,
  ecaron: 444,
  Ydieresis: 556,
  divide: 675,
  Yacute: 556,
  Acircumflex: 611,
  aacute: 500,
  Ucircumflex: 722,
  yacute: 444,
  scommaaccent: 389,
  ecircumflex: 444,
  Uring: 722,
  Udieresis: 722,
  aogonek: 500,
  Uacute: 722,
  uogonek: 500,
  Edieresis: 611,
  Dcroat: 722,
  commaaccent: 250,
  copyright: 760,
  Emacron: 611,
  ccaron: 444,
  aring: 500,
  Ncommaaccent: 667,
  lacute: 278,
  agrave: 500,
  Tcommaaccent: 556,
  Cacute: 667,
  atilde: 500,
  Edotaccent: 611,
  scaron: 389,
  scedilla: 389,
  iacute: 278,
  lozenge: 471,
  Rcaron: 611,
  Gcommaaccent: 722,
  ucircumflex: 500,
  acircumflex: 500,
  Amacron: 611,
  rcaron: 389,
  ccedilla: 444,
  Zdotaccent: 556,
  Thorn: 611,
  Omacron: 722,
  Racute: 611,
  Sacute: 500,
  dcaron: 544,
  Umacron: 722,
  uring: 500,
  threesuperior: 300,
  Ograve: 722,
  Agrave: 611,
  Abreve: 611,
  multiply: 675,
  uacute: 500,
  Tcaron: 556,
  partialdiff: 476,
  ydieresis: 444,
  Nacute: 667,
  icircumflex: 278,
  Ecircumflex: 611,
  adieresis: 500,
  edieresis: 444,
  cacute: 444,
  nacute: 500,
  umacron: 500,
  Ncaron: 667,
  Iacute: 333,
  plusminus: 675,
  brokenbar: 275,
  registered: 760,
  Gbreve: 722,
  Idotaccent: 333,
  summation: 600,
  Egrave: 611,
  racute: 389,
  omacron: 500,
  Zacute: 556,
  Zcaron: 556,
  greaterequal: 549,
  Eth: 722,
  Ccedilla: 667,
  lcommaaccent: 278,
  tcaron: 300,
  eogonek: 444,
  Uogonek: 722,
  Aacute: 611,
  Adieresis: 611,
  egrave: 444,
  zacute: 389,
  iogonek: 278,
  Oacute: 722,
  oacute: 500,
  amacron: 500,
  sacute: 389,
  idieresis: 278,
  Ocircumflex: 722,
  Ugrave: 722,
  Delta: 612,
  thorn: 500,
  twosuperior: 300,
  Odieresis: 722,
  mu: 500,
  igrave: 278,
  ohungarumlaut: 500,
  Eogonek: 611,
  dcroat: 500,
  threequarters: 750,
  Scedilla: 500,
  lcaron: 300,
  Kcommaaccent: 667,
  Lacute: 556,
  trademark: 980,
  edotaccent: 444,
  Igrave: 333,
  Imacron: 333,
  Lcaron: 611,
  onehalf: 750,
  lessequal: 549,
  ocircumflex: 500,
  ntilde: 500,
  Uhungarumlaut: 722,
  Eacute: 611,
  emacron: 444,
  gbreve: 500,
  onequarter: 750,
  Scaron: 500,
  Scommaaccent: 500,
  Ohungarumlaut: 722,
  degree: 400,
  ograve: 500,
  Ccaron: 667,
  ugrave: 500,
  radical: 453,
  Dcaron: 722,
  rcommaaccent: 389,
  Ntilde: 667,
  otilde: 500,
  Rcommaaccent: 611,
  Lcommaaccent: 556,
  Atilde: 611,
  Aogonek: 611,
  Aring: 611,
  Otilde: 722,
  zdotaccent: 389,
  Ecaron: 611,
  Iogonek: 333,
  kcommaaccent: 444,
  minus: 675,
  Icircumflex: 333,
  ncaron: 500,
  tcommaaccent: 278,
  logicalnot: 675,
  odieresis: 500,
  udieresis: 500,
  notequal: 549,
  gcommaaccent: 500,
  eth: 500,
  zcaron: 389,
  ncommaaccent: 500,
  onesuperior: 300,
  imacron: 278,
  Euro: 500
};
var kernPairs = {
  "A\0C": -30,
  "A\0Cacute": -30,
  "A\0Ccaron": -30,
  "A\0Ccedilla": -30,
  "A\0G": -35,
  "A\0Gbreve": -35,
  "A\0Gcommaaccent": -35,
  "A\0O": -40,
  "A\0Oacute": -40,
  "A\0Ocircumflex": -40,
  "A\0Odieresis": -40,
  "A\0Ograve": -40,
  "A\0Ohungarumlaut": -40,
  "A\0Omacron": -40,
  "A\0Oslash": -40,
  "A\0Otilde": -40,
  "A\0Q": -40,
  "A\0T": -37,
  "A\0Tcaron": -37,
  "A\0Tcommaaccent": -37,
  "A\0U": -50,
  "A\0Uacute": -50,
  "A\0Ucircumflex": -50,
  "A\0Udieresis": -50,
  "A\0Ugrave": -50,
  "A\0Uhungarumlaut": -50,
  "A\0Umacron": -50,
  "A\0Uogonek": -50,
  "A\0Uring": -50,
  "A\0V": -105,
  "A\0W": -95,
  "A\0Y": -55,
  "A\0Yacute": -55,
  "A\0Ydieresis": -55,
  "A\0quoteright": -37,
  "A\0u": -20,
  "A\0uacute": -20,
  "A\0ucircumflex": -20,
  "A\0udieresis": -20,
  "A\0ugrave": -20,
  "A\0uhungarumlaut": -20,
  "A\0umacron": -20,
  "A\0uogonek": -20,
  "A\0uring": -20,
  "A\0v": -55,
  "A\0w": -55,
  "A\0y": -55,
  "A\0yacute": -55,
  "A\0ydieresis": -55,
  "Aacute\0C": -30,
  "Aacute\0Cacute": -30,
  "Aacute\0Ccaron": -30,
  "Aacute\0Ccedilla": -30,
  "Aacute\0G": -35,
  "Aacute\0Gbreve": -35,
  "Aacute\0Gcommaaccent": -35,
  "Aacute\0O": -40,
  "Aacute\0Oacute": -40,
  "Aacute\0Ocircumflex": -40,
  "Aacute\0Odieresis": -40,
  "Aacute\0Ograve": -40,
  "Aacute\0Ohungarumlaut": -40,
  "Aacute\0Omacron": -40,
  "Aacute\0Oslash": -40,
  "Aacute\0Otilde": -40,
  "Aacute\0Q": -40,
  "Aacute\0T": -37,
  "Aacute\0Tcaron": -37,
  "Aacute\0Tcommaaccent": -37,
  "Aacute\0U": -50,
  "Aacute\0Uacute": -50,
  "Aacute\0Ucircumflex": -50,
  "Aacute\0Udieresis": -50,
  "Aacute\0Ugrave": -50,
  "Aacute\0Uhungarumlaut": -50,
  "Aacute\0Umacron": -50,
  "Aacute\0Uogonek": -50,
  "Aacute\0Uring": -50,
  "Aacute\0V": -105,
  "Aacute\0W": -95,
  "Aacute\0Y": -55,
  "Aacute\0Yacute": -55,
  "Aacute\0Ydieresis": -55,
  "Aacute\0quoteright": -37,
  "Aacute\0u": -20,
  "Aacute\0uacute": -20,
  "Aacute\0ucircumflex": -20,
  "Aacute\0udieresis": -20,
  "Aacute\0ugrave": -20,
  "Aacute\0uhungarumlaut": -20,
  "Aacute\0umacron": -20,
  "Aacute\0uogonek": -20,
  "Aacute\0uring": -20,
  "Aacute\0v": -55,
  "Aacute\0w": -55,
  "Aacute\0y": -55,
  "Aacute\0yacute": -55,
  "Aacute\0ydieresis": -55,
  "Abreve\0C": -30,
  "Abreve\0Cacute": -30,
  "Abreve\0Ccaron": -30,
  "Abreve\0Ccedilla": -30,
  "Abreve\0G": -35,
  "Abreve\0Gbreve": -35,
  "Abreve\0Gcommaaccent": -35,
  "Abreve\0O": -40,
  "Abreve\0Oacute": -40,
  "Abreve\0Ocircumflex": -40,
  "Abreve\0Odieresis": -40,
  "Abreve\0Ograve": -40,
  "Abreve\0Ohungarumlaut": -40,
  "Abreve\0Omacron": -40,
  "Abreve\0Oslash": -40,
  "Abreve\0Otilde": -40,
  "Abreve\0Q": -40,
  "Abreve\0T": -37,
  "Abreve\0Tcaron": -37,
  "Abreve\0Tcommaaccent": -37,
  "Abreve\0U": -50,
  "Abreve\0Uacute": -50,
  "Abreve\0Ucircumflex": -50,
  "Abreve\0Udieresis": -50,
  "Abreve\0Ugrave": -50,
  "Abreve\0Uhungarumlaut": -50,
  "Abreve\0Umacron": -50,
  "Abreve\0Uogonek": -50,
  "Abreve\0Uring": -50,
  "Abreve\0V": -105,
  "Abreve\0W": -95,
  "Abreve\0Y": -55,
  "Abreve\0Yacute": -55,
  "Abreve\0Ydieresis": -55,
  "Abreve\0quoteright": -37,
  "Abreve\0u": -20,
  "Abreve\0uacute": -20,
  "Abreve\0ucircumflex": -20,
  "Abreve\0udieresis": -20,
  "Abreve\0ugrave": -20,
  "Abreve\0uhungarumlaut": -20,
  "Abreve\0umacron": -20,
  "Abreve\0uogonek": -20,
  "Abreve\0uring": -20,
  "Abreve\0v": -55,
  "Abreve\0w": -55,
  "Abreve\0y": -55,
  "Abreve\0yacute": -55,
  "Abreve\0ydieresis": -55,
  "Acircumflex\0C": -30,
  "Acircumflex\0Cacute": -30,
  "Acircumflex\0Ccaron": -30,
  "Acircumflex\0Ccedilla": -30,
  "Acircumflex\0G": -35,
  "Acircumflex\0Gbreve": -35,
  "Acircumflex\0Gcommaaccent": -35,
  "Acircumflex\0O": -40,
  "Acircumflex\0Oacute": -40,
  "Acircumflex\0Ocircumflex": -40,
  "Acircumflex\0Odieresis": -40,
  "Acircumflex\0Ograve": -40,
  "Acircumflex\0Ohungarumlaut": -40,
  "Acircumflex\0Omacron": -40,
  "Acircumflex\0Oslash": -40,
  "Acircumflex\0Otilde": -40,
  "Acircumflex\0Q": -40,
  "Acircumflex\0T": -37,
  "Acircumflex\0Tcaron": -37,
  "Acircumflex\0Tcommaaccent": -37,
  "Acircumflex\0U": -50,
  "Acircumflex\0Uacute": -50,
  "Acircumflex\0Ucircumflex": -50,
  "Acircumflex\0Udieresis": -50,
  "Acircumflex\0Ugrave": -50,
  "Acircumflex\0Uhungarumlaut": -50,
  "Acircumflex\0Umacron": -50,
  "Acircumflex\0Uogonek": -50,
  "Acircumflex\0Uring": -50,
  "Acircumflex\0V": -105,
  "Acircumflex\0W": -95,
  "Acircumflex\0Y": -55,
  "Acircumflex\0Yacute": -55,
  "Acircumflex\0Ydieresis": -55,
  "Acircumflex\0quoteright": -37,
  "Acircumflex\0u": -20,
  "Acircumflex\0uacute": -20,
  "Acircumflex\0ucircumflex": -20,
  "Acircumflex\0udieresis": -20,
  "Acircumflex\0ugrave": -20,
  "Acircumflex\0uhungarumlaut": -20,
  "Acircumflex\0umacron": -20,
  "Acircumflex\0uogonek": -20,
  "Acircumflex\0uring": -20,
  "Acircumflex\0v": -55,
  "Acircumflex\0w": -55,
  "Acircumflex\0y": -55,
  "Acircumflex\0yacute": -55,
  "Acircumflex\0ydieresis": -55,
  "Adieresis\0C": -30,
  "Adieresis\0Cacute": -30,
  "Adieresis\0Ccaron": -30,
  "Adieresis\0Ccedilla": -30,
  "Adieresis\0G": -35,
  "Adieresis\0Gbreve": -35,
  "Adieresis\0Gcommaaccent": -35,
  "Adieresis\0O": -40,
  "Adieresis\0Oacute": -40,
  "Adieresis\0Ocircumflex": -40,
  "Adieresis\0Odieresis": -40,
  "Adieresis\0Ograve": -40,
  "Adieresis\0Ohungarumlaut": -40,
  "Adieresis\0Omacron": -40,
  "Adieresis\0Oslash": -40,
  "Adieresis\0Otilde": -40,
  "Adieresis\0Q": -40,
  "Adieresis\0T": -37,
  "Adieresis\0Tcaron": -37,
  "Adieresis\0Tcommaaccent": -37,
  "Adieresis\0U": -50,
  "Adieresis\0Uacute": -50,
  "Adieresis\0Ucircumflex": -50,
  "Adieresis\0Udieresis": -50,
  "Adieresis\0Ugrave": -50,
  "Adieresis\0Uhungarumlaut": -50,
  "Adieresis\0Umacron": -50,
  "Adieresis\0Uogonek": -50,
  "Adieresis\0Uring": -50,
  "Adieresis\0V": -105,
  "Adieresis\0W": -95,
  "Adieresis\0Y": -55,
  "Adieresis\0Yacute": -55,
  "Adieresis\0Ydieresis": -55,
  "Adieresis\0quoteright": -37,
  "Adieresis\0u": -20,
  "Adieresis\0uacute": -20,
  "Adieresis\0ucircumflex": -20,
  "Adieresis\0udieresis": -20,
  "Adieresis\0ugrave": -20,
  "Adieresis\0uhungarumlaut": -20,
  "Adieresis\0umacron": -20,
  "Adieresis\0uogonek": -20,
  "Adieresis\0uring": -20,
  "Adieresis\0v": -55,
  "Adieresis\0w": -55,
  "Adieresis\0y": -55,
  "Adieresis\0yacute": -55,
  "Adieresis\0ydieresis": -55,
  "Agrave\0C": -30,
  "Agrave\0Cacute": -30,
  "Agrave\0Ccaron": -30,
  "Agrave\0Ccedilla": -30,
  "Agrave\0G": -35,
  "Agrave\0Gbreve": -35,
  "Agrave\0Gcommaaccent": -35,
  "Agrave\0O": -40,
  "Agrave\0Oacute": -40,
  "Agrave\0Ocircumflex": -40,
  "Agrave\0Odieresis": -40,
  "Agrave\0Ograve": -40,
  "Agrave\0Ohungarumlaut": -40,
  "Agrave\0Omacron": -40,
  "Agrave\0Oslash": -40,
  "Agrave\0Otilde": -40,
  "Agrave\0Q": -40,
  "Agrave\0T": -37,
  "Agrave\0Tcaron": -37,
  "Agrave\0Tcommaaccent": -37,
  "Agrave\0U": -50,
  "Agrave\0Uacute": -50,
  "Agrave\0Ucircumflex": -50,
  "Agrave\0Udieresis": -50,
  "Agrave\0Ugrave": -50,
  "Agrave\0Uhungarumlaut": -50,
  "Agrave\0Umacron": -50,
  "Agrave\0Uogonek": -50,
  "Agrave\0Uring": -50,
  "Agrave\0V": -105,
  "Agrave\0W": -95,
  "Agrave\0Y": -55,
  "Agrave\0Yacute": -55,
  "Agrave\0Ydieresis": -55,
  "Agrave\0quoteright": -37,
  "Agrave\0u": -20,
  "Agrave\0uacute": -20,
  "Agrave\0ucircumflex": -20,
  "Agrave\0udieresis": -20,
  "Agrave\0ugrave": -20,
  "Agrave\0uhungarumlaut": -20,
  "Agrave\0umacron": -20,
  "Agrave\0uogonek": -20,
  "Agrave\0uring": -20,
  "Agrave\0v": -55,
  "Agrave\0w": -55,
  "Agrave\0y": -55,
  "Agrave\0yacute": -55,
  "Agrave\0ydieresis": -55,
  "Amacron\0C": -30,
  "Amacron\0Cacute": -30,
  "Amacron\0Ccaron": -30,
  "Amacron\0Ccedilla": -30,
  "Amacron\0G": -35,
  "Amacron\0Gbreve": -35,
  "Amacron\0Gcommaaccent": -35,
  "Amacron\0O": -40,
  "Amacron\0Oacute": -40,
  "Amacron\0Ocircumflex": -40,
  "Amacron\0Odieresis": -40,
  "Amacron\0Ograve": -40,
  "Amacron\0Ohungarumlaut": -40,
  "Amacron\0Omacron": -40,
  "Amacron\0Oslash": -40,
  "Amacron\0Otilde": -40,
  "Amacron\0Q": -40,
  "Amacron\0T": -37,
  "Amacron\0Tcaron": -37,
  "Amacron\0Tcommaaccent": -37,
  "Amacron\0U": -50,
  "Amacron\0Uacute": -50,
  "Amacron\0Ucircumflex": -50,
  "Amacron\0Udieresis": -50,
  "Amacron\0Ugrave": -50,
  "Amacron\0Uhungarumlaut": -50,
  "Amacron\0Umacron": -50,
  "Amacron\0Uogonek": -50,
  "Amacron\0Uring": -50,
  "Amacron\0V": -105,
  "Amacron\0W": -95,
  "Amacron\0Y": -55,
  "Amacron\0Yacute": -55,
  "Amacron\0Ydieresis": -55,
  "Amacron\0quoteright": -37,
  "Amacron\0u": -20,
  "Amacron\0uacute": -20,
  "Amacron\0ucircumflex": -20,
  "Amacron\0udieresis": -20,
  "Amacron\0ugrave": -20,
  "Amacron\0uhungarumlaut": -20,
  "Amacron\0umacron": -20,
  "Amacron\0uogonek": -20,
  "Amacron\0uring": -20,
  "Amacron\0v": -55,
  "Amacron\0w": -55,
  "Amacron\0y": -55,
  "Amacron\0yacute": -55,
  "Amacron\0ydieresis": -55,
  "Aogonek\0C": -30,
  "Aogonek\0Cacute": -30,
  "Aogonek\0Ccaron": -30,
  "Aogonek\0Ccedilla": -30,
  "Aogonek\0G": -35,
  "Aogonek\0Gbreve": -35,
  "Aogonek\0Gcommaaccent": -35,
  "Aogonek\0O": -40,
  "Aogonek\0Oacute": -40,
  "Aogonek\0Ocircumflex": -40,
  "Aogonek\0Odieresis": -40,
  "Aogonek\0Ograve": -40,
  "Aogonek\0Ohungarumlaut": -40,
  "Aogonek\0Omacron": -40,
  "Aogonek\0Oslash": -40,
  "Aogonek\0Otilde": -40,
  "Aogonek\0Q": -40,
  "Aogonek\0T": -37,
  "Aogonek\0Tcaron": -37,
  "Aogonek\0Tcommaaccent": -37,
  "Aogonek\0U": -50,
  "Aogonek\0Uacute": -50,
  "Aogonek\0Ucircumflex": -50,
  "Aogonek\0Udieresis": -50,
  "Aogonek\0Ugrave": -50,
  "Aogonek\0Uhungarumlaut": -50,
  "Aogonek\0Umacron": -50,
  "Aogonek\0Uogonek": -50,
  "Aogonek\0Uring": -50,
  "Aogonek\0V": -105,
  "Aogonek\0W": -95,
  "Aogonek\0Y": -55,
  "Aogonek\0Yacute": -55,
  "Aogonek\0Ydieresis": -55,
  "Aogonek\0quoteright": -37,
  "Aogonek\0u": -20,
  "Aogonek\0uacute": -20,
  "Aogonek\0ucircumflex": -20,
  "Aogonek\0udieresis": -20,
  "Aogonek\0ugrave": -20,
  "Aogonek\0uhungarumlaut": -20,
  "Aogonek\0umacron": -20,
  "Aogonek\0uogonek": -20,
  "Aogonek\0uring": -20,
  "Aogonek\0v": -55,
  "Aogonek\0w": -55,
  "Aogonek\0y": -55,
  "Aogonek\0yacute": -55,
  "Aogonek\0ydieresis": -55,
  "Aring\0C": -30,
  "Aring\0Cacute": -30,
  "Aring\0Ccaron": -30,
  "Aring\0Ccedilla": -30,
  "Aring\0G": -35,
  "Aring\0Gbreve": -35,
  "Aring\0Gcommaaccent": -35,
  "Aring\0O": -40,
  "Aring\0Oacute": -40,
  "Aring\0Ocircumflex": -40,
  "Aring\0Odieresis": -40,
  "Aring\0Ograve": -40,
  "Aring\0Ohungarumlaut": -40,
  "Aring\0Omacron": -40,
  "Aring\0Oslash": -40,
  "Aring\0Otilde": -40,
  "Aring\0Q": -40,
  "Aring\0T": -37,
  "Aring\0Tcaron": -37,
  "Aring\0Tcommaaccent": -37,
  "Aring\0U": -50,
  "Aring\0Uacute": -50,
  "Aring\0Ucircumflex": -50,
  "Aring\0Udieresis": -50,
  "Aring\0Ugrave": -50,
  "Aring\0Uhungarumlaut": -50,
  "Aring\0Umacron": -50,
  "Aring\0Uogonek": -50,
  "Aring\0Uring": -50,
  "Aring\0V": -105,
  "Aring\0W": -95,
  "Aring\0Y": -55,
  "Aring\0Yacute": -55,
  "Aring\0Ydieresis": -55,
  "Aring\0quoteright": -37,
  "Aring\0u": -20,
  "Aring\0uacute": -20,
  "Aring\0ucircumflex": -20,
  "Aring\0udieresis": -20,
  "Aring\0ugrave": -20,
  "Aring\0uhungarumlaut": -20,
  "Aring\0umacron": -20,
  "Aring\0uogonek": -20,
  "Aring\0uring": -20,
  "Aring\0v": -55,
  "Aring\0w": -55,
  "Aring\0y": -55,
  "Aring\0yacute": -55,
  "Aring\0ydieresis": -55,
  "Atilde\0C": -30,
  "Atilde\0Cacute": -30,
  "Atilde\0Ccaron": -30,
  "Atilde\0Ccedilla": -30,
  "Atilde\0G": -35,
  "Atilde\0Gbreve": -35,
  "Atilde\0Gcommaaccent": -35,
  "Atilde\0O": -40,
  "Atilde\0Oacute": -40,
  "Atilde\0Ocircumflex": -40,
  "Atilde\0Odieresis": -40,
  "Atilde\0Ograve": -40,
  "Atilde\0Ohungarumlaut": -40,
  "Atilde\0Omacron": -40,
  "Atilde\0Oslash": -40,
  "Atilde\0Otilde": -40,
  "Atilde\0Q": -40,
  "Atilde\0T": -37,
  "Atilde\0Tcaron": -37,
  "Atilde\0Tcommaaccent": -37,
  "Atilde\0U": -50,
  "Atilde\0Uacute": -50,
  "Atilde\0Ucircumflex": -50,
  "Atilde\0Udieresis": -50,
  "Atilde\0Ugrave": -50,
  "Atilde\0Uhungarumlaut": -50,
  "Atilde\0Umacron": -50,
  "Atilde\0Uogonek": -50,
  "Atilde\0Uring": -50,
  "Atilde\0V": -105,
  "Atilde\0W": -95,
  "Atilde\0Y": -55,
  "Atilde\0Yacute": -55,
  "Atilde\0Ydieresis": -55,
  "Atilde\0quoteright": -37,
  "Atilde\0u": -20,
  "Atilde\0uacute": -20,
  "Atilde\0ucircumflex": -20,
  "Atilde\0udieresis": -20,
  "Atilde\0ugrave": -20,
  "Atilde\0uhungarumlaut": -20,
  "Atilde\0umacron": -20,
  "Atilde\0uogonek": -20,
  "Atilde\0uring": -20,
  "Atilde\0v": -55,
  "Atilde\0w": -55,
  "Atilde\0y": -55,
  "Atilde\0yacute": -55,
  "Atilde\0ydieresis": -55,
  "B\0A": -25,
  "B\0Aacute": -25,
  "B\0Abreve": -25,
  "B\0Acircumflex": -25,
  "B\0Adieresis": -25,
  "B\0Agrave": -25,
  "B\0Amacron": -25,
  "B\0Aogonek": -25,
  "B\0Aring": -25,
  "B\0Atilde": -25,
  "B\0U": -10,
  "B\0Uacute": -10,
  "B\0Ucircumflex": -10,
  "B\0Udieresis": -10,
  "B\0Ugrave": -10,
  "B\0Uhungarumlaut": -10,
  "B\0Umacron": -10,
  "B\0Uogonek": -10,
  "B\0Uring": -10,
  "D\0A": -35,
  "D\0Aacute": -35,
  "D\0Abreve": -35,
  "D\0Acircumflex": -35,
  "D\0Adieresis": -35,
  "D\0Agrave": -35,
  "D\0Amacron": -35,
  "D\0Aogonek": -35,
  "D\0Aring": -35,
  "D\0Atilde": -35,
  "D\0V": -40,
  "D\0W": -40,
  "D\0Y": -40,
  "D\0Yacute": -40,
  "D\0Ydieresis": -40,
  "Dcaron\0A": -35,
  "Dcaron\0Aacute": -35,
  "Dcaron\0Abreve": -35,
  "Dcaron\0Acircumflex": -35,
  "Dcaron\0Adieresis": -35,
  "Dcaron\0Agrave": -35,
  "Dcaron\0Amacron": -35,
  "Dcaron\0Aogonek": -35,
  "Dcaron\0Aring": -35,
  "Dcaron\0Atilde": -35,
  "Dcaron\0V": -40,
  "Dcaron\0W": -40,
  "Dcaron\0Y": -40,
  "Dcaron\0Yacute": -40,
  "Dcaron\0Ydieresis": -40,
  "Dcroat\0A": -35,
  "Dcroat\0Aacute": -35,
  "Dcroat\0Abreve": -35,
  "Dcroat\0Acircumflex": -35,
  "Dcroat\0Adieresis": -35,
  "Dcroat\0Agrave": -35,
  "Dcroat\0Amacron": -35,
  "Dcroat\0Aogonek": -35,
  "Dcroat\0Aring": -35,
  "Dcroat\0Atilde": -35,
  "Dcroat\0V": -40,
  "Dcroat\0W": -40,
  "Dcroat\0Y": -40,
  "Dcroat\0Yacute": -40,
  "Dcroat\0Ydieresis": -40,
  "F\0A": -115,
  "F\0Aacute": -115,
  "F\0Abreve": -115,
  "F\0Acircumflex": -115,
  "F\0Adieresis": -115,
  "F\0Agrave": -115,
  "F\0Amacron": -115,
  "F\0Aogonek": -115,
  "F\0Aring": -115,
  "F\0Atilde": -115,
  "F\0a": -75,
  "F\0aacute": -75,
  "F\0abreve": -75,
  "F\0acircumflex": -75,
  "F\0adieresis": -75,
  "F\0agrave": -75,
  "F\0amacron": -75,
  "F\0aogonek": -75,
  "F\0aring": -75,
  "F\0atilde": -75,
  "F\0comma": -135,
  "F\0e": -75,
  "F\0eacute": -75,
  "F\0ecaron": -75,
  "F\0ecircumflex": -75,
  "F\0edieresis": -75,
  "F\0edotaccent": -75,
  "F\0egrave": -75,
  "F\0emacron": -75,
  "F\0eogonek": -75,
  "F\0i": -45,
  "F\0iacute": -45,
  "F\0icircumflex": -45,
  "F\0idieresis": -45,
  "F\0igrave": -45,
  "F\0imacron": -45,
  "F\0iogonek": -45,
  "F\0o": -105,
  "F\0oacute": -105,
  "F\0ocircumflex": -105,
  "F\0odieresis": -105,
  "F\0ograve": -105,
  "F\0ohungarumlaut": -105,
  "F\0omacron": -105,
  "F\0oslash": -105,
  "F\0otilde": -105,
  "F\0period": -135,
  "F\0r": -55,
  "F\0racute": -55,
  "F\0rcaron": -55,
  "F\0rcommaaccent": -55,
  "J\0A": -40,
  "J\0Aacute": -40,
  "J\0Abreve": -40,
  "J\0Acircumflex": -40,
  "J\0Adieresis": -40,
  "J\0Agrave": -40,
  "J\0Amacron": -40,
  "J\0Aogonek": -40,
  "J\0Aring": -40,
  "J\0Atilde": -40,
  "J\0a": -35,
  "J\0aacute": -35,
  "J\0abreve": -35,
  "J\0acircumflex": -35,
  "J\0adieresis": -35,
  "J\0agrave": -35,
  "J\0amacron": -35,
  "J\0aogonek": -35,
  "J\0aring": -35,
  "J\0atilde": -35,
  "J\0comma": -25,
  "J\0e": -25,
  "J\0eacute": -25,
  "J\0ecaron": -25,
  "J\0ecircumflex": -25,
  "J\0edieresis": -25,
  "J\0edotaccent": -25,
  "J\0egrave": -25,
  "J\0emacron": -25,
  "J\0eogonek": -25,
  "J\0o": -25,
  "J\0oacute": -25,
  "J\0ocircumflex": -25,
  "J\0odieresis": -25,
  "J\0ograve": -25,
  "J\0ohungarumlaut": -25,
  "J\0omacron": -25,
  "J\0oslash": -25,
  "J\0otilde": -25,
  "J\0period": -25,
  "J\0u": -35,
  "J\0uacute": -35,
  "J\0ucircumflex": -35,
  "J\0udieresis": -35,
  "J\0ugrave": -35,
  "J\0uhungarumlaut": -35,
  "J\0umacron": -35,
  "J\0uogonek": -35,
  "J\0uring": -35,
  "K\0O": -50,
  "K\0Oacute": -50,
  "K\0Ocircumflex": -50,
  "K\0Odieresis": -50,
  "K\0Ograve": -50,
  "K\0Ohungarumlaut": -50,
  "K\0Omacron": -50,
  "K\0Oslash": -50,
  "K\0Otilde": -50,
  "K\0e": -35,
  "K\0eacute": -35,
  "K\0ecaron": -35,
  "K\0ecircumflex": -35,
  "K\0edieresis": -35,
  "K\0edotaccent": -35,
  "K\0egrave": -35,
  "K\0emacron": -35,
  "K\0eogonek": -35,
  "K\0o": -40,
  "K\0oacute": -40,
  "K\0ocircumflex": -40,
  "K\0odieresis": -40,
  "K\0ograve": -40,
  "K\0ohungarumlaut": -40,
  "K\0omacron": -40,
  "K\0oslash": -40,
  "K\0otilde": -40,
  "K\0u": -40,
  "K\0uacute": -40,
  "K\0ucircumflex": -40,
  "K\0udieresis": -40,
  "K\0ugrave": -40,
  "K\0uhungarumlaut": -40,
  "K\0umacron": -40,
  "K\0uogonek": -40,
  "K\0uring": -40,
  "K\0y": -40,
  "K\0yacute": -40,
  "K\0ydieresis": -40,
  "Kcommaaccent\0O": -50,
  "Kcommaaccent\0Oacute": -50,
  "Kcommaaccent\0Ocircumflex": -50,
  "Kcommaaccent\0Odieresis": -50,
  "Kcommaaccent\0Ograve": -50,
  "Kcommaaccent\0Ohungarumlaut": -50,
  "Kcommaaccent\0Omacron": -50,
  "Kcommaaccent\0Oslash": -50,
  "Kcommaaccent\0Otilde": -50,
  "Kcommaaccent\0e": -35,
  "Kcommaaccent\0eacute": -35,
  "Kcommaaccent\0ecaron": -35,
  "Kcommaaccent\0ecircumflex": -35,
  "Kcommaaccent\0edieresis": -35,
  "Kcommaaccent\0edotaccent": -35,
  "Kcommaaccent\0egrave": -35,
  "Kcommaaccent\0emacron": -35,
  "Kcommaaccent\0eogonek": -35,
  "Kcommaaccent\0o": -40,
  "Kcommaaccent\0oacute": -40,
  "Kcommaaccent\0ocircumflex": -40,
  "Kcommaaccent\0odieresis": -40,
  "Kcommaaccent\0ograve": -40,
  "Kcommaaccent\0ohungarumlaut": -40,
  "Kcommaaccent\0omacron": -40,
  "Kcommaaccent\0oslash": -40,
  "Kcommaaccent\0otilde": -40,
  "Kcommaaccent\0u": -40,
  "Kcommaaccent\0uacute": -40,
  "Kcommaaccent\0ucircumflex": -40,
  "Kcommaaccent\0udieresis": -40,
  "Kcommaaccent\0ugrave": -40,
  "Kcommaaccent\0uhungarumlaut": -40,
  "Kcommaaccent\0umacron": -40,
  "Kcommaaccent\0uogonek": -40,
  "Kcommaaccent\0uring": -40,
  "Kcommaaccent\0y": -40,
  "Kcommaaccent\0yacute": -40,
  "Kcommaaccent\0ydieresis": -40,
  "L\0T": -20,
  "L\0Tcaron": -20,
  "L\0Tcommaaccent": -20,
  "L\0V": -55,
  "L\0W": -55,
  "L\0Y": -20,
  "L\0Yacute": -20,
  "L\0Ydieresis": -20,
  "L\0quoteright": -37,
  "L\0y": -30,
  "L\0yacute": -30,
  "L\0ydieresis": -30,
  "Lacute\0T": -20,
  "Lacute\0Tcaron": -20,
  "Lacute\0Tcommaaccent": -20,
  "Lacute\0V": -55,
  "Lacute\0W": -55,
  "Lacute\0Y": -20,
  "Lacute\0Yacute": -20,
  "Lacute\0Ydieresis": -20,
  "Lacute\0quoteright": -37,
  "Lacute\0y": -30,
  "Lacute\0yacute": -30,
  "Lacute\0ydieresis": -30,
  "Lcommaaccent\0T": -20,
  "Lcommaaccent\0Tcaron": -20,
  "Lcommaaccent\0Tcommaaccent": -20,
  "Lcommaaccent\0V": -55,
  "Lcommaaccent\0W": -55,
  "Lcommaaccent\0Y": -20,
  "Lcommaaccent\0Yacute": -20,
  "Lcommaaccent\0Ydieresis": -20,
  "Lcommaaccent\0quoteright": -37,
  "Lcommaaccent\0y": -30,
  "Lcommaaccent\0yacute": -30,
  "Lcommaaccent\0ydieresis": -30,
  "Lslash\0T": -20,
  "Lslash\0Tcaron": -20,
  "Lslash\0Tcommaaccent": -20,
  "Lslash\0V": -55,
  "Lslash\0W": -55,
  "Lslash\0Y": -20,
  "Lslash\0Yacute": -20,
  "Lslash\0Ydieresis": -20,
  "Lslash\0quoteright": -37,
  "Lslash\0y": -30,
  "Lslash\0yacute": -30,
  "Lslash\0ydieresis": -30,
  "N\0A": -27,
  "N\0Aacute": -27,
  "N\0Abreve": -27,
  "N\0Acircumflex": -27,
  "N\0Adieresis": -27,
  "N\0Agrave": -27,
  "N\0Amacron": -27,
  "N\0Aogonek": -27,
  "N\0Aring": -27,
  "N\0Atilde": -27,
  "Nacute\0A": -27,
  "Nacute\0Aacute": -27,
  "Nacute\0Abreve": -27,
  "Nacute\0Acircumflex": -27,
  "Nacute\0Adieresis": -27,
  "Nacute\0Agrave": -27,
  "Nacute\0Amacron": -27,
  "Nacute\0Aogonek": -27,
  "Nacute\0Aring": -27,
  "Nacute\0Atilde": -27,
  "Ncaron\0A": -27,
  "Ncaron\0Aacute": -27,
  "Ncaron\0Abreve": -27,
  "Ncaron\0Acircumflex": -27,
  "Ncaron\0Adieresis": -27,
  "Ncaron\0Agrave": -27,
  "Ncaron\0Amacron": -27,
  "Ncaron\0Aogonek": -27,
  "Ncaron\0Aring": -27,
  "Ncaron\0Atilde": -27,
  "Ncommaaccent\0A": -27,
  "Ncommaaccent\0Aacute": -27,
  "Ncommaaccent\0Abreve": -27,
  "Ncommaaccent\0Acircumflex": -27,
  "Ncommaaccent\0Adieresis": -27,
  "Ncommaaccent\0Agrave": -27,
  "Ncommaaccent\0Amacron": -27,
  "Ncommaaccent\0Aogonek": -27,
  "Ncommaaccent\0Aring": -27,
  "Ncommaaccent\0Atilde": -27,
  "Ntilde\0A": -27,
  "Ntilde\0Aacute": -27,
  "Ntilde\0Abreve": -27,
  "Ntilde\0Acircumflex": -27,
  "Ntilde\0Adieresis": -27,
  "Ntilde\0Agrave": -27,
  "Ntilde\0Amacron": -27,
  "Ntilde\0Aogonek": -27,
  "Ntilde\0Aring": -27,
  "Ntilde\0Atilde": -27,
  "O\0A": -55,
  "O\0Aacute": -55,
  "O\0Abreve": -55,
  "O\0Acircumflex": -55,
  "O\0Adieresis": -55,
  "O\0Agrave": -55,
  "O\0Amacron": -55,
  "O\0Aogonek": -55,
  "O\0Aring": -55,
  "O\0Atilde": -55,
  "O\0T": -40,
  "O\0Tcaron": -40,
  "O\0Tcommaaccent": -40,
  "O\0V": -50,
  "O\0W": -50,
  "O\0X": -40,
  "O\0Y": -50,
  "O\0Yacute": -50,
  "O\0Ydieresis": -50,
  "Oacute\0A": -55,
  "Oacute\0Aacute": -55,
  "Oacute\0Abreve": -55,
  "Oacute\0Acircumflex": -55,
  "Oacute\0Adieresis": -55,
  "Oacute\0Agrave": -55,
  "Oacute\0Amacron": -55,
  "Oacute\0Aogonek": -55,
  "Oacute\0Aring": -55,
  "Oacute\0Atilde": -55,
  "Oacute\0T": -40,
  "Oacute\0Tcaron": -40,
  "Oacute\0Tcommaaccent": -40,
  "Oacute\0V": -50,
  "Oacute\0W": -50,
  "Oacute\0X": -40,
  "Oacute\0Y": -50,
  "Oacute\0Yacute": -50,
  "Oacute\0Ydieresis": -50,
  "Ocircumflex\0A": -55,
  "Ocircumflex\0Aacute": -55,
  "Ocircumflex\0Abreve": -55,
  "Ocircumflex\0Acircumflex": -55,
  "Ocircumflex\0Adieresis": -55,
  "Ocircumflex\0Agrave": -55,
  "Ocircumflex\0Amacron": -55,
  "Ocircumflex\0Aogonek": -55,
  "Ocircumflex\0Aring": -55,
  "Ocircumflex\0Atilde": -55,
  "Ocircumflex\0T": -40,
  "Ocircumflex\0Tcaron": -40,
  "Ocircumflex\0Tcommaaccent": -40,
  "Ocircumflex\0V": -50,
  "Ocircumflex\0W": -50,
  "Ocircumflex\0X": -40,
  "Ocircumflex\0Y": -50,
  "Ocircumflex\0Yacute": -50,
  "Ocircumflex\0Ydieresis": -50,
  "Odieresis\0A": -55,
  "Odieresis\0Aacute": -55,
  "Odieresis\0Abreve": -55,
  "Odieresis\0Acircumflex": -55,
  "Odieresis\0Adieresis": -55,
  "Odieresis\0Agrave": -55,
  "Odieresis\0Amacron": -55,
  "Odieresis\0Aogonek": -55,
  "Odieresis\0Aring": -55,
  "Odieresis\0Atilde": -55,
  "Odieresis\0T": -40,
  "Odieresis\0Tcaron": -40,
  "Odieresis\0Tcommaaccent": -40,
  "Odieresis\0V": -50,
  "Odieresis\0W": -50,
  "Odieresis\0X": -40,
  "Odieresis\0Y": -50,
  "Odieresis\0Yacute": -50,
  "Odieresis\0Ydieresis": -50,
  "Ograve\0A": -55,
  "Ograve\0Aacute": -55,
  "Ograve\0Abreve": -55,
  "Ograve\0Acircumflex": -55,
  "Ograve\0Adieresis": -55,
  "Ograve\0Agrave": -55,
  "Ograve\0Amacron": -55,
  "Ograve\0Aogonek": -55,
  "Ograve\0Aring": -55,
  "Ograve\0Atilde": -55,
  "Ograve\0T": -40,
  "Ograve\0Tcaron": -40,
  "Ograve\0Tcommaaccent": -40,
  "Ograve\0V": -50,
  "Ograve\0W": -50,
  "Ograve\0X": -40,
  "Ograve\0Y": -50,
  "Ograve\0Yacute": -50,
  "Ograve\0Ydieresis": -50,
  "Ohungarumlaut\0A": -55,
  "Ohungarumlaut\0Aacute": -55,
  "Ohungarumlaut\0Abreve": -55,
  "Ohungarumlaut\0Acircumflex": -55,
  "Ohungarumlaut\0Adieresis": -55,
  "Ohungarumlaut\0Agrave": -55,
  "Ohungarumlaut\0Amacron": -55,
  "Ohungarumlaut\0Aogonek": -55,
  "Ohungarumlaut\0Aring": -55,
  "Ohungarumlaut\0Atilde": -55,
  "Ohungarumlaut\0T": -40,
  "Ohungarumlaut\0Tcaron": -40,
  "Ohungarumlaut\0Tcommaaccent": -40,
  "Ohungarumlaut\0V": -50,
  "Ohungarumlaut\0W": -50,
  "Ohungarumlaut\0X": -40,
  "Ohungarumlaut\0Y": -50,
  "Ohungarumlaut\0Yacute": -50,
  "Ohungarumlaut\0Ydieresis": -50,
  "Omacron\0A": -55,
  "Omacron\0Aacute": -55,
  "Omacron\0Abreve": -55,
  "Omacron\0Acircumflex": -55,
  "Omacron\0Adieresis": -55,
  "Omacron\0Agrave": -55,
  "Omacron\0Amacron": -55,
  "Omacron\0Aogonek": -55,
  "Omacron\0Aring": -55,
  "Omacron\0Atilde": -55,
  "Omacron\0T": -40,
  "Omacron\0Tcaron": -40,
  "Omacron\0Tcommaaccent": -40,
  "Omacron\0V": -50,
  "Omacron\0W": -50,
  "Omacron\0X": -40,
  "Omacron\0Y": -50,
  "Omacron\0Yacute": -50,
  "Omacron\0Ydieresis": -50,
  "Oslash\0A": -55,
  "Oslash\0Aacute": -55,
  "Oslash\0Abreve": -55,
  "Oslash\0Acircumflex": -55,
  "Oslash\0Adieresis": -55,
  "Oslash\0Agrave": -55,
  "Oslash\0Amacron": -55,
  "Oslash\0Aogonek": -55,
  "Oslash\0Aring": -55,
  "Oslash\0Atilde": -55,
  "Oslash\0T": -40,
  "Oslash\0Tcaron": -40,
  "Oslash\0Tcommaaccent": -40,
  "Oslash\0V": -50,
  "Oslash\0W": -50,
  "Oslash\0X": -40,
  "Oslash\0Y": -50,
  "Oslash\0Yacute": -50,
  "Oslash\0Ydieresis": -50,
  "Otilde\0A": -55,
  "Otilde\0Aacute": -55,
  "Otilde\0Abreve": -55,
  "Otilde\0Acircumflex": -55,
  "Otilde\0Adieresis": -55,
  "Otilde\0Agrave": -55,
  "Otilde\0Amacron": -55,
  "Otilde\0Aogonek": -55,
  "Otilde\0Aring": -55,
  "Otilde\0Atilde": -55,
  "Otilde\0T": -40,
  "Otilde\0Tcaron": -40,
  "Otilde\0Tcommaaccent": -40,
  "Otilde\0V": -50,
  "Otilde\0W": -50,
  "Otilde\0X": -40,
  "Otilde\0Y": -50,
  "Otilde\0Yacute": -50,
  "Otilde\0Ydieresis": -50,
  "P\0A": -90,
  "P\0Aacute": -90,
  "P\0Abreve": -90,
  "P\0Acircumflex": -90,
  "P\0Adieresis": -90,
  "P\0Agrave": -90,
  "P\0Amacron": -90,
  "P\0Aogonek": -90,
  "P\0Aring": -90,
  "P\0Atilde": -90,
  "P\0a": -80,
  "P\0aacute": -80,
  "P\0abreve": -80,
  "P\0acircumflex": -80,
  "P\0adieresis": -80,
  "P\0agrave": -80,
  "P\0amacron": -80,
  "P\0aogonek": -80,
  "P\0aring": -80,
  "P\0atilde": -80,
  "P\0comma": -135,
  "P\0e": -80,
  "P\0eacute": -80,
  "P\0ecaron": -80,
  "P\0ecircumflex": -80,
  "P\0edieresis": -80,
  "P\0edotaccent": -80,
  "P\0egrave": -80,
  "P\0emacron": -80,
  "P\0eogonek": -80,
  "P\0o": -80,
  "P\0oacute": -80,
  "P\0ocircumflex": -80,
  "P\0odieresis": -80,
  "P\0ograve": -80,
  "P\0ohungarumlaut": -80,
  "P\0omacron": -80,
  "P\0oslash": -80,
  "P\0otilde": -80,
  "P\0period": -135,
  "Q\0U": -10,
  "Q\0Uacute": -10,
  "Q\0Ucircumflex": -10,
  "Q\0Udieresis": -10,
  "Q\0Ugrave": -10,
  "Q\0Uhungarumlaut": -10,
  "Q\0Umacron": -10,
  "Q\0Uogonek": -10,
  "Q\0Uring": -10,
  "R\0O": -40,
  "R\0Oacute": -40,
  "R\0Ocircumflex": -40,
  "R\0Odieresis": -40,
  "R\0Ograve": -40,
  "R\0Ohungarumlaut": -40,
  "R\0Omacron": -40,
  "R\0Oslash": -40,
  "R\0Otilde": -40,
  "R\0U": -40,
  "R\0Uacute": -40,
  "R\0Ucircumflex": -40,
  "R\0Udieresis": -40,
  "R\0Ugrave": -40,
  "R\0Uhungarumlaut": -40,
  "R\0Umacron": -40,
  "R\0Uogonek": -40,
  "R\0Uring": -40,
  "R\0V": -18,
  "R\0W": -18,
  "R\0Y": -18,
  "R\0Yacute": -18,
  "R\0Ydieresis": -18,
  "Racute\0O": -40,
  "Racute\0Oacute": -40,
  "Racute\0Ocircumflex": -40,
  "Racute\0Odieresis": -40,
  "Racute\0Ograve": -40,
  "Racute\0Ohungarumlaut": -40,
  "Racute\0Omacron": -40,
  "Racute\0Oslash": -40,
  "Racute\0Otilde": -40,
  "Racute\0U": -40,
  "Racute\0Uacute": -40,
  "Racute\0Ucircumflex": -40,
  "Racute\0Udieresis": -40,
  "Racute\0Ugrave": -40,
  "Racute\0Uhungarumlaut": -40,
  "Racute\0Umacron": -40,
  "Racute\0Uogonek": -40,
  "Racute\0Uring": -40,
  "Racute\0V": -18,
  "Racute\0W": -18,
  "Racute\0Y": -18,
  "Racute\0Yacute": -18,
  "Racute\0Ydieresis": -18,
  "Rcaron\0O": -40,
  "Rcaron\0Oacute": -40,
  "Rcaron\0Ocircumflex": -40,
  "Rcaron\0Odieresis": -40,
  "Rcaron\0Ograve": -40,
  "Rcaron\0Ohungarumlaut": -40,
  "Rcaron\0Omacron": -40,
  "Rcaron\0Oslash": -40,
  "Rcaron\0Otilde": -40,
  "Rcaron\0U": -40,
  "Rcaron\0Uacute": -40,
  "Rcaron\0Ucircumflex": -40,
  "Rcaron\0Udieresis": -40,
  "Rcaron\0Ugrave": -40,
  "Rcaron\0Uhungarumlaut": -40,
  "Rcaron\0Umacron": -40,
  "Rcaron\0Uogonek": -40,
  "Rcaron\0Uring": -40,
  "Rcaron\0V": -18,
  "Rcaron\0W": -18,
  "Rcaron\0Y": -18,
  "Rcaron\0Yacute": -18,
  "Rcaron\0Ydieresis": -18,
  "Rcommaaccent\0O": -40,
  "Rcommaaccent\0Oacute": -40,
  "Rcommaaccent\0Ocircumflex": -40,
  "Rcommaaccent\0Odieresis": -40,
  "Rcommaaccent\0Ograve": -40,
  "Rcommaaccent\0Ohungarumlaut": -40,
  "Rcommaaccent\0Omacron": -40,
  "Rcommaaccent\0Oslash": -40,
  "Rcommaaccent\0Otilde": -40,
  "Rcommaaccent\0U": -40,
  "Rcommaaccent\0Uacute": -40,
  "Rcommaaccent\0Ucircumflex": -40,
  "Rcommaaccent\0Udieresis": -40,
  "Rcommaaccent\0Ugrave": -40,
  "Rcommaaccent\0Uhungarumlaut": -40,
  "Rcommaaccent\0Umacron": -40,
  "Rcommaaccent\0Uogonek": -40,
  "Rcommaaccent\0Uring": -40,
  "Rcommaaccent\0V": -18,
  "Rcommaaccent\0W": -18,
  "Rcommaaccent\0Y": -18,
  "Rcommaaccent\0Yacute": -18,
  "Rcommaaccent\0Ydieresis": -18,
  "T\0A": -50,
  "T\0Aacute": -50,
  "T\0Abreve": -50,
  "T\0Acircumflex": -50,
  "T\0Adieresis": -50,
  "T\0Agrave": -50,
  "T\0Amacron": -50,
  "T\0Aogonek": -50,
  "T\0Aring": -50,
  "T\0Atilde": -50,
  "T\0O": -18,
  "T\0Oacute": -18,
  "T\0Ocircumflex": -18,
  "T\0Odieresis": -18,
  "T\0Ograve": -18,
  "T\0Ohungarumlaut": -18,
  "T\0Omacron": -18,
  "T\0Oslash": -18,
  "T\0Otilde": -18,
  "T\0a": -92,
  "T\0aacute": -92,
  "T\0abreve": -92,
  "T\0acircumflex": -92,
  "T\0adieresis": -92,
  "T\0agrave": -92,
  "T\0amacron": -92,
  "T\0aogonek": -92,
  "T\0aring": -92,
  "T\0atilde": -92,
  "T\0colon": -55,
  "T\0comma": -74,
  "T\0e": -92,
  "T\0eacute": -92,
  "T\0ecaron": -92,
  "T\0ecircumflex": -52,
  "T\0edieresis": -52,
  "T\0edotaccent": -92,
  "T\0egrave": -52,
  "T\0emacron": -52,
  "T\0eogonek": -92,
  "T\0hyphen": -74,
  "T\0i": -55,
  "T\0iacute": -55,
  "T\0iogonek": -55,
  "T\0o": -92,
  "T\0oacute": -92,
  "T\0ocircumflex": -92,
  "T\0odieresis": -92,
  "T\0ograve": -92,
  "T\0ohungarumlaut": -92,
  "T\0omacron": -92,
  "T\0oslash": -92,
  "T\0otilde": -92,
  "T\0period": -74,
  "T\0r": -55,
  "T\0racute": -55,
  "T\0rcaron": -55,
  "T\0rcommaaccent": -55,
  "T\0semicolon": -65,
  "T\0u": -55,
  "T\0uacute": -55,
  "T\0ucircumflex": -55,
  "T\0udieresis": -55,
  "T\0ugrave": -55,
  "T\0uhungarumlaut": -55,
  "T\0umacron": -55,
  "T\0uogonek": -55,
  "T\0uring": -55,
  "T\0w": -74,
  "T\0y": -74,
  "T\0yacute": -74,
  "T\0ydieresis": -34,
  "Tcaron\0A": -50,
  "Tcaron\0Aacute": -50,
  "Tcaron\0Abreve": -50,
  "Tcaron\0Acircumflex": -50,
  "Tcaron\0Adieresis": -50,
  "Tcaron\0Agrave": -50,
  "Tcaron\0Amacron": -50,
  "Tcaron\0Aogonek": -50,
  "Tcaron\0Aring": -50,
  "Tcaron\0Atilde": -50,
  "Tcaron\0O": -18,
  "Tcaron\0Oacute": -18,
  "Tcaron\0Ocircumflex": -18,
  "Tcaron\0Odieresis": -18,
  "Tcaron\0Ograve": -18,
  "Tcaron\0Ohungarumlaut": -18,
  "Tcaron\0Omacron": -18,
  "Tcaron\0Oslash": -18,
  "Tcaron\0Otilde": -18,
  "Tcaron\0a": -92,
  "Tcaron\0aacute": -92,
  "Tcaron\0abreve": -92,
  "Tcaron\0acircumflex": -92,
  "Tcaron\0adieresis": -92,
  "Tcaron\0agrave": -92,
  "Tcaron\0amacron": -92,
  "Tcaron\0aogonek": -92,
  "Tcaron\0aring": -92,
  "Tcaron\0atilde": -92,
  "Tcaron\0colon": -55,
  "Tcaron\0comma": -74,
  "Tcaron\0e": -92,
  "Tcaron\0eacute": -92,
  "Tcaron\0ecaron": -92,
  "Tcaron\0ecircumflex": -52,
  "Tcaron\0edieresis": -52,
  "Tcaron\0edotaccent": -92,
  "Tcaron\0egrave": -52,
  "Tcaron\0emacron": -52,
  "Tcaron\0eogonek": -92,
  "Tcaron\0hyphen": -74,
  "Tcaron\0i": -55,
  "Tcaron\0iacute": -55,
  "Tcaron\0iogonek": -55,
  "Tcaron\0o": -92,
  "Tcaron\0oacute": -92,
  "Tcaron\0ocircumflex": -92,
  "Tcaron\0odieresis": -92,
  "Tcaron\0ograve": -92,
  "Tcaron\0ohungarumlaut": -92,
  "Tcaron\0omacron": -92,
  "Tcaron\0oslash": -92,
  "Tcaron\0otilde": -92,
  "Tcaron\0period": -74,
  "Tcaron\0r": -55,
  "Tcaron\0racute": -55,
  "Tcaron\0rcaron": -55,
  "Tcaron\0rcommaaccent": -55,
  "Tcaron\0semicolon": -65,
  "Tcaron\0u": -55,
  "Tcaron\0uacute": -55,
  "Tcaron\0ucircumflex": -55,
  "Tcaron\0udieresis": -55,
  "Tcaron\0ugrave": -55,
  "Tcaron\0uhungarumlaut": -55,
  "Tcaron\0umacron": -55,
  "Tcaron\0uogonek": -55,
  "Tcaron\0uring": -55,
  "Tcaron\0w": -74,
  "Tcaron\0y": -74,
  "Tcaron\0yacute": -74,
  "Tcaron\0ydieresis": -34,
  "Tcommaaccent\0A": -50,
  "Tcommaaccent\0Aacute": -50,
  "Tcommaaccent\0Abreve": -50,
  "Tcommaaccent\0Acircumflex": -50,
  "Tcommaaccent\0Adieresis": -50,
  "Tcommaaccent\0Agrave": -50,
  "Tcommaaccent\0Amacron": -50,
  "Tcommaaccent\0Aogonek": -50,
  "Tcommaaccent\0Aring": -50,
  "Tcommaaccent\0Atilde": -50,
  "Tcommaaccent\0O": -18,
  "Tcommaaccent\0Oacute": -18,
  "Tcommaaccent\0Ocircumflex": -18,
  "Tcommaaccent\0Odieresis": -18,
  "Tcommaaccent\0Ograve": -18,
  "Tcommaaccent\0Ohungarumlaut": -18,
  "Tcommaaccent\0Omacron": -18,
  "Tcommaaccent\0Oslash": -18,
  "Tcommaaccent\0Otilde": -18,
  "Tcommaaccent\0a": -92,
  "Tcommaaccent\0aacute": -92,
  "Tcommaaccent\0abreve": -92,
  "Tcommaaccent\0acircumflex": -92,
  "Tcommaaccent\0adieresis": -92,
  "Tcommaaccent\0agrave": -92,
  "Tcommaaccent\0amacron": -92,
  "Tcommaaccent\0aogonek": -92,
  "Tcommaaccent\0aring": -92,
  "Tcommaaccent\0atilde": -92,
  "Tcommaaccent\0colon": -55,
  "Tcommaaccent\0comma": -74,
  "Tcommaaccent\0e": -92,
  "Tcommaaccent\0eacute": -92,
  "Tcommaaccent\0ecaron": -92,
  "Tcommaaccent\0ecircumflex": -52,
  "Tcommaaccent\0edieresis": -52,
  "Tcommaaccent\0edotaccent": -92,
  "Tcommaaccent\0egrave": -52,
  "Tcommaaccent\0emacron": -52,
  "Tcommaaccent\0eogonek": -92,
  "Tcommaaccent\0hyphen": -74,
  "Tcommaaccent\0i": -55,
  "Tcommaaccent\0iacute": -55,
  "Tcommaaccent\0iogonek": -55,
  "Tcommaaccent\0o": -92,
  "Tcommaaccent\0oacute": -92,
  "Tcommaaccent\0ocircumflex": -92,
  "Tcommaaccent\0odieresis": -92,
  "Tcommaaccent\0ograve": -92,
  "Tcommaaccent\0ohungarumlaut": -92,
  "Tcommaaccent\0omacron": -92,
  "Tcommaaccent\0oslash": -92,
  "Tcommaaccent\0otilde": -92,
  "Tcommaaccent\0period": -74,
  "Tcommaaccent\0r": -55,
  "Tcommaaccent\0racute": -55,
  "Tcommaaccent\0rcaron": -55,
  "Tcommaaccent\0rcommaaccent": -55,
  "Tcommaaccent\0semicolon": -65,
  "Tcommaaccent\0u": -55,
  "Tcommaaccent\0uacute": -55,
  "Tcommaaccent\0ucircumflex": -55,
  "Tcommaaccent\0udieresis": -55,
  "Tcommaaccent\0ugrave": -55,
  "Tcommaaccent\0uhungarumlaut": -55,
  "Tcommaaccent\0umacron": -55,
  "Tcommaaccent\0uogonek": -55,
  "Tcommaaccent\0uring": -55,
  "Tcommaaccent\0w": -74,
  "Tcommaaccent\0y": -74,
  "Tcommaaccent\0yacute": -74,
  "Tcommaaccent\0ydieresis": -34,
  "U\0A": -40,
  "U\0Aacute": -40,
  "U\0Abreve": -40,
  "U\0Acircumflex": -40,
  "U\0Adieresis": -40,
  "U\0Agrave": -40,
  "U\0Amacron": -40,
  "U\0Aogonek": -40,
  "U\0Aring": -40,
  "U\0Atilde": -40,
  "U\0comma": -25,
  "U\0period": -25,
  "Uacute\0A": -40,
  "Uacute\0Aacute": -40,
  "Uacute\0Abreve": -40,
  "Uacute\0Acircumflex": -40,
  "Uacute\0Adieresis": -40,
  "Uacute\0Agrave": -40,
  "Uacute\0Amacron": -40,
  "Uacute\0Aogonek": -40,
  "Uacute\0Aring": -40,
  "Uacute\0Atilde": -40,
  "Uacute\0comma": -25,
  "Uacute\0period": -25,
  "Ucircumflex\0A": -40,
  "Ucircumflex\0Aacute": -40,
  "Ucircumflex\0Abreve": -40,
  "Ucircumflex\0Acircumflex": -40,
  "Ucircumflex\0Adieresis": -40,
  "Ucircumflex\0Agrave": -40,
  "Ucircumflex\0Amacron": -40,
  "Ucircumflex\0Aogonek": -40,
  "Ucircumflex\0Aring": -40,
  "Ucircumflex\0Atilde": -40,
  "Ucircumflex\0comma": -25,
  "Ucircumflex\0period": -25,
  "Udieresis\0A": -40,
  "Udieresis\0Aacute": -40,
  "Udieresis\0Abreve": -40,
  "Udieresis\0Acircumflex": -40,
  "Udieresis\0Adieresis": -40,
  "Udieresis\0Agrave": -40,
  "Udieresis\0Amacron": -40,
  "Udieresis\0Aogonek": -40,
  "Udieresis\0Aring": -40,
  "Udieresis\0Atilde": -40,
  "Udieresis\0comma": -25,
  "Udieresis\0period": -25,
  "Ugrave\0A": -40,
  "Ugrave\0Aacute": -40,
  "Ugrave\0Abreve": -40,
  "Ugrave\0Acircumflex": -40,
  "Ugrave\0Adieresis": -40,
  "Ugrave\0Agrave": -40,
  "Ugrave\0Amacron": -40,
  "Ugrave\0Aogonek": -40,
  "Ugrave\0Aring": -40,
  "Ugrave\0Atilde": -40,
  "Ugrave\0comma": -25,
  "Ugrave\0period": -25,
  "Uhungarumlaut\0A": -40,
  "Uhungarumlaut\0Aacute": -40,
  "Uhungarumlaut\0Abreve": -40,
  "Uhungarumlaut\0Acircumflex": -40,
  "Uhungarumlaut\0Adieresis": -40,
  "Uhungarumlaut\0Agrave": -40,
  "Uhungarumlaut\0Amacron": -40,
  "Uhungarumlaut\0Aogonek": -40,
  "Uhungarumlaut\0Aring": -40,
  "Uhungarumlaut\0Atilde": -40,
  "Uhungarumlaut\0comma": -25,
  "Uhungarumlaut\0period": -25,
  "Umacron\0A": -40,
  "Umacron\0Aacute": -40,
  "Umacron\0Abreve": -40,
  "Umacron\0Acircumflex": -40,
  "Umacron\0Adieresis": -40,
  "Umacron\0Agrave": -40,
  "Umacron\0Amacron": -40,
  "Umacron\0Aogonek": -40,
  "Umacron\0Aring": -40,
  "Umacron\0Atilde": -40,
  "Umacron\0comma": -25,
  "Umacron\0period": -25,
  "Uogonek\0A": -40,
  "Uogonek\0Aacute": -40,
  "Uogonek\0Abreve": -40,
  "Uogonek\0Acircumflex": -40,
  "Uogonek\0Adieresis": -40,
  "Uogonek\0Agrave": -40,
  "Uogonek\0Amacron": -40,
  "Uogonek\0Aogonek": -40,
  "Uogonek\0Aring": -40,
  "Uogonek\0Atilde": -40,
  "Uogonek\0comma": -25,
  "Uogonek\0period": -25,
  "Uring\0A": -40,
  "Uring\0Aacute": -40,
  "Uring\0Abreve": -40,
  "Uring\0Acircumflex": -40,
  "Uring\0Adieresis": -40,
  "Uring\0Agrave": -40,
  "Uring\0Amacron": -40,
  "Uring\0Aogonek": -40,
  "Uring\0Aring": -40,
  "Uring\0Atilde": -40,
  "Uring\0comma": -25,
  "Uring\0period": -25,
  "V\0A": -60,
  "V\0Aacute": -60,
  "V\0Abreve": -60,
  "V\0Acircumflex": -60,
  "V\0Adieresis": -60,
  "V\0Agrave": -60,
  "V\0Amacron": -60,
  "V\0Aogonek": -60,
  "V\0Aring": -60,
  "V\0Atilde": -60,
  "V\0O": -30,
  "V\0Oacute": -30,
  "V\0Ocircumflex": -30,
  "V\0Odieresis": -30,
  "V\0Ograve": -30,
  "V\0Ohungarumlaut": -30,
  "V\0Omacron": -30,
  "V\0Oslash": -30,
  "V\0Otilde": -30,
  "V\0a": -111,
  "V\0aacute": -111,
  "V\0abreve": -111,
  "V\0acircumflex": -111,
  "V\0adieresis": -111,
  "V\0agrave": -111,
  "V\0amacron": -111,
  "V\0aogonek": -111,
  "V\0aring": -111,
  "V\0atilde": -111,
  "V\0colon": -65,
  "V\0comma": -129,
  "V\0e": -111,
  "V\0eacute": -111,
  "V\0ecaron": -111,
  "V\0ecircumflex": -111,
  "V\0edieresis": -71,
  "V\0edotaccent": -111,
  "V\0egrave": -71,
  "V\0emacron": -71,
  "V\0eogonek": -111,
  "V\0hyphen": -55,
  "V\0i": -74,
  "V\0iacute": -74,
  "V\0icircumflex": -34,
  "V\0idieresis": -34,
  "V\0igrave": -34,
  "V\0imacron": -34,
  "V\0iogonek": -74,
  "V\0o": -111,
  "V\0oacute": -111,
  "V\0ocircumflex": -111,
  "V\0odieresis": -111,
  "V\0ograve": -111,
  "V\0ohungarumlaut": -111,
  "V\0omacron": -111,
  "V\0oslash": -111,
  "V\0otilde": -111,
  "V\0period": -129,
  "V\0semicolon": -74,
  "V\0u": -74,
  "V\0uacute": -74,
  "V\0ucircumflex": -74,
  "V\0udieresis": -74,
  "V\0ugrave": -74,
  "V\0uhungarumlaut": -74,
  "V\0umacron": -74,
  "V\0uogonek": -74,
  "V\0uring": -74,
  "W\0A": -60,
  "W\0Aacute": -60,
  "W\0Abreve": -60,
  "W\0Acircumflex": -60,
  "W\0Adieresis": -60,
  "W\0Agrave": -60,
  "W\0Amacron": -60,
  "W\0Aogonek": -60,
  "W\0Aring": -60,
  "W\0Atilde": -60,
  "W\0O": -25,
  "W\0Oacute": -25,
  "W\0Ocircumflex": -25,
  "W\0Odieresis": -25,
  "W\0Ograve": -25,
  "W\0Ohungarumlaut": -25,
  "W\0Omacron": -25,
  "W\0Oslash": -25,
  "W\0Otilde": -25,
  "W\0a": -92,
  "W\0aacute": -92,
  "W\0abreve": -92,
  "W\0acircumflex": -92,
  "W\0adieresis": -92,
  "W\0agrave": -92,
  "W\0amacron": -92,
  "W\0aogonek": -92,
  "W\0aring": -92,
  "W\0atilde": -92,
  "W\0colon": -65,
  "W\0comma": -92,
  "W\0e": -92,
  "W\0eacute": -92,
  "W\0ecaron": -92,
  "W\0ecircumflex": -92,
  "W\0edieresis": -52,
  "W\0edotaccent": -92,
  "W\0egrave": -52,
  "W\0emacron": -52,
  "W\0eogonek": -92,
  "W\0hyphen": -37,
  "W\0i": -55,
  "W\0iacute": -55,
  "W\0iogonek": -55,
  "W\0o": -92,
  "W\0oacute": -92,
  "W\0ocircumflex": -92,
  "W\0odieresis": -92,
  "W\0ograve": -92,
  "W\0ohungarumlaut": -92,
  "W\0omacron": -92,
  "W\0oslash": -92,
  "W\0otilde": -92,
  "W\0period": -92,
  "W\0semicolon": -65,
  "W\0u": -55,
  "W\0uacute": -55,
  "W\0ucircumflex": -55,
  "W\0udieresis": -55,
  "W\0ugrave": -55,
  "W\0uhungarumlaut": -55,
  "W\0umacron": -55,
  "W\0uogonek": -55,
  "W\0uring": -55,
  "W\0y": -70,
  "W\0yacute": -70,
  "W\0ydieresis": -70,
  "Y\0A": -50,
  "Y\0Aacute": -50,
  "Y\0Abreve": -50,
  "Y\0Acircumflex": -50,
  "Y\0Adieresis": -50,
  "Y\0Agrave": -50,
  "Y\0Amacron": -50,
  "Y\0Aogonek": -50,
  "Y\0Aring": -50,
  "Y\0Atilde": -50,
  "Y\0O": -15,
  "Y\0Oacute": -15,
  "Y\0Ocircumflex": -15,
  "Y\0Odieresis": -15,
  "Y\0Ograve": -15,
  "Y\0Ohungarumlaut": -15,
  "Y\0Omacron": -15,
  "Y\0Oslash": -15,
  "Y\0Otilde": -15,
  "Y\0a": -92,
  "Y\0aacute": -92,
  "Y\0abreve": -92,
  "Y\0acircumflex": -92,
  "Y\0adieresis": -92,
  "Y\0agrave": -92,
  "Y\0amacron": -92,
  "Y\0aogonek": -92,
  "Y\0aring": -92,
  "Y\0atilde": -92,
  "Y\0colon": -65,
  "Y\0comma": -92,
  "Y\0e": -92,
  "Y\0eacute": -92,
  "Y\0ecaron": -92,
  "Y\0ecircumflex": -92,
  "Y\0edieresis": -52,
  "Y\0edotaccent": -92,
  "Y\0egrave": -52,
  "Y\0emacron": -52,
  "Y\0eogonek": -92,
  "Y\0hyphen": -74,
  "Y\0i": -74,
  "Y\0iacute": -74,
  "Y\0icircumflex": -34,
  "Y\0idieresis": -34,
  "Y\0igrave": -34,
  "Y\0imacron": -34,
  "Y\0iogonek": -74,
  "Y\0o": -92,
  "Y\0oacute": -92,
  "Y\0ocircumflex": -92,
  "Y\0odieresis": -92,
  "Y\0ograve": -92,
  "Y\0ohungarumlaut": -92,
  "Y\0omacron": -92,
  "Y\0oslash": -92,
  "Y\0otilde": -92,
  "Y\0period": -92,
  "Y\0semicolon": -65,
  "Y\0u": -92,
  "Y\0uacute": -92,
  "Y\0ucircumflex": -92,
  "Y\0udieresis": -92,
  "Y\0ugrave": -92,
  "Y\0uhungarumlaut": -92,
  "Y\0umacron": -92,
  "Y\0uogonek": -92,
  "Y\0uring": -92,
  "Yacute\0A": -50,
  "Yacute\0Aacute": -50,
  "Yacute\0Abreve": -50,
  "Yacute\0Acircumflex": -50,
  "Yacute\0Adieresis": -50,
  "Yacute\0Agrave": -50,
  "Yacute\0Amacron": -50,
  "Yacute\0Aogonek": -50,
  "Yacute\0Aring": -50,
  "Yacute\0Atilde": -50,
  "Yacute\0O": -15,
  "Yacute\0Oacute": -15,
  "Yacute\0Ocircumflex": -15,
  "Yacute\0Odieresis": -15,
  "Yacute\0Ograve": -15,
  "Yacute\0Ohungarumlaut": -15,
  "Yacute\0Omacron": -15,
  "Yacute\0Oslash": -15,
  "Yacute\0Otilde": -15,
  "Yacute\0a": -92,
  "Yacute\0aacute": -92,
  "Yacute\0abreve": -92,
  "Yacute\0acircumflex": -92,
  "Yacute\0adieresis": -92,
  "Yacute\0agrave": -92,
  "Yacute\0amacron": -92,
  "Yacute\0aogonek": -92,
  "Yacute\0aring": -92,
  "Yacute\0atilde": -92,
  "Yacute\0colon": -65,
  "Yacute\0comma": -92,
  "Yacute\0e": -92,
  "Yacute\0eacute": -92,
  "Yacute\0ecaron": -92,
  "Yacute\0ecircumflex": -92,
  "Yacute\0edieresis": -52,
  "Yacute\0edotaccent": -92,
  "Yacute\0egrave": -52,
  "Yacute\0emacron": -52,
  "Yacute\0eogonek": -92,
  "Yacute\0hyphen": -74,
  "Yacute\0i": -74,
  "Yacute\0iacute": -74,
  "Yacute\0icircumflex": -34,
  "Yacute\0idieresis": -34,
  "Yacute\0igrave": -34,
  "Yacute\0imacron": -34,
  "Yacute\0iogonek": -74,
  "Yacute\0o": -92,
  "Yacute\0oacute": -92,
  "Yacute\0ocircumflex": -92,
  "Yacute\0odieresis": -92,
  "Yacute\0ograve": -92,
  "Yacute\0ohungarumlaut": -92,
  "Yacute\0omacron": -92,
  "Yacute\0oslash": -92,
  "Yacute\0otilde": -92,
  "Yacute\0period": -92,
  "Yacute\0semicolon": -65,
  "Yacute\0u": -92,
  "Yacute\0uacute": -92,
  "Yacute\0ucircumflex": -92,
  "Yacute\0udieresis": -92,
  "Yacute\0ugrave": -92,
  "Yacute\0uhungarumlaut": -92,
  "Yacute\0umacron": -92,
  "Yacute\0uogonek": -92,
  "Yacute\0uring": -92,
  "Ydieresis\0A": -50,
  "Ydieresis\0Aacute": -50,
  "Ydieresis\0Abreve": -50,
  "Ydieresis\0Acircumflex": -50,
  "Ydieresis\0Adieresis": -50,
  "Ydieresis\0Agrave": -50,
  "Ydieresis\0Amacron": -50,
  "Ydieresis\0Aogonek": -50,
  "Ydieresis\0Aring": -50,
  "Ydieresis\0Atilde": -50,
  "Ydieresis\0O": -15,
  "Ydieresis\0Oacute": -15,
  "Ydieresis\0Ocircumflex": -15,
  "Ydieresis\0Odieresis": -15,
  "Ydieresis\0Ograve": -15,
  "Ydieresis\0Ohungarumlaut": -15,
  "Ydieresis\0Omacron": -15,
  "Ydieresis\0Oslash": -15,
  "Ydieresis\0Otilde": -15,
  "Ydieresis\0a": -92,
  "Ydieresis\0aacute": -92,
  "Ydieresis\0abreve": -92,
  "Ydieresis\0acircumflex": -92,
  "Ydieresis\0adieresis": -92,
  "Ydieresis\0agrave": -92,
  "Ydieresis\0amacron": -92,
  "Ydieresis\0aogonek": -92,
  "Ydieresis\0aring": -92,
  "Ydieresis\0atilde": -92,
  "Ydieresis\0colon": -65,
  "Ydieresis\0comma": -92,
  "Ydieresis\0e": -92,
  "Ydieresis\0eacute": -92,
  "Ydieresis\0ecaron": -92,
  "Ydieresis\0ecircumflex": -92,
  "Ydieresis\0edieresis": -52,
  "Ydieresis\0edotaccent": -92,
  "Ydieresis\0egrave": -52,
  "Ydieresis\0emacron": -52,
  "Ydieresis\0eogonek": -92,
  "Ydieresis\0hyphen": -74,
  "Ydieresis\0i": -74,
  "Ydieresis\0iacute": -74,
  "Ydieresis\0icircumflex": -34,
  "Ydieresis\0idieresis": -34,
  "Ydieresis\0igrave": -34,
  "Ydieresis\0imacron": -34,
  "Ydieresis\0iogonek": -74,
  "Ydieresis\0o": -92,
  "Ydieresis\0oacute": -92,
  "Ydieresis\0ocircumflex": -92,
  "Ydieresis\0odieresis": -92,
  "Ydieresis\0ograve": -92,
  "Ydieresis\0ohungarumlaut": -92,
  "Ydieresis\0omacron": -92,
  "Ydieresis\0oslash": -92,
  "Ydieresis\0otilde": -92,
  "Ydieresis\0period": -92,
  "Ydieresis\0semicolon": -65,
  "Ydieresis\0u": -92,
  "Ydieresis\0uacute": -92,
  "Ydieresis\0ucircumflex": -92,
  "Ydieresis\0udieresis": -92,
  "Ydieresis\0ugrave": -92,
  "Ydieresis\0uhungarumlaut": -92,
  "Ydieresis\0umacron": -92,
  "Ydieresis\0uogonek": -92,
  "Ydieresis\0uring": -92,
  "a\0g": -10,
  "a\0gbreve": -10,
  "a\0gcommaaccent": -10,
  "aacute\0g": -10,
  "aacute\0gbreve": -10,
  "aacute\0gcommaaccent": -10,
  "abreve\0g": -10,
  "abreve\0gbreve": -10,
  "abreve\0gcommaaccent": -10,
  "acircumflex\0g": -10,
  "acircumflex\0gbreve": -10,
  "acircumflex\0gcommaaccent": -10,
  "adieresis\0g": -10,
  "adieresis\0gbreve": -10,
  "adieresis\0gcommaaccent": -10,
  "agrave\0g": -10,
  "agrave\0gbreve": -10,
  "agrave\0gcommaaccent": -10,
  "amacron\0g": -10,
  "amacron\0gbreve": -10,
  "amacron\0gcommaaccent": -10,
  "aogonek\0g": -10,
  "aogonek\0gbreve": -10,
  "aogonek\0gcommaaccent": -10,
  "aring\0g": -10,
  "aring\0gbreve": -10,
  "aring\0gcommaaccent": -10,
  "atilde\0g": -10,
  "atilde\0gbreve": -10,
  "atilde\0gcommaaccent": -10,
  "b\0period": -40,
  "b\0u": -20,
  "b\0uacute": -20,
  "b\0ucircumflex": -20,
  "b\0udieresis": -20,
  "b\0ugrave": -20,
  "b\0uhungarumlaut": -20,
  "b\0umacron": -20,
  "b\0uogonek": -20,
  "b\0uring": -20,
  "c\0h": -15,
  "c\0k": -20,
  "c\0kcommaaccent": -20,
  "cacute\0h": -15,
  "cacute\0k": -20,
  "cacute\0kcommaaccent": -20,
  "ccaron\0h": -15,
  "ccaron\0k": -20,
  "ccaron\0kcommaaccent": -20,
  "ccedilla\0h": -15,
  "ccedilla\0k": -20,
  "ccedilla\0kcommaaccent": -20,
  "comma\0quotedblright": -140,
  "comma\0quoteright": -140,
  "e\0comma": -10,
  "e\0g": -40,
  "e\0gbreve": -40,
  "e\0gcommaaccent": -40,
  "e\0period": -15,
  "e\0v": -15,
  "e\0w": -15,
  "e\0x": -20,
  "e\0y": -30,
  "e\0yacute": -30,
  "e\0ydieresis": -30,
  "eacute\0comma": -10,
  "eacute\0g": -40,
  "eacute\0gbreve": -40,
  "eacute\0gcommaaccent": -40,
  "eacute\0period": -15,
  "eacute\0v": -15,
  "eacute\0w": -15,
  "eacute\0x": -20,
  "eacute\0y": -30,
  "eacute\0yacute": -30,
  "eacute\0ydieresis": -30,
  "ecaron\0comma": -10,
  "ecaron\0g": -40,
  "ecaron\0gbreve": -40,
  "ecaron\0gcommaaccent": -40,
  "ecaron\0period": -15,
  "ecaron\0v": -15,
  "ecaron\0w": -15,
  "ecaron\0x": -20,
  "ecaron\0y": -30,
  "ecaron\0yacute": -30,
  "ecaron\0ydieresis": -30,
  "ecircumflex\0comma": -10,
  "ecircumflex\0g": -40,
  "ecircumflex\0gbreve": -40,
  "ecircumflex\0gcommaaccent": -40,
  "ecircumflex\0period": -15,
  "ecircumflex\0v": -15,
  "ecircumflex\0w": -15,
  "ecircumflex\0x": -20,
  "ecircumflex\0y": -30,
  "ecircumflex\0yacute": -30,
  "ecircumflex\0ydieresis": -30,
  "edieresis\0comma": -10,
  "edieresis\0g": -40,
  "edieresis\0gbreve": -40,
  "edieresis\0gcommaaccent": -40,
  "edieresis\0period": -15,
  "edieresis\0v": -15,
  "edieresis\0w": -15,
  "edieresis\0x": -20,
  "edieresis\0y": -30,
  "edieresis\0yacute": -30,
  "edieresis\0ydieresis": -30,
  "edotaccent\0comma": -10,
  "edotaccent\0g": -40,
  "edotaccent\0gbreve": -40,
  "edotaccent\0gcommaaccent": -40,
  "edotaccent\0period": -15,
  "edotaccent\0v": -15,
  "edotaccent\0w": -15,
  "edotaccent\0x": -20,
  "edotaccent\0y": -30,
  "edotaccent\0yacute": -30,
  "edotaccent\0ydieresis": -30,
  "egrave\0comma": -10,
  "egrave\0g": -40,
  "egrave\0gbreve": -40,
  "egrave\0gcommaaccent": -40,
  "egrave\0period": -15,
  "egrave\0v": -15,
  "egrave\0w": -15,
  "egrave\0x": -20,
  "egrave\0y": -30,
  "egrave\0yacute": -30,
  "egrave\0ydieresis": -30,
  "emacron\0comma": -10,
  "emacron\0g": -40,
  "emacron\0gbreve": -40,
  "emacron\0gcommaaccent": -40,
  "emacron\0period": -15,
  "emacron\0v": -15,
  "emacron\0w": -15,
  "emacron\0x": -20,
  "emacron\0y": -30,
  "emacron\0yacute": -30,
  "emacron\0ydieresis": -30,
  "eogonek\0comma": -10,
  "eogonek\0g": -40,
  "eogonek\0gbreve": -40,
  "eogonek\0gcommaaccent": -40,
  "eogonek\0period": -15,
  "eogonek\0v": -15,
  "eogonek\0w": -15,
  "eogonek\0x": -20,
  "eogonek\0y": -30,
  "eogonek\0yacute": -30,
  "eogonek\0ydieresis": -30,
  "f\0comma": -10,
  "f\0dotlessi": -60,
  "f\0f": -18,
  "f\0i": -20,
  "f\0iogonek": -20,
  "f\0period": -15,
  "f\0quoteright": 92,
  "g\0comma": -10,
  "g\0e": -10,
  "g\0eacute": -10,
  "g\0ecaron": -10,
  "g\0ecircumflex": -10,
  "g\0edieresis": -10,
  "g\0edotaccent": -10,
  "g\0egrave": -10,
  "g\0emacron": -10,
  "g\0eogonek": -10,
  "g\0g": -10,
  "g\0gbreve": -10,
  "g\0gcommaaccent": -10,
  "g\0period": -15,
  "gbreve\0comma": -10,
  "gbreve\0e": -10,
  "gbreve\0eacute": -10,
  "gbreve\0ecaron": -10,
  "gbreve\0ecircumflex": -10,
  "gbreve\0edieresis": -10,
  "gbreve\0edotaccent": -10,
  "gbreve\0egrave": -10,
  "gbreve\0emacron": -10,
  "gbreve\0eogonek": -10,
  "gbreve\0g": -10,
  "gbreve\0gbreve": -10,
  "gbreve\0gcommaaccent": -10,
  "gbreve\0period": -15,
  "gcommaaccent\0comma": -10,
  "gcommaaccent\0e": -10,
  "gcommaaccent\0eacute": -10,
  "gcommaaccent\0ecaron": -10,
  "gcommaaccent\0ecircumflex": -10,
  "gcommaaccent\0edieresis": -10,
  "gcommaaccent\0edotaccent": -10,
  "gcommaaccent\0egrave": -10,
  "gcommaaccent\0emacron": -10,
  "gcommaaccent\0eogonek": -10,
  "gcommaaccent\0g": -10,
  "gcommaaccent\0gbreve": -10,
  "gcommaaccent\0gcommaaccent": -10,
  "gcommaaccent\0period": -15,
  "k\0e": -10,
  "k\0eacute": -10,
  "k\0ecaron": -10,
  "k\0ecircumflex": -10,
  "k\0edieresis": -10,
  "k\0edotaccent": -10,
  "k\0egrave": -10,
  "k\0emacron": -10,
  "k\0eogonek": -10,
  "k\0o": -10,
  "k\0oacute": -10,
  "k\0ocircumflex": -10,
  "k\0odieresis": -10,
  "k\0ograve": -10,
  "k\0ohungarumlaut": -10,
  "k\0omacron": -10,
  "k\0oslash": -10,
  "k\0otilde": -10,
  "k\0y": -10,
  "k\0yacute": -10,
  "k\0ydieresis": -10,
  "kcommaaccent\0e": -10,
  "kcommaaccent\0eacute": -10,
  "kcommaaccent\0ecaron": -10,
  "kcommaaccent\0ecircumflex": -10,
  "kcommaaccent\0edieresis": -10,
  "kcommaaccent\0edotaccent": -10,
  "kcommaaccent\0egrave": -10,
  "kcommaaccent\0emacron": -10,
  "kcommaaccent\0eogonek": -10,
  "kcommaaccent\0o": -10,
  "kcommaaccent\0oacute": -10,
  "kcommaaccent\0ocircumflex": -10,
  "kcommaaccent\0odieresis": -10,
  "kcommaaccent\0ograve": -10,
  "kcommaaccent\0ohungarumlaut": -10,
  "kcommaaccent\0omacron": -10,
  "kcommaaccent\0oslash": -10,
  "kcommaaccent\0otilde": -10,
  "kcommaaccent\0y": -10,
  "kcommaaccent\0yacute": -10,
  "kcommaaccent\0ydieresis": -10,
  "n\0v": -40,
  "nacute\0v": -40,
  "ncaron\0v": -40,
  "ncommaaccent\0v": -40,
  "ntilde\0v": -40,
  "o\0g": -10,
  "o\0gbreve": -10,
  "o\0gcommaaccent": -10,
  "o\0v": -10,
  "oacute\0g": -10,
  "oacute\0gbreve": -10,
  "oacute\0gcommaaccent": -10,
  "oacute\0v": -10,
  "ocircumflex\0g": -10,
  "ocircumflex\0gbreve": -10,
  "ocircumflex\0gcommaaccent": -10,
  "ocircumflex\0v": -10,
  "odieresis\0g": -10,
  "odieresis\0gbreve": -10,
  "odieresis\0gcommaaccent": -10,
  "odieresis\0v": -10,
  "ograve\0g": -10,
  "ograve\0gbreve": -10,
  "ograve\0gcommaaccent": -10,
  "ograve\0v": -10,
  "ohungarumlaut\0g": -10,
  "ohungarumlaut\0gbreve": -10,
  "ohungarumlaut\0gcommaaccent": -10,
  "ohungarumlaut\0v": -10,
  "omacron\0g": -10,
  "omacron\0gbreve": -10,
  "omacron\0gcommaaccent": -10,
  "omacron\0v": -10,
  "oslash\0g": -10,
  "oslash\0gbreve": -10,
  "oslash\0gcommaaccent": -10,
  "oslash\0v": -10,
  "otilde\0g": -10,
  "otilde\0gbreve": -10,
  "otilde\0gcommaaccent": -10,
  "otilde\0v": -10,
  "period\0quotedblright": -140,
  "period\0quoteright": -140,
  "quoteleft\0quoteleft": -111,
  "quoteright\0d": -25,
  "quoteright\0dcroat": -25,
  "quoteright\0quoteright": -111,
  "quoteright\0r": -25,
  "quoteright\0racute": -25,
  "quoteright\0rcaron": -25,
  "quoteright\0rcommaaccent": -25,
  "quoteright\0s": -40,
  "quoteright\0sacute": -40,
  "quoteright\0scaron": -40,
  "quoteright\0scedilla": -40,
  "quoteright\0scommaaccent": -40,
  "quoteright\0space": -111,
  "quoteright\0t": -30,
  "quoteright\0tcommaaccent": -30,
  "quoteright\0v": -10,
  "r\0a": -15,
  "r\0aacute": -15,
  "r\0abreve": -15,
  "r\0acircumflex": -15,
  "r\0adieresis": -15,
  "r\0agrave": -15,
  "r\0amacron": -15,
  "r\0aogonek": -15,
  "r\0aring": -15,
  "r\0atilde": -15,
  "r\0c": -37,
  "r\0cacute": -37,
  "r\0ccaron": -37,
  "r\0ccedilla": -37,
  "r\0comma": -111,
  "r\0d": -37,
  "r\0dcroat": -37,
  "r\0e": -37,
  "r\0eacute": -37,
  "r\0ecaron": -37,
  "r\0ecircumflex": -37,
  "r\0edieresis": -37,
  "r\0edotaccent": -37,
  "r\0egrave": -37,
  "r\0emacron": -37,
  "r\0eogonek": -37,
  "r\0g": -37,
  "r\0gbreve": -37,
  "r\0gcommaaccent": -37,
  "r\0hyphen": -20,
  "r\0o": -45,
  "r\0oacute": -45,
  "r\0ocircumflex": -45,
  "r\0odieresis": -45,
  "r\0ograve": -45,
  "r\0ohungarumlaut": -45,
  "r\0omacron": -45,
  "r\0oslash": -45,
  "r\0otilde": -45,
  "r\0period": -111,
  "r\0q": -37,
  "r\0s": -10,
  "r\0sacute": -10,
  "r\0scaron": -10,
  "r\0scedilla": -10,
  "r\0scommaaccent": -10,
  "racute\0a": -15,
  "racute\0aacute": -15,
  "racute\0abreve": -15,
  "racute\0acircumflex": -15,
  "racute\0adieresis": -15,
  "racute\0agrave": -15,
  "racute\0amacron": -15,
  "racute\0aogonek": -15,
  "racute\0aring": -15,
  "racute\0atilde": -15,
  "racute\0c": -37,
  "racute\0cacute": -37,
  "racute\0ccaron": -37,
  "racute\0ccedilla": -37,
  "racute\0comma": -111,
  "racute\0d": -37,
  "racute\0dcroat": -37,
  "racute\0e": -37,
  "racute\0eacute": -37,
  "racute\0ecaron": -37,
  "racute\0ecircumflex": -37,
  "racute\0edieresis": -37,
  "racute\0edotaccent": -37,
  "racute\0egrave": -37,
  "racute\0emacron": -37,
  "racute\0eogonek": -37,
  "racute\0g": -37,
  "racute\0gbreve": -37,
  "racute\0gcommaaccent": -37,
  "racute\0hyphen": -20,
  "racute\0o": -45,
  "racute\0oacute": -45,
  "racute\0ocircumflex": -45,
  "racute\0odieresis": -45,
  "racute\0ograve": -45,
  "racute\0ohungarumlaut": -45,
  "racute\0omacron": -45,
  "racute\0oslash": -45,
  "racute\0otilde": -45,
  "racute\0period": -111,
  "racute\0q": -37,
  "racute\0s": -10,
  "racute\0sacute": -10,
  "racute\0scaron": -10,
  "racute\0scedilla": -10,
  "racute\0scommaaccent": -10,
  "rcaron\0a": -15,
  "rcaron\0aacute": -15,
  "rcaron\0abreve": -15,
  "rcaron\0acircumflex": -15,
  "rcaron\0adieresis": -15,
  "rcaron\0agrave": -15,
  "rcaron\0amacron": -15,
  "rcaron\0aogonek": -15,
  "rcaron\0aring": -15,
  "rcaron\0atilde": -15,
  "rcaron\0c": -37,
  "rcaron\0cacute": -37,
  "rcaron\0ccaron": -37,
  "rcaron\0ccedilla": -37,
  "rcaron\0comma": -111,
  "rcaron\0d": -37,
  "rcaron\0dcroat": -37,
  "rcaron\0e": -37,
  "rcaron\0eacute": -37,
  "rcaron\0ecaron": -37,
  "rcaron\0ecircumflex": -37,
  "rcaron\0edieresis": -37,
  "rcaron\0edotaccent": -37,
  "rcaron\0egrave": -37,
  "rcaron\0emacron": -37,
  "rcaron\0eogonek": -37,
  "rcaron\0g": -37,
  "rcaron\0gbreve": -37,
  "rcaron\0gcommaaccent": -37,
  "rcaron\0hyphen": -20,
  "rcaron\0o": -45,
  "rcaron\0oacute": -45,
  "rcaron\0ocircumflex": -45,
  "rcaron\0odieresis": -45,
  "rcaron\0ograve": -45,
  "rcaron\0ohungarumlaut": -45,
  "rcaron\0omacron": -45,
  "rcaron\0oslash": -45,
  "rcaron\0otilde": -45,
  "rcaron\0period": -111,
  "rcaron\0q": -37,
  "rcaron\0s": -10,
  "rcaron\0sacute": -10,
  "rcaron\0scaron": -10,
  "rcaron\0scedilla": -10,
  "rcaron\0scommaaccent": -10,
  "rcommaaccent\0a": -15,
  "rcommaaccent\0aacute": -15,
  "rcommaaccent\0abreve": -15,
  "rcommaaccent\0acircumflex": -15,
  "rcommaaccent\0adieresis": -15,
  "rcommaaccent\0agrave": -15,
  "rcommaaccent\0amacron": -15,
  "rcommaaccent\0aogonek": -15,
  "rcommaaccent\0aring": -15,
  "rcommaaccent\0atilde": -15,
  "rcommaaccent\0c": -37,
  "rcommaaccent\0cacute": -37,
  "rcommaaccent\0ccaron": -37,
  "rcommaaccent\0ccedilla": -37,
  "rcommaaccent\0comma": -111,
  "rcommaaccent\0d": -37,
  "rcommaaccent\0dcroat": -37,
  "rcommaaccent\0e": -37,
  "rcommaaccent\0eacute": -37,
  "rcommaaccent\0ecaron": -37,
  "rcommaaccent\0ecircumflex": -37,
  "rcommaaccent\0edieresis": -37,
  "rcommaaccent\0edotaccent": -37,
  "rcommaaccent\0egrave": -37,
  "rcommaaccent\0emacron": -37,
  "rcommaaccent\0eogonek": -37,
  "rcommaaccent\0g": -37,
  "rcommaaccent\0gbreve": -37,
  "rcommaaccent\0gcommaaccent": -37,
  "rcommaaccent\0hyphen": -20,
  "rcommaaccent\0o": -45,
  "rcommaaccent\0oacute": -45,
  "rcommaaccent\0ocircumflex": -45,
  "rcommaaccent\0odieresis": -45,
  "rcommaaccent\0ograve": -45,
  "rcommaaccent\0ohungarumlaut": -45,
  "rcommaaccent\0omacron": -45,
  "rcommaaccent\0oslash": -45,
  "rcommaaccent\0otilde": -45,
  "rcommaaccent\0period": -111,
  "rcommaaccent\0q": -37,
  "rcommaaccent\0s": -10,
  "rcommaaccent\0sacute": -10,
  "rcommaaccent\0scaron": -10,
  "rcommaaccent\0scedilla": -10,
  "rcommaaccent\0scommaaccent": -10,
  "space\0A": -18,
  "space\0Aacute": -18,
  "space\0Abreve": -18,
  "space\0Acircumflex": -18,
  "space\0Adieresis": -18,
  "space\0Agrave": -18,
  "space\0Amacron": -18,
  "space\0Aogonek": -18,
  "space\0Aring": -18,
  "space\0Atilde": -18,
  "space\0T": -18,
  "space\0Tcaron": -18,
  "space\0Tcommaaccent": -18,
  "space\0V": -35,
  "space\0W": -40,
  "space\0Y": -75,
  "space\0Yacute": -75,
  "space\0Ydieresis": -75,
  "v\0comma": -74,
  "v\0period": -74,
  "w\0comma": -74,
  "w\0period": -74,
  "y\0comma": -55,
  "y\0period": -55,
  "yacute\0comma": -55,
  "yacute\0period": -55,
  "ydieresis\0comma": -55,
  "ydieresis\0period": -55
};
var TimesItalic = {
  attributes: attributes,
  glyphWidths: glyphWidths,
  kernPairs: kernPairs
};
var STANDARD_FONTS = {
  Courier: Courier,
  'Courier-Bold': CourierBold,
  'Courier-Oblique': CourierOblique,
  Helvetica: Helvetica,
  'Helvetica-Bold': HelveticaBold,
  'Helvetica-Oblique': HelveticaOblique,
  'Times-Roman': TimesRoman,
  'Times-Bold': TimesBold,
  'Times-Italic': TimesItalic
};

var createStandardFont = function createStandardFont(PDFFont) {
  return /*#__PURE__*/function (_PDFFont) {
    _inheritsLoose(StandardFont, _PDFFont);

    function StandardFont(document, name, id) {
      var _this;

      _this = _PDFFont.call(this) || this;
      _this.document = document;
      _this.name = name;
      _this.id = id;
      _this.font = AFMFont.fromJson(STANDARD_FONTS[_this.name]);
      _this.ascender = _this.font.ascender;
      _this.descender = _this.font.descender;
      _this.bbox = _this.font.bbox;
      _this.lineGap = _this.font.lineGap;
      return _this;
    }

    var _proto = StandardFont.prototype;

    _proto.embed = function embed() {
      this.dictionary.data = {
        Type: 'Font',
        BaseFont: this.name,
        Subtype: 'Type1',
        Encoding: 'WinAnsiEncoding'
      };
      return this.dictionary.end();
    };

    _proto.encode = function encode(text) {
      var encoded = this.font.encodeText(text);
      var glyphs = this.font.glyphsForString("" + text);
      var advances = this.font.advancesForGlyphs(glyphs);
      var positions = [];

      for (var i = 0; i < glyphs.length; i++) {
        var glyph = glyphs[i];
        positions.push({
          xAdvance: advances[i],
          yAdvance: 0,
          xOffset: 0,
          yOffset: 0,
          advanceWidth: this.font.widthOfGlyph(glyph)
        });
      }

      return [encoded, positions];
    };

    _proto.encodeGlyphs = function encodeGlyphs(glyphs) {
      var res = [];

      for (var _i = 0, _Array$from = Array.from(glyphs); _i < _Array$from.length; _i++) {
        var glyph = _Array$from[_i];
        res.push(("00" + glyph.id.toString(16)).slice(-2));
      }

      return res;
    };

    _proto.widthOfString = function widthOfString(string, size) {
      var glyphs = this.font.glyphsForString("" + string);
      var advances = this.font.advancesForGlyphs(glyphs);
      var width = 0;

      for (var _i2 = 0, _Array$from2 = Array.from(advances); _i2 < _Array$from2.length; _i2++) {
        var advance = _Array$from2[_i2];
        width += advance;
      }

      var scale = size / 1000;
      return width * scale;
    };

    StandardFont.isStandardFont = function isStandardFont(name) {
      return name in STANDARD_FONTS;
    };

    return StandardFont;
  }(PDFFont);
};

var toHex = function toHex() {
  for (var _len = arguments.length, codePoints = new Array(_len), _key = 0; _key < _len; _key++) {
    codePoints[_key] = arguments[_key];
  }

  var codes = Array.from(codePoints).map(function (code) {
    return ("0000" + code.toString(16)).slice(-4);
  });
  return codes.join('');
};

var createEmbeddedFont = function createEmbeddedFont(PDFFont) {
  return /*#__PURE__*/function (_PDFFont) {
    _inheritsLoose(EmbeddedFont, _PDFFont);

    function EmbeddedFont(document, font, id) {
      var _this;

      _this = _PDFFont.call(this) || this;
      _this.document = document;
      _this.font = font;
      _this.id = id;
      _this.subset = _this.font.createSubset();
      _this.unicode = [[0]];
      _this.widths = [_this.font.getGlyph(0).advanceWidth];
      _this.name = _this.font.postscriptName;
      _this.scale = 1000 / _this.font.unitsPerEm;
      _this.ascender = _this.font.ascent * _this.scale;
      _this.descender = _this.font.descent * _this.scale;
      _this.xHeight = _this.font.xHeight * _this.scale;
      _this.capHeight = _this.font.capHeight * _this.scale;
      _this.lineGap = _this.font.lineGap * _this.scale;
      _this.bbox = _this.font.bbox;
      _this.layoutCache = Object.create(null);
      return _this;
    }

    var _proto = EmbeddedFont.prototype;

    _proto.layoutRun = function layoutRun(text, features) {
      var run = this.font.layout(text, features); // Normalize position values

      for (var i = 0; i < run.positions.length; i++) {
        var position = run.positions[i];

        for (var key in position) {
          position[key] *= this.scale;
        }

        position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
      }

      return run;
    };

    _proto.layoutCached = function layoutCached(text) {
      var cached;

      if (cached = this.layoutCache[text]) {
        return cached;
      }

      var run = this.layoutRun(text);
      this.layoutCache[text] = run;
      return run;
    };

    _proto.layout = function layout(text, features, onlyWidth) {
      // Skip the cache if any user defined features are applied
      if (onlyWidth == null) {
        onlyWidth = false;
      }

      if (features) {
        return this.layoutRun(text, features);
      }

      var glyphs = onlyWidth ? null : [];
      var positions = onlyWidth ? null : [];
      var advanceWidth = 0; // Split the string by words to increase cache efficiency.
      // For this purpose, spaces and tabs are a good enough delimeter.

      var last = 0;
      var index = 0;

      while (index <= text.length) {
        var needle;

        if (index === text.length && last < index || (needle = text.charAt(index), [' ', '\t'].includes(needle))) {
          var run = this.layoutCached(text.slice(last, ++index));

          if (!onlyWidth) {
            glyphs.push.apply(glyphs, Array.from(run.glyphs || []));
            positions.push.apply(positions, Array.from(run.positions || []));
          }

          advanceWidth += run.advanceWidth;
          last = index;
        } else {
          index++;
        }
      }

      return {
        glyphs: glyphs,
        positions: positions,
        advanceWidth: advanceWidth
      };
    };

    _proto.encode = function encode(text, features) {
      var _this$layout = this.layout(text, features),
          glyphs = _this$layout.glyphs,
          positions = _this$layout.positions;

      var res = [];

      for (var i = 0; i < glyphs.length; i++) {
        var glyph = glyphs[i];
        var gid = this.subset.includeGlyph(glyph.id);
        res.push(("0000" + gid.toString(16)).slice(-4));

        if (this.widths[gid] == null) {
          this.widths[gid] = glyph.advanceWidth * this.scale;
        }

        if (this.unicode[gid] == null) {
          this.unicode[gid] = this.font._cmapProcessor.codePointsForGlyph(glyph.id);
        }
      }

      return [res, positions];
    };

    _proto.encodeGlyphs = function encodeGlyphs(glyphs) {
      var res = [];

      for (var i = 0; i < glyphs.length; i++) {
        var glyph = glyphs[i];
        var gid = this.subset.includeGlyph(glyph.id);
        res.push(("0000" + gid.toString(16)).slice(-4));

        if (this.widths[gid] == null) {
          this.widths[gid] = glyph.advanceWidth * this.scale;
        }

        if (this.unicode[gid] == null) {
          this.unicode[gid] = this.font._cmapProcessor.codePointsForGlyph(glyph.id);
        }
      }

      return res;
    };

    _proto.widthOfString = function widthOfString(string, size, features) {
      var width = this.layout(string, features, true).advanceWidth;
      var scale = size / 1000;
      return width * scale;
    };

    _proto.embed = function embed() {
      var isCFF = this.subset.cff != null;
      var fontFile = this.document.ref();

      if (isCFF) {
        fontFile.data.Subtype = 'CIDFontType0C';
      }

      this.subset.encodeStream().pipe(fontFile);
      var familyClass = ((this.font['OS/2'] != null ? this.font['OS/2'].sFamilyClass : undefined) || 0) >> 8;
      var flags = 0;

      if (this.font.post.isFixedPitch) {
        flags |= 1 << 0;
      }

      if (1 <= familyClass && familyClass <= 7) {
        flags |= 1 << 1;
      }

      flags |= 1 << 2; // assume the font uses non-latin characters

      if (familyClass === 10) {
        flags |= 1 << 3;
      }

      if (this.font.head.macStyle.italic) {
        flags |= 1 << 6;
      } // generate a random tag (6 uppercase letters. 65 is the char code for 'A')


      var tag = [0, 1, 2, 3, 4, 5].map(function (i) {
        return String.fromCharCode(Math.random() * 26 + 65);
      }).join('');
      var name = tag + '+' + this.font.postscriptName;
      var bbox = this.font.bbox;
      var descriptor = this.document.ref({
        Type: 'FontDescriptor',
        FontName: name,
        Flags: flags,
        FontBBox: [bbox.minX * this.scale, bbox.minY * this.scale, bbox.maxX * this.scale, bbox.maxY * this.scale],
        ItalicAngle: this.font.italicAngle,
        Ascent: this.ascender,
        Descent: this.descender,
        CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
        XHeight: (this.font.xHeight || 0) * this.scale,
        StemV: 0
      }); // not sure how to calculate this

      if (isCFF) {
        descriptor.data.FontFile3 = fontFile;
      } else {
        descriptor.data.FontFile2 = fontFile;
      }

      descriptor.end();
      var descendantFont = this.document.ref({
        Type: 'Font',
        Subtype: isCFF ? 'CIDFontType0' : 'CIDFontType2',
        BaseFont: name,
        CIDSystemInfo: {
          Registry: new String('Adobe'),
          Ordering: new String('Identity'),
          Supplement: 0
        },
        FontDescriptor: descriptor,
        W: [0, this.widths]
      });
      descendantFont.end();
      this.dictionary.data = {
        Type: 'Font',
        Subtype: 'Type0',
        BaseFont: name,
        Encoding: 'Identity-H',
        DescendantFonts: [descendantFont],
        ToUnicode: this.toUnicodeCmap()
      };
      return this.dictionary.end();
    } // Maps the glyph ids encoded in the PDF back to unicode strings
    // Because of ligature substitutions and the like, there may be one or more
    // unicode characters represented by each glyph.
    ;

    _proto.toUnicodeCmap = function toUnicodeCmap() {
      var cmap = this.document.ref();
      var entries = [];

      for (var _i = 0, _Array$from = Array.from(this.unicode); _i < _Array$from.length; _i++) {
        var codePoints = _Array$from[_i];
        var encoded = [];

        for (var _i2 = 0, _Array$from2 = Array.from(codePoints); _i2 < _Array$from2.length; _i2++) {
          var value = _Array$from2[_i2];

          if (value > 0xffff) {
            value -= 0x10000;
            encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
            value = 0xdc00 | value & 0x3ff;
          }

          encoded.push(toHex(value));
          entries.push("<" + encoded.join(' ') + ">");
        }
      }

      cmap.end("  /CIDInit /ProcSet findresource begin\n  12 dict begin\n  begincmap\n  /CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n  >> def\n  /CMapName /Adobe-Identity-UCS def\n  /CMapType 2 def\n  1 begincodespacerange\n  <0000><ffff>\n  endcodespacerange\n  1 beginbfrange\n  <0000> <" + toHex(entries.length - 1) + "> [" + entries.join(' ') + "]\n  endbfrange\n  endcmap\n  CMapName currentdict /CMap defineresource pop\n  end\n  end  ");
      return cmap;
    };

    return EmbeddedFont;
  }(PDFFont);
};

var PDFFont = /*#__PURE__*/function () {
  function PDFFont() {}

  PDFFont.open = function open(document, src, family, id) {
    var font;

    if (typeof src === 'string') {
      if (StandardFont.isStandardFont(src)) {
        return new StandardFont(document, src, id);
      }

      font = fontkit.openSync(src, family);
    } else if (Buffer.isBuffer(src)) {
      font = fontkit.create(src, family);
    } else if (src instanceof Uint8Array) {
      font = fontkit.create(Buffer.from(src), family);
    } else if (src instanceof ArrayBuffer) {
      font = fontkit.create(Buffer.from(new Uint8Array(src)), family);
    } else if (typeof src === 'object') {
      font = src;
    }

    if (font == null) {
      throw new Error('Not a supported font format or standard PDF font.');
    }

    return new EmbeddedFont(document, font, id);
  };

  var _proto = PDFFont.prototype;

  _proto.encode = function encode(text) {
    throw new Error('Must be implemented by subclasses');
  };

  _proto.widthOfString = function widthOfString(text) {
    throw new Error('Must be implemented by subclasses');
  };

  _proto.ref = function ref() {
    return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
  };

  _proto.finalize = function finalize() {
    if (this.embedded || this.dictionary == null) {
      return;
    }

    this.embed();
    return this.embedded = true;
  };

  _proto.embed = function embed() {
    throw new Error('Must be implemented by subclasses');
  };

  _proto.lineHeight = function lineHeight(size, includeGap) {
    if (includeGap == null) {
      includeGap = false;
    }

    var gap = includeGap ? this.lineGap : 0;
    return (this.ascender + gap - this.descender) / 1000 * size;
  };

  return PDFFont;
}();

var StandardFont = createStandardFont(PDFFont);
var EmbeddedFont = createEmbeddedFont(PDFFont);
var Fonts = {
  initFonts: function initFonts() {
    // Lookup table for embedded fonts
    this._fontFamilies = {};
    this._fontCount = 0; // Font state

    this._fontSize = 12;
    this._font = null;
    this._registeredFonts = {}; // Set the default font

    return this.font('Helvetica');
  },
  font: function font(src, family, size) {
    var cacheKey, font;

    if (typeof family === 'number') {
      size = family;
      family = null;
    } // check registered fonts if src is a string


    if (typeof src === 'string' && this._registeredFonts[src]) {
      cacheKey = src;
      var _this$_registeredFont = this._registeredFonts[src];
      src = _this$_registeredFont.src;
      family = _this$_registeredFont.family;
    } else {
      cacheKey = family || src;

      if (typeof cacheKey !== 'string') {
        cacheKey = null;
      }
    }

    if (size != null) {
      this.fontSize(size);
    } // fast path: check if the font is already in the PDF


    if (font = this._fontFamilies[cacheKey]) {
      this._font = font;
      return this;
    } // load the font


    var id = "F" + ++this._fontCount;
    this._font = PDFFont.open(this, src, family, id); // check for existing font familes with the same name already in the PDF
    // useful if the font was passed as a buffer

    if (font = this._fontFamilies[this._font.name]) {
      this._font = font;
      return this;
    } // save the font for reuse later


    if (cacheKey) {
      this._fontFamilies[cacheKey] = this._font;
    }

    if (this._font.name) {
      this._fontFamilies[this._font.name] = this._font;
    }

    return this;
  },
  fontSize: function fontSize(_fontSize) {
    this._fontSize = _fontSize;
    return this;
  },
  currentLineHeight: function currentLineHeight(includeGap) {
    if (includeGap == null) {
      includeGap = false;
    }

    return this._font.lineHeight(this._fontSize, includeGap);
  },
  registerFont: function registerFont(name, src, family) {
    this._registeredFonts[name] = {
      src: src,
      family: family
    };
    return this;
  }
};
var number = PDFObject$1.number;
var Text = {
  initText: function initText() {
    this._line = this._line.bind(this); // Current coordinates

    this.x = 0;
    this.y = 0;
    return this._lineGap = 0;
  },
  _text: function _text(text, x, y, options, lineCallback) {
    var _this = this;

    options = this._initOptions(x, y, options); // Convert text to a string

    text = text == null ? '' : "" + text; // if the wordSpacing option is specified, remove multiple consecutive spaces

    if (options.wordSpacing) {
      text = text.replace(/\s{2,}/g, ' ');
    }

    var addStructure = function addStructure() {
      if (options.structParent) {
        options.structParent.add(_this.struct(options.structType || 'P', [_this.markStructureContent(options.structType || 'P')]));
      }
    };

    for (var _iterator = _createForOfIteratorHelperLoose(text.split('\n')), _step; !(_step = _iterator()).done;) {
      var line = _step.value;
      addStructure();
      lineCallback(line, options);
    }

    return this;
  },
  text: function text(_text2, x, y, options) {
    return this._text(_text2, x, y, options, this._line);
  },
  widthOfString: function widthOfString(string, options) {
    if (options === void 0) {
      options = {};
    }

    return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
  },
  _initOptions: function _initOptions(x, y, options) {
    if (x === void 0) {
      x = {};
    }

    if (options === void 0) {
      options = {};
    }

    if (typeof x === 'object') {
      options = x;
      x = null;
    } // clone options object


    var result = Object.assign({}, options); // extend options with previous values for continued text

    if (this._textOptions) {
      for (var key in this._textOptions) {
        var val = this._textOptions[key];

        if (key !== 'continued') {
          if (result[key] === undefined) {
            result[key] = val;
          }
        }
      }
    } // Update the current position


    if (x != null) {
      this.x = x;
    }

    if (y != null) {
      this.y = y;
    } // wrap to margins if no x or y position passed


    if (result.lineBreak !== false) {
      if (result.width == null) {
        result.width = this.page.width - this.x - this.page.margins.right;
      }

      result.width = Math.max(result.width, 0);
    }

    if (!result.columns) {
      result.columns = 0;
    }

    if (result.columnGap == null) {
      result.columnGap = 18;
    } // 1/4 inch


    return result;
  },
  _line: function _line(text, options) {
    if (options === void 0) {
      options = {};
    }

    this._fragment(text, this.x, this.y, options);

    return this.x += this.widthOfString(text);
  },
  _fragment: function _fragment(text, x, y, options) {
    text = ("" + text).replace(/\n/g, '');
    if (text.length === 0) return;

    var _this$_font$encode = this._font.encode(text, options.features),
        encoded = _this$_font$encode[0],
        positions = _this$_font$encode[1];

    var dy = this._font.ascender / 1000 * this._fontSize;

    this._glyphs(encoded, positions, x, y + dy, options);
  },
  _glyphs: function _glyphs(encoded, positions, x, y, options) {
    var _this2 = this;

    var commands = [];
    var scale = this._fontSize / 1000;
    var i;
    var last = 0;
    var hadOffset = false;
    this.save(); // flip coordinate system

    this.transform(1, 0, 0, -1, 0, this.page.height);
    y = this.page.height - y; // add current font to page if necessary

    if (this.page.fonts[this._font.id] == null) {
      this.page.fonts[this._font.id] = this._font.ref();
    } // begin the text object


    this.addContent('BT'); // text position

    this.addContent("1 0 0 1 " + number(x) + " " + number(y) + " Tm"); // font and font size

    this.addContent("/" + this._font.id + " " + number(this._fontSize) + " Tf"); // rendering mode

    var mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;

    if (mode) {
      this.addContent(mode + " Tr");
    } // Adds a segment of text to the TJ command buffer


    var addSegment = function addSegment(cur) {
      if (last < cur) {
        var hex = encoded.slice(last, cur).join('');
        var advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
        commands.push("<" + hex + "> " + number(-advance));
      }

      return last = cur;
    }; // Flushes the current TJ commands to the output stream


    var flush = function flush(i) {
      addSegment(i);

      if (commands.length > 0) {
        _this2.addContent("[" + commands.join(' ') + "] TJ");

        return commands.length = 0;
      }
    };

    for (i = 0; i < positions.length; i++) {
      // If we have an x or y offset, we have to break out of the current TJ command
      // so we can move the text position.
      var pos = positions[i];

      if (pos.xOffset || pos.yOffset) {
        // Flush the current buffer
        flush(i); // Move the text position and flush just the current character

        this.addContent("1 0 0 1 " + number(x + pos.xOffset * scale) + " " + number(y + pos.yOffset * scale) + " Tm");
        flush(i + 1);
        hadOffset = true;
      } else {
        // If the last character had an offset, reset the text position
        if (hadOffset) {
          this.addContent("1 0 0 1 " + number(x) + " " + number(y) + " Tm");
          hadOffset = false;
        } // Group segments that don't have any advance adjustments


        if (pos.xAdvance - pos.advanceWidth !== 0) {
          addSegment(i + 1);
        }
      }

      x += pos.xAdvance * scale;
    } // Flush any remaining commands


    flush(i); // end the text object

    this.addContent('ET'); // restore flipped coordinate system

    return this.restore();
  }
};
var MARKERS = [0xffc0, 0xffc1, 0xffc2, 0xffc3, 0xffc5, 0xffc6, 0xffc7, 0xffc8, 0xffc9, 0xffca, 0xffcb, 0xffcc, 0xffcd, 0xffce, 0xffcf];

var JPEG = /*#__PURE__*/function () {
  function JPEG(data, label) {
    var marker;
    this.data = data;
    this.label = label;

    if (this.data.readUInt16BE(0) !== 0xffd8) {
      throw 'SOI not found in JPEG';
    }

    var pos = 2;

    while (pos < this.data.length) {
      marker = this.data.readUInt16BE(pos);
      pos += 2;

      if (Array.from(MARKERS).includes(marker)) {
        break;
      }

      pos += this.data.readUInt16BE(pos);
    }

    if (!Array.from(MARKERS).includes(marker)) {
      throw 'Invalid JPEG.';
    }

    pos += 2;
    this.bits = this.data[pos++];
    this.height = this.data.readUInt16BE(pos);
    pos += 2;
    this.width = this.data.readUInt16BE(pos);
    pos += 2;
    var channels = this.data[pos++];

    this.colorSpace = function () {
      switch (channels) {
        case 1:
          return 'DeviceGray';

        case 3:
          return 'DeviceRGB';

        case 4:
          return 'DeviceCMYK';
      }
    }();

    this.obj = null;
  }

  var _proto = JPEG.prototype;

  _proto.embed = function embed(document) {
    if (this.obj) {
      return;
    }

    this.obj = document.ref({
      Type: 'XObject',
      Subtype: 'Image',
      BitsPerComponent: this.bits,
      Width: this.width,
      Height: this.height,
      ColorSpace: this.colorSpace,
      Filter: 'DCTDecode'
    }); // add extra decode params for CMYK images. By swapping the
    // min and max values from the default, we invert the colors. See
    // section 4.8.4 of the spec.

    if (this.colorSpace === 'DeviceCMYK') {
      this.obj.data['Decode'] = [1.0, 0.0, 1.0, 0.0, 1.0, 0.0, 1.0, 0.0];
    }

    this.obj.end(this.data); // free memory

    return this.data = null;
  };

  return JPEG;
}();

var PNGImage = /*#__PURE__*/function () {
  function PNGImage(data, label) {
    this.label = label;
    this.image = new PNG(data);
    this.width = this.image.width;
    this.height = this.image.height;
    this.imgData = this.image.imgData;
    this.obj = null;
  }

  var _proto = PNGImage.prototype;

  _proto.embed = function embed(document) {
    var dataDecoded = false;
    this.document = document;

    if (this.obj) {
      return;
    }

    var hasAlphaChannel = this.image.hasAlphaChannel;
    var isInterlaced = this.image.interlaceMethod === 1;
    this.obj = this.document.ref({
      Type: 'XObject',
      Subtype: 'Image',
      BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
      Width: this.width,
      Height: this.height,
      Filter: 'FlateDecode'
    });

    if (!hasAlphaChannel) {
      var params = this.document.ref({
        Predictor: isInterlaced ? 1 : 15,
        Colors: this.image.colors,
        BitsPerComponent: this.image.bits,
        Columns: this.width
      });
      this.obj.data['DecodeParms'] = params;
      params.end();
    }

    if (this.image.palette.length === 0) {
      this.obj.data['ColorSpace'] = this.image.colorSpace;
    } else {
      // embed the color palette in the PDF as an object stream
      var palette = this.document.ref();
      palette.end(Buffer.from(this.image.palette)); // build the color space array for the image

      this.obj.data['ColorSpace'] = ['Indexed', 'DeviceRGB', this.image.palette.length / 3 - 1, palette];
    } // For PNG color types 0, 2 and 3, the transparency data is stored in
    // a dedicated PNG chunk.


    if (this.image.transparency.grayscale != null) {
      // Use Color Key Masking (spec section 4.8.5)
      // An array with N elements, where N is two times the number of color components.
      var val = this.image.transparency.grayscale;
      this.obj.data['Mask'] = [val, val];
    } else if (this.image.transparency.rgb) {
      // Use Color Key Masking (spec section 4.8.5)
      // An array with N elements, where N is two times the number of color components.
      var rgb = this.image.transparency.rgb;
      var mask = [];

      for (var _iterator = _createForOfIteratorHelperLoose(rgb), _step; !(_step = _iterator()).done;) {
        var x = _step.value;
        mask.push(x, x);
      }

      this.obj.data['Mask'] = mask;
    } else if (this.image.transparency.indexed) {
      // Create a transparency SMask for the image based on the data
      // in the PLTE and tRNS sections. See below for details on SMasks.
      dataDecoded = true;
      return this.loadIndexedAlphaChannel();
    } else if (hasAlphaChannel) {
      // For PNG color types 4 and 6, the transparency data is stored as a alpha
      // channel mixed in with the main image data. Separate this data out into an
      // SMask object and store it separately in the PDF.
      dataDecoded = true;
      return this.splitAlphaChannel();
    }

    if (isInterlaced && !dataDecoded) {
      return this.decodeData();
    }

    this.finalize();
  };

  _proto.finalize = function finalize() {
    if (this.alphaChannel) {
      var sMask = this.document.ref({
        Type: 'XObject',
        Subtype: 'Image',
        Height: this.height,
        Width: this.width,
        BitsPerComponent: 8,
        Filter: 'FlateDecode',
        ColorSpace: 'DeviceGray',
        Decode: [0, 1]
      });
      sMask.end(this.alphaChannel);
      this.obj.data['SMask'] = sMask;
    } // add the actual image data


    this.obj.end(this.imgData); // free memory

    this.image = null;
    return this.imgData = null;
  };

  _proto.splitAlphaChannel = function splitAlphaChannel() {
    var _this = this;

    return this.image.decodePixels(function (pixels) {
      var a;
      var p;
      var colorCount = _this.image.colors;
      var pixelCount = _this.width * _this.height;
      var imgData = Buffer.alloc(pixelCount * colorCount);
      var alphaChannel = Buffer.alloc(pixelCount);
      var i = p = a = 0;
      var len = pixels.length; // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)

      var skipByteCount = _this.image.bits === 16 ? 1 : 0;

      while (i < len) {
        for (var colorIndex = 0; colorIndex < colorCount; colorIndex++) {
          imgData[p++] = pixels[i++];
          i += skipByteCount;
        }

        alphaChannel[a++] = pixels[i++];
        i += skipByteCount;
      }

      _this.imgData = zlib.deflateSync(imgData);
      _this.alphaChannel = zlib.deflateSync(alphaChannel);
      return _this.finalize();
    });
  };

  _proto.loadIndexedAlphaChannel = function loadIndexedAlphaChannel() {
    var _this2 = this;

    var transparency = this.image.transparency.indexed;
    return this.image.decodePixels(function (pixels) {
      var alphaChannel = Buffer.alloc(_this2.width * _this2.height);
      var i = 0;

      for (var j = 0, end = pixels.length; j < end; j++) {
        alphaChannel[i++] = transparency[pixels[j]];
      }

      _this2.alphaChannel = zlib.deflateSync(alphaChannel);
      return _this2.finalize();
    });
  };

  _proto.decodeData = function decodeData() {
    var _this3 = this;

    this.image.decodePixels(function (pixels) {
      _this3.imgData = zlib.deflateSync(pixels);

      _this3.finalize();
    });
  };

  return PNGImage;
}();

var PDFImage = /*#__PURE__*/function () {
  function PDFImage() {}

  PDFImage.open = function open(src, label) {
    var data;

    if (Buffer.isBuffer(src)) {
      data = src;
    } else if (src instanceof ArrayBuffer) {
      data = Buffer.from(new Uint8Array(src));
    } else {
      var match = /^data:.+;base64,(.*)$/.exec(src);

      if (match) {
        data = Buffer.from(match[1], 'base64');
      }
    }

    if (data[0] === 0xff && data[1] === 0xd8) {
      return new JPEG(data, label);
    } else if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') {
      return new PNGImage(data, label);
    } else {
      throw new Error('Unknown image format.');
    }
  };

  return PDFImage;
}();

var Images = {
  initImages: function initImages() {
    this._imageRegistry = {};
    return this._imageCount = 0;
  },
  image: function image(src, x, y, options) {
    var bh, bp, bw, image, ip, left, left1;

    if (options == null) {
      options = {};
    }

    if (typeof x === 'object') {
      options = x;
      x = null;
    }

    x = (left = x != null ? x : options.x) != null ? left : this.x;
    y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;

    if (typeof src === 'string') {
      image = this._imageRegistry[src];
    }

    if (!image) {
      if (src.width && src.height) {
        image = src;
      } else {
        image = this.openImage(src);
      }
    }

    if (!image.obj) {
      image.embed(this);
    }

    if (this.page.xobjects[image.label] == null) {
      this.page.xobjects[image.label] = image.obj;
    }

    var w = options.width || image.width;
    var h = options.height || image.height;

    if (options.width && !options.height) {
      var wp = w / image.width;
      w = image.width * wp;
      h = image.height * wp;
    } else if (options.height && !options.width) {
      var hp = h / image.height;
      w = image.width * hp;
      h = image.height * hp;
    } else if (options.scale) {
      w = image.width * options.scale;
      h = image.height * options.scale;
    } else if (options.fit) {
      var _Array$from = Array.from(options.fit);

      bw = _Array$from[0];
      bh = _Array$from[1];
      bp = bw / bh;
      ip = image.width / image.height;

      if (ip > bp) {
        w = bw;
        h = bw / ip;
      } else {
        h = bh;
        w = bh * ip;
      }
    } else if (options.cover) {
      var _Array$from2 = Array.from(options.cover);

      bw = _Array$from2[0];
      bh = _Array$from2[1];
      bp = bw / bh;
      ip = image.width / image.height;

      if (ip > bp) {
        h = bh;
        w = bh * ip;
      } else {
        w = bw;
        h = bw / ip;
      }
    }

    if (options.fit || options.cover) {
      if (options.align === 'center') {
        x = x + bw / 2 - w / 2;
      } else if (options.align === 'right') {
        x = x + bw - w;
      }

      if (options.valign === 'center') {
        y = y + bh / 2 - h / 2;
      } else if (options.valign === 'bottom') {
        y = y + bh - h;
      }
    } // create link annotations if the link option is given


    if (options.link != null) {
      this.link(x, y, w, h, options.link);
    }

    if (options.goTo != null) {
      this.goTo(x, y, w, h, options.goTo);
    }

    if (options.destination != null) {
      this.addNamedDestination(options.destination, 'XYZ', x, y, null);
    } // Set the current y position to below the image if it is in the document flow


    if (this.y === y) {
      this.y += h;
    }

    this.save();
    this.transform(w, 0, 0, -h, x, y + h);
    this.addContent("/" + image.label + " Do");
    this.restore();
    return this;
  },
  openImage: function openImage(src) {
    var image;

    if (typeof src === 'string') {
      image = this._imageRegistry[src];
    }

    if (!image) {
      image = PDFImage.open(src, "I" + ++this._imageCount);

      if (typeof src === 'string') {
        this._imageRegistry[src] = image;
      }
    }

    return image;
  }
};
var Annotations = {
  annotate: function annotate(x, y, w, h, options) {
    options.Type = 'Annot';
    options.Rect = this._convertRect(x, y, w, h);
    options.Border = [0, 0, 0];

    if (options.Subtype === 'Link' && typeof options.F === 'undefined') {
      options.F = 1 << 2; // Print Annotation Flag
    }

    if (options.Subtype !== 'Link') {
      if (options.C == null) {
        options.C = this._normalizeColor(options.color || [0, 0, 0]);
      }
    } // convert colors


    delete options.color;

    if (typeof options.Dest === 'string') {
      options.Dest = new String(options.Dest);
    } // Capitalize keys


    for (var key in options) {
      var val = options[key];
      options[key[0].toUpperCase() + key.slice(1)] = val;
    }

    var ref = this.ref(options);
    this.page.annotations.push(ref);
    ref.end();
    return this;
  },
  note: function note(x, y, w, h, contents, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Text';
    options.Contents = new String(contents);
    options.Name = 'Comment';

    if (options.color == null) {
      options.color = [243, 223, 92];
    }

    return this.annotate(x, y, w, h, options);
  },
  goTo: function goTo(x, y, w, h, name, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Link';
    options.A = this.ref({
      S: 'GoTo',
      D: new String(name)
    });
    options.A.end();
    return this.annotate(x, y, w, h, options);
  },
  link: function link(x, y, w, h, url, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Link';

    if (typeof url === 'number') {
      // Link to a page in the document (the page must already exist)
      var pages = this._root.data.Pages.data;

      if (url >= 0 && url < pages.Kids.length) {
        options.A = this.ref({
          S: 'GoTo',
          D: [pages.Kids[url], 'XYZ', null, null, null]
        });
        options.A.end();
      } else {
        throw new Error("The document has no page " + url);
      }
    } else {
      // Link to an external url
      options.A = this.ref({
        S: 'URI',
        URI: new String(url)
      });
      options.A.end();
    }

    return this.annotate(x, y, w, h, options);
  },
  _markup: function _markup(x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    var _this$_convertRect = this._convertRect(x, y, w, h),
        x1 = _this$_convertRect[0],
        y1 = _this$_convertRect[1],
        x2 = _this$_convertRect[2],
        y2 = _this$_convertRect[3];

    options.QuadPoints = [x1, y2, x2, y2, x1, y1, x2, y1];
    options.Contents = new String();
    return this.annotate(x, y, w, h, options);
  },
  highlight: function highlight(x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Highlight';

    if (options.color == null) {
      options.color = [241, 238, 148];
    }

    return this._markup(x, y, w, h, options);
  },
  underline: function underline(x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Underline';
    return this._markup(x, y, w, h, options);
  },
  strike: function strike(x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'StrikeOut';
    return this._markup(x, y, w, h, options);
  },
  lineAnnotation: function lineAnnotation(x1, y1, x2, y2, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Line';
    options.Contents = new String();
    options.L = [x1, this.page.height - y1, x2, this.page.height - y2];
    return this.annotate(x1, y1, x2, y2, options);
  },
  rectAnnotation: function rectAnnotation(x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Square';
    options.Contents = new String();
    return this.annotate(x, y, w, h, options);
  },
  ellipseAnnotation: function ellipseAnnotation(x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'Circle';
    options.Contents = new String();
    return this.annotate(x, y, w, h, options);
  },
  textAnnotation: function textAnnotation(x, y, w, h, text, options) {
    if (options === void 0) {
      options = {};
    }

    options.Subtype = 'FreeText';
    options.Contents = new String(text);
    options.DA = new String();
    return this.annotate(x, y, w, h, options);
  },
  fileAnnotation: function fileAnnotation(x, y, w, h, file, options) {
    if (file === void 0) {
      file = {};
    }

    if (options === void 0) {
      options = {};
    } // create hidden file


    var filespec = this.file(file.src, Object.assign({
      hidden: true
    }, file));
    options.Subtype = 'FileAttachment';
    options.FS = filespec; // add description from filespec unless description (Contents) has already been set

    if (options.Contents) {
      options.Contents = new String(options.Contents);
    } else if (filespec.data.Desc) {
      options.Contents = filespec.data.Desc;
    }

    return this.annotate(x, y, w, h, options);
  },
  _convertRect: function _convertRect(x1, y1, w, h) {
    // flip y1 and y2
    var y2 = y1;
    y1 += h; // make x2

    var x2 = x1 + w; // apply current transformation matrix to points

    var _this$_ctm = this._ctm,
        m0 = _this$_ctm[0],
        m1 = _this$_ctm[1],
        m2 = _this$_ctm[2],
        m3 = _this$_ctm[3],
        m4 = _this$_ctm[4],
        m5 = _this$_ctm[5];
    x1 = m0 * x1 + m2 * y1 + m4;
    y1 = m1 * x1 + m3 * y1 + m5;
    x2 = m0 * x2 + m2 * y2 + m4;
    y2 = m1 * x2 + m3 * y2 + m5;
    return [x1, y1, x2, y2];
  }
};
var FIELD_FLAGS = {
  readOnly: 1,
  required: 2,
  noExport: 4,
  multiline: 0x1000,
  password: 0x2000,
  toggleToOffButton: 0x4000,
  radioButton: 0x8000,
  pushButton: 0x10000,
  combo: 0x20000,
  edit: 0x40000,
  sort: 0x80000,
  multiSelect: 0x200000,
  noSpell: 0x400000
};
var FIELD_JUSTIFY = {
  left: 0,
  center: 1,
  right: 2
};
var VALUE_MAP = {
  value: 'V',
  defaultValue: 'DV'
};
var FORMAT_SPECIAL = {
  zip: '0',
  zipPlus4: '1',
  zip4: '1',
  phone: '2',
  ssn: '3'
};
var FORMAT_DEFAULT = {
  number: {
    nDec: 0,
    sepComma: false,
    negStyle: 'MinusBlack',
    currency: '',
    currencyPrepend: true
  },
  percent: {
    nDec: 0,
    sepComma: false
  }
};
var AcroFormMixin = {
  /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */
  initForm: function initForm() {
    if (!this._font) {
      throw new Error('Must set a font before calling initForm method');
    }

    this._acroform = {
      fonts: {},
      defaultFont: this._font.name
    };
    this._acroform.fonts[this._font.id] = this._font.ref();
    var data = {
      Fields: [],
      NeedAppearances: true,
      DA: new String("/" + this._font.id + " 0 Tf 0 g"),
      DR: {
        Font: {}
      }
    };
    data.DR.Font[this._font.id] = this._font.ref();
    var AcroForm = this.ref(data);
    this._root.data.AcroForm = AcroForm;
    return this;
  },

  /**
   * Called automatically by document.js
   */
  endAcroForm: function endAcroForm() {
    var _this = this;

    if (this._root.data.AcroForm) {
      if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) {
        throw new Error('No fonts specified for PDF form');
      }

      var fontDict = this._root.data.AcroForm.data.DR.Font;
      Object.keys(this._acroform.fonts).forEach(function (name) {
        fontDict[name] = _this._acroform.fonts[name];
      });

      this._root.data.AcroForm.data.Fields.forEach(function (fieldRef) {
        _this._endChild(fieldRef);
      });

      this._root.data.AcroForm.end();
    }

    return this;
  },
  _endChild: function _endChild(ref) {
    var _this2 = this;

    if (Array.isArray(ref.data.Kids)) {
      ref.data.Kids.forEach(function (childRef) {
        _this2._endChild(childRef);
      });
      ref.end();
    }

    return this;
  },

  /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */
  formField: function formField(name, options) {
    if (options === void 0) {
      options = {};
    }

    var fieldDict = this._fieldDict(name, null, options);

    var fieldRef = this.ref(fieldDict);

    this._addToParent(fieldRef);

    return fieldRef;
  },

  /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */
  formAnnotation: function formAnnotation(name, type, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    var fieldDict = this._fieldDict(name, type, options);

    fieldDict.Subtype = 'Widget';

    if (fieldDict.F === undefined) {
      fieldDict.F = 4; // print the annotation
    } // Add Field annot to page, and get it's ref


    this.annotate(x, y, w, h, fieldDict);
    var annotRef = this.page.annotations[this.page.annotations.length - 1];
    return this._addToParent(annotRef);
  },
  formText: function formText(name, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    return this.formAnnotation(name, 'text', x, y, w, h, options);
  },
  formPushButton: function formPushButton(name, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    return this.formAnnotation(name, 'pushButton', x, y, w, h, options);
  },
  formCombo: function formCombo(name, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    return this.formAnnotation(name, 'combo', x, y, w, h, options);
  },
  formList: function formList(name, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    return this.formAnnotation(name, 'list', x, y, w, h, options);
  },
  formRadioButton: function formRadioButton(name, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    return this.formAnnotation(name, 'radioButton', x, y, w, h, options);
  },
  formCheckbox: function formCheckbox(name, x, y, w, h, options) {
    if (options === void 0) {
      options = {};
    }

    return this.formAnnotation(name, 'checkbox', x, y, w, h, options);
  },
  _addToParent: function _addToParent(fieldRef) {
    var parent = fieldRef.data.Parent;

    if (parent) {
      if (!parent.data.Kids) {
        parent.data.Kids = [];
      }

      parent.data.Kids.push(fieldRef);
    } else {
      this._root.data.AcroForm.data.Fields.push(fieldRef);
    }

    return this;
  },
  _fieldDict: function _fieldDict(name, type, options) {
    if (options === void 0) {
      options = {};
    }

    if (!this._acroform) {
      throw new Error('Call document.initForms() method before adding form elements to document');
    }

    var opts = Object.assign({}, options);

    if (type !== null) {
      opts = this._resolveType(type, options);
    }

    opts = this._resolveFlags(opts);
    opts = this._resolveJustify(opts);
    opts = this._resolveFont(opts);
    opts = this._resolveStrings(opts);
    opts = this._resolveColors(opts);
    opts = this._resolveFormat(opts);
    opts.T = new String(name);

    if (opts.parent) {
      opts.Parent = opts.parent;
      delete opts.parent;
    }

    return opts;
  },
  _resolveType: function _resolveType(type, opts) {
    if (type === 'text') {
      opts.FT = 'Tx';
    } else if (type === 'pushButton') {
      opts.FT = 'Btn';
      opts.pushButton = true;
    } else if (type === 'radioButton') {
      opts.FT = 'Btn';
      opts.radioButton = true;
    } else if (type === 'checkbox') {
      opts.FT = 'Btn';
    } else if (type === 'combo') {
      opts.FT = 'Ch';
      opts.combo = true;
    } else if (type === 'list') {
      opts.FT = 'Ch';
    } else {
      throw new Error("Invalid form annotation type '" + type + "'");
    }

    return opts;
  },
  _resolveFormat: function _resolveFormat(opts) {
    var f = opts.format;

    if (f && f.type) {
      var fnKeystroke;
      var fnFormat;
      var params = '';

      if (FORMAT_SPECIAL[f.type] !== undefined) {
        fnKeystroke = "AFSpecial_Keystroke";
        fnFormat = "AFSpecial_Format";
        params = FORMAT_SPECIAL[f.type];
      } else {
        var format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
        fnKeystroke = "AF" + format + "_Keystroke";
        fnFormat = "AF" + format + "_Format";

        if (f.type === 'date') {
          fnKeystroke += 'Ex';
          params = String(f.param);
        } else if (f.type === 'time') {
          params = String(f.param);
        } else if (f.type === 'number') {
          var p = Object.assign({}, FORMAT_DEFAULT.number, f);
          params = String([String(p.nDec), p.sepComma ? '0' : '1', '"' + p.negStyle + '"', 'null', '"' + p.currency + '"', String(p.currencyPrepend)].join(','));
        } else if (f.type === 'percent') {
          var _p = Object.assign({}, FORMAT_DEFAULT.percent, f);

          params = String([String(_p.nDec), _p.sepComma ? '0' : '1'].join(','));
        }
      }

      opts.AA = opts.AA ? opts.AA : {};
      opts.AA.K = {
        S: 'JavaScript',
        JS: new String(fnKeystroke + "(" + params + ");")
      };
      opts.AA.F = {
        S: 'JavaScript',
        JS: new String(fnFormat + "(" + params + ");")
      };
    }

    delete opts.format;
    return opts;
  },
  _resolveColors: function _resolveColors(opts) {
    var color = this._normalizeColor(opts.backgroundColor);

    if (color) {
      if (!opts.MK) {
        opts.MK = {};
      }

      opts.MK.BG = color;
    }

    color = this._normalizeColor(opts.borderColor);

    if (color) {
      if (!opts.MK) {
        opts.MK = {};
      }

      opts.MK.BC = color;
    }

    delete opts.backgroundColor;
    delete opts.borderColor;
    return opts;
  },
  _resolveFlags: function _resolveFlags(options) {
    var result = 0;
    Object.keys(options).forEach(function (key) {
      if (FIELD_FLAGS[key]) {
        result |= FIELD_FLAGS[key];
        delete options[key];
      }
    });

    if (result !== 0) {
      options.Ff = options.Ff ? options.Ff : 0;
      options.Ff |= result;
    }

    return options;
  },
  _resolveJustify: function _resolveJustify(options) {
    var result = 0;

    if (options.align !== undefined) {
      if (typeof FIELD_JUSTIFY[options.align] === 'number') {
        result = FIELD_JUSTIFY[options.align];
      }

      delete options.align;
    }

    if (result !== 0) {
      options.Q = result; // default
    }

    return options;
  },
  _resolveFont: function _resolveFont(options) {
    // add current font to document-level AcroForm dict if necessary
    if (this._acroform.fonts[this._font.id] === null) {
      this._acroform.fonts[this._font.id] = this._font.ref();
    } // add current font to field's resource dict (RD) if not the default acroform font


    if (this._acroform.defaultFont !== this._font.name) {
      options.DR = {
        Font: {}
      };
      options.DR.Font[this._font.id] = this._font.ref();
      options.DA = new String("/" + this._font.id + " 0 Tf 0 g");
    }

    return options;
  },
  _resolveStrings: function _resolveStrings(options) {
    var select = [];

    function appendChoices(a) {
      if (Array.isArray(a)) {
        for (var idx = 0; idx < a.length; idx++) {
          if (typeof a[idx] === 'string') {
            select.push(new String(a[idx]));
          } else {
            select.push(a[idx]);
          }
        }
      }
    }

    appendChoices(options.Opt);

    if (options.select) {
      appendChoices(options.select);
      delete options.select;
    }

    if (select.length) {
      options.Opt = select;
    }

    Object.keys(VALUE_MAP).forEach(function (key) {
      if (options[key] !== undefined) {
        options[VALUE_MAP[key]] = options[key];
        delete options[key];
      }
    });
    ['V', 'DV'].forEach(function (key) {
      if (typeof options[key] === 'string') {
        options[key] = new String(options[key]);
      }
    });

    if (options.MK && options.MK.CA) {
      options.MK.CA = new String(options.MK.CA);
    }

    if (options.label) {
      options.MK = options.MK ? options.MK : {};
      options.MK.CA = new String(options.label);
      delete options.label;
    }

    return options;
  }
};
var Attachments = {
  /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */
  file: function file(src, options) {
    if (options === void 0) {
      options = {};
    }

    options.name = options.name || src;
    var refBody = {
      Type: 'EmbeddedFile',
      Params: {}
    };
    var data;

    if (!src) {
      throw new Error('No src specified');
    }

    if (Buffer.isBuffer(src)) {
      data = src;
    } else if (src instanceof ArrayBuffer) {
      data = Buffer.from(new Uint8Array(src));
    } else {
      var match;

      if (match = /^data:(.*);base64,(.*)$/.exec(src)) {
        if (match[1]) {
          refBody.Subtype = match[1].replace('/', '#2F');
        }

        data = Buffer.from(match[2], 'base64');
      } else {
        throw new Error("Could not find file " + src);
      }
    } // override creation date and modified date


    if (options.creationDate instanceof Date) {
      refBody.Params.CreationDate = options.creationDate;
    }

    if (options.modifiedDate instanceof Date) {
      refBody.Params.ModDate = options.modifiedDate;
    } // add optional subtype


    if (options.type) {
      refBody.Subtype = options.type.replace('/', '#2F');
    } // add checksum and size information


    var checksum = CryptoJS.MD5(CryptoJS.lib.WordArray.create(new Uint8Array(data)));
    refBody.Params.CheckSum = new String(checksum);
    refBody.Params.Size = data.byteLength; // save some space when embedding the same file again
    // if a file with the same name and metadata exists, reuse its reference

    var ref;
    if (!this._fileRegistry) this._fileRegistry = {};
    var file = this._fileRegistry[options.name];

    if (file && isEqual(refBody, file)) {
      ref = file.ref;
    } else {
      ref = this.ref(refBody);
      ref.end(data);
      this._fileRegistry[options.name] = _extends({}, refBody, {
        ref: ref
      });
    } // add filespec for embedded file


    var fileSpecBody = {
      Type: 'Filespec',
      F: new String(options.name),
      EF: {
        F: ref
      },
      UF: new String(options.name)
    };

    if (options.description) {
      fileSpecBody.Desc = new String(options.description);
    }

    var filespec = this.ref(fileSpecBody);
    filespec.end();

    if (!options.hidden) {
      this.addNamedEmbeddedFile(options.name, filespec);
    }

    return filespec;
  }
};
/** check two embedded file metadata objects for equality */

function isEqual(a, b) {
  if (a.Subtype !== b.Subtype || a.Params.CheckSum.toString() !== b.Params.CheckSum.toString() || a.Params.Size !== b.Params.Size || a.Params.CreationDate !== b.Params.CreationDate || a.Params.ModDate !== b.Params.ModDate) {
    return false;
  }

  return true;
}

var PDFDocument = /*#__PURE__*/function (_stream$Readable) {
  _inheritsLoose(PDFDocument, _stream$Readable);

  function PDFDocument(options) {
    var _this;

    if (options === void 0) {
      options = {};
    }

    _this = _stream$Readable.call(this) || this;
    _this.options = options; // PDF version

    switch (options.pdfVersion) {
      case '1.4':
        _this.version = 1.4;
        break;

      case '1.5':
        _this.version = 1.5;
        break;

      case '1.6':
        _this.version = 1.6;
        break;

      case '1.7':
      case '1.7ext3':
        _this.version = 1.7;
        break;

      default:
        _this.version = 1.3;
        break;
    } // Whether streams should be compressed


    _this.compress = _this.options.compress != null ? _this.options.compress : true;
    _this._pageBuffer = [];
    _this._pageBufferStart = 0; // The PDF object store

    _this._offsets = [];
    _this._waiting = 0;
    _this._ended = false;
    _this._offset = 0;

    var Pages = _this.ref({
      Type: 'Pages',
      Count: 0,
      Kids: []
    });

    var Names = _this.ref({
      Dests: new PDFNameTree()
    });

    _this._root = _this.ref({
      Type: 'Catalog',
      Pages: Pages,
      Names: Names
    });

    if (_this.options.lang) {
      _this._root.data.Lang = new String(_this.options.lang);
    } // The current page


    _this.page = null; // Initialize mixins

    _this.initColor();

    _this.initVector();

    _this.initFonts();

    _this.initText();

    _this.initImages(); // Initialize the metadata


    _this.info = {
      Producer: 'PDFKit',
      Creator: 'PDFKit',
      CreationDate: new Date()
    };

    if (_this.options.info) {
      for (var key in _this.options.info) {
        var val = _this.options.info[key];
        _this.info[key] = val;
      }
    }

    if (_this.options.displayTitle) {
      _this._root.data.ViewerPreferences = _this.ref({
        DisplayDocTitle: true
      });
    } // Write the header PDF version


    _this._write("%PDF-" + _this.version); // 4 binary chars, as recommended by the spec


    _this._write('%\xFF\xFF\xFF\xFF'); // Add the first page


    if (_this.options.autoFirstPage !== false) {
      _this.addPage();
    }

    return _this;
  }

  var _proto = PDFDocument.prototype;

  _proto.addPage = function addPage(options) {
    // end the current page if needed
    if (options == null) {
      options = this.options;
    }

    if (!this.options.bufferPages) {
      this.flushPages();
    } // create a page object


    this.page = new PDFPage(this, options);

    this._pageBuffer.push(this.page); // add the page to the object store


    var pages = this._root.data.Pages.data;
    pages.Kids.push(this.page.dictionary);
    pages.Count++; // flip PDF coordinate system so that the origin is in
    // the top left rather than the bottom left

    this._ctm = [1, 0, 0, 1, 0, 0];
    this.transform(1, 0, 0, -1, 0, this.page.height);
    return this;
  };

  _proto.flushPages = function flushPages() {
    // this local variable exists so we're future-proof against
    // reentrant calls to flushPages.
    var pages = this._pageBuffer;
    this._pageBuffer = [];
    this._pageBufferStart += pages.length;

    for (var _i = 0, _Array$from = Array.from(pages); _i < _Array$from.length; _i++) {
      var page = _Array$from[_i];
      page.end();
    }
  };

  _proto.addNamedDestination = function addNamedDestination(name) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 0) {
      args = ['XYZ', null, null, null];
    }

    if (args[0] === 'XYZ' && args[2] !== null) {
      args[2] = this.page.height - args[2];
    }

    args.unshift(this.page.dictionary);

    this._root.data.Names.data.Dests.add(name, args);
  };

  _proto.addNamedEmbeddedFile = function addNamedEmbeddedFile(name, ref) {
    if (!this._root.data.Names.data.EmbeddedFiles) {
      // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
      this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
        limits: false
      });
    } // add filespec to EmbeddedFiles


    this._root.data.Names.data.EmbeddedFiles.add(name, ref);
  };

  _proto.addNamedJavaScript = function addNamedJavaScript(name, js) {
    if (!this._root.data.Names.data.JavaScript) {
      this._root.data.Names.data.JavaScript = new PDFNameTree();
    }

    var data = {
      JS: new String(js),
      S: 'JavaScript'
    };

    this._root.data.Names.data.JavaScript.add(name, data);
  };

  _proto.ref = function ref(data) {
    var ref = new PDFReference(this, this._offsets.length + 1, data);

    this._offsets.push(null); // placeholder for this object's offset once it is finalized


    this._waiting++;
    return ref;
  };

  _proto._read = function _read() {// do nothing, but this method is required by node
  };

  _proto._write = function _write(data) {
    if (!Buffer.isBuffer(data)) {
      data = Buffer.from(data + '\n', 'binary');
    }

    this.push(data);
    return this._offset += data.length;
  };

  _proto.addContent = function addContent(data) {
    this.page.write(data);
    return this;
  };

  _proto._refEnd = function _refEnd(ref) {
    this._offsets[ref.id - 1] = ref.offset;

    if (--this._waiting === 0 && this._ended) {
      this._finalize();

      return this._ended = false;
    }
  };

  _proto.end = function end() {
    this.flushPages();
    this._info = this.ref();

    for (var key in this.info) {
      var val = this.info[key];

      if (typeof val === 'string') {
        val = new String(val);
      }

      var entry = this.ref(val);
      entry.end();
      this._info.data[key] = entry;
    }

    this._info.end();

    for (var name in this._fontFamilies) {
      var font = this._fontFamilies[name];
      font.finalize();
    }

    this._root.end();

    this._root.data.Pages.end();

    this._root.data.Names.end();

    this.endAcroForm();

    if (this._root.data.ViewerPreferences) {
      this._root.data.ViewerPreferences.end();
    }

    if (this._waiting === 0) {
      return this._finalize();
    } else {
      return this._ended = true;
    }
  };

  _proto._finalize = function _finalize(fn) {
    // generate xref
    var xRefOffset = this._offset;

    this._write('xref');

    this._write("0 " + (this._offsets.length + 1));

    this._write('0000000000 65535 f ');

    for (var _i2 = 0, _Array$from2 = Array.from(this._offsets); _i2 < _Array$from2.length; _i2++) {
      var offset = _Array$from2[_i2];
      offset = ("0000000000" + offset).slice(-10);

      this._write(offset + ' 00000 n ');
    } // trailer


    this._write('trailer');

    this._write(PDFObject$1.convert({
      Size: this._offsets.length + 1,
      Root: this._root,
      Info: this._info
    }));

    this._write('startxref');

    this._write("" + xRefOffset);

    this._write('%%EOF'); // end the stream


    return this.push(null);
  };

  _proto.toString = function toString() {
    return '[object PDFDocument]';
  };

  return PDFDocument;
}(stream.Readable);

var mixin = function mixin(methods) {
  return function () {
    var result = [];

    for (var name in methods) {
      var method = methods[name];
      result.push(PDFDocument.prototype[name] = method);
    }

    return result;
  }();
}; // Load mixins


mixin(Color);
mixin(Vector);
mixin(Fonts);
mixin(Text);
mixin(Images);
mixin(Annotations);
mixin(AcroFormMixin);
mixin(Attachments);
export { EmbeddedFont, PDFFont, StandardFont, PDFDocument as default };